// @noflow
// eslint-disable
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  ThemeColour: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum Account {
  free = 'free',
  paid = 'paid',
  trial = 'trial'
}

export enum Action {
  js_function = 'js_function',
  link = 'link'
}

export type ActionCard = Node & {
  __typename?: 'ActionCard';
  actionCta: Scalars['String']['output'];
  actionPayload: Scalars['String']['output'];
  actionType: Action;
  description: Scalars['String']['output'];
  dismissAfterAction: Scalars['Boolean']['output'];
  dismissible: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  slug: Scalars['String']['output'];
  style: Style;
  title: Scalars['String']['output'];
};

export enum ActionCardPlatform {
  app = 'app',
  web = 'web',
  web_and_app = 'web_and_app'
}

export type ActivitiesInput = {
  activities: Array<Activity>;
  dogId: Scalars['ID']['input'];
};

export enum Activity {
  cuddling = 'cuddling',
  doing_tricks = 'doing_tricks',
  making_friends = 'making_friends',
  walking = 'walking'
}

/** Autogenerated return type of AddDiscountToGuest */
export type AddDiscountToGuestPayload = {
  __typename?: 'AddDiscountToGuestPayload';
  guest: Guest;
};

/** Autogenerated return type of AddDogs */
export type AddDogsPayload = {
  __typename?: 'AddDogsPayload';
  dogs: Array<Dog>;
  mealSelectionTypeSwitched: Scalars['Boolean']['output'];
  user: User;
};

export type Address = Node & {
  __typename?: 'Address';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  allowedToChangeToAddress: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  deliverable: Scalars['Boolean']['output'];
  deliveryCarrier?: Maybe<Scalars['String']['output']>;
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  postcode: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  shippingCountry: ShippingCountry;
};


export type AddressallowedToChangeToAddressArgs = {
  newAddress: AddressInput;
};

export type AddressInput = {
  addressLineOne: Scalars['String']['input'];
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  recipientName: Scalars['String']['input'];
  shippingCountryId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminUser = Node & {
  __typename?: 'AdminUser';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum Affiliate {
  ambassador = 'ambassador',
  influencer = 'influencer',
  not_affiliate = 'not_affiliate'
}

export enum AgeClassificationByUserWhenCreated {
  classified_as_adult_by_user_when_created = 'classified_as_adult_by_user_when_created',
  classified_as_puppy_by_user_when_created = 'classified_as_puppy_by_user_when_created',
  classified_as_senior_by_user_when_created = 'classified_as_senior_by_user_when_created',
  unclassified_when_created = 'unclassified_when_created'
}

export type AllVsMixData = {
  __typename?: 'AllVsMixData';
  data: Array<AllVsMixRow>;
  personalData: Array<AllVsMixRow>;
};

export type AllVsMixRow = RepRowDetails & {
  __typename?: 'AllVsMixRow';
  allPercentage: Scalars['Int']['output'];
  allSalesCount: Scalars['Int']['output'];
  dsRepName: Scalars['String']['output'];
  mixSalesCount: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
};

export type Allergen = {
  __typename?: 'Allergen';
  flavours: Array<NewFlavour>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type AmbassadorReferrer = Referrer & {
  __typename?: 'AmbassadorReferrer';
  companyName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  profession: Scalars['String']['output'];
  referralDiscountMessage: Scalars['String']['output'];
};

export type Answer = {
  __typename?: 'Answer';
  id: Scalars['Int']['output'];
  option: Option;
  question: Question;
  value: Scalars['Int']['output'];
};

export type AnswerInput = {
  optionId: Scalars['Int']['input'];
  questionId: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
};

export enum App {
  ds_app = 'ds_app'
}

export type AppVersionToUse = {
  __typename?: 'AppVersionToUse';
  message?: Maybe<Scalars['String']['output']>;
  shouldUpdateVersion: Scalars['Boolean']['output'];
  targetVersion?: Maybe<Scalars['String']['output']>;
};

export type ApplicableDiscount = {
  __typename?: 'ApplicableDiscount';
  applicableDiscountParts: Array<ApplicableDiscountPart>;
  discountBasis: ApplicableDiscountPartDiscountBasis;
  discounts: Array<Discount>;
  value: Scalars['Int']['output'];
};

export type ApplicableDiscountPart = {
  __typename?: 'ApplicableDiscountPart';
  discountBasis: ApplicableDiscountPartDiscountBasis;
  discountType: ApplicableDiscountPartDiscount;
  discounts: Array<Discount>;
  n: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export enum ApplicableDiscountPartDiscount {
  every_nth_box = 'every_nth_box',
  n_boxes = 'n_boxes',
  nth_box = 'nth_box',
  rollover = 'rollover',
  single_use = 'single_use'
}

export enum ApplicableDiscountPartDiscountBasis {
  percentage = 'percentage',
  total = 'total'
}

/** Autogenerated return type of ApplyDiscount */
export type ApplyDiscountPayload = {
  __typename?: 'ApplyDiscountPayload';
  resolutionApplicationConfirmation: CustomerIssueResolutionAcceptanceApplicationConfirmation;
  user: User;
};

export type ApplyDiscounts = CustomerIssueResolutionDetails & {
  __typename?: 'ApplyDiscounts';
  discountCode: DiscountCode;
  type: CustomerIssueResolutionDetailsTypeField;
};

export type Appointment = Node & {
  __typename?: 'Appointment';
  appointmentProduct: AppointmentProduct;
  appointmentReason: AppointmentReason;
  calendlyEventUuid?: Maybe<Scalars['String']['output']>;
  clientImages: Array<Image>;
  clientNotes: Scalars['String']['output'];
  consultationNotes?: Maybe<Scalars['String']['output']>;
  dog: Dog;
  furtherInformation?: Maybe<Scalars['String']['output']>;
  historyNotes?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: NonCoreOrder;
  orderPart: NonCoreOrderPart;
  outcomeNotes?: Maybe<Scalars['String']['output']>;
  petCareProfessional: PetCareProfessional;
  published: Scalars['Boolean']['output'];
  status: AppointmentStatus;
  time?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum AppointmentEnum {
  ten_minute = 'ten_minute',
  thirty_minute = 'thirty_minute'
}

export type AppointmentProduct = Node & {
  __typename?: 'AppointmentProduct';
  appointmentType: AppointmentEnum;
  discountedPrice: Scalars['Int']['output'];
  grossPrice: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  product: Product;
};

export type AppointmentReason = Node & {
  __typename?: 'AppointmentReason';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  petCareProfessional: PetCareProfessional;
};

export enum AppointmentStatus {
  cancelled = 'cancelled',
  confirmed = 'confirmed',
  pending = 'pending',
  pending_cancellation = 'pending_cancellation'
}

export type ApsInBoxOneData = {
  __typename?: 'ApsInBoxOneData';
  data: Array<ApsInBoxOneRow>;
  personalData: Array<ApsInBoxOneRow>;
};

export type ApsInBoxOneRow = RepRowDetails & {
  __typename?: 'ApsInBoxOneRow';
  dsRepName: Scalars['String']['output'];
  extrasPercentage: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
};

/** Autogenerated return type of ArchiveDogs */
export type ArchiveDogsPayload = {
  __typename?: 'ArchiveDogsPayload';
  user: User;
};

/** Autogenerated return type of ArchivePaymentMethod */
export type ArchivePaymentMethodPayload = {
  __typename?: 'ArchivePaymentMethodPayload';
  user: User;
};

export enum ArchivedType {
  all = 'all',
  archived = 'archived',
  non_archived = 'non_archived'
}

export type Authenticatable = {
  __typename?: 'Authenticatable';
  email: Scalars['String']['output'];
};

export type AuthenticationSetup = Node & {
  __typename?: 'AuthenticationSetup';
  id: Scalars['ID']['output'];
  provider: Provider;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  status: AuthenticationSetupStatus;
  token?: Maybe<Scalars['String']['output']>;
  type: AuthenticationType;
};

/** Autogenerated return type of AuthenticationSetupCreate */
export type AuthenticationSetupCreatePayload = {
  __typename?: 'AuthenticationSetupCreatePayload';
  authenticationSetup: AuthenticationSetup;
  user: Guest;
};

export enum AuthenticationSetupStatus {
  canceled = 'canceled',
  failed = 'failed',
  processing = 'processing',
  requires_action = 'requires_action',
  requires_confirmation = 'requires_confirmation',
  requires_payment_method = 'requires_payment_method',
  succeeded = 'succeeded'
}

/** Autogenerated return type of AuthenticationSetupUpdate */
export type AuthenticationSetupUpdatePayload = {
  __typename?: 'AuthenticationSetupUpdatePayload';
  requestStatus: Scalars['String']['output'];
  user: User;
};

export enum AuthenticationStrategy {
  admin = 'admin',
  token = 'token',
  user = 'user'
}

export enum AuthenticationType {
  billing_agreement = 'billing_agreement',
  card = 'card',
  card_present = 'card_present',
  ideal = 'ideal'
}

export enum Availability {
  archived = 'archived',
  available = 'available',
  unavailable = 'unavailable'
}

export enum AvailablePlansScopeType {
  all = 'all',
  duration = 'duration',
  pricing_cohort = 'pricing_cohort'
}

export type AvatarInput = {
  avatar: Scalars['Upload']['input'];
  dogId: Scalars['ID']['input'];
};

export type Banner = {
  __typename?: 'Banner';
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  liveDate: Scalars['ISO8601DateTime']['output'];
  order: Scalars['Int']['output'];
  showAgainAfterXDays?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  template: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Basket = Node & {
  __typename?: 'Basket';
  basketProducts: Array<BasketProduct>;
  discountedPrice: Scalars['Int']['output'];
  grossPrice: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  smallOrderFee: Scalars['Int']['output'];
};

export type BasketProduct = Node & {
  __typename?: 'BasketProduct';
  discountedPrice: Scalars['Int']['output'];
  grossPrice: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
};

/** Autogenerated return type of BasketProductsUpdate */
export type BasketProductsUpdatePayload = {
  __typename?: 'BasketProductsUpdatePayload';
  user: User;
};

export type BillingAgreement = {
  __typename?: 'BillingAgreement';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  paypalEmail?: Maybe<Scalars['String']['output']>;
  type: PaymentMethodable;
};

/** Autogenerated return type of BillingRequestFlowCreate */
export type BillingRequestFlowCreatePayload = {
  __typename?: 'BillingRequestFlowCreatePayload';
  billingRequestFlowId: Scalars['String']['output'];
  billingRequestFlowUrl: Scalars['String']['output'];
  billingRequestId: Scalars['String']['output'];
};

export enum BodyShape {
  chubby = 'chubby',
  just_right = 'just_right',
  skinny = 'skinny'
}

export type BoostedBox = Node & {
  __typename?: 'BoostedBox';
  id: Scalars['ID']['output'];
  /** The delivery fee amount if the box was not boosted */
  nonBoostedDeliveryFeeAmount: Scalars['Int']['output'];
  /**
   * Total boost related savings, this is not the total savings of the box
   * @deprecated Does not represent the total savings of the box, set to return 0
   */
  savingsTotal: Scalars['Int']['output'];
};

export type Box = Boxable & Node & PlanPriceable & {
  __typename?: 'Box';
  address: Address;
  amendable: Scalars['Boolean']['output'];
  boostedBox?: Maybe<BoostedBox>;
  consignment?: Maybe<Consignment>;
  /** @deprecated Field does not match app schema */
  cumulativeDiscount?: Maybe<Discount>;
  cutOffDate: Scalars['ISO8601Date']['output'];
  delayed: Scalars['Boolean']['output'];
  /** @deprecated Migrating to standard encoding - ISO8601Date */
  deliveryDate: Date;
  /** @deprecated Prefer moved_from_undeliverable_delivery_date field */
  deliveryDateAdjustedBySystem: Scalars['Boolean']['output'];
  descriptor: Descriptor;
  discountValue: Scalars['Int']['output'];
  discounts: Array<Discount>;
  durationInDays: Scalars['Int']['output'];
  editable: Scalars['Boolean']['output'];
  full: Scalars['Boolean']['output'];
  hasPreviousOrderIssue: Scalars['Boolean']['output'];
  hoursUntilCutOff: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invoice: Invoice;
  invoices: Array<NewInvoice>;
  isBoosted: Scalars['Boolean']['output'];
  isFreeBox: Scalars['Boolean']['output'];
  isNextEditableBox: Scalars['Boolean']['output'];
  isOneOffBox: Scalars['Boolean']['output'];
  isReplacementBox: Scalars['Boolean']['output'];
  isTrialBox: Scalars['Boolean']['output'];
  isoDeliveryDate: Scalars['ISO8601Date']['output'];
  mealSelectionType: MealSelectionType;
  meals?: Maybe<Array<Meal>>;
  movedFromUndeliverableDeliveryDate: Scalars['Boolean']['output'];
  netPrice: Scalars['Int']['output'];
  numberOfPouches: Scalars['Int']['output'];
  order: Order;
  physicalOrderProducts: Array<OrderProduct>;
  plan: Plan;
  planPricePerDay: Scalars['Int']['output'];
  planPricePerPouch: Scalars['Int']['output'];
  planPriceTotal: Scalars['Int']['output'];
  potentialMissingItems: Array<PotentialMissingItem>;
  potentialMissingProducts: Array<OrderProduct>;
  price: Scalars['Int']['output'];
  productSpacesFree: Scalars['Int']['output'];
  productSpacesUsed: Scalars['Int']['output'];
  /** @deprecated Use consignment field instead */
  scurriConsignment?: Maybe<ScurriConsignment>;
  shippingCountry: ShippingCountry;
  shippingDate: Scalars['ISO8601Date']['output'];
  shouldOfferSelfService: Scalars['Boolean']['output'];
  status: BoxStatus;
  totalGrams: Scalars['Int']['output'];
};

export type BoxInput = {
  address: AddressInput;
  deliveryDate: Scalars['ISO8601Date']['input'];
};

export enum BoxKind {
  all_bb = 'all_bb',
  mix_bb = 'mix_bb'
}

export enum BoxStatus {
  active = 'active',
  skipped = 'skipped',
  void = 'void'
}

export type Boxable = {
  address: Address;
  amendable: Scalars['Boolean']['output'];
  boostedBox?: Maybe<BoostedBox>;
  consignment?: Maybe<Consignment>;
  /** @deprecated Field does not match app schema */
  cumulativeDiscount?: Maybe<Discount>;
  cutOffDate: Scalars['ISO8601Date']['output'];
  delayed: Scalars['Boolean']['output'];
  /** @deprecated Migrating to standard encoding - ISO8601Date */
  deliveryDate: Date;
  /** @deprecated Prefer moved_from_undeliverable_delivery_date field */
  deliveryDateAdjustedBySystem: Scalars['Boolean']['output'];
  descriptor: Descriptor;
  discountValue: Scalars['Int']['output'];
  discounts: Array<Discount>;
  durationInDays: Scalars['Int']['output'];
  editable: Scalars['Boolean']['output'];
  full: Scalars['Boolean']['output'];
  hasPreviousOrderIssue: Scalars['Boolean']['output'];
  hoursUntilCutOff: Scalars['Int']['output'];
  invoice: Invoice;
  invoices: Array<NewInvoice>;
  isBoosted: Scalars['Boolean']['output'];
  isFreeBox: Scalars['Boolean']['output'];
  isNextEditableBox: Scalars['Boolean']['output'];
  isOneOffBox: Scalars['Boolean']['output'];
  isReplacementBox: Scalars['Boolean']['output'];
  isTrialBox: Scalars['Boolean']['output'];
  isoDeliveryDate: Scalars['ISO8601Date']['output'];
  mealSelectionType: MealSelectionType;
  meals?: Maybe<Array<Meal>>;
  movedFromUndeliverableDeliveryDate: Scalars['Boolean']['output'];
  netPrice: Scalars['Int']['output'];
  numberOfPouches: Scalars['Int']['output'];
  order: Order;
  physicalOrderProducts: Array<OrderProduct>;
  plan: Plan;
  potentialMissingItems: Array<PotentialMissingItem>;
  potentialMissingProducts: Array<OrderProduct>;
  price: Scalars['Int']['output'];
  productSpacesFree: Scalars['Int']['output'];
  productSpacesUsed: Scalars['Int']['output'];
  /** @deprecated Use consignment field instead */
  scurriConsignment?: Maybe<ScurriConsignment>;
  shippingCountry: ShippingCountry;
  shippingDate: Scalars['ISO8601Date']['output'];
  shouldOfferSelfService: Scalars['Boolean']['output'];
  status: BoxStatus;
  totalGrams: Scalars['Int']['output'];
};

export enum Brand {
  butternutbox = 'butternutbox',
  psibufet = 'psibufet'
}

export type Breed = Node & {
  __typename?: 'Breed';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  popular: Scalars['Boolean']['output'];
};

export type BundleItem = {
  __typename?: 'BundleItem';
  constituent: ProductVariant;
  quantity: Scalars['Int']['output'];
};

export type CalendarDate = {
  __typename?: 'CalendarDate';
  date: Scalars['ISO8601Date']['output'];
  deliverable: Scalars['Boolean']['output'];
  endOfLeadTime: Scalars['ISO8601DateTime']['output'];
  replacementDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

export type CardAuthenticationSetup = Node & {
  __typename?: 'CardAuthenticationSetup';
  clientSecret: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type Carrier = {
  __typename?: 'Carrier';
  name?: Maybe<Scalars['String']['output']>;
};

export type CarrierService = {
  __typename?: 'CarrierService';
  carrier: Carrier;
  deliveryNotesLimit: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  service: Scalars['String']['output'];
  typeOfDelivery: Scalars['String']['output'];
};

/** Autogenerated return type of CategorySubmission */
export type CategorySubmissionPayload = {
  __typename?: 'CategorySubmissionPayload';
  entryFields: Array<CustomerIssueEntryField>;
  entryId: Scalars['ID']['output'];
  fields: Array<CustomerIssueField>;
  reasons?: Maybe<Array<CustomerIssueReason>>;
  reportId: Scalars['ID']['output'];
  resolutions?: Maybe<Array<CustomerIssueResolution>>;
};

export enum ClientPlatform {
  android = 'android',
  ds_app = 'ds_app',
  ios = 'ios',
  web = 'web'
}

export type ClientReferralLink = {
  __typename?: 'ClientReferralLink';
  pendingReferrals: Array<PendingReferral>;
  referralDiscount: DiscountCode;
  referralDiscountsTotalValue: Scalars['Int']['output'];
  referralLinkTypeName: Scalars['String']['output'];
  referrals: Array<Referral>;
  referrerDiscount?: Maybe<ApplicableDiscount>;
  url: Scalars['String']['output'];
};

export type ClientReferralLinkTypeCopyEntry = {
  __typename?: 'ClientReferralLinkTypeCopyEntry';
  text: Scalars['String']['output'];
};

export type ClientReferrer = Referrer & {
  __typename?: 'ClientReferrer';
  dogsNames: Array<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  referralDiscountMessage: Scalars['String']['output'];
};

export enum Code {
  BE = 'BE',
  CZ = 'CZ',
  DE = 'DE',
  GB = 'GB',
  IE = 'IE',
  NI = 'NI',
  NL = 'NL',
  PL = 'PL'
}

/** Autogenerated return type of CompleteActionCard */
export type CompleteActionCardPayload = {
  __typename?: 'CompleteActionCardPayload';
  actionCard?: Maybe<ActionCard>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type Consignment = {
  __typename?: 'Consignment';
  carrierConsignmentId?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Status>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Constituent = {
  __typename?: 'Constituent';
  name: Scalars['String']['output'];
};

export type ContactInformation = {
  __typename?: 'ContactInformation';
  /** The contact hours for the relevant ShippingCountry eg. Monday to Friday, 10am - 5pm (excluding Bank Holidays). */
  contactHours?: Maybe<Scalars['String']['output']>;
  /** The unformatted contact number for the relevant ShippingCountry eg. +3238080469 */
  contactNumber?: Maybe<Scalars['String']['output']>;
  /** The formatted contact number for the relevant ShippingCountry eg. +32 38 080 469 */
  displayContactNumber?: Maybe<Scalars['String']['output']>;
  /** The formatted WhatsApp number for the relevant ShippingCountry eg. +32 38 080 469 */
  displayWhatsappNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The WhatsApp contact hours for the relevant ShippingCountry eg. Monday to Friday, 10am - 5pm (excluding Bank Holidays). */
  whatsappContactHours?: Maybe<Scalars['String']['output']>;
  /** The unformatted WhatsApp number for the relevant ShippingCountry eg. +3238080469 */
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateMembership */
export type CreateMembershipPayload = {
  __typename?: 'CreateMembershipPayload';
  membership: Membership;
  user: User;
};

/** Autogenerated return type of CreatePendingSubscription */
export type CreatePendingSubscriptionPayload = {
  __typename?: 'CreatePendingSubscriptionPayload';
  pendingSubscription: PendingSubscription;
  user: Guest;
};

export type Credential = {
  __typename?: 'Credential';
  accessToken: Scalars['String']['output'];
  client: Scalars['String']['output'];
  expiry: Scalars['Int']['output'];
  tokenType: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  lastFourDigits: Scalars['String']['output'];
};

export type CreditCardInput = {
  active: Scalars['Boolean']['input'];
  paymentMethodId: Scalars['String']['input'];
};

export type CreditCardPaymentMethod = {
  __typename?: 'CreditCardPaymentMethod';
  active: Scalars['Boolean']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastFourDigits: Scalars['String']['output'];
  type: PaymentMethodable;
};

export enum Currency {
  CZK = 'CZK',
  EUR = 'EUR',
  GBP = 'GBP',
  PLN = 'PLN'
}

export enum CurrentFood {
  dry_food = 'dry_food',
  home_food = 'home_food',
  raw_food = 'raw_food',
  wet_food = 'wet_food'
}

/** A customer issue category */
export type CustomerIssueCategory = Node & {
  __typename?: 'CustomerIssueCategory';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  selfServable?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerIssueEntryField = Node & {
  __typename?: 'CustomerIssueEntryField';
  allowedValues: Array<Scalars['String']['output']>;
  dataType: CustomerIssueEntryFieldData;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
};

export type CustomerIssueEntryFieldAssociation = CustomerIssueField & Node & {
  __typename?: 'CustomerIssueEntryFieldAssociation';
  allowedAssociationValues?: Maybe<Array<CustomerIssueEntryFieldTypesAssociationAllowedValue>>;
  associationDisplayType: CustomerIssueEntryFieldTypesAssociationDisplayType;
  associationType?: Maybe<CustomerIssueEntryFieldTypesAssociationAssociationType>;
  dataType: CustomerIssueEntryFieldData;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueEntryFieldSelectionFormat;
};

export type CustomerIssueEntryFieldBoolean = CustomerIssueField & Node & {
  __typename?: 'CustomerIssueEntryFieldBoolean';
  booleanDisplayType: CustomerIssueEntryFieldTypesBooleanDisplayType;
  dataType: CustomerIssueEntryFieldData;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueEntryFieldSelectionFormat;
};

export enum CustomerIssueEntryFieldData {
  association = 'association',
  boolean = 'boolean',
  integer = 'integer',
  multifield = 'multifield',
  string = 'string'
}

export type CustomerIssueEntryFieldInteger = CustomerIssueField & Node & {
  __typename?: 'CustomerIssueEntryFieldInteger';
  allowedIntegerValues?: Maybe<Array<Scalars['Int']['output']>>;
  dataType: CustomerIssueEntryFieldData;
  id: Scalars['ID']['output'];
  integerDisplayType: CustomerIssueEntryFieldTypesIntegerDisplayType;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueEntryFieldSelectionFormat;
};

export type CustomerIssueEntryFieldMultifield = CustomerIssueField & Node & {
  __typename?: 'CustomerIssueEntryFieldMultifield';
  dataType: CustomerIssueEntryFieldData;
  fields: Array<CustomerIssueField>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  multifieldDisplayType: CustomerIssueEntryFieldTypesMultifieldDisplayType;
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueEntryFieldSelectionFormat;
};

export enum CustomerIssueEntryFieldSelectionFormat {
  multiple = 'multiple',
  not_applicable = 'not_applicable',
  single = 'single'
}

export type CustomerIssueEntryFieldString = CustomerIssueField & Node & {
  __typename?: 'CustomerIssueEntryFieldString';
  allowedStringValues?: Maybe<Array<Scalars['String']['output']>>;
  dataType: CustomerIssueEntryFieldData;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueEntryFieldSelectionFormat;
  stringDisplayType: CustomerIssueEntryFieldTypesStringDisplayType;
};

export type CustomerIssueEntryFieldTypesAssociationAllowedValue = CustomerIssueCategory | Product;

export enum CustomerIssueEntryFieldTypesAssociationAssociationType {
  Product = 'Product'
}

export enum CustomerIssueEntryFieldTypesAssociationDisplayType {
  dropdown = 'dropdown',
  multiselect = 'multiselect'
}

export enum CustomerIssueEntryFieldTypesBooleanDisplayType {
  confirmation_box = 'confirmation_box'
}

export enum CustomerIssueEntryFieldTypesIntegerDisplayType {
  dropdown = 'dropdown',
  numerical_input = 'numerical_input',
  stepper = 'stepper'
}

export enum CustomerIssueEntryFieldTypesMultifieldDisplayType {
  damaged_product = 'damaged_product',
  grouped_list = 'grouped_list',
  multi_product_count = 'multi_product_count',
  product_count = 'product_count',
  unsatisfactory_items = 'unsatisfactory_items'
}

export enum CustomerIssueEntryFieldTypesStringDisplayType {
  checkbox = 'checkbox',
  dropdown = 'dropdown',
  freetext = 'freetext'
}

/** Autogenerated return type of CustomerIssueEntryInputsCreate */
export type CustomerIssueEntryInputsCreatePayload = {
  __typename?: 'CustomerIssueEntryInputsCreatePayload';
  entryId: Scalars['ID']['output'];
  reportId: Scalars['ID']['output'];
  resolutionOffering?: Maybe<CustomerIssueManagementResolutionOffering>;
};

export type CustomerIssueField = {
  dataType: CustomerIssueEntryFieldData;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueEntryFieldSelectionFormat;
};

/** A customer issue category */
export type CustomerIssueManagementCategory = Node & {
  __typename?: 'CustomerIssueManagementCategory';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  presentationalOrder: Scalars['Int']['output'];
};


/** A customer issue category */
export type CustomerIssueManagementCategorypresentationalOrderArgs = {
  reportableType: CustomerIssueManagementReportable;
};

/** A customer issue category reason */
export type CustomerIssueManagementCategoryReason = Node & {
  __typename?: 'CustomerIssueManagementCategoryReason';
  id: Scalars['ID']['output'];
  presentationalOrder: Scalars['Int']['output'];
  reasons: Array<CustomerIssueManagementReason>;
};

/** A customer issue input field */
export type CustomerIssueManagementInputField = {
  dataType: CustomerIssueManagementInputFieldDataType;
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueManagementInputFieldSelectionFormat;
};

/** A customer issue association input field */
export type CustomerIssueManagementInputFieldAssociation = CustomerIssueManagementInputField & Node & {
  __typename?: 'CustomerIssueManagementInputFieldAssociation';
  allowedAssociationValues?: Maybe<Array<CustomerIssueManagementInputFieldAssociationAllowedValue>>;
  associationDisplayType: CustomerIssueManagementInputFieldAssociationDisplayType;
  associationType: CustomerIssueManagementInputFieldAssociationAssociationType;
  dataType: CustomerIssueManagementInputFieldDataType;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueManagementInputFieldSelectionFormat;
};

export type CustomerIssueManagementInputFieldAssociationAllowedValue = Product;

export enum CustomerIssueManagementInputFieldAssociationAssociationType {
  Product = 'Product'
}

export enum CustomerIssueManagementInputFieldAssociationDisplayType {
  dropdown = 'dropdown',
  multiselect = 'multiselect'
}

/** A customer issue boolean input field */
export type CustomerIssueManagementInputFieldBoolean = CustomerIssueManagementInputField & Node & {
  __typename?: 'CustomerIssueManagementInputFieldBoolean';
  booleanDisplayType: CustomerIssueManagementInputFieldBooleanDisplayType;
  dataType: CustomerIssueManagementInputFieldDataType;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueManagementInputFieldSelectionFormat;
};

export enum CustomerIssueManagementInputFieldBooleanDisplayType {
  confirmation_box = 'confirmation_box'
}

export enum CustomerIssueManagementInputFieldDataType {
  association = 'association',
  boolean = 'boolean',
  integer = 'integer',
  multifield = 'multifield',
  string = 'string'
}

/** A customer issue integer input field */
export type CustomerIssueManagementInputFieldInteger = CustomerIssueManagementInputField & Node & {
  __typename?: 'CustomerIssueManagementInputFieldInteger';
  allowedIntegerValues?: Maybe<Array<Scalars['Int']['output']>>;
  dataType: CustomerIssueManagementInputFieldDataType;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integerDisplayType: CustomerIssueManagementInputFieldIntegerDisplayType;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueManagementInputFieldSelectionFormat;
};

export enum CustomerIssueManagementInputFieldIntegerDisplayType {
  dropdown = 'dropdown',
  numerical_input = 'numerical_input',
  stepper = 'stepper'
}

/** A customer issue multifield input field */
export type CustomerIssueManagementInputFieldMultifield = CustomerIssueManagementInputField & Node & {
  __typename?: 'CustomerIssueManagementInputFieldMultifield';
  dataType: CustomerIssueManagementInputFieldDataType;
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<CustomerIssueManagementInputField>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  multifieldDisplayType: CustomerIssueManagementInputFieldMultifieldDisplayType;
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueManagementInputFieldSelectionFormat;
};

export enum CustomerIssueManagementInputFieldMultifieldDisplayType {
  damaged_product = 'damaged_product',
  grouped_list = 'grouped_list',
  multi_product_count = 'multi_product_count',
  product_count = 'product_count',
  unsatisfactory_items = 'unsatisfactory_items'
}

export enum CustomerIssueManagementInputFieldSelectionFormat {
  multiple = 'multiple',
  not_applicable = 'not_applicable',
  single = 'single'
}

/** A customer issue string input field */
export type CustomerIssueManagementInputFieldString = CustomerIssueManagementInputField & Node & {
  __typename?: 'CustomerIssueManagementInputFieldString';
  allowedStringValues?: Maybe<Array<Scalars['String']['output']>>;
  dataType: CustomerIssueManagementInputFieldDataType;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  presentationalOrder: Scalars['Int']['output'];
  selectionFormat: CustomerIssueManagementInputFieldSelectionFormat;
  stringDisplayType: CustomerIssueManagementInputFieldStringDisplayType;
};

export enum CustomerIssueManagementInputFieldStringDisplayType {
  checkbox = 'checkbox',
  dropdown = 'dropdown',
  freetext = 'freetext'
}

export type CustomerIssueManagementInputInput = {
  associationValue?: InputMaybe<Scalars['ID']['input']>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  fieldId: Scalars['ID']['input'];
  inputs?: InputMaybe<Array<CustomerIssueManagementInputInput>>;
  integerValue?: InputMaybe<Scalars['Int']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

/** A customer issue reason */
export type CustomerIssueManagementReason = Node & {
  __typename?: 'CustomerIssueManagementReason';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  presentationalOrder?: Maybe<Scalars['Int']['output']>;
};

export enum CustomerIssueManagementReportable {
  Box = 'Box',
  NonCore_Order = 'NonCore_Order'
}

export enum CustomerIssueManagementReporterable {
  AdminUser = 'AdminUser',
  User = 'User'
}

export type CustomerIssueManagementResolutionApplicationDetails = {
  type: CustomerIssueManagementResolutionResolutionType;
};

/** A customer issue apply discount resolution application details */
export type CustomerIssueManagementResolutionApplicationDetailsApplyDiscount = CustomerIssueManagementResolutionApplicationDetails & {
  __typename?: 'CustomerIssueManagementResolutionApplicationDetailsApplyDiscount';
  resolutionRemnant: ApplicableDiscount;
  type: CustomerIssueManagementResolutionResolutionType;
};

/** A customer issue replace box resolution application details */
export type CustomerIssueManagementResolutionApplicationDetailsReplaceBox = CustomerIssueManagementResolutionApplicationDetails & {
  __typename?: 'CustomerIssueManagementResolutionApplicationDetailsReplaceBox';
  resolutionRemnant: Box;
  type: CustomerIssueManagementResolutionResolutionType;
};

export type CustomerIssueManagementResolutionDetails = {
  type: CustomerIssueManagementResolutionResolutionType;
};

/** A customer issue apply discount resolution details */
export type CustomerIssueManagementResolutionDetailsApplyDiscount = CustomerIssueManagementResolutionDetails & {
  __typename?: 'CustomerIssueManagementResolutionDetailsApplyDiscount';
  discountCode: DiscountCode;
  type: CustomerIssueManagementResolutionResolutionType;
};

/** A customer issue help centre articles resolution details */
export type CustomerIssueManagementResolutionDetailsHelpCentreArticle = CustomerIssueManagementResolutionDetails & {
  __typename?: 'CustomerIssueManagementResolutionDetailsHelpCentreArticle';
  articleId: Scalars['ID']['output'];
  type: CustomerIssueManagementResolutionResolutionType;
};

/** A customer issue replace box resolution details */
export type CustomerIssueManagementResolutionDetailsReplaceBox = CustomerIssueManagementResolutionDetails & {
  __typename?: 'CustomerIssueManagementResolutionDetailsReplaceBox';
  availableDeliveryDates: Array<CalendarDate>;
  defaultAddress: Address;
  type: CustomerIssueManagementResolutionResolutionType;
};

/** A customer issue track order resolution details */
export type CustomerIssueManagementResolutionDetailsTrackOrder = CustomerIssueManagementResolutionDetails & {
  __typename?: 'CustomerIssueManagementResolutionDetailsTrackOrder';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  boxId: Scalars['ID']['output'];
  courierName: Scalars['String']['output'];
  trackingId?: Maybe<Scalars['ID']['output']>;
  trackingUrl: Scalars['String']['output'];
  type: CustomerIssueManagementResolutionResolutionType;
};

/** A customer issue resolution offering */
export type CustomerIssueManagementResolutionOffering = Node & {
  __typename?: 'CustomerIssueManagementResolutionOffering';
  acceptanceStatus: CustomerIssueManagementResolutionOfferingAcceptanceStatus;
  details: CustomerIssueManagementResolutionDetails;
  id: Scalars['ID']['output'];
  resolutionId: Node;
  resolutionType: CustomerIssueManagementResolutionResolutionType;
};

export type CustomerIssueManagementResolutionOfferingAcceptanceDetailsInput = {
  id: Scalars['ID']['input'];
  replaceBox?: InputMaybe<CustomerIssueManagementResolutionOfferingAcceptanceDetailsReplaceBoxInput>;
};

export type CustomerIssueManagementResolutionOfferingAcceptanceDetailsReplaceBoxInput = {
  deliveryAddress: AddressInput;
  deliveryDate: Scalars['ISO8601Date']['input'];
};

export enum CustomerIssueManagementResolutionOfferingAcceptanceStatus {
  accepted = 'accepted',
  pending = 'pending',
  rejected = 'rejected'
}

export type CustomerIssueManagementResolutionOfferingRejectionDetailsInput = {
  id: Scalars['ID']['input'];
};

export enum CustomerIssueManagementResolutionResolutionType {
  apply_discount = 'apply_discount',
  help_centre_article = 'help_centre_article',
  replace_box = 'replace_box',
  track_order = 'track_order'
}

/** A customer issue reason */
export type CustomerIssueReason = {
  __typename?: 'CustomerIssueReason';
  causalArea: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  presentationalOrder: Scalars['Int']['output'];
  requiresInternalConfirmation: Scalars['Boolean']['output'];
  requiresInvestigation: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CustomerIssueReportCreate */
export type CustomerIssueReportCreatePayload = {
  __typename?: 'CustomerIssueReportCreatePayload';
  categoryReasons?: Maybe<Array<CustomerIssueManagementCategoryReason>>;
  entryId: Scalars['ID']['output'];
  inputFields?: Maybe<Array<CustomerIssueManagementInputField>>;
  reportId: Scalars['ID']['output'];
  resolutionOffering?: Maybe<CustomerIssueManagementResolutionOffering>;
};

export type CustomerIssueReportEntryInputInput = {
  associationValue?: InputMaybe<Scalars['ID']['input']>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  entryFieldInputs?: InputMaybe<Array<CustomerIssueReportEntryInputInput>>;
  fieldId: Scalars['ID']['input'];
  integerValue?: InputMaybe<Scalars['Int']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerIssueResolution = {
  __typename?: 'CustomerIssueResolution';
  details: CustomerIssueResolutionDetails;
  key: CustomerIssueResolutionKey;
  requiresAction: Scalars['Boolean']['output'];
  resolutionType: CustomerIssueResolutionResolution;
};

export type CustomerIssueResolutionAcceptanceApplicationConfirmation = {
  type: CustomerIssueResolutionDetailsTypeField;
};

export type CustomerIssueResolutionAcceptanceApplicationConfirmationApplyDiscount = CustomerIssueResolutionAcceptanceApplicationConfirmation & {
  __typename?: 'CustomerIssueResolutionAcceptanceApplicationConfirmationApplyDiscount';
  applicableDiscount: ApplicableDiscount;
  type: CustomerIssueResolutionDetailsTypeField;
};

export type CustomerIssueResolutionAcceptanceApplicationConfirmationReplacementBox = CustomerIssueResolutionAcceptanceApplicationConfirmation & {
  __typename?: 'CustomerIssueResolutionAcceptanceApplicationConfirmationReplacementBox';
  box: Box;
  type: CustomerIssueResolutionDetailsTypeField;
};

export type CustomerIssueResolutionAcceptanceReplacementBoxDetailsInput = {
  deliveryAddress: AddressInput;
  deliveryDate: Scalars['ISO8601Date']['input'];
};

export type CustomerIssueResolutionDetails = {
  type: CustomerIssueResolutionDetailsTypeField;
};

export enum CustomerIssueResolutionDetailsTypeField {
  apply_discount = 'apply_discount',
  order_tracking_number = 'order_tracking_number',
  replace_box = 'replace_box',
  replacement_box_details = 'replacement_box_details',
  track_order = 'track_order'
}

export enum CustomerIssueResolutionKey {
  apply_discount = 'apply_discount',
  replace_box = 'replace_box',
  replacement_box = 'replacement_box',
  track_order = 'track_order'
}

/** Autogenerated return type of CustomerIssueResolutionOfferingAccept */
export type CustomerIssueResolutionOfferingAcceptPayload = {
  __typename?: 'CustomerIssueResolutionOfferingAcceptPayload';
  applicationDetails: CustomerIssueManagementResolutionApplicationDetails;
  user: User;
};

/** Autogenerated return type of CustomerIssueResolutionOfferingReject */
export type CustomerIssueResolutionOfferingRejectPayload = {
  __typename?: 'CustomerIssueResolutionOfferingRejectPayload';
  resolutionOffering: CustomerIssueManagementResolutionOffering;
  user: User;
};

export enum CustomerIssueResolutionResolution {
  invariable = 'invariable',
  variable = 'variable'
}

export type CustomerReview = {
  __typename?: 'CustomerReview';
  author: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
};

export enum Data {
  association = 'association',
  boolean = 'boolean',
  integer = 'integer',
  multifield = 'multifield',
  string = 'string'
}

export type Date = {
  __typename?: 'Date';
  /** @deprecated Do not use this type in favour of ISO8601Date */
  day: Scalars['Int']['output'];
  /** @deprecated Do not use this type in favour of ISO8601Date */
  dayOfWeek: Scalars['String']['output'];
  /** @deprecated Do not use this type in favour of ISO8601Date */
  month: Scalars['Int']['output'];
  /** @deprecated Do not use this type in favour of ISO8601Date */
  year: Scalars['Int']['output'];
};

export enum Delivery {
  ad_hoc = 'ad_hoc',
  regular = 'regular'
}

export type DeliveryArea = {
  __typename?: 'DeliveryArea';
  calendarDates: Array<CalendarDate>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preferredCarrierService: CarrierService;
  regularDeliveryDaysOfWeek: Array<Scalars['Int']['output']>;
};


export type DeliveryAreacalendarDatesArgs = {
  nDays: Scalars['Int']['input'];
  shipmentType?: InputMaybe<Scalars['String']['input']>;
  shouldAttemptToOfferNextDayDelivery: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type DeprecatedDeliveryFee = {
  __typename?: 'DeprecatedDeliveryFee';
  price: Scalars['Int']['output'];
};

export type DescriptionInput = {
  description: Scalars['String']['input'];
  dogId: Scalars['ID']['input'];
};

export enum Descriptor {
  future = 'future',
  next = 'next',
  past = 'past'
}

export type Device = {
  __typename?: 'Device';
  isAndroid: Scalars['Boolean']['output'];
  isIos: Scalars['Boolean']['output'];
  isMobile: Scalars['Boolean']['output'];
  platformName: Scalars['String']['output'];
};

export type DirectSalesEvent = {
  __typename?: 'DirectSalesEvent';
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shippingCountry: ShippingCountry;
  startDate: Scalars['ISO8601DateTime']['output'];
};

export type DirectSalesLeaderboard = {
  __typename?: 'DirectSalesLeaderboard';
  directSalesLeaderboardRows: Array<DirectSalesLeaderboardRow>;
  totalDirectTeamSales?: Maybe<Scalars['Int']['output']>;
};

export type DirectSalesLeaderboardRow = {
  __typename?: 'DirectSalesLeaderboardRow';
  allPlanCount?: Maybe<Scalars['Int']['output']>;
  allPlanPercentage?: Maybe<Scalars['Int']['output']>;
  boxOneCount?: Maybe<Scalars['Int']['output']>;
  boxTwoCount?: Maybe<Scalars['Int']['output']>;
  boxTwoRetention?: Maybe<Scalars['Int']['output']>;
  directSalesId: Scalars['ID']['output'];
  directSalesName?: Maybe<Scalars['String']['output']>;
  directSalesTeamName?: Maybe<Scalars['String']['output']>;
  mixPlanCount?: Maybe<Scalars['Int']['output']>;
  paidApOnBoxOne?: Maybe<Scalars['Int']['output']>;
  salesCount?: Maybe<Scalars['Int']['output']>;
  spsCount?: Maybe<Scalars['Int']['output']>;
  tailmailCount?: Maybe<Scalars['Int']['output']>;
};

export type DirectSalesPendingSubscription = {
  __typename?: 'DirectSalesPendingSubscription';
  address: Address;
  consentedToMarketing: Scalars['Boolean']['output'];
  discountCode?: Maybe<DiscountCode>;
  marketingPreferences: MarketingPreferences;
  pendingSubscription: PendingSubscription;
  phoneNumber: Scalars['String']['output'];
};

export type DirectSalesQrCodeInput = {
  address: AddressInput;
  discountCodeId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  flavourIds: Array<Scalars['ID']['input']>;
  mealBreakdown: MealInput;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  privacyPreferences?: InputMaybe<PrivacyPreferencesInput>;
  productVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  singlePuppyNotBroughtHome?: InputMaybe<Scalars['Boolean']['input']>;
  supportedMarketingMethodPurposeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetFirstDeliveryDate: Scalars['ISO8601Date']['input'];
  user: GuestInput;
};

export type DirectSalesRepresentative = Node & {
  __typename?: 'DirectSalesRepresentative';
  allDiscountCodes: Array<DiscountCode>;
  defaultDiscountCode: DiscountCode;
  defaultLanguage: Language;
  defaultRetrialDiscountCode: DiscountCode;
  directSalesTeam: DirectSalesTeam;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  trackingId: Scalars['String']['output'];
};

/** Autogenerated return type of DirectSalesRepresentativeLogin */
export type DirectSalesRepresentativeLoginPayload = {
  __typename?: 'DirectSalesRepresentativeLoginPayload';
  authenticatable: DirectSalesRepresentative;
  credentials: Credential;
};

/** Autogenerated return type of DirectSalesStripeCustomerCreate */
export type DirectSalesStripeCustomerCreatePayload = {
  __typename?: 'DirectSalesStripeCustomerCreatePayload';
  paymentIntentId: Scalars['String']['output'];
};

/** Autogenerated return type of DirectSalesSubscriptionCreate */
export type DirectSalesSubscriptionCreatePayload = {
  __typename?: 'DirectSalesSubscriptionCreatePayload';
  dsRepTeam: Scalars['String']['output'];
  dsRepTrackingId: Scalars['String']['output'];
  firstDeliveryDate: Scalars['ISO8601Date']['output'];
  firstInvoiceStatus: InvoiceStatus;
  referralLinkUrl: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  userSignInUrl: Scalars['String']['output'];
};

export type DirectSalesTeam = Node & {
  __typename?: 'DirectSalesTeam';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shippingCountry: ShippingCountry;
};

/** Autogenerated return type of DirectSalesTerminalBoxOneCharge */
export type DirectSalesTerminalBoxOneChargePayload = {
  __typename?: 'DirectSalesTerminalBoxOneChargePayload';
  capturedChargeId: Scalars['ID']['output'];
};

/** Autogenerated return type of DisableDeviceForPushNotifications */
export type DisableDeviceForPushNotificationsPayload = {
  __typename?: 'DisableDeviceForPushNotificationsPayload';
  status: Scalars['String']['output'];
  user: User;
};

export type Discount = {
  __typename?: 'Discount';
  applicableDiscountPart?: Maybe<ApplicableDiscountPart>;
  discountBasis: ApplicableDiscountPartDiscountBasis;
  value: Scalars['Int']['output'];
};

export type DiscountCode = Node & {
  __typename?: 'DiscountCode';
  channel?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  discountBasis: DiscountCodePartDiscountBasis;
  discountCodeParts: Array<DiscountCodePart>;
  discountType: DiscountCodePartDiscount;
  id: Scalars['ID']['output'];
  n?: Maybe<Scalars['Int']['output']>;
  referrer?: Maybe<Referrer>;
  shortDiscountCopy?: Maybe<Scalars['String']['output']>;
  value: Scalars['Int']['output'];
};

export type DiscountCodeInput = {
  code: Scalars['String']['input'];
};

export type DiscountCodePart = {
  __typename?: 'DiscountCodePart';
  discountBasis: DiscountCodePartDiscountBasis;
  discountType: DiscountCodePartDiscount;
  n?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Int']['output'];
};

export enum DiscountCodePartDiscount {
  every_nth_box = 'every_nth_box',
  n_boxes = 'n_boxes',
  nth_box = 'nth_box',
  single_use = 'single_use'
}

export enum DiscountCodePartDiscountBasis {
  percentage = 'percentage',
  total = 'total'
}

/** Autogenerated return type of DismissActionCard */
export type DismissActionCardPayload = {
  __typename?: 'DismissActionCardPayload';
  actionCard?: Maybe<ActionCard>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type Dog = Node & {
  __typename?: 'Dog';
  ageClassificationByUserWhenCreated: AgeClassificationByUserWhenCreated;
  ageInMonths: Scalars['Int']['output'];
  allergens: Array<Allergen>;
  appointments: Array<Appointment>;
  bodyShape: BodyShape;
  breed: Breed;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dailyCalories: Scalars['Int']['output'];
  /** Amount in calories of what the plan_portion_in_grams exceeds for their daily_grams */
  dailyCaloriesExceededByPlanPortion: Scalars['Int']['output'];
  /** Percentage of what the plan_portion_in_grams exceeds for their daily_grams */
  dailyCaloriesExceededByPlanPortionInPercentage: Scalars['Int']['output'];
  /** The calorie requirements for the given percentage of nutritional needs not fulfilled by the plan portion */
  dailyCaloriesPercentageUnfulfilledByPlanPortion: Scalars['Int']['output'];
  /** The calorie requirements for all nutritional needs not fulfilled by the plan portion */
  dailyCaloriesUnfulfilledByPlanPortion: Scalars['Int']['output'];
  /** What they need to cover all daily calorie needs (not based on plan). Use plan_portion_in_grams to get portion for this dog based on plan. */
  dailyGrams: Scalars['Int']['output'];
  deliveriesReceived: Scalars['Int']['output'];
  dogProfile?: Maybe<DogProfile>;
  eaterType: Eater;
  exercise: Exercise;
  gender: Gender;
  healthIssues: Array<HealthIssue>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  neutered: Scalars['Boolean']['output'];
  /** The calories fulfilled by the plan portion */
  planPortionInCalories: Scalars['Int']['output'];
  /** Plan portion for dog based on calorie needs */
  planPortionInGrams: Scalars['Int']['output'];
  /** Plan portion for dog based on calorie needs for a specific plan */
  planPortionInGramsForPlan: Scalars['Int']['output'];
  /** Percentage of what the plan_portion_in_grams covers for their daily_grams */
  planPortionInPercentage: Scalars['Int']['output'];
  possessivePronoun?: Maybe<Scalars['String']['output']>;
  pouchSizeInGrams: Scalars['Int']['output'];
  previousFoodTypes: Array<PreviousFood>;
  recommendedCareDetails: RecommendedCareDetails;
  /** The daily calories needed to fulfill all nutritional needs, rounded to the nearest multiple_of */
  roundedDailyCalories: Scalars['Int']['output'];
  /** Amount in calories of what the plan_portion_in_grams exceeds for their daily_grams,rounded to the nearest multiple_of */
  roundedDailyCaloriesExceededByPlanPortion: Scalars['Int']['output'];
  /** Percentage of what the plan_portion_in_grams exceeds for their daily_grams,rounded to the nearest multiple_of */
  roundedDailyCaloriesExceededByPlanPortionInPercentage: Scalars['Int']['output'];
  /** The calorie requirements for the given percentage of nutritional needs not fulfilled by the plan portion, rounded to the nearest multiple_of */
  roundedDailyCaloriesPercentageUnfulfilledByPlanPortion: Scalars['Int']['output'];
  /** The calorie requirements for all nutritional needs not fulfilled by the plan portion, rounded to the nearest multiple_of */
  roundedDailyCaloriesUnfulfilledByPlanPortion: Scalars['Int']['output'];
  /** The daily calories needed to fulfill the given percentage of the nutritional needs, rounded to the nearest multiple_of */
  roundedPercentageOfDailyCalories: Scalars['Int']['output'];
  /** The calories fulfilled by the plan portion, rounded to the nearest multiple_of */
  roundedPlanPortionInCalories: Scalars['Int']['output'];
  /** Percentage of what the plan_portion_in_grams covers for their daily_grams, rounded to the nearest multiple_of */
  roundedPlanPortionInPercentage: Scalars['Int']['output'];
  /** Percentage of what the plan_portion_in_grams covers for their daily_grams and beyondif more than 100%, rounded to the nearest multiple_of */
  roundedUncappedPlanPortionInPercentage: Scalars['Int']['output'];
  snackingHabits: SnackingHabit;
  /** Percentage of what the plan_portion_in_grams covers for their daily_grams and beyondif more than 100% */
  uncappedPlanPortionInPercentage: Scalars['Int']['output'];
  weightInGrams: Scalars['Int']['output'];
};


export type DogappointmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<AppointmentStatus>>;
};


export type DogdailyCaloriesPercentageUnfulfilledByPlanPortionArgs = {
  percentage: Scalars['Int']['input'];
};


export type DogplanPortionInGramsForPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type DogroundedDailyCaloriesArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogroundedDailyCaloriesExceededByPlanPortionArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogroundedDailyCaloriesExceededByPlanPortionInPercentageArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogroundedDailyCaloriesPercentageUnfulfilledByPlanPortionArgs = {
  multipleOf: Scalars['Int']['input'];
  percentage: Scalars['Int']['input'];
};


export type DogroundedDailyCaloriesUnfulfilledByPlanPortionArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogroundedPercentageOfDailyCaloriesArgs = {
  multipleOf: Scalars['Int']['input'];
  percentage: Scalars['Int']['input'];
};


export type DogroundedPlanPortionInCaloriesArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogroundedPlanPortionInPercentageArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogroundedUncappedPlanPortionInPercentageArgs = {
  multipleOf: Scalars['Int']['input'];
};

export type DogActivity = {
  __typename?: 'DogActivity';
  activity: Activity;
};

export type DogInput = {
  ageClassificationByUserWhenCreated: AgeClassificationByUserWhenCreated;
  ageInMonthsWhenLastUpdated: Scalars['Int']['input'];
  allergenIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  archiveReasonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  bodyShape: BodyShape;
  breedId: Scalars['ID']['input'];
  currentFood?: InputMaybe<CurrentFood>;
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  eaterType?: InputMaybe<Eater>;
  exercise: Exercise;
  feedingGuidelinesUsed: FeedingGuidelinesUsed;
  foodCategoryIds: Array<Scalars['ID']['input']>;
  gender: Gender;
  healthIssueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  neutered: Scalars['Boolean']['input'];
  snackingHabits: SnackingHabit;
  weightInGrams: Scalars['Int']['input'];
};

export type DogPersonalityTrait = {
  __typename?: 'DogPersonalityTrait';
  trait: Trait;
};

export type DogPlanPortioning = {
  __typename?: 'DogPlanPortioning';
  /** The number of daily calories that exceed the recommended amount */
  dailyCaloriesExceeded: Scalars['Int']['output'];
  /** The percentage by which daily calories exceed the recommended amount */
  dailyCaloriesExceededPercentage: Scalars['Float']['output'];
  /** The percentage of daily calories that are unfulfilled */
  dailyCaloriesPercentageUnfulfilled: Scalars['Int']['output'];
  /** The number of daily calories that are unfulfilled by the current portion */
  dailyCaloriesUnfulfilled: Scalars['Int']['output'];
  /** The unique identifier of the dog */
  dogId: Scalars['ID']['output'];
  /** The name of the dog */
  name: Scalars['String']['output'];
  /** The daily portion in calories for this dog and plan */
  portionInCalories: Scalars['Int']['output'];
  /** The daily portion in grams for this dog and plan */
  portionInGrams: Scalars['Float']['output'];
  /** The daily portion as a percentage of total plan calories */
  portionInPercentage: Scalars['Float']['output'];
  /** The exceeded daily calories, rounded to the nearest multiple_of */
  roundedDailyCaloriesExceeded: Scalars['Int']['output'];
  /** The percentage of exceeded daily calories, rounded to the nearest multiple_of */
  roundedDailyCaloriesExceededPercentage: Scalars['Float']['output'];
  /** The percentage of unfulfilled daily calories, rounded to the nearest multiple_of */
  roundedDailyCaloriesPercentageUnfulfilled: Scalars['Int']['output'];
  /** The unfulfilled daily calories, rounded to the nearest multiple_of */
  roundedDailyCaloriesUnfulfilled: Scalars['Int']['output'];
  /** The daily portion in calories, rounded to the nearest multiple_of */
  roundedPortionInCalories: Scalars['Int']['output'];
  /** The daily portion percentage, rounded to the nearest multiple_of */
  roundedPortionInPercentage: Scalars['Float']['output'];
  /** The uncapped daily portion percentage, rounded to the nearest multiple_of */
  roundedUncappedPortionInPercentage: Scalars['Float']['output'];
  /** The uncapped daily portion as a percentage of total plan calories */
  uncappedPortionInPercentage: Scalars['Float']['output'];
};


export type DogPlanPortioningdailyCaloriesPercentageUnfulfilledArgs = {
  percentage: Scalars['Int']['input'];
};


export type DogPlanPortioningroundedDailyCaloriesExceededArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogPlanPortioningroundedDailyCaloriesExceededPercentageArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogPlanPortioningroundedDailyCaloriesPercentageUnfulfilledArgs = {
  multipleOf: Scalars['Int']['input'];
  percentage: Scalars['Int']['input'];
};


export type DogPlanPortioningroundedDailyCaloriesUnfulfilledArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogPlanPortioningroundedPortionInCaloriesArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogPlanPortioningroundedPortionInPercentageArgs = {
  multipleOf: Scalars['Int']['input'];
};


export type DogPlanPortioningroundedUncappedPortionInPercentageArgs = {
  multipleOf: Scalars['Int']['input'];
};

export type DogPortion = {
  __typename?: 'DogPortion';
  dogId: Scalars['ID']['output'];
  gramsPerDay: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DogPricing = {
  __typename?: 'DogPricing';
  /** @deprecated Use PlanPricePerDayPerDogType.name on User instead */
  name: Scalars['String']['output'];
  /** @deprecated Use PlanPricePerDayPerDogType.trial_discounted_price_per_day on User instead */
  pricePerDayWithDiscount: Scalars['Int']['output'];
  /** @deprecated Use PlanPricePerDayPerDogType.price_per_day on User instead */
  pricePerDayWithoutDiscount: Scalars['Int']['output'];
};

export type DogProfile = {
  __typename?: 'DogProfile';
  avatarImageAttached: Scalars['Boolean']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogActivities: Array<DogActivity>;
  dogPersonalityTraits: Array<DogPersonalityTrait>;
  favouriteGame?: Maybe<FavouriteGame>;
  id: Scalars['ID']['output'];
};

export type DogUpdateInput = {
  ageInMonthsWhenLastUpdated?: InputMaybe<Scalars['Int']['input']>;
  allergenIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  bodyShape?: InputMaybe<BodyShape>;
  breedKey?: InputMaybe<Key>;
  eaterType?: InputMaybe<Eater>;
  exercise?: InputMaybe<Exercise>;
  gender?: InputMaybe<Gender>;
  healthIssueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  snackingHabits?: InputMaybe<SnackingHabit>;
  weightInGrams?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of DsAppPendingSubscriptionCreate */
export type DsAppPendingSubscriptionCreatePayload = {
  __typename?: 'DsAppPendingSubscriptionCreatePayload';
  token: Scalars['String']['output'];
};

export enum DsLeaderboardTimePeriod {
  all = 'all',
  month = 'month',
  today = 'today',
  week = 'week',
  year = 'year'
}

export enum Eater {
  eats_anything = 'eats_anything',
  fussy_eater = 'fussy_eater',
  good_eater = 'good_eater',
  picky_eater = 'picky_eater'
}

export type EntryInput = {
  fieldId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export enum Exercise {
  hyper = 'hyper',
  low = 'low',
  normal = 'normal'
}

export enum FavouriteGame {
  ball_chaser = 'ball_chaser',
  just_hanging_out = 'just_hanging_out',
  stick_fetcher = 'stick_fetcher',
  toy_squeaker = 'toy_squeaker',
  tug_of_war_master = 'tug_of_war_master',
  unknown_favourite_game = 'unknown_favourite_game'
}

export type FavouriteGameInput = {
  dogId: Scalars['ID']['input'];
  favouriteGame: FavouriteGame;
};

export enum FeedingGuidelinesUsed {
  adult_only_feeding_guidelines = 'adult_only_feeding_guidelines',
  combined_feeding_guidelines = 'combined_feeding_guidelines',
  legacy_feeding_guidelines = 'legacy_feeding_guidelines',
  october2020_feeding_guidelines = 'october2020_feeding_guidelines',
  snack_feeding_guidelines = 'snack_feeding_guidelines'
}

export type Field = Node & {
  __typename?: 'Field';
  allowedValues: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Data;
};

export type FlavourConstituent = {
  __typename?: 'FlavourConstituent';
  constituent: Constituent;
  percentage: Scalars['Int']['output'];
};

export type FlavourPriority = {
  __typename?: 'FlavourPriority';
  priority: Scalars['Int']['output'];
};

export enum Food {
  dry_food = 'dry_food',
  home_food = 'home_food',
  raw_food = 'raw_food',
  wet_food = 'wet_food'
}

export type FoodBrand = Node & {
  __typename?: 'FoodBrand';
  foodBrandRanges: Array<FoodBrandRange>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FoodBrandRange = Node & {
  __typename?: 'FoodBrandRange';
  category: FoodBrandRangeCategory;
  foodBrandRangeVarieties: Array<FoodBrandRangeVariety>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum FoodBrandRangeCategory {
  dry = 'dry',
  home_cooked = 'home_cooked',
  raw = 'raw',
  wet = 'wet'
}

export type FoodBrandRangeVariety = Node & {
  __typename?: 'FoodBrandRangeVariety';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FoodCategory = {
  __typename?: 'FoodCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Use 'id' instead */
  slug: Scalars['String']['output'];
};

export enum FooterColumn {
  column_1 = 'column_1',
  column_2 = 'column_2',
  column_3 = 'column_3',
  social_icons = 'social_icons',
  sub_footer = 'sub_footer'
}

export type FooterLink = {
  __typename?: 'FooterLink';
  availableForStatuses: Array<SubscriptionStatus>;
  footerColumn: FooterColumn;
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  visibleOnlyWhenSignedIn: Scalars['Boolean']['output'];
};

export enum Frequency {
  one_off = 'one_off',
  recurring = 'recurring'
}

export type FunnelGiftCampaign = {
  __typename?: 'FunnelGiftCampaign';
  productVariant: ProductVariant;
};

export enum Gender {
  female = 'female',
  male = 'male'
}

export type GocardlessUserParam = Node & {
  __typename?: 'GocardlessUserParam';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  planId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  userParams: Scalars['String']['output'];
};

/** Autogenerated return type of GocardlessUserParamCreate */
export type GocardlessUserParamCreatePayload = {
  __typename?: 'GocardlessUserParamCreatePayload';
  gocardlessUserParam: GocardlessUserParam;
};

export enum Group {
  admin = 'admin',
  default = 'default',
  deprecated = 'deprecated',
  more_food = 'more_food',
  pouch_portioning = 'pouch_portioning'
}

export type Guest = Node & {
  __typename?: 'Guest';
  affiliateType: Affiliate;
  assumedShippingCountry: ShippingCountry;
  assumedShippingCountryId?: Maybe<Scalars['ID']['output']>;
  discountCode?: Maybe<DiscountCode>;
  dogs: Array<Dog>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  marketingPreference: MarketingPreferences;
  multiplePlansOfferedAsAllPlans?: Maybe<Array<Plan>>;
  multiplePlansOfferedAsMixPlans?: Maybe<Array<Plan>>;
  numberOfAffiliateFreeBoxes: Scalars['Int']['output'];
  pendingSubscription: PendingSubscription;
  pendingSubscriptionOrderPrices: Array<PendingSubscriptionOrderPricing>;
  planPricePerDayPerDog?: Maybe<Array<PlanPricePerDayPerDog>>;
  planRecommendation?: Maybe<PlanRecommendation>;
  preferredLanguage: Language;
  referredByAmbassador?: Maybe<Scalars['Boolean']['output']>;
  referredByInfluencer?: Maybe<Scalars['Boolean']['output']>;
  requiresPaymentDetailsOnCheckout: Scalars['Boolean']['output'];
  shouldSupportSca: Scalars['Boolean']['output'];
  totalDogCalories?: Maybe<Scalars['Int']['output']>;
};


export type GuestpendingSubscriptionOrderPricesArgs = {
  discountCodeId?: InputMaybe<Scalars['ID']['input']>;
  expectedFirstShippingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  flavourQuantities: MealInput;
  mealSelectionType?: InputMaybe<Scalars['String']['input']>;
  oneOffProductsPresent?: InputMaybe<Scalars['Boolean']['input']>;
  planId: Scalars['ID']['input'];
  productVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuestplanPricePerDayPerDogArgs = {
  discountCodePartId?: InputMaybe<Scalars['ID']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of GuestCreateOrUpdate */
export type GuestCreateOrUpdatePayload = {
  __typename?: 'GuestCreateOrUpdatePayload';
  guest: Guest;
};

export type GuestInput = {
  assumedShippingCountryId: Scalars['ID']['input'];
  discountCodeId?: InputMaybe<Scalars['ID']['input']>;
  dogs: Array<DogInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type GuestUserDetailsInput = {
  assumedShippingCountryId?: InputMaybe<Scalars['ID']['input']>;
  discountCodeId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type HealthIssue = {
  __typename?: 'HealthIssue';
  flavours: Array<NewFlavour>;
  id: Scalars['ID']['output'];
  information: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  warning: Scalars['Boolean']['output'];
};

export enum IdealBank {
  abn_amro = 'abn_amro',
  asn_bank = 'asn_bank',
  bunq = 'bunq',
  ing = 'ing',
  knab = 'knab',
  rabobank = 'rabobank',
  regiobank = 'regiobank',
  revolut = 'revolut',
  sns_bank = 'sns_bank',
  triodos_bank = 'triodos_bank',
  van_lanschot = 'van_lanschot',
  yoursafe = 'yoursafe'
}

export type Image = {
  __typename?: 'Image';
  src: Scalars['String']['output'];
};

export type InfluencerSignupPayload = {
  __typename?: 'InfluencerSignupPayload';
  token: Scalars['String']['output'];
};

/** Autogenerated return type of InitiateCustomerCharge */
export type InitiateCustomerChargePayload = {
  __typename?: 'InitiateCustomerChargePayload';
  paymentToken: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export enum InputPaymentMethod {
  billing_agreement = 'billing_agreement',
  credit_card = 'credit_card',
  direct_debit = 'direct_debit',
  merchant_initiated_payment = 'merchant_initiated_payment',
  sepa_direct_debit = 'sepa_direct_debit'
}

/** Autogenerated return type of InstantChargeSetupCreate */
export type InstantChargeSetupCreatePayload = {
  __typename?: 'InstantChargeSetupCreatePayload';
  instantChargeSetupToken: Scalars['String']['output'];
  user: User;
};

export enum IntentType {
  payment_intent = 'payment_intent',
  setup_intent = 'setup_intent'
}

export type Invoice = Node & {
  __typename?: 'Invoice';
  id: Scalars['ID']['output'];
  status: InvoiceStatus;
};

export enum InvoiceStatus {
  disputed = 'disputed',
  forgiven = 'forgiven',
  free = 'free',
  paid = 'paid',
  processing = 'processing',
  unpaid = 'unpaid'
}

export enum Key {
  affenpinscher = 'affenpinscher',
  affenpoo_affenpinscher_poodle_mix = 'affenpoo_affenpinscher_poodle_mix',
  afghan_hound = 'afghan_hound',
  aidi = 'aidi',
  airedale_terrier = 'airedale_terrier',
  airedoodle_airedale_terrier_poodle_mix = 'airedoodle_airedale_terrier_poodle_mix',
  akbash = 'akbash',
  akita = 'akita',
  alano_espanol = 'alano_espanol',
  alapaha_blue_blood_bulldog = 'alapaha_blue_blood_bulldog',
  alaskan_klee_kai = 'alaskan_klee_kai',
  alaskan_malamute = 'alaskan_malamute',
  alaskan_malamute_x_dutch_herder = 'alaskan_malamute_x_dutch_herder',
  alaskan_malamute_x_northern_innuit = 'alaskan_malamute_x_northern_innuit',
  american_akita = 'american_akita',
  american_bulldog = 'american_bulldog',
  american_bully = 'american_bully',
  american_cocker_spaniel = 'american_cocker_spaniel',
  american_cockerpoo = 'american_cockerpoo',
  american_english_coonhound = 'american_english_coonhound',
  american_eskimo_dog = 'american_eskimo_dog',
  american_foxhound = 'american_foxhound',
  american_hairless_terrier = 'american_hairless_terrier',
  american_mastiff = 'american_mastiff',
  american_pit_bull_terrier = 'american_pit_bull_terrier',
  american_shepherd = 'american_shepherd',
  american_staffordshire_terrier = 'american_staffordshire_terrier',
  american_staghound = 'american_staghound',
  american_water_spaniel = 'american_water_spaniel',
  american_white_shepherd = 'american_white_shepherd',
  american_xl_bully = 'american_xl_bully',
  anatolian_karabash = 'anatolian_karabash',
  anatolian_shepherd_dog = 'anatolian_shepherd_dog',
  andalusian_podenco = 'andalusian_podenco',
  appenzeller_sennenhund = 'appenzeller_sennenhund',
  argentine_dogo = 'argentine_dogo',
  ariege_pointer = 'ariege_pointer',
  ariegeois = 'ariegeois',
  aussiedoodle_australian_shepherd_poodle_mix = 'aussiedoodle_australian_shepherd_poodle_mix',
  australian_bulldog = 'australian_bulldog',
  australian_cattle_dog = 'australian_cattle_dog',
  australian_kelpie = 'australian_kelpie',
  australian_labradoodle = 'australian_labradoodle',
  australian_shepherd = 'australian_shepherd',
  australian_silky_terrier = 'australian_silky_terrier',
  australian_stumpy_tail_cattle_dog = 'australian_stumpy_tail_cattle_dog',
  australian_terrier = 'australian_terrier',
  austrian_black_and_tan_hound = 'austrian_black_and_tan_hound',
  austrian_pinscher = 'austrian_pinscher',
  azawakh = 'azawakh',
  barbet = 'barbet',
  basenji = 'basenji',
  bashar = 'bashar',
  basset_bleu_de_gascogne = 'basset_bleu_de_gascogne',
  basset_fauve_de_bretagne = 'basset_fauve_de_bretagne',
  basset_hound = 'basset_hound',
  bassetoodle_basset_hound_poodle_mix = 'bassetoodle_basset_hound_poodle_mix',
  bassugg = 'bassugg',
  bavarian_mountain_hound = 'bavarian_mountain_hound',
  beagle = 'beagle',
  beagle_harrier = 'beagle_harrier',
  beaglier = 'beaglier',
  bearded_collie = 'bearded_collie',
  beardiecockerpoo_bearded_collie_cockerpoo_mix = 'beardiecockerpoo_bearded_collie_cockerpoo_mix',
  beauceron = 'beauceron',
  bedlington_terrier = 'bedlington_terrier',
  belgian_malinois = 'belgian_malinois',
  belgian_sheepdog = 'belgian_sheepdog',
  belgian_shepherd_dog = 'belgian_shepherd_dog',
  belgian_shepherd_laekenois = 'belgian_shepherd_laekenois',
  belgian_shepherd_malinois = 'belgian_shepherd_malinois',
  belgian_shepherd_tervuren = 'belgian_shepherd_tervuren',
  belgian_tervuren = 'belgian_tervuren',
  bergamasco = 'bergamasco',
  berger_picard = 'berger_picard',
  bernedoodle_bernese_mountain_dog_poodle_mix = 'bernedoodle_bernese_mountain_dog_poodle_mix',
  bernese_mountain_dog = 'bernese_mountain_dog',
  bichon_frise = 'bichon_frise',
  bichpoo_bichon_frise_poodle_mix = 'bichpoo_bichon_frise_poodle_mix',
  biewer_terrier = 'biewer_terrier',
  black_and_tan_coonhound = 'black_and_tan_coonhound',
  black_norwegian_elkhound = 'black_norwegian_elkhound',
  black_russian_terrier = 'black_russian_terrier',
  blackmouth_cur = 'blackmouth_cur',
  bloodhound = 'bloodhound',
  blue_lacy = 'blue_lacy',
  blue_merle_collie = 'blue_merle_collie',
  blue_picardy_spaniel = 'blue_picardy_spaniel',
  bluetick_coonhound = 'bluetick_coonhound',
  bocker_beagle_cocker_spaniel_mix = 'bocker_beagle_cocker_spaniel_mix',
  boerboel = 'boerboel',
  bohemian_shepherd = 'bohemian_shepherd',
  bolognese = 'bolognese',
  bolonka = 'bolonka',
  bolonoodle_bolognese_poodle_mix = 'bolonoodle_bolognese_poodle_mix',
  boomer = 'boomer',
  borador = 'borador',
  border_collie = 'border_collie',
  border_terrier = 'border_terrier',
  bordernese_bernese_mountain_dog_x_border_collie = 'bordernese_bernese_mountain_dog_x_border_collie',
  bordoodle_border_collie_poodle_mix = 'bordoodle_border_collie_poodle_mix',
  borzoi = 'borzoi',
  bossipoo_boston_terrier_poodle_mix = 'bossipoo_boston_terrier_poodle_mix',
  boston_terrier = 'boston_terrier',
  bouvier_de_ardennes = 'bouvier_de_ardennes',
  bouvier_des_flandres = 'bouvier_des_flandres',
  boxador = 'boxador',
  boxer = 'boxer',
  boxerdoodle_boxer_poodle_mix = 'boxerdoodle_boxer_poodle_mix',
  boykin_spaniel = 'boykin_spaniel',
  bracco_italiano = 'bracco_italiano',
  braque_dauvergne = 'braque_dauvergne',
  braque_du_bourbonnais = 'braque_du_bourbonnais',
  brazilian_terrier = 'brazilian_terrier',
  briard = 'briard',
  briquet_griffon_vendeen = 'briquet_griffon_vendeen',
  brittany = 'brittany',
  broodle_griffon_brussels_griffon_poodle = 'broodle_griffon_brussels_griffon_poodle',
  brussels_griffon = 'brussels_griffon',
  bukovina_sheepdog = 'bukovina_sheepdog',
  bulgarian_shepherd_dog = 'bulgarian_shepherd_dog',
  bull_greyhound = 'bull_greyhound',
  bull_terrier = 'bull_terrier',
  bulldog = 'bulldog',
  bullmastiff = 'bullmastiff',
  bullpei = 'bullpei',
  cadoodle_collie_x_poodle_mix = 'cadoodle_collie_x_poodle_mix',
  cairn_terrier = 'cairn_terrier',
  cairnoodle_cairn_terrier_poodle_mix = 'cairnoodle_cairn_terrier_poodle_mix',
  canaan_dog = 'canaan_dog',
  canadian_eskimo_dog = 'canadian_eskimo_dog',
  cane_corso = 'cane_corso',
  cao_da_serra_de_aires = 'cao_da_serra_de_aires',
  caravan_hound = 'caravan_hound',
  cardigan_welsh_corgi = 'cardigan_welsh_corgi',
  carolina_dog = 'carolina_dog',
  carpathian_sheepdog = 'carpathian_sheepdog',
  catahoula_bulldog = 'catahoula_bulldog',
  catahoula_cur = 'catahoula_cur',
  catahoula_leopard_dog = 'catahoula_leopard_dog',
  catalan_sheepdog = 'catalan_sheepdog',
  caucasian_ovtcharka = 'caucasian_ovtcharka',
  cavachon = 'cavachon',
  cavalier_king_charles_spaniel = 'cavalier_king_charles_spaniel',
  cavapoo_cavalier_king_charles_spaniel_poodle_mix = 'cavapoo_cavalier_king_charles_spaniel_poodle_mix',
  cavapoochon_cavalier_king_charles_bichon_frise_poodle_mix = 'cavapoochon_cavalier_king_charles_bichon_frise_poodle_mix',
  central_asian_shepherd_dog = 'central_asian_shepherd_dog',
  cesky_fousek = 'cesky_fousek',
  cesky_terrier = 'cesky_terrier',
  chart_polski = 'chart_polski',
  cheagle = 'cheagle',
  chesapeake_bay_retriever = 'chesapeake_bay_retriever',
  chihuahua = 'chihuahua',
  chinese_crested = 'chinese_crested',
  chinese_crestepoo_chinese_crested_poodle_mix = 'chinese_crestepoo_chinese_crested_poodle_mix',
  chinese_sharpei = 'chinese_sharpei',
  chinook = 'chinook',
  chipoo_chihuahua_poodle_mix = 'chipoo_chihuahua_poodle_mix',
  chishi = 'chishi',
  chiweenie = 'chiweenie',
  chorkie = 'chorkie',
  chow_chow = 'chow_chow',
  chug_chihuahua_pug_mix = 'chug_chihuahua_pug_mix',
  cirneco_dell_etna = 'cirneco_dell_etna',
  clumber_spaniel = 'clumber_spaniel',
  clumberdoodle = 'clumberdoodle',
  cockador = 'cockador',
  cockapoo_cocker_spaniel_poodle_mix = 'cockapoo_cocker_spaniel_poodle_mix',
  cocker_spaniel = 'cocker_spaniel',
  cockerchon_cocker_bichon_frise_cross = 'cockerchon_cocker_bichon_frise_cross',
  cockerpei_cocker_spaniel_sharpei_mix = 'cockerpei_cocker_spaniel_sharpei_mix',
  collie = 'collie',
  collie_x_retriever = 'collie_x_retriever',
  corgipoo_corgi_poodle_mix = 'corgipoo_corgi_poodle_mix',
  coton_de_tulear = 'coton_de_tulear',
  croatian_sheepdog = 'croatian_sheepdog',
  crossbreed = 'crossbreed',
  curlycoated_retriever = 'curlycoated_retriever',
  czechoslovakian_shepherd = 'czechoslovakian_shepherd',
  czechoslovakian_wolfdog = 'czechoslovakian_wolfdog',
  dachshund = 'dachshund',
  daisy_dog_bichon_poodle_shih_tzu_mix = 'daisy_dog_bichon_poodle_shih_tzu_mix',
  dalmadoodle_dalmatian_poodle_mix = 'dalmadoodle_dalmatian_poodle_mix',
  dalmatian = 'dalmatian',
  dandie_dinmont_terrier = 'dandie_dinmont_terrier',
  danishswedish_farmdog = 'danishswedish_farmdog',
  deerhound = 'deerhound',
  deutsche_bracke = 'deutsche_bracke',
  doberman_pinscher = 'doberman_pinscher',
  dobermann = 'dobermann',
  dogue_de_bordeaux = 'dogue_de_bordeaux',
  doodleman_pinscher_doberman_standard_poodle_mix = 'doodleman_pinscher_doberman_standard_poodle_mix',
  double_doodle_goldendoodle_labradoodle_mix = 'double_doodle_goldendoodle_labradoodle_mix',
  doxiepoo_dachshund_poodle_mix = 'doxiepoo_dachshund_poodle_mix',
  drentse_patrijshond = 'drentse_patrijshond',
  drever = 'drever',
  dunker = 'dunker',
  dutch_shepherd = 'dutch_shepherd',
  dutch_smoushond = 'dutch_smoushond',
  east_siberian_laika = 'east_siberian_laika',
  easteuropean_shepherd = 'easteuropean_shepherd',
  english_boodle_english_bulldog_poodle_mix = 'english_boodle_english_bulldog_poodle_mix',
  english_bully_english_bull_terrier_staffordshire_bull_terrier = 'english_bully_english_bull_terrier_staffordshire_bull_terrier',
  english_cocker_spaniel = 'english_cocker_spaniel',
  english_coonhound = 'english_coonhound',
  english_foxhound = 'english_foxhound',
  english_mastiff = 'english_mastiff',
  english_pointer = 'english_pointer',
  english_setter = 'english_setter',
  english_shepherd = 'english_shepherd',
  english_springer_spaniel = 'english_springer_spaniel',
  english_toy_spaniel = 'english_toy_spaniel',
  english_toy_terrier = 'english_toy_terrier',
  entlebucher_mountain_dog = 'entlebucher_mountain_dog',
  eskapoo_american_eskimo_dog_poodle_mix = 'eskapoo_american_eskimo_dog_poodle_mix',
  eskimo_dog = 'eskimo_dog',
  estrela_mountain_dog = 'estrela_mountain_dog',
  eurasier = 'eurasier',
  field_spaniel = 'field_spaniel',
  fila_brasileiro = 'fila_brasileiro',
  finnish_hound = 'finnish_hound',
  finnish_lapphund = 'finnish_lapphund',
  finnish_spitz = 'finnish_spitz',
  flandoodle_bouvier_des_flandres_poodle_mix = 'flandoodle_bouvier_des_flandres_poodle_mix',
  flatcoated_retriever = 'flatcoated_retriever',
  foodle_poodle_toy_fox_terrier_mix = 'foodle_poodle_toy_fox_terrier_mix',
  fox_terrier_toy = 'fox_terrier_toy',
  foxhoodle_fox_hound_poodle_mix = 'foxhoodle_fox_hound_poodle_mix',
  francais_blanc_et_noir = 'francais_blanc_et_noir',
  french_brittany = 'french_brittany',
  french_bulldog = 'french_bulldog',
  french_spaniel = 'french_spaniel',
  frug = 'frug',
  gerberian_shepsky_german_shepherd_x_siberian_husky = 'gerberian_shepsky_german_shepherd_x_siberian_husky',
  german_longhaired_pointer = 'german_longhaired_pointer',
  german_pinscher = 'german_pinscher',
  german_shepherd = 'german_shepherd',
  german_shepherd_dog = 'german_shepherd_dog',
  german_sheprador = 'german_sheprador',
  german_short_haired_pointer = 'german_short_haired_pointer',
  german_shorthaired_pointer = 'german_shorthaired_pointer',
  german_spitz = 'german_spitz',
  german_wirehaired_pointer = 'german_wirehaired_pointer',
  giant_schnauzer = 'giant_schnauzer',
  giant_schnoodle_giant_schnauzer_standard_poodle_mix = 'giant_schnoodle_giant_schnauzer_standard_poodle_mix',
  glen_of_imaal_terrier = 'glen_of_imaal_terrier',
  goldador = 'goldador',
  golden_retriever = 'golden_retriever',
  golden_retriever_x_newfoundland = 'golden_retriever_x_newfoundland',
  goldendoodle_golden_retriever_poodle_mix = 'goldendoodle_golden_retriever_poodle_mix',
  gordon_setter = 'gordon_setter',
  grand_basset_griffon_vendeen = 'grand_basset_griffon_vendeen',
  grand_bleu_de_gascogne = 'grand_bleu_de_gascogne',
  great_dane = 'great_dane',
  great_danoodle_great_dane_poodle_mix = 'great_danoodle_great_dane_poodle_mix',
  great_pyrenees = 'great_pyrenees',
  great_swiss_mountain_dog = 'great_swiss_mountain_dog',
  greater_swiss_mountain_dog = 'greater_swiss_mountain_dog',
  greek_harehound = 'greek_harehound',
  greenland_dog = 'greenland_dog',
  greyhound = 'greyhound',
  greyhound_x_saluki = 'greyhound_x_saluki',
  griffon_bleu_du_gascogne = 'griffon_bleu_du_gascogne',
  griffon_bruxellois = 'griffon_bruxellois',
  griffon_nivernais = 'griffon_nivernais',
  groenendael = 'groenendael',
  hamiltonstovare = 'hamiltonstovare',
  harrier = 'harrier',
  havanese = 'havanese',
  hokkaido = 'hokkaido',
  hovawart = 'hovawart',
  hungarian_vizsla = 'hungarian_vizsla',
  hush_basset_cocker_spaniel_x_basset_hound = 'hush_basset_cocker_spaniel_x_basset_hound',
  husky_x_samoyed = 'husky_x_samoyed',
  huskyhungarian_vizsla = 'huskyhungarian_vizsla',
  ibizan_hound = 'ibizan_hound',
  icelandic_sheepdog = 'icelandic_sheepdog',
  imperial_shih_tzu = 'imperial_shih_tzu',
  irish_doodle_irish_setter_poodle_mix = 'irish_doodle_irish_setter_poodle_mix',
  irish_red_and_white_setter = 'irish_red_and_white_setter',
  irish_setter = 'irish_setter',
  irish_terrier = 'irish_terrier',
  irish_troodle_irish_terrier_poodle_mix = 'irish_troodle_irish_terrier_poodle_mix',
  irish_water_spaniel = 'irish_water_spaniel',
  irish_wolfhound = 'irish_wolfhound',
  italian_greyhound = 'italian_greyhound',
  italian_spinone = 'italian_spinone',
  jack_highland_terrier = 'jack_highland_terrier',
  jack_russell_terrier = 'jack_russell_terrier',
  jackabee = 'jackabee',
  jackapoo_jack_russell_terrier_poodle_mix = 'jackapoo_jack_russell_terrier_poodle_mix',
  jackawawa = 'jackawawa',
  jackchi = 'jackchi',
  jagdterrier = 'jagdterrier',
  jamthund_swedish_elkhound = 'jamthund_swedish_elkhound',
  japanese_akita = 'japanese_akita',
  japanese_chin = 'japanese_chin',
  japanese_shiba_inu = 'japanese_shiba_inu',
  japanese_spitz = 'japanese_spitz',
  japanese_terrier = 'japanese_terrier',
  jorkie_yorkshire_terrier_jack_russell_mix = 'jorkie_yorkshire_terrier_jack_russell_mix',
  jug = 'jug',
  karelian_bear_dog = 'karelian_bear_dog',
  keeshond = 'keeshond',
  kerry_blue_terrier = 'kerry_blue_terrier',
  king_charles_spaniel = 'king_charles_spaniel',
  kishu = 'kishu',
  kokoni = 'kokoni',
  komondor = 'komondor',
  kooikerhondje = 'kooikerhondje',
  korean_jindo = 'korean_jindo',
  korthals_griffon = 'korthals_griffon',
  kromfohrlander = 'kromfohrlander',
  kuvasz = 'kuvasz',
  kyileo = 'kyileo',
  labradoodle_labrador_retriever_poodle_mix = 'labradoodle_labrador_retriever_poodle_mix',
  labrador_retriever = 'labrador_retriever',
  labrador_x_spaniel_mix = 'labrador_x_spaniel_mix',
  labrador_x_vizsla_mix = 'labrador_x_vizsla_mix',
  lacasapoo_cockapoo_x_lhasa_apso_mix = 'lacasapoo_cockapoo_x_lhasa_apso_mix',
  lagotto_romagnolo = 'lagotto_romagnolo',
  lakeland_terrier = 'lakeland_terrier',
  lakeland_trailhound = 'lakeland_trailhound',
  lancashire_heeler = 'lancashire_heeler',
  landseer = 'landseer',
  lapponian_herder = 'lapponian_herder',
  large_munsterlander = 'large_munsterlander',
  leonberger = 'leonberger',
  lhasa_apso = 'lhasa_apso',
  lhasa_apso_x_shih_tzu = 'lhasa_apso_x_shih_tzu',
  lhasapoo_lhasa_apso_poodle_mix = 'lhasapoo_lhasa_apso_poodle_mix',
  lhatese_malteselhasa_apso = 'lhatese_malteselhasa_apso',
  lowchen = 'lowchen',
  lurcher = 'lurcher',
  lurcher_x_spaniel = 'lurcher_x_spaniel',
  malshi = 'malshi',
  maltese = 'maltese',
  maltichon = 'maltichon',
  maltipoo_maltese_poodle_mix = 'maltipoo_maltese_poodle_mix',
  manchester_terrier = 'manchester_terrier',
  maremma_sheepdog = 'maremma_sheepdog',
  mastador = 'mastador',
  mastidoodle_mastiff_poodle_mix = 'mastidoodle_mastiff_poodle_mix',
  mastiff = 'mastiff',
  mcnab = 'mcnab',
  miki = 'miki',
  mini_american_shepherd = 'mini_american_shepherd',
  miniature_aussiedoodle_miniature_australian_shepherd_miniature_poodle_mix = 'miniature_aussiedoodle_miniature_australian_shepherd_miniature_poodle_mix',
  miniature_bull_terrier = 'miniature_bull_terrier',
  miniature_dachshund = 'miniature_dachshund',
  miniature_goldendoodle_golden_retriever_toy_or_miniature_poodle_mix = 'miniature_goldendoodle_golden_retriever_toy_or_miniature_poodle_mix',
  miniature_jack_russel_terrier = 'miniature_jack_russel_terrier',
  miniature_labradoodle_labrador_retriever_toy_or_miniature_poodle_mix = 'miniature_labradoodle_labrador_retriever_toy_or_miniature_poodle_mix',
  miniature_pinscher = 'miniature_pinscher',
  miniature_poodle = 'miniature_poodle',
  miniature_schnauzer = 'miniature_schnauzer',
  miniature_yorkshire_terrier = 'miniature_yorkshire_terrier',
  mongrel = 'mongrel',
  morkie = 'morkie',
  mudi = 'mudi',
  neapolitan_mastiff = 'neapolitan_mastiff',
  new_guinea_singing_dog = 'new_guinea_singing_dog',
  new_zealand_huntaway = 'new_zealand_huntaway',
  new_zealand_huntaway_cross = 'new_zealand_huntaway_cross',
  newfoundland = 'newfoundland',
  newfypoo_newfoundland_poodle_mix = 'newfypoo_newfoundland_poodle_mix',
  norfolk_terrier = 'norfolk_terrier',
  norrbottenspets = 'norrbottenspets',
  northern_inuit = 'northern_inuit',
  norwegian_buhund = 'norwegian_buhund',
  norwegian_elkhound = 'norwegian_elkhound',
  norwegian_lundehund = 'norwegian_lundehund',
  norwich_terrier = 'norwich_terrier',
  nova_scotia_duck_tolling_retriever = 'nova_scotia_duck_tolling_retriever',
  old_english_sheepdog = 'old_english_sheepdog',
  olde_english_bulldogge = 'olde_english_bulldogge',
  olde_tyme_bulldog = 'olde_tyme_bulldog',
  other = 'other',
  otterhound = 'otterhound',
  pakistani_mastiff = 'pakistani_mastiff',
  paperanian_papillonpomeranian_mix = 'paperanian_papillonpomeranian_mix',
  papillion = 'papillion',
  papillon = 'papillon',
  papipoo_papillon_poodle_mix = 'papipoo_papillon_poodle_mix',
  parson_jack_russell_terrier = 'parson_jack_russell_terrier',
  parson_russell_terrier = 'parson_russell_terrier',
  patterdale_terrier = 'patterdale_terrier',
  pekepoo_pekingese_poodle_mix = 'pekepoo_pekingese_poodle_mix',
  pekingese = 'pekingese',
  pembroke_welsh_corgi = 'pembroke_welsh_corgi',
  perro_de_presa_canario = 'perro_de_presa_canario',
  perro_de_presa_mallorquin = 'perro_de_presa_mallorquin',
  peruvian_inca_orchid = 'peruvian_inca_orchid',
  petit_basset_griffon_vendeen = 'petit_basset_griffon_vendeen',
  petite_goldendoodle_golden_retriever_cocker_spaniel_poodle_mix = 'petite_goldendoodle_golden_retriever_cocker_spaniel_poodle_mix',
  petite_labradoodle_labrador_retriever_cocker_spaniel_poodle_mix = 'petite_labradoodle_labrador_retriever_cocker_spaniel_poodle_mix',
  pharaoh_hound = 'pharaoh_hound',
  picardy_spaniel = 'picardy_spaniel',
  pinnypoo_miniature_pinscher_poodle_mix = 'pinnypoo_miniature_pinscher_poodle_mix',
  plott = 'plott',
  plott_hound = 'plott_hound',
  plummer_terrier = 'plummer_terrier',
  podenco_canario = 'podenco_canario',
  podenco_maneto = 'podenco_maneto',
  pointer = 'pointer',
  polish_hunting_dog = 'polish_hunting_dog',
  polish_lowland_sheepdog = 'polish_lowland_sheepdog',
  polish_tatra_sheepdog = 'polish_tatra_sheepdog',
  pomapoo_pomeranian_poodle_mix = 'pomapoo_pomeranian_poodle_mix',
  pomchi = 'pomchi',
  pomeranian = 'pomeranian',
  pomsky = 'pomsky',
  pontaudemer_spaniel = 'pontaudemer_spaniel',
  poochin_japanese_chin_poodle_mix = 'poochin_japanese_chin_poodle_mix',
  poodle = 'poodle',
  poogle_beagle_poodle_mix = 'poogle_beagle_poodle_mix',
  poolky_poodle_silky_terrier_mix = 'poolky_poodle_silky_terrier_mix',
  pooshi_poodle_shiba_inu_mix = 'pooshi_poodle_shiba_inu_mix',
  pooshih = 'pooshih',
  pootalian_italian_greyhound_poodle_mix = 'pootalian_italian_greyhound_poodle_mix',
  pooton_coton_de_tulear_poodle_mix = 'pooton_coton_de_tulear_poodle_mix',
  poovanese_havanese_poodle_mix = 'poovanese_havanese_poodle_mix',
  porkie = 'porkie',
  portuguese_podengo = 'portuguese_podengo',
  portuguese_podengo_pequeno = 'portuguese_podengo_pequeno',
  portuguese_pointer = 'portuguese_pointer',
  portuguese_water_dog = 'portuguese_water_dog',
  posavac_hound = 'posavac_hound',
  prazsky_krysarik = 'prazsky_krysarik',
  pudelpointer = 'pudelpointer',
  pug = 'pug',
  pug_x_staffordshire_bull_terrier = 'pug_x_staffordshire_bull_terrier',
  pugalier = 'pugalier',
  pugapoo_pug_poodle_mix = 'pugapoo_pug_poodle_mix',
  puggle = 'puggle',
  puggle_pug_beagle_mix = 'puggle_pug_beagle_mix',
  pugzu = 'pugzu',
  puli = 'puli',
  pumi = 'pumi',
  pyredoodle_great_pyrenees_poodle_mix = 'pyredoodle_great_pyrenees_poodle_mix',
  pyrenean_mastiff = 'pyrenean_mastiff',
  pyrenean_mountain_dog = 'pyrenean_mountain_dog',
  pyrenean_shepherd = 'pyrenean_shepherd',
  rafeiro_do_alentejo = 'rafeiro_do_alentejo',
  rajapalyam = 'rajapalyam',
  rat_terrier = 'rat_terrier',
  ratonero_bodeguero_andaluz = 'ratonero_bodeguero_andaluz',
  rattle_american_rat_terrier_poodle_mix = 'rattle_american_rat_terrier_poodle_mix',
  redbone_coonhound = 'redbone_coonhound',
  rhodesian_ridgeback = 'rhodesian_ridgeback',
  romanian_mioritic_shepherd_dog = 'romanian_mioritic_shepherd_dog',
  rottle_rottweiler_standard_poodle_mix = 'rottle_rottweiler_standard_poodle_mix',
  rottweiler = 'rottweiler',
  rottweiler_x_american_akita = 'rottweiler_x_american_akita',
  rottweiler_x_mastiff = 'rottweiler_x_mastiff',
  rough_collie = 'rough_collie',
  russell_terrier = 'russell_terrier',
  russian_spaniel = 'russian_spaniel',
  russian_toy = 'russian_toy',
  saarloos_wolfdog = 'saarloos_wolfdog',
  saint_berdoodle_saint_bernard_poodle_mix = 'saint_berdoodle_saint_bernard_poodle_mix',
  saint_bernard = 'saint_bernard',
  saluki = 'saluki',
  samoyed = 'samoyed',
  sapsali = 'sapsali',
  sarplaninac = 'sarplaninac',
  schapendoes = 'schapendoes',
  schipperke = 'schipperke',
  schipperpoo_poodle_schipperke_mix = 'schipperpoo_poodle_schipperke_mix',
  schnauzer = 'schnauzer',
  schnoodle = 'schnoodle',
  schnoodle_schnauzer_poodle_mix = 'schnoodle_schnauzer_poodle_mix',
  scoodle_scottish_terrier_poodle_mix = 'scoodle_scottish_terrier_poodle_mix',
  scottish_deerhound = 'scottish_deerhound',
  scottish_terrier = 'scottish_terrier',
  sealyham_terrier = 'sealyham_terrier',
  segugio_italiano = 'segugio_italiano',
  seppala_siberian_sleddog = 'seppala_siberian_sleddog',
  serbian_defence_dog = 'serbian_defence_dog',
  serbian_hound = 'serbian_hound',
  shar_pei = 'shar_pei',
  sharpoo_sharpei_poodle_mix = 'sharpoo_sharpei_poodle_mix',
  sheepadoodle_old_english_sheepdog_standard_poodle_mix = 'sheepadoodle_old_english_sheepdog_standard_poodle_mix',
  sheltidoodle_sheltie_poodle_mix = 'sheltidoodle_sheltie_poodle_mix',
  shepadoodle_german_shepherd_standard_poodle_mix = 'shepadoodle_german_shepherd_standard_poodle_mix',
  shepweiler_rottweiler_germand_shepherd_mix = 'shepweiler_rottweiler_germand_shepherd_mix',
  shetland_sheepdog = 'shetland_sheepdog',
  shiba_inu = 'shiba_inu',
  shichon = 'shichon',
  shih_tzu = 'shih_tzu',
  shih_tzupugchihuahua = 'shih_tzupugchihuahua',
  shih_tzy_poodle = 'shih_tzy_poodle',
  shihpoo = 'shihpoo',
  shihpoo_shih_tzu_poodle_mix = 'shihpoo_shih_tzu_poodle_mix',
  shihpoo_standard = 'shihpoo_standard',
  shikoku = 'shikoku',
  shiloh_shepherd_dog = 'shiloh_shepherd_dog',
  shorkie = 'shorkie',
  siberian_husky = 'siberian_husky',
  siberian_husky_x_norwegian_elkhound = 'siberian_husky_x_norwegian_elkhound',
  siberpoo_siberian_husky_poodle_mix = 'siberpoo_siberian_husky_poodle_mix',
  silken_windhound = 'silken_windhound',
  silky_terrier = 'silky_terrier',
  skye_terrier = 'skye_terrier',
  skypoo_poodle_skye_terrier_mix = 'skypoo_poodle_skye_terrier_mix',
  sloughi = 'sloughi',
  slovakian_rough_haired_pointer = 'slovakian_rough_haired_pointer',
  smaland_hound = 'smaland_hound',
  small_munsterlander = 'small_munsterlander',
  smooth_fox_terrier = 'smooth_fox_terrier',
  smooth_haired_chihuahua = 'smooth_haired_chihuahua',
  soft_coated_wheaten_terrier = 'soft_coated_wheaten_terrier',
  soft_coated_wheaton_terrier = 'soft_coated_wheaton_terrier',
  south_russian_ovcharka = 'south_russian_ovcharka',
  spanish_galgo = 'spanish_galgo',
  spanish_mastiff = 'spanish_mastiff',
  spanish_podenco = 'spanish_podenco',
  spanish_water_dog = 'spanish_water_dog',
  spinone_italiano = 'spinone_italiano',
  sporting_lucas_terrier = 'sporting_lucas_terrier',
  spreagle = 'spreagle',
  springador = 'springador',
  springbatt = 'springbatt',
  springerdoodle_english_springer_spaniel_poodle_mix = 'springerdoodle_english_springer_spaniel_poodle_mix',
  sprocker = 'sprocker',
  sprollie_springer_spaniel_x_border_collie = 'sprollie_springer_spaniel_x_border_collie',
  sprusky_siberian_husky_x_springer_spaniel = 'sprusky_siberian_husky_x_springer_spaniel',
  st_bernard = 'st_bernard',
  stabijhoun = 'stabijhoun',
  staffador = 'staffador',
  staffordshire_bull_terrier = 'staffordshire_bull_terrier',
  staffsky = 'staffsky',
  staffy_x_french_bulldogamerican_bully = 'staffy_x_french_bulldogamerican_bully',
  standard_poodle = 'standard_poodle',
  standard_schnauzer = 'standard_schnauzer',
  standard_schnoodle_poodle_standard_schnauzer_mix = 'standard_schnoodle_poodle_standard_schnauzer_mix',
  sussex_spaniel = 'sussex_spaniel',
  swedish_lapphund = 'swedish_lapphund',
  swedish_valhund = 'swedish_valhund',
  swedish_vallhund = 'swedish_vallhund',
  swiss_shepherd = 'swiss_shepherd',
  tamaskan = 'tamaskan',
  terripoo_australian_terrier_poodle_mix = 'terripoo_australian_terrier_poodle_mix',
  thai_bangkaew = 'thai_bangkaew',
  thai_ridgeback = 'thai_ridgeback',
  tibetan_mastiff = 'tibetan_mastiff',
  tibetan_spaniel = 'tibetan_spaniel',
  tibetan_terrier = 'tibetan_terrier',
  tornjak = 'tornjak',
  tosa_inu = 'tosa_inu',
  toy_fox_terrier = 'toy_fox_terrier',
  toy_poodle = 'toy_poodle',
  transylvanian_hound = 'transylvanian_hound',
  treeing_walker_coonhound = 'treeing_walker_coonhound',
  ttoodle_poodle_tibetan_terrier_mix = 'ttoodle_poodle_tibetan_terrier_mix',
  turkish_kangal_dog = 'turkish_kangal_dog',
  turkish_kangol = 'turkish_kangol',
  utonagan = 'utonagan',
  valley_bulldog = 'valley_bulldog',
  victorian_bulldog = 'victorian_bulldog',
  vizsla = 'vizsla',
  volpino_italiano = 'volpino_italiano',
  weechon_westie_bischon_frise_mix = 'weechon_westie_bischon_frise_mix',
  weimaraner = 'weimaraner',
  weimardoodle_weimaraner_poodle_mix = 'weimardoodle_weimaraner_poodle_mix',
  welsh_corgi = 'welsh_corgi',
  welsh_sheepdog = 'welsh_sheepdog',
  welsh_springer_spaniel = 'welsh_springer_spaniel',
  welsh_terrier = 'welsh_terrier',
  west_highland_schnauzer = 'west_highland_schnauzer',
  west_highland_white_terrier = 'west_highland_white_terrier',
  west_siberian_laika = 'west_siberian_laika',
  westie_x_bedlington_terrier = 'westie_x_bedlington_terrier',
  westiepoo_westie_poodle_mix = 'westiepoo_westie_poodle_mix',
  wetterhoun = 'wetterhoun',
  whippet = 'whippet',
  whippet_x_italian_bloodhound = 'whippet_x_italian_bloodhound',
  whippet_x_poodle = 'whippet_x_poodle',
  white_swiss_shepherd_dog = 'white_swiss_shepherd_dog',
  whoodle_soft_coated_wheaton_terrier_poodle_mix = 'whoodle_soft_coated_wheaton_terrier_poodle_mix',
  wire_fox_terrier = 'wire_fox_terrier',
  wire_haired_dachshund = 'wire_haired_dachshund',
  wirehaired_hungarian_vizsla = 'wirehaired_hungarian_vizsla',
  wirehaired_pointing_griffon = 'wirehaired_pointing_griffon',
  wirepoo_wirehaired_fox_terrier_x_poodle_mix = 'wirepoo_wirehaired_fox_terrier_x_poodle_mix',
  woodle_welsh_terrier_poodle_mix = 'woodle_welsh_terrier_poodle_mix',
  working_cocker_spaniel = 'working_cocker_spaniel',
  xoloitzcuintli = 'xoloitzcuintli',
  yoranian = 'yoranian',
  yorkipoo_yorkie_poodle_mix = 'yorkipoo_yorkie_poodle_mix',
  yorkshire_terrier = 'yorkshire_terrier',
  zuchon = 'zuchon'
}

export enum Label {
  limited_edition = 'limited_edition',
  new = 'new',
  vegetarian = 'vegetarian'
}

export enum Language {
  cs_CZ = 'cs_CZ',
  de_DE = 'de_DE',
  en = 'en',
  fr = 'fr',
  nl = 'nl',
  nl_BE = 'nl_BE',
  pl = 'pl',
  pl_PL = 'pl_PL'
}

export type LeaderboardData = {
  __typename?: 'LeaderboardData';
  allVsMix: AllVsMixData;
  apsInBoxOne: ApsInBoxOneData;
  retention: RetentionData;
  sales: SalesData;
  salesPerShift: SalesPerShiftData;
  tailmail: TailmailData;
};

export type LeaderboardUrls = {
  __typename?: 'LeaderboardUrls';
  dateOption?: Maybe<Scalars['String']['output']>;
  leaderboardName: Scalars['String']['output'];
  team?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** Autogenerated return type of Login */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  authenticatable?: Maybe<User>;
  credentials: Credential;
};

export type MarketingMethod = Node & {
  __typename?: 'MarketingMethod';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum MarketingPreferences {
  /** Consent to receive promotions (deals) only */
  deals_only = 'deals_only',
  /** Full consent to all marketing communications */
  full_consent = 'full_consent',
  /** No consent to any marketing communications */
  no_consent = 'no_consent'
}

export type MarketingPurpose = Node & {
  __typename?: 'MarketingPurpose';
  description: Scalars['String']['output'];
  encouraged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** A GraphQL type representing an instance of the meals table. We therefore make the assumption (in additional_cost) that the MealType is associated with a current_resource that is a Users::Client */
export type Meal = {
  __typename?: 'Meal';
  flavour: NewFlavour;
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Access this information through flavour#product_label */
  label?: Maybe<Label>;
  /** @deprecated Use slug field instead */
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  /**
   * The total extra cost of the current meal element (WRT the quantity)
   * @deprecated Access this information through flavour#recipe_surcharge
   */
  recipeSurcharge?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
};

export type MealInput = {
  beef?: InputMaybe<Scalars['Int']['input']>;
  chicken?: InputMaybe<Scalars['Int']['input']>;
  chickenGrain?: InputMaybe<Scalars['Int']['input']>;
  duckAndChicken?: InputMaybe<Scalars['Int']['input']>;
  game?: InputMaybe<Scalars['Int']['input']>;
  lamb?: InputMaybe<Scalars['Int']['input']>;
  mlBeef?: InputMaybe<Scalars['Int']['input']>;
  mlChicken?: InputMaybe<Scalars['Int']['input']>;
  mlChickenGrain?: InputMaybe<Scalars['Int']['input']>;
  mlDuckAndChicken?: InputMaybe<Scalars['Int']['input']>;
  mlGame?: InputMaybe<Scalars['Int']['input']>;
  mlLamb?: InputMaybe<Scalars['Int']['input']>;
  mlPork?: InputMaybe<Scalars['Int']['input']>;
  mlPorkGrain?: InputMaybe<Scalars['Int']['input']>;
  mlSalmon?: InputMaybe<Scalars['Int']['input']>;
  mlTurkey?: InputMaybe<Scalars['Int']['input']>;
  mlVeggie?: InputMaybe<Scalars['Int']['input']>;
  plBeef?: InputMaybe<Scalars['Int']['input']>;
  plChicken?: InputMaybe<Scalars['Int']['input']>;
  plDuckAndChicken?: InputMaybe<Scalars['Int']['input']>;
  plGame?: InputMaybe<Scalars['Int']['input']>;
  plLamb?: InputMaybe<Scalars['Int']['input']>;
  plPork?: InputMaybe<Scalars['Int']['input']>;
  plSalmon?: InputMaybe<Scalars['Int']['input']>;
  plTurkey?: InputMaybe<Scalars['Int']['input']>;
  plant?: InputMaybe<Scalars['Int']['input']>;
  pork?: InputMaybe<Scalars['Int']['input']>;
  porkGrain?: InputMaybe<Scalars['Int']['input']>;
  salmon?: InputMaybe<Scalars['Int']['input']>;
  turkey?: InputMaybe<Scalars['Int']['input']>;
  veggie?: InputMaybe<Scalars['Int']['input']>;
  venisonWithDuck?: InputMaybe<Scalars['Int']['input']>;
  whiteFish?: InputMaybe<Scalars['Int']['input']>;
};

export enum MealSelectionType {
  adult_mix = 'adult_mix',
  chefs_choice = 'chefs_choice',
  default = 'default',
  high_surcharge = 'high_surcharge',
  high_variety = 'high_variety',
  limited_variety = 'limited_variety',
  low_fat = 'low_fat',
  low_surcharge = 'low_surcharge',
  puppy_mix = 'puppy_mix',
  specialised_diets = 'specialised_diets'
}

export type Membership = {
  __typename?: 'Membership';
  boxAllowance: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  membershipType: MembershipTypes;
  undeliveredMembershipBoxesRemaining: Scalars['Int']['output'];
};

export type MembershipInput = {
  membershipType?: InputMaybe<MembershipTypes>;
};

export enum MembershipTypes {
  boost = 'boost',
  boost_ap_only = 'boost_ap_only'
}

export type MerchantInitiatedPayment = {
  __typename?: 'MerchantInitiatedPayment';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  merchantInitiatedType: Scalars['String']['output'];
  type: PaymentMethodable;
};

export type Mutation = {
  __typename?: 'Mutation';
  activitiesUpdate?: Maybe<Subscription>;
  addDiscountToGuest?: Maybe<AddDiscountToGuestPayload>;
  /** Add additional dogs to an existing user */
  addDogs?: Maybe<AddDogsPayload>;
  addressUpdate?: Maybe<User>;
  appSessionStartedEvent?: Maybe<Subscription>;
  applicableDiscountCreate?: Maybe<Subscription>;
  /** Archives a set of dogs */
  archiveDogs?: Maybe<ArchiveDogsPayload>;
  archivePaymentMethod?: Maybe<ArchivePaymentMethodPayload>;
  /** Create an AuthenticationSetup to support authenticating a payment method */
  authenticationSetupCreate?: Maybe<AuthenticationSetupCreatePayload>;
  /** Update a preexisting AuthenticationSetup */
  authenticationSetupUpdate?: Maybe<AuthenticationSetupUpdatePayload>;
  avatarsUpdate?: Maybe<User>;
  basketProductsUpdate?: Maybe<BasketProductsUpdatePayload>;
  billingRequestFlowCreate?: Maybe<BillingRequestFlowCreatePayload>;
  boxAddressUpdate?: Maybe<User>;
  boxDeliveryDateUpdate?: Maybe<User>;
  cardAuthenticationSetupCreate?: Maybe<CardAuthenticationSetup>;
  completeActionCard?: Maybe<CompleteActionCardPayload>;
  convertToPaid?: Maybe<User>;
  /** Creating a new membership for user */
  createMembership?: Maybe<CreateMembershipPayload>;
  /** Creating a new PendingSubscription for users who are in the plans flow */
  createPendingSubscription?: Maybe<CreatePendingSubscriptionPayload>;
  creditCardsCreate?: Maybe<User>;
  customerIssueCategorySubmission?: Maybe<CategorySubmissionPayload>;
  customerIssueEntryInputsCreate?: Maybe<CustomerIssueEntryInputsCreatePayload>;
  customerIssueReportCreate?: Maybe<CustomerIssueReportCreatePayload>;
  customerIssueReportEntriesSubmission?: Maybe<ReportEntriesSubmissionPayload>;
  customerIssueResolutionAcceptanceApplyDiscount?: Maybe<ApplyDiscountPayload>;
  customerIssueResolutionAcceptanceReplacementBoxSubmission?: Maybe<ReplacementBoxSubmissionPayload>;
  customerIssueResolutionOfferingAccept?: Maybe<CustomerIssueResolutionOfferingAcceptPayload>;
  customerIssueResolutionOfferingReject?: Maybe<CustomerIssueResolutionOfferingRejectPayload>;
  descriptionsUpdate?: Maybe<Subscription>;
  directSalesRepresentativeLogin?: Maybe<DirectSalesRepresentativeLoginPayload>;
  directSalesStripeCustomerCreate?: Maybe<DirectSalesStripeCustomerCreatePayload>;
  /** Create a subscription from DS App */
  directSalesSubscriptionCreate?: Maybe<DirectSalesSubscriptionCreatePayload>;
  /** Create charge to capture later after taking terminal payment */
  directSalesTerminalBoxOneCharge?: Maybe<DirectSalesTerminalBoxOneChargePayload>;
  /** Disables the device for the given token on iterable for the current user */
  disableDeviceForPushNotifications?: Maybe<DisableDeviceForPushNotificationsPayload>;
  dismissActionCard?: Maybe<DismissActionCardPayload>;
  dogProfilesCreate?: Maybe<Subscription>;
  dogsUpdate?: Maybe<User>;
  dsAppPendingSubscriptionCreate?: Maybe<DsAppPendingSubscriptionCreatePayload>;
  editableBoxPricingRecalculate?: Maybe<Subscription>;
  favouriteGamesUpdate?: Maybe<Subscription>;
  gocardlessUserParamCreate?: Maybe<GocardlessUserParamCreatePayload>;
  /** Create or update a Guest */
  guestCreateOrUpdate?: Maybe<GuestCreateOrUpdatePayload>;
  guestUserUpdate?: Maybe<Guest>;
  initiateCustomerCharge?: Maybe<InitiateCustomerChargePayload>;
  instantChargeSetupCreate?: Maybe<InstantChargeSetupCreatePayload>;
  /** Change languages for users and guests */
  languageUpdate?: Maybe<UserUnion>;
  marketingMethodPurposeUpdate?: Maybe<User>;
  mealUpdate?: Maybe<Array<Meal>>;
  nonCoreOrderCreate?: Maybe<NonCoreOrderCreatePayload>;
  oneOffBoxCreate?: Maybe<User>;
  orderIssueReportCreate?: Maybe<User>;
  orderProductsCreate?: Maybe<OrderProductsCreatePayload>;
  orderProductsUpdate?: Maybe<Subscription>;
  pauseFlowStartedEventCreate?: Maybe<Subscription>;
  payOverdueInvoicesAndUnsuspend?: Maybe<PayOverdueInvoicesAndUnsuspendPayload>;
  paymentMethodSetActive?: Maybe<User>;
  paymentMethodsCreate?: Maybe<User>;
  petCareProAppointmentCreate?: Maybe<PetCareProAppointmentCreatePayload>;
  preWizardGuestIterableUpsert?: Maybe<PreWizardGuest>;
  preWizardGuestIterableUpsertWithRecaptcha?: Maybe<PreWizardGuest>;
  rafCodeRequestedWorkflowCreate?: Maybe<RafCodeRequestedWorkflowCreatePayload>;
  recurringOrderProductsUpdate?: Maybe<Subscription>;
  redeemReactivationDiscount?: Maybe<User>;
  referAFriendUpsert?: Maybe<User>;
  /** Registers the given push notification token with iterable for the current user */
  registerForPushNotifications?: Maybe<RegisterForPushNotificationsPayload>;
  removeSurchargedRecipes?: Maybe<RemoveSurchargedRecipesPayload>;
  replacementBoxCreate?: Maybe<User>;
  /** Reactivate a subscription via the Retrial flow */
  retrialSubscriptionReactivation?: Maybe<RetrialSubscriptionReactivationPayload>;
  revolutCreateOrder?: Maybe<RevolutCreateOrderPayload>;
  sendAppSms?: Maybe<SendAppSMSPayload>;
  sendCalendlyCancellation?: Maybe<SendCalendlyCancellationPayload>;
  /** Upsert pending referral info to iterable to trigger a nudge email */
  sendNudgeToPendingReferrals?: Maybe<SendNudgeToPendingReferralsPayload>;
  sendRafSms?: Maybe<SendRafSMSPayload>;
  sendRafSmsFromSoc?: Maybe<SendRafSMSFromSocPayload>;
  signInAuthorisedSubscribedCheckoutUser?: Maybe<SignInAuthorisedSubscribedCheckoutUserPayload>;
  signupInfluencer?: Maybe<SignupPayload>;
  /** Change SMS Delivery Reminder opt in preference */
  smsDeliveryReminderUpdate?: Maybe<User>;
  stripeChargeBoxOneAndSetupPaymentMethod?: Maybe<StripeChargeBoxOneAndSetupPaymentMethodPayload>;
  stripeUserParamsSetupIntentCreate?: Maybe<StripeUserParamsSetupIntentCreatePayload>;
  submitSurveyAnswers?: Maybe<SubmitAnswersPayload>;
  /** Create a subscription */
  subscriptionCreate?: Maybe<SubscriptionCreatePayload>;
  subscriptionNextEditableBoxDeliveryDateUpdate?: Maybe<User>;
  subscriptionPlanUpdate?: Maybe<User>;
  subscriptionResume?: Maybe<User>;
  subscriptionResumeWithDeliveryDate?: Maybe<User>;
  subscriptionResumedEventCreate?: Maybe<Subscription>;
  subscriptionResumedWorkflowCreate?: Maybe<Subscription>;
  subscriptionUnsuspensionAttempt?: Maybe<User>;
  switchSubscriptionToChefsChoice?: Maybe<User>;
  switchSubscriptionToDefault?: Maybe<User>;
  /** Tracks that a push notification was open on Iterable */
  trackPushNotificationOpen?: Maybe<TrackPushNotificationOpenPayload>;
  traitsUpdate?: Maybe<Subscription>;
  userDetailsUpdate?: Maybe<User>;
  userLogin?: Maybe<LoginPayload>;
  userLogout?: Maybe<UserLogoutPayload>;
};


export type MutationactivitiesUpdateArgs = {
  activitiesInput: Array<ActivitiesInput>;
  userId: Scalars['ID']['input'];
};


export type MutationaddDiscountToGuestArgs = {
  code: Scalars['String']['input'];
};


export type MutationaddDogsArgs = {
  dogs: Array<DogInput>;
  triggerWorkflows?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationaddressUpdateArgs = {
  address: AddressInput;
  triggerWorkflows?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationappSessionStartedEventArgs = {
  properties?: InputMaybe<PropertiesInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationapplicableDiscountCreateArgs = {
  code: ValidMutationCode;
  userId: Scalars['ID']['input'];
};


export type MutationarchiveDogsArgs = {
  archiveReason: Scalars['String']['input'];
  dogIds: Array<Scalars['ID']['input']>;
};


export type MutationarchivePaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationauthenticationSetupCreateArgs = {
  authenticationType: Scalars['String']['input'];
  email: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationauthenticationSetupUpdateArgs = {
  authenticationSetupId: Scalars['ID']['input'];
  authenticationType: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  updateType: Scalars['String']['input'];
};


export type MutationavatarsUpdateArgs = {
  avatarsInput: Array<AvatarInput>;
  userId: Scalars['ID']['input'];
};


export type MutationbasketProductsUpdateArgs = {
  basketProductVariants?: InputMaybe<Array<ProductVariantInput>>;
  basketProducts?: InputMaybe<Array<ProductInput>>;
  userId: Scalars['ID']['input'];
};


export type MutationbillingRequestFlowCreateArgs = {
  address: AddressInput;
  email: Scalars['String']['input'];
  existingCustomerId?: InputMaybe<Scalars['String']['input']>;
  exitUrl?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationboxAddressUpdateArgs = {
  address: AddressInput;
  boxId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationboxDeliveryDateUpdateArgs = {
  adjustFutureBoxDates: Scalars['Boolean']['input'];
  boxId: Scalars['ID']['input'];
  date: Scalars['ISO8601Date']['input'];
  deliveryAreaId?: InputMaybe<Scalars['ID']['input']>;
  triggerEvents?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationcompleteActionCardArgs = {
  actionCardId: Scalars['ID']['input'];
};


export type MutationconvertToPaidArgs = {
  creditCard: CreditCardInput;
  userId: Scalars['ID']['input'];
};


export type MutationcreateMembershipArgs = {
  membership: MembershipInput;
};


export type MutationcreatePendingSubscriptionArgs = {
  pendingSubscription: PendingSubscriptionInput;
};


export type MutationcreditCardsCreateArgs = {
  creditCards: Array<CreditCardInput>;
  userId: Scalars['ID']['input'];
};


export type MutationcustomerIssueCategorySubmissionArgs = {
  boxId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationcustomerIssueEntryInputsCreateArgs = {
  entryId: Scalars['ID']['input'];
  inputs?: InputMaybe<Array<CustomerIssueManagementInputInput>>;
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  reporterableId: Scalars['ID']['input'];
  reporterableType: CustomerIssueManagementReporterable;
};


export type MutationcustomerIssueReportCreateArgs = {
  categoryId: Scalars['ID']['input'];
  reportableId: Scalars['ID']['input'];
  reportableType: CustomerIssueManagementReportable;
  reporterableId: Scalars['ID']['input'];
  reporterableType: CustomerIssueManagementReporterable;
};


export type MutationcustomerIssueReportEntriesSubmissionArgs = {
  entryFieldInputs: Array<CustomerIssueReportEntryInputInput>;
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationcustomerIssueResolutionAcceptanceApplyDiscountArgs = {
  reportId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationcustomerIssueResolutionAcceptanceReplacementBoxSubmissionArgs = {
  replacementBoxDetails: CustomerIssueResolutionAcceptanceReplacementBoxDetailsInput;
  reportId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationcustomerIssueResolutionOfferingAcceptArgs = {
  acceptanceDetails: CustomerIssueManagementResolutionOfferingAcceptanceDetailsInput;
};


export type MutationcustomerIssueResolutionOfferingRejectArgs = {
  rejectionDetails: CustomerIssueManagementResolutionOfferingRejectionDetailsInput;
};


export type MutationdescriptionsUpdateArgs = {
  descriptionsInput: Array<DescriptionInput>;
  userId: Scalars['ID']['input'];
};


export type MutationdirectSalesRepresentativeLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationdirectSalesStripeCustomerCreateArgs = {
  amount: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdirectSalesSubscriptionCreateArgs = {
  address: AddressInput;
  chargedOnBoxOne?: InputMaybe<Scalars['Boolean']['input']>;
  discountCodeId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privacyPreferences?: InputMaybe<PrivacyPreferencesInput>;
  singlePuppyNotBroughtHome?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionInput: SubscriptionInput;
  supportedMarketingMethodPurposeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationdirectSalesTerminalBoxOneChargeArgs = {
  amountToCharge: Scalars['Int']['input'];
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationdisableDeviceForPushNotificationsArgs = {
  token: Scalars['String']['input'];
};


export type MutationdismissActionCardArgs = {
  actionCardId: Scalars['ID']['input'];
};


export type MutationdogProfilesCreateArgs = {
  dogIdsInput: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationdogsUpdateArgs = {
  attributes: Array<DogUpdateInput>;
  userId: Scalars['ID']['input'];
};


export type MutationdsAppPendingSubscriptionCreateArgs = {
  qrCodeInput: DirectSalesQrCodeInput;
};


export type MutationeditableBoxPricingRecalculateArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationfavouriteGamesUpdateArgs = {
  favouriteGamesInput: Array<FavouriteGameInput>;
  userId: Scalars['ID']['input'];
};


export type MutationgocardlessUserParamCreateArgs = {
  email: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  userParams: Scalars['String']['input'];
};


export type MutationguestCreateOrUpdateArgs = {
  guest: GuestInput;
};


export type MutationguestUserUpdateArgs = {
  guestUserDetails: GuestUserDetailsInput;
  userId: Scalars['ID']['input'];
};


export type MutationinitiateCustomerChargeArgs = {
  amount: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  paypalPaymentOptions?: InputMaybe<PaypalInitiateChargeInput>;
  provider: Scalars['String']['input'];
  stripePaymentOptions?: InputMaybe<StripeInitiateChargeInput>;
};


export type MutationinstantChargeSetupCreateArgs = {
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationlanguageUpdateArgs = {
  language: Language;
};


export type MutationmarketingMethodPurposeUpdateArgs = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  authenticationStrategy: AuthenticationStrategy;
  encryptionKey?: InputMaybe<Scalars['String']['input']>;
  purposeIds: Array<Scalars['ID']['input']>;
  shaType?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationmealUpdateArgs = {
  meal: MealInput;
  triggerWorkflows?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationnonCoreOrderCreateArgs = {
  deliveryAddress: AddressInput;
  deliveryDate: Scalars['ISO8601Date']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationoneOffBoxCreateArgs = {
  address: AddressInput;
  deliveryDate: Scalars['ISO8601Date']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationorderIssueReportCreateArgs = {
  boxId: Scalars['ID']['input'];
  entries: Array<EntryInput>;
  userId: Scalars['ID']['input'];
};


export type MutationorderProductsCreateArgs = {
  productVariantInput: ProductVariantInput;
  userId: Scalars['ID']['input'];
};


export type MutationorderProductsUpdateArgs = {
  boxId: Scalars['ID']['input'];
  orderProducts: Array<ProductInput>;
  userId: Scalars['ID']['input'];
};


export type MutationpauseFlowStartedEventCreateArgs = {
  properties: Scalars['Boolean']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationpayOverdueInvoicesAndUnsuspendArgs = {
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentResourceId?: InputMaybe<Scalars['String']['input']>;
  paymentResourceType?: InputMaybe<PaymentResourceType>;
  provider: Scalars['String']['input'];
};


export type MutationpaymentMethodSetActiveArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationpaymentMethodsCreateArgs = {
  paymentMethods: Array<PaymentMethodInput>;
  userId: Scalars['ID']['input'];
};


export type MutationpetCareProAppointmentCreateArgs = {
  appointmentProductId: Scalars['ID']['input'];
  appointmentReasonId: Scalars['ID']['input'];
  clientImages?: InputMaybe<Array<Scalars['String']['input']>>;
  clientNotes?: InputMaybe<Scalars['String']['input']>;
  dogId: Scalars['ID']['input'];
  petCareProfessionalId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationpreWizardGuestIterableUpsertArgs = {
  email: Scalars['String']['input'];
};


export type MutationpreWizardGuestIterableUpsertWithRecaptchaArgs = {
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};


export type MutationrafCodeRequestedWorkflowCreateArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationrecurringOrderProductsUpdateArgs = {
  recurringOrderProducts?: InputMaybe<Array<ProductInput>>;
  userId: Scalars['ID']['input'];
};


export type MutationredeemReactivationDiscountArgs = {
  discountCode: DiscountCodeInput;
  userId: Scalars['ID']['input'];
};


export type MutationreferAFriendUpsertArgs = {
  emails: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationregisterForPushNotificationsArgs = {
  application: Scalars['String']['input'];
  platform: PushNotificationPlatform;
  token: Scalars['String']['input'];
};


export type MutationreplacementBoxCreateArgs = {
  boxId: Scalars['ID']['input'];
  boxParams: BoxInput;
  userId: Scalars['ID']['input'];
};


export type MutationretrialSubscriptionReactivationArgs = {
  directSalesRepresentativeId: Scalars['ID']['input'];
  discountCodeId: Scalars['ID']['input'];
  paymentId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
  paymentMethodType: PaymentMethodable;
  paymentProvider: Provider;
  productVariantInputs?: InputMaybe<Array<ProductVariantInput>>;
  targetFirstDeliveryDate: Scalars['ISO8601Date']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationsendAppSmsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationsendCalendlyCancellationArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type MutationsendNudgeToPendingReferralsArgs = {
  email: Scalars['String']['input'];
};


export type MutationsendRafSmsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationsendRafSmsFromSocArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationsignInAuthorisedSubscribedCheckoutUserArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationsignupInfluencerArgs = {
  influencerInput: SignupInfluencerInput;
};


export type MutationsmsDeliveryReminderUpdateArgs = {
  smsDeliveryReminder: Scalars['Boolean']['input'];
};


export type MutationstripeChargeBoxOneAndSetupPaymentMethodArgs = {
  paymentMethodType: Scalars['String']['input'];
};


export type MutationstripeUserParamsSetupIntentCreateArgs = {
  authenticationType: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
  subscriptionData: SubscriptionDataInput;
};


export type MutationsubmitSurveyAnswersArgs = {
  answers: Array<AnswerInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsubscriptionCreateArgs = {
  clientInput: PotentialClientUserInput;
};


export type MutationsubscriptionNextEditableBoxDeliveryDateUpdateArgs = {
  adjustFutureBoxDates: Scalars['Boolean']['input'];
  date: Scalars['ISO8601Date']['input'];
  triggerEvents?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationsubscriptionPlanUpdateArgs = {
  planId: Scalars['ID']['input'];
  triggerWorkflows?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsubscriptionResumeArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsubscriptionResumeWithDeliveryDateArgs = {
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type MutationsubscriptionResumedEventCreateArgs = {
  properties?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsubscriptionResumedWorkflowCreateArgs = {
  properties?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationswitchSubscriptionToChefsChoiceArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationswitchSubscriptionToDefaultArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationtrackPushNotificationOpenArgs = {
  campaignId: Scalars['Int']['input'];
  messageId: Scalars['String']['input'];
};


export type MutationtraitsUpdateArgs = {
  traitsInput: Array<TraitsInput>;
  userId: Scalars['ID']['input'];
};


export type MutationuserDetailsUpdateArgs = {
  userDetails: UserDetailsInput;
  userId: Scalars['ID']['input'];
};


export type MutationuserLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum MutationMessage {
  no_phone_error = 'no_phone_error'
}

export type NewFlavour = {
  __typename?: 'NewFlavour';
  additives: Scalars['String']['output'];
  allergens?: Maybe<Array<Allergen>>;
  composition: Scalars['String']['output'];
  flavourConstituents: Array<FlavourConstituent>;
  flavourPriority: FlavourPriority;
  fussyApproved?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  /** @deprecated Deprecated in favour of images */
  imagesArr: Array<Image>;
  limitedEdition: Scalars['Boolean']['output'];
  longDescription: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primaryImage: Image;
  productBenefits: Array<ProductBenefit>;
  /** @deprecated Warning: `product_label` is deprecated, use `product_labels` instead */
  productLabel?: Maybe<ProductLabel>;
  productLabels?: Maybe<Array<ProductLabel>>;
  recipeSurcharge?: Maybe<Scalars['Int']['output']>;
  recipeSurcharges: Array<RecipeSurcharge>;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  standardPricePerDay: Scalars['Int']['output'];
  storage: Scalars['String']['output'];
  themeColour: Scalars['String']['output'];
  thumbnail: Image;
  tier: Tier;
  tooltip?: Maybe<Scalars['String']['output']>;
};


export type NewFlavouradditivesArgs = {
  includeHtml?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewFlavourcompositionArgs = {
  includeHtml?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewFlavourlongDescriptionArgs = {
  includeHtml?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewFlavourrecipeSurchargeArgs = {
  calculationType?: InputMaybe<RecipeSurchargeCalculation>;
  planId?: InputMaybe<Scalars['ID']['input']>;
};


export type NewFlavourshortDescriptionArgs = {
  includeHtml?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewFlavourstandardPricePerDayArgs = {
  planId: Scalars['ID']['input'];
};


export type NewFlavourstorageArgs = {
  includeHtml?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewFlavourtooltipArgs = {
  includeHtml?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewInvoice = Node & {
  __typename?: 'NewInvoice';
  corrective: Scalars['Boolean']['output'];
  grossTotal: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  issueDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Persisted and retrievable object */
export type Node = {
  id: Scalars['ID']['output'];
};

export type NonCoreInvoice = Node & {
  __typename?: 'NonCoreInvoice';
  discountTotal: Scalars['Int']['output'];
  discountedPrice: Scalars['Int']['output'];
  grossPrice: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  status: NonCoreInvoiceStatus;
};

export enum NonCoreInvoiceStatus {
  failed = 'failed',
  forgiven = 'forgiven',
  free = 'free',
  paid = 'paid',
  pending = 'pending',
  unpaid = 'unpaid'
}

export type NonCoreOrder = Node & {
  __typename?: 'NonCoreOrder';
  address: Address;
  createdAt: Scalars['ISO8601Date']['output'];
  descriptor: Descriptor;
  id: Scalars['ID']['output'];
  invoice: NonCoreInvoice;
  orderParts: Array<NonCoreOrderPart>;
};

/** Autogenerated return type of NonCoreOrderCreate */
export type NonCoreOrderCreatePayload = {
  __typename?: 'NonCoreOrderCreatePayload';
  order: NonCoreOrder;
  user: User;
};

export type NonCoreOrderPart = {
  __typename?: 'NonCoreOrderPart';
  consignment?: Maybe<Consignment>;
  deliveryDate: Scalars['ISO8601Date']['output'];
  deliverySurcharge: Scalars['Int']['output'];
  deliveryType: Delivery;
  orderPartType: OrderPart;
  orderProducts: Array<NonCoreOrderProduct>;
  orderProductsTotal: Scalars['Int']['output'];
  /** @deprecated Use order_products instead */
  orderProductsWithoutFees: Array<NonCoreOrderProduct>;
  physicalOrderProducts: Array<NonCoreOrderProduct>;
  /** @deprecated Use consignment field instead */
  scurriConsignment?: Maybe<ScurriConsignment>;
  shippingDate: Scalars['ISO8601Date']['output'];
  smallOrderSurcharge: Scalars['Int']['output'];
};

export type NonCoreOrderProduct = Node & {
  __typename?: 'NonCoreOrderProduct';
  discountedPrice: Scalars['Int']['output'];
  grossPrice: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
};

export enum NonPaymentReason {
  admin_gift = 'admin_gift',
  churn_treatment = 'churn_treatment',
  free_sample = 'free_sample',
  raf_campaign_gift = 'raf_campaign_gift',
  shopify_purchase = 'shopify_purchase',
  surprise_gift = 'surprise_gift'
}

export type Notification = {
  __typename?: 'Notification';
  altText?: Maybe<Scalars['String']['output']>;
  availableForStatuses: Array<Scalars['String']['output']>;
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  link: Scalars['String']['output'];
  /** @deprecated Column no longer in use */
  linkText?: Maybe<Scalars['String']['output']>;
  liveDate: Scalars['ISO8601DateTime']['output'];
  order: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  shippingCountries: Array<ShippingCountry>;
  /** @deprecated Column no longer in use */
  template?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type Option = {
  __typename?: 'Option';
  goodOption?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Image>;
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  deliveryFee: Scalars['Int']['output'];
  discountTotal?: Maybe<Scalars['Int']['output']>;
  discountTotalPercentage?: Maybe<Scalars['Int']['output']>;
  discountedSubtotalPricePerDay: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  orderProducts: Array<OrderProduct>;
  physicalOrderProducts: Array<OrderProduct>;
  physicalProductsTotal?: Maybe<Scalars['Int']['output']>;
  planTotal: Scalars['Int']['output'];
  planTotalPerDay: Scalars['Int']['output'];
  subtotal?: Maybe<Scalars['Int']['output']>;
  subtotalPricePerDay: Scalars['Int']['output'];
  surchargeTotal: Scalars['Int']['output'];
  totalPrice: Scalars['Int']['output'];
};

/** An order issue category */
export type OrderIssueCategory = {
  fields: Array<Field>;
  /** A non-humanized string */
  name: Scalars['String']['output'];
};

export enum OrderPart {
  advent_calendar = 'advent_calendar',
  care = 'care',
  on_demand_extras = 'on_demand_extras'
}

export type OrderProduct = Node & {
  __typename?: 'OrderProduct';
  discountedPrice: Scalars['Int']['output'];
  frequency: Frequency;
  id: Scalars['ID']['output'];
  nonPaymentReason?: Maybe<NonPaymentReason>;
  price: Scalars['Int']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  requiresPayment: Scalars['Boolean']['output'];
  visibilityScope: VisibilityScope;
};

/** Autogenerated return type of OrderProductsCreate */
export type OrderProductsCreatePayload = {
  __typename?: 'OrderProductsCreatePayload';
  user: User;
};

export type OrderTrackingNumber = CustomerIssueResolutionDetails & {
  __typename?: 'OrderTrackingNumber';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  boxId: Scalars['ID']['output'];
  courierName: Scalars['String']['output'];
  trackingId?: Maybe<Scalars['ID']['output']>;
  trackingUrl: Scalars['String']['output'];
  type: CustomerIssueResolutionDetailsTypeField;
};

/** Allow possible order types */
export type OrderUnion = Box | NonCoreOrder;

export type Pause = {
  __typename?: 'Pause';
  createdAt: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  priceSensitiveTreatments: Array<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  segmentedTreatments: Array<Scalars['String']['output']>;
  subreason?: Maybe<Scalars['String']['output']>;
  treatments: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of PayOverdueInvoicesAndUnsuspend */
export type PayOverdueInvoicesAndUnsuspendPayload = {
  __typename?: 'PayOverdueInvoicesAndUnsuspendPayload';
  user: User;
};

export enum Payment {
  billing_agreement = 'billing_agreement',
  credit_card = 'credit_card',
  direct_debit = 'direct_debit',
  merchant_initiated_payment = 'merchant_initiated_payment',
  sepa_direct_debit = 'sepa_direct_debit'
}

export type PaymentMethod = BillingAgreement | CreditCardPaymentMethod | MerchantInitiatedPayment | SepaDirectDebit;

export type PaymentMethodInput = {
  active: Scalars['Boolean']['input'];
  paymentMethodId: Scalars['String']['input'];
  paymentMethodType: InputPaymentMethod;
  paymentProvider: Provider;
};

export type PaymentMethodSetupMedium = {
  __typename?: 'PaymentMethodSetupMedium';
  inputType: PaymentMethodSetupMediumInputType;
  paymentMethodType: PaymentMethodType;
  provider: Provider;
};

export enum PaymentMethodSetupMediumInputType {
  apple_pay = 'apple_pay',
  bancontact = 'bancontact',
  card_input = 'card_input',
  google_pay = 'google_pay',
  ideal = 'ideal',
  sepa_debit = 'sepa_debit',
  third_party_accept_and_alert = 'third_party_accept_and_alert'
}

export enum PaymentMethodType {
  billing_agreement = 'billing_agreement',
  credit_card = 'credit_card',
  direct_debit = 'direct_debit',
  merchant_initiated_payment = 'merchant_initiated_payment',
  sepa_direct_debit = 'sepa_direct_debit'
}

export enum PaymentMethodable {
  BillingAgreement = 'BillingAgreement',
  CreditCard = 'CreditCard',
  DirectDebit = 'DirectDebit',
  MerchantInitiatedPayment = 'MerchantInitiatedPayment',
  SepaDirectDebit = 'SepaDirectDebit'
}

export enum PaymentResourceType {
  charge = 'charge',
  payment_intent = 'payment_intent'
}

export type PaypalInitiateChargeInput = {
  redirectUrl: Scalars['String']['input'];
};

export type PendingReferral = {
  __typename?: 'PendingReferral';
  email: Scalars['String']['output'];
};

export type PendingSubscription = PlanPriceable & {
  __typename?: 'PendingSubscription';
  firstOrderPricing: PendingSubscriptionOrderPricing;
  id: Scalars['ID']['output'];
  mealSelectionType: Scalars['String']['output'];
  pendingSubscriptionFlavours: Array<PendingSubscriptionFlavour>;
  plan: Plan;
  planPricePerDay: Scalars['Int']['output'];
  planPricePerPouch: Scalars['Int']['output'];
  planPriceTotal: Scalars['Int']['output'];
  productVariants: Array<PendingSubscriptionsProductVariant>;
  secondOrderPricing: PendingSubscriptionOrderPricing;
  standardOrderPricing: PendingSubscriptionOrderPricing;
  thirdOrderPricing: PendingSubscriptionOrderPricing;
  trialDiscountCodePart?: Maybe<DiscountCodePart>;
  user: Guest;
};


export type PendingSubscriptionfirstOrderPricingArgs = {
  expectedFirstShippingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type PendingSubscriptionsecondOrderPricingArgs = {
  expectedFirstShippingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type PendingSubscriptionstandardOrderPricingArgs = {
  expectedFirstShippingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type PendingSubscriptionthirdOrderPricingArgs = {
  expectedFirstShippingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type PendingSubscriptionFlavour = {
  __typename?: 'PendingSubscriptionFlavour';
  flavour: NewFlavour;
  id: Scalars['ID']['output'];
  servings: Scalars['Int']['output'];
  sevenDayServings: Scalars['Int']['output'];
  trialBoxServings: Scalars['Int']['output'];
};

export type PendingSubscriptionInput = {
  flavourIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mealSelectionType?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
  productVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PendingSubscriptionOrderFlavourPricing = {
  __typename?: 'PendingSubscriptionOrderFlavourPricing';
  flavourName: Scalars['String']['output'];
  grossFirstOrderPricePerServing: Scalars['Int']['output'];
  grossStandardOrderPricePerServing: Scalars['Int']['output'];
  netFirstOrderPricePerServing: Scalars['Int']['output'];
  netStandardOrderPricePerServing: Scalars['Int']['output'];
  savedAmountForFirstOrderPerServing: Scalars['Int']['output'];
  savedAmountForStandardOrderPerServing: Scalars['Int']['output'];
  servings: Scalars['Int']['output'];
};

export type PendingSubscriptionOrderPricing = {
  __typename?: 'PendingSubscriptionOrderPricing';
  additionalProductPrices: Array<PendingSubscriptionOrderPricingExtras>;
  additionalProductsDiscountedAmount: Scalars['Int']['output'];
  coreFoodDiscountedAmount: Scalars['Int']['output'];
  deliverySurchargeDiscountedAmount: Scalars['Int']['output'];
  flavourPricings: Array<PendingSubscriptionOrderFlavourPricing>;
  grossAdditionalProductsPrice: Scalars['Int']['output'];
  grossCoreFoodPrice: Scalars['Int']['output'];
  grossCoreFoodPricePerDay: Scalars['Int']['output'];
  grossDeliverySurchargePrice: Scalars['Int']['output'];
  grossOneOffAdditionalProductsPrice: Scalars['Int']['output'];
  grossRecipeSurchargePrice: Scalars['Int']['output'];
  grossTotalPrice: Scalars['Int']['output'];
  grossTotalPricePerDay: Scalars['Int']['output'];
  netAdditionalProductsPrice: Scalars['Int']['output'];
  netCoreFoodPrice: Scalars['Int']['output'];
  netCoreFoodPricePerDay: Scalars['Int']['output'];
  netDeliverySurchargePrice: Scalars['Int']['output'];
  netOneOffAdditionalProductsPrice: Scalars['Int']['output'];
  netRecipeSurchargePrice: Scalars['Int']['output'];
  netTotalPrice: Scalars['Int']['output'];
  netTotalPricePerDay: Scalars['Int']['output'];
  orderNumber: Scalars['Int']['output'];
  recipeSurchargeDiscountedAmount: Scalars['Int']['output'];
  standardOrderCoreFoodGrossPrice: Scalars['Int']['output'];
  standardOrderCoreFoodGrossPricePerDay: Scalars['Int']['output'];
  totalDiscountedAmount: Scalars['Int']['output'];
  totalSavedAmount: Scalars['Int']['output'];
};

export type PendingSubscriptionOrderPricingExtras = {
  __typename?: 'PendingSubscriptionOrderPricingExtras';
  discountedOneOffPrice: Scalars['Int']['output'];
  discountedRecurringPrice: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  oneOffPrice: Scalars['Int']['output'];
  recurringPrice: Scalars['Int']['output'];
};

export type PendingSubscriptionsProductVariant = {
  __typename?: 'PendingSubscriptionsProductVariant';
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  productVariant: ProductVariant;
};

/** Autogenerated return type of PetCareProAppointmentCreate */
export type PetCareProAppointmentCreatePayload = {
  __typename?: 'PetCareProAppointmentCreatePayload';
  appointment: Appointment;
  user: User;
};

export type PetCareProfessional = Node & {
  __typename?: 'PetCareProfessional';
  availability: Availability;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profession: Profession;
  profilePicture: Scalars['String']['output'];
  specialties: Array<Scalars['String']['output']>;
};

export type Plan = Node & {
  __typename?: 'Plan';
  boxKind: BoxKind;
  downsizeablePlan?: Maybe<Plan>;
  durationInDays: Scalars['Int']['output'];
  durationInWeeks: Scalars['Int']['output'];
  /** @deprecated Replaced by `grams_per_day` on PlanServingInformationType */
  gramsPerDay: Scalars['Int']['output'];
  gramsPerDayPerDogs: Array<DogPortion>;
  group: Group;
  id: Scalars['ID']['output'];
  /** Returns the next upcoming price after a given date. Use the PlanPriceable fields for resource pricing */
  nextUpcomingPrice?: Maybe<ProductPrice>;
  numberOfPouches: Scalars['Int']['output'];
  /** @deprecated Replaced by `number_of_servings` on PlanServingInformationType */
  numberOfServings: Scalars['Int']['output'];
  portioningForDogs: Array<DogPlanPortioning>;
  pouchSize: Scalars['Int']['output'];
  pouchesPerDay: Scalars['Float']['output'];
  /** Returns the current price. Use the PlanPriceable fields for resource pricing */
  price: Scalars['Int']['output'];
  /** Returns the current price_per_day. Use the PlanPriceable fields for resource pricing */
  pricePerDay: Scalars['Int']['output'];
  /** Returns the current price_per_pouch. Use the PlanPriceable fields for resource pricing */
  pricePerPouch: Scalars['Int']['output'];
  /** Returns the current price_per_day. Use the PlanPriceable fields for resource pricing */
  pricePerWeek: Scalars['Int']['output'];
  /** @deprecated Field has been moved to user_type - `plan_price_per_day_per_dog`Querying for trial pricing should be handled through the PendingSubscriptionType */
  pricesPerDayPerDogs: Array<DogPricing>;
  pricingCurve: PricingCurve;
  /** @deprecated Replaced by `rounded_calories_per_day` on PlanServingInformationType */
  roundedCaloriesPerDay: Scalars['Int']['output'];
  servingInformation: PlanServingInformation;
  /** @deprecated Replaced by `serving_size` on PlanServingInformationType */
  servingSize: Scalars['Int']['output'];
  /** @deprecated Replaced by `serving_type` on PlanServingInformationType */
  servingType: Serving;
  swappablePlan?: Maybe<Plan>;
  trial: PlanTrial;
  /** @deprecated Pricing for a specific order should not be queried through a Plan */
  trialDiscountedPricePerDay: Scalars['Int']['output'];
  /** @deprecated Replaced by `length_in_days` on PlanTrialType */
  trialLengthInDays: Scalars['Int']['output'];
  /** @deprecated Replaced by `number_of_servings` on PlanTrialType */
  trialNumberOfServings: Scalars['Int']['output'];
  /** @deprecated Replaced by `calorie_fulfillment_categorisation` on UserType */
  typeOfPlanForCustomer: TypeOfPlan;
};


export type PlandownsizeablePlanArgs = {
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlannextUpcomingPriceArgs = {
  effectiveFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlanpriceArgs = {
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlanpricePerDayArgs = {
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlanpricePerPouchArgs = {
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlanpricePerWeekArgs = {
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlanswappablePlanArgs = {
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlanPricePerDayPerDog = {
  __typename?: 'PlanPricePerDayPerDog';
  name: Scalars['String']['output'];
  pricePerDay: Scalars['Int']['output'];
};

/** Fields for resources that implement the PlanPriceable concern */
export type PlanPriceable = {
  planPricePerDay: Scalars['Int']['output'];
  planPricePerPouch: Scalars['Int']['output'];
  planPriceTotal: Scalars['Int']['output'];
};

export type PlanRecommendation = {
  __typename?: 'PlanRecommendation';
  /** @deprecated No longer in use */
  chefsChoiceFlavours: Array<NewFlavour>;
  combinedNotRecommendedFlavours: Array<NewFlavour>;
  combinedOtherFlavours: Array<NewFlavour>;
  combinedRecommendedFlavours: Array<NewFlavour>;
  idealAllPlan?: Maybe<Plan>;
  idealGramsAmount?: Maybe<Scalars['Int']['output']>;
  idealMixPlan?: Maybe<Plan>;
  /** @deprecated Prefer ideal_all_plan */
  idealPlan?: Maybe<Plan>;
  individual: Array<Recommendation>;
  plans?: Maybe<Array<Plan>>;
  /** @deprecated Experiment finished */
  recipeMixExperimentVariant?: Maybe<Scalars['String']['output']>;
  recommendationReasons: Array<RecommendationReason>;
  recommendedExtraProductVariants?: Maybe<Array<ProductVariant>>;
};

export type PlanServingInformation = {
  __typename?: 'PlanServingInformation';
  gramsPerDay: Scalars['Int']['output'];
  numberOfServings: Scalars['Int']['output'];
  pouchesPerServing: Scalars['Float']['output'];
  roundedCaloriesPerDay: Scalars['Int']['output'];
  servingSize: Scalars['Int']['output'];
  servingType: Serving;
};

export type PlanTrial = {
  __typename?: 'PlanTrial';
  lengthInDays: Scalars['Int']['output'];
  numberOfPouches: Scalars['Int']['output'];
  numberOfServings: Scalars['Int']['output'];
  pricePerDay: Scalars['Int']['output'];
};


export type PlanTrialpricePerDayArgs = {
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};

export enum Platform {
  direct_sales = 'direct_sales'
}

export type PotentialClientUserInput = {
  address: AddressInput;
  discountCodeId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privacyPreferences?: InputMaybe<PrivacyPreferencesInput>;
  singlePuppyNotBroughtHome: Scalars['Boolean']['input'];
  subscriptionInput: SubscriptionInput;
  supportedMarketingMethodPurposeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PotentialMissingItem = {
  __typename?: 'PotentialMissingItem';
  category: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  /** @deprecated This is not a valid field */
  productCode: Scalars['String']['output'];
  /** @deprecated Use product_variant#id instead */
  productId: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  /** @deprecated Field not in use */
  size: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  /** @deprecated Field not in use */
  unit: Scalars['String']['output'];
};

export type PreWizardGuest = {
  __typename?: 'PreWizardGuest';
  createdAt: Scalars['ISO8601DateTime']['output'];
  trackingId?: Maybe<Scalars['String']['output']>;
};

export type PreviewBox = Boxable & PlanPriceable & {
  __typename?: 'PreviewBox';
  address: Address;
  amendable: Scalars['Boolean']['output'];
  boostedBox?: Maybe<BoostedBox>;
  consignment?: Maybe<Consignment>;
  /** @deprecated Field does not match app schema */
  cumulativeDiscount?: Maybe<Discount>;
  cutOffDate: Scalars['ISO8601Date']['output'];
  delayed: Scalars['Boolean']['output'];
  /** @deprecated Migrating to standard encoding - ISO8601Date */
  deliveryDate: Date;
  /** @deprecated Prefer moved_from_undeliverable_delivery_date field */
  deliveryDateAdjustedBySystem: Scalars['Boolean']['output'];
  descriptor: Descriptor;
  discountValue: Scalars['Int']['output'];
  discounts: Array<Discount>;
  durationInDays: Scalars['Int']['output'];
  editable: Scalars['Boolean']['output'];
  full: Scalars['Boolean']['output'];
  hasPreviousOrderIssue: Scalars['Boolean']['output'];
  hoursUntilCutOff: Scalars['Int']['output'];
  invoice: Invoice;
  invoices: Array<NewInvoice>;
  isBoosted: Scalars['Boolean']['output'];
  isFreeBox: Scalars['Boolean']['output'];
  isNextEditableBox: Scalars['Boolean']['output'];
  isOneOffBox: Scalars['Boolean']['output'];
  isReplacementBox: Scalars['Boolean']['output'];
  isTrialBox: Scalars['Boolean']['output'];
  isoDeliveryDate: Scalars['ISO8601Date']['output'];
  mealSelectionType: MealSelectionType;
  meals?: Maybe<Array<Meal>>;
  movedFromUndeliverableDeliveryDate: Scalars['Boolean']['output'];
  netPrice: Scalars['Int']['output'];
  numberOfPouches: Scalars['Int']['output'];
  order: Order;
  physicalOrderProducts: Array<OrderProduct>;
  plan: Plan;
  planPricePerDay: Scalars['Int']['output'];
  planPricePerPouch: Scalars['Int']['output'];
  planPriceTotal: Scalars['Int']['output'];
  potentialMissingItems: Array<PotentialMissingItem>;
  potentialMissingProducts: Array<OrderProduct>;
  price: Scalars['Int']['output'];
  productSpacesFree: Scalars['Int']['output'];
  productSpacesUsed: Scalars['Int']['output'];
  /** @deprecated Use consignment field instead */
  scurriConsignment?: Maybe<ScurriConsignment>;
  shippingCountry: ShippingCountry;
  shippingDate: Scalars['ISO8601Date']['output'];
  shouldOfferSelfService: Scalars['Boolean']['output'];
  status: BoxStatus;
  totalGrams: Scalars['Int']['output'];
};

export type PreviousFood = {
  __typename?: 'PreviousFood';
  foodItem: Food;
};

export type PriceAdjustment = {
  __typename?: 'PriceAdjustment';
  operator: PriceAdjustmentOperator;
  value: Scalars['Float']['output'];
};

export enum PriceAdjustmentOperator {
  minus = 'minus',
  multiply = 'multiply'
}

export type PricingCurve = Node & {
  __typename?: 'PricingCurve';
  id: Scalars['ID']['output'];
  pricingCohort: Scalars['String']['output'];
  pricingCurveType: Scalars['String']['output'];
};

export type PrivacyPreferencesInput = {
  consentedToMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  marketingPreferences?: InputMaybe<MarketingPreferences>;
};

export type Product = Node & {
  __typename?: 'Product';
  /** @deprecated Do not use this type */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Do not use this type */
  name: Scalars['String']['output'];
  /** @deprecated Do not use this type */
  price: Scalars['Int']['output'];
  /** @deprecated Do not use this type */
  productCode: Scalars['String']['output'];
  /** @deprecated Do not use this type */
  productCollection?: Maybe<ProductCollection>;
  /** @deprecated Do not use this type */
  shippingCountryCode: Code;
  /** @deprecated Do not use this type */
  sizeDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Do not use this type */
  volumeWeight: Scalars['Float']['output'];
};

export type ProductBenefit = {
  __typename?: 'ProductBenefit';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
  /** @deprecated Use 'id' instead */
  slug: Scalars['String']['output'];
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  about: Scalars['String']['output'];
  allergens?: Maybe<Array<Allergen>>;
  averageCustomerRating?: Maybe<Scalars['Float']['output']>;
  badge?: Maybe<Scalars['String']['output']>;
  countOfCustomerRatings: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  discount?: Maybe<Discount>;
  /** @deprecated Use discount field instead */
  discountCodeParts: Array<DiscountCodePart>;
  healthIssues?: Maybe<Array<HealthIssue>>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  merchandisingImage: Image;
  name: Scalars['String']['output'];
  primaryImage?: Maybe<Image>;
  productBenefits: Array<ProductBenefit>;
  productLabel?: Maybe<ProductLabel>;
  productSticker?: Maybe<ProductSticker>;
  productVariants: Array<ProductVariant>;
  publicCustomerReviews: Array<CustomerReview>;
  singleProductImage?: Maybe<Image>;
  sizeGuide?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  thumbnail: Image;
  unavailableObject?: Maybe<UnavailableObject>;
};

export type ProductGroup = {
  __typename?: 'ProductGroup';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  productCollections: Array<ProductCollection>;
  slug: Scalars['String']['output'];
  themeColour: Scalars['ThemeColour']['output'];
  thumbnail: Image;
};

export type ProductInput = {
  productId?: InputMaybe<Scalars['ID']['input']>;
  productVariantId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  requiresPayment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductLabel = {
  __typename?: 'ProductLabel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  themeColour: Scalars['String']['output'];
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  effectiveFrom: Scalars['ISO8601Date']['output'];
  shippingCountry: ShippingCountry;
  value: Scalars['Int']['output'];
};

export type ProductSticker = {
  __typename?: 'ProductSticker';
  id: Scalars['ID']['output'];
  image: Image;
  /** @deprecated Use 'id' instead */
  slug: Scalars['String']['output'];
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  associatedBundles?: Maybe<Array<ProductVariant>>;
  bundleItems?: Maybe<Array<BundleItem>>;
  constituents: Array<ProductVariant>;
  /** In almost all cases you probably want productVariantDeliveryTypes#netPrice. Ensure that what you want is actually this field */
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  grossPrice: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  onDemandDeliveryType?: Maybe<ProductVariantDeliveryType>;
  oneOffDeliveryType?: Maybe<ProductVariantDeliveryType>;
  /** @deprecated Use grossPrice that will return the correct currency for the requester */
  prices: Array<ProductPrice>;
  productCollection: ProductCollection;
  productVariantDeliveryTypes: Array<ProductVariantDeliveryType>;
  recurringDeliveryType?: Maybe<ProductVariantDeliveryType>;
  slug: Scalars['String']['output'];
  subscribeAndSaveable: Scalars['Boolean']['output'];
  unavailableObject?: Maybe<UnavailableObject>;
};

export type ProductVariantDeliveryType = {
  __typename?: 'ProductVariantDeliveryType';
  adjustedGrossPrice: Scalars['Int']['output'];
  boostedNetPrice?: Maybe<Scalars['Int']['output']>;
  deliveryType: VariantDelivery;
  netPrice: Scalars['Int']['output'];
  priceAdjustment?: Maybe<PriceAdjustment>;
};

export type ProductVariantInput = {
  deliveryType: VariantDelivery;
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export enum Profession {
  vet_nurse = 'vet_nurse'
}

export type PropertiesInput = {
  appVersion: Scalars['String']['input'];
  deviceType: Scalars['String']['input'];
  sessionStartedFrom: Scalars['String']['input'];
};

export enum Provider {
  gocardless = 'gocardless',
  paypal = 'paypal',
  revolut = 'revolut',
  stripe = 'stripe'
}

export enum PushNotificationPlatform {
  /** Identifies the mobile device platform as APNS on iterable */
  APNS = 'APNS',
  /** Identifies the mobile device platform as APNS_SANDBOX on iterable */
  APNS_SANDBOX = 'APNS_SANDBOX',
  /** Identifies the mobile device platform as GCM on iterable */
  GCM = 'GCM'
}

export type Query = {
  __typename?: 'Query';
  actionCards: Array<ActionCard>;
  addressLookup: Array<Address>;
  allergens: Array<Allergen>;
  appVersionToUse: AppVersionToUse;
  appointmentProducts: Array<AppointmentProduct>;
  appointmentReasons: Array<AppointmentReason>;
  archiveReasons: Array<Scalars['String']['output']>;
  availableMarketingMethodPurposes: Array<SupportedMarketingMethodPurpose>;
  banners: Array<Banner>;
  breeds: Array<Breed>;
  brightbackAppId?: Maybe<Scalars['String']['output']>;
  calendarDates: Array<CalendarDate>;
  chargeIdFromPaymentIntentId: Scalars['String']['output'];
  chefsChoiceBenefits?: Maybe<Array<Scalars['String']['output']>>;
  copyEntry: ClientReferralLinkTypeCopyEntry;
  currentAdminUser?: Maybe<AdminUser>;
  currentUser?: Maybe<UserUnion>;
  customerIssueCategories: Array<CustomerIssueCategory>;
  defaultSelectedDate: CalendarDate;
  deliveryAreaOptions: Array<DeliveryArea>;
  /** @deprecated Use standard_delivery_fee instead */
  deliveryFee: DeprecatedDeliveryFee;
  device: Device;
  directSalesEvents: Array<DirectSalesEvent>;
  directSalesLeaderboard?: Maybe<DirectSalesLeaderboard>;
  directSalesPendingSubscription: DirectSalesPendingSubscription;
  directSalesRepresentative: DirectSalesRepresentative;
  directSalesRetrialArchiveReasons: Array<Scalars['String']['output']>;
  directSalesWeeklyTarget?: Maybe<Scalars['Int']['output']>;
  discountCode: DiscountCode;
  dsLeaderboardData?: Maybe<LeaderboardData>;
  dsTeamNames: Array<Scalars['String']['output']>;
  eligibleCustomerIssueCategories?: Maybe<Array<CustomerIssueManagementCategory>>;
  extrasUpsellRecommendations: Array<ProductVariant>;
  featureFlag?: Maybe<Scalars['String']['output']>;
  flavour: NewFlavour;
  flavours: Array<NewFlavour>;
  foodBrand: Array<FoodBrand>;
  foodCategories: Array<FoodCategory>;
  funnelGiftCampaign?: Maybe<FunnelGiftCampaign>;
  guest: Guest;
  healthIssues: Array<HealthIssue>;
  leaderboardUrls: Array<LeaderboardUrls>;
  marketingPreferences: Array<MarketingPreferences>;
  nonCoreOrderDeliveryFee: Scalars['Int']['output'];
  nonCoreOrderSmallOrderFee: Scalars['Int']['output'];
  nonCoreOrderSmallOrderMinimumOrderValue: Scalars['Int']['output'];
  notifications: Array<Notification>;
  orderIssueCategories: Array<OrderIssueCategory>;
  /** @deprecated This field has been moved to guest_type */
  pendingSubscription: PendingSubscription;
  pendingSubscriptionOrderPrices: Array<PendingSubscriptionOrderPricing>;
  petCareProfessionals: Array<PetCareProfessional>;
  plan: Plan;
  /** @deprecated Use plan_recommendation on GuestType or UserType instead */
  planRecommendation?: Maybe<PlanRecommendation>;
  plans: Array<Plan>;
  postCheckoutRecommendation: Array<ProductVariant>;
  postcodeIsDeliverable: Scalars['Boolean']['output'];
  postcodeValidationRegexp: Scalars['String']['output'];
  productCollection: ProductCollection;
  productCollections: Array<ProductCollection>;
  productGroups: Array<ProductGroup>;
  reactivationCampaign?: Maybe<ReactivationCampaign>;
  sepaPaymentMethodIdFromIntentSecret: Scalars['String']['output'];
  settings: Array<Setting>;
  shippingCountries: Array<ShippingCountry>;
  /** Assuming no elimination criteria (plan/discount/etc) this field will return the "happy path" delivery fee that will be applied to the Subscription for the current_resource */
  standardDeliveryFee: Scalars['Int']['output'];
  stripeConnectionToken: Scalars['String']['output'];
  supportedIdealBanks: Array<IdealBank>;
  survey?: Maybe<Survey>;
  twoDayPostcodes: Array<Scalars['String']['output']>;
  upsellableProductCollections: Array<ProductCollection>;
  upsellableVariants: Array<ProductVariant>;
  user: User;
  users: Array<User>;
};


export type QueryactionCardsArgs = {
  platform: ActionCardPlatform;
};


export type QueryaddressLookupArgs = {
  postcode: Scalars['String']['input'];
};


export type QueryappVersionToUseArgs = {
  app: App;
  clientVersion: Scalars['String']['input'];
};


export type QueryarchiveReasonsArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
};


export type QuerybreedsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  popular?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerycalendarDatesArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  deliveryAreaId?: InputMaybe<Scalars['ID']['input']>;
  nDays?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  shipmentType?: InputMaybe<Scalars['String']['input']>;
  shouldAttemptToOfferNextDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerychargeIdFromPaymentIntentIdArgs = {
  paymentIntentId: Scalars['String']['input'];
  paymentMethodType: PaymentMethodType;
};


export type QuerycopyEntryArgs = {
  slug: Scalars['String']['input'];
};


export type QuerycustomerIssueCategoriesArgs = {
  selfServable: Scalars['Boolean']['input'];
};


export type QuerydefaultSelectedDateArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  shouldOfferSundayAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerydeliveryAreaOptionsArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
};


export type QuerydeliveryFeeArgs = {
  postcode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydirectSalesEventsArgs = {
  filterFromInclusive: Scalars['ISO8601DateTime']['input'];
};


export type QuerydirectSalesLeaderboardArgs = {
  directSalesRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  timePeriod?: InputMaybe<TimePeriod>;
};


export type QuerydirectSalesPendingSubscriptionArgs = {
  pendingSubscriptionId: Scalars['ID']['input'];
};


export type QuerydirectSalesWeeklyTargetArgs = {
  date?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QuerydiscountCodeArgs = {
  discountCodeId: Scalars['ID']['input'];
};


export type QuerydsLeaderboardDataArgs = {
  directSalesRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  timePeriod: DsLeaderboardTimePeriod;
};


export type QueryeligibleCustomerIssueCategoriesArgs = {
  reportableId: Scalars['ID']['input'];
  reportableType: CustomerIssueManagementReportable;
};


export type QueryextrasUpsellRecommendationsArgs = {
  deliveryType?: InputMaybe<VariantDelivery>;
  type: Scalars['String']['input'];
};


export type QueryfeatureFlagArgs = {
  fallback?: InputMaybe<Scalars['String']['input']>;
  flag: Scalars['String']['input'];
  trackEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryflavourArgs = {
  slug: Scalars['String']['input'];
};


export type QueryfunnelGiftCampaignArgs = {
  slug: Scalars['String']['input'];
};


export type QueryguestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerynotificationsArgs = {
  clientPlatform?: InputMaybe<ClientPlatform>;
};


export type QuerypendingSubscriptionOrderPricesArgs = {
  discountCodeId?: InputMaybe<Scalars['ID']['input']>;
  expectedFirstShippingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  flavourQuantities: MealInput;
  mealSelectionType?: InputMaybe<Scalars['String']['input']>;
  oneOffProductsPresent?: InputMaybe<Scalars['Boolean']['input']>;
  planId: Scalars['ID']['input'];
  productVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryplanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryplansArgs = {
  offerPouchPortioning?: InputMaybe<Scalars['Boolean']['input']>;
  platform: Platform;
};


export type QuerypostcodeIsDeliverableArgs = {
  postcode: Scalars['String']['input'];
};


export type QueryproductCollectionArgs = {
  slug: Scalars['String']['input'];
};


export type QueryreactivationCampaignArgs = {
  name: Scalars['String']['input'];
};


export type QuerysepaPaymentMethodIdFromIntentSecretArgs = {
  intentSecret: Scalars['String']['input'];
  intentType: IntentType;
};


export type QuerysettingsArgs = {
  names: Array<Scalars['String']['input']>;
};


export type QuerysupportedIdealBanksArgs = {
  platform: ClientPlatform;
};


export type QuerysurveyArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
  startingUrl?: InputMaybe<Scalars['String']['input']>;
};


export type QueryupsellableProductCollectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryuserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryusersArgs = {
  userSearchParams: UserSearchParamsInput;
};

export type Question = {
  __typename?: 'Question';
  ctaDestination?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  options: Array<Option>;
  order: Scalars['Int']['output'];
  questionType: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type RafCampaign = {
  __typename?: 'RafCampaign';
  endDate: Scalars['ISO8601DateTime']['output'];
  name: Scalars['String']['output'];
};

export type RafCampaignVariant = {
  __typename?: 'RafCampaignVariant';
  name: Scalars['String']['output'];
  rafCampaign: RafCampaign;
  view?: Maybe<View>;
};

/** Autogenerated return type of RafCodeRequestedWorkflowCreate */
export type RafCodeRequestedWorkflowCreatePayload = {
  __typename?: 'RafCodeRequestedWorkflowCreatePayload';
  success: Scalars['Boolean']['output'];
};

export type ReactivationCampaign = {
  __typename?: 'ReactivationCampaign';
  currentUserIsEligible: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountCode: DiscountCode;
  expiryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  image?: Maybe<Image>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Use `discount_code.redirect_url` instead */
  redirectionEndpoint?: Maybe<Scalars['String']['output']>;
};

export type RecentOrderTracking = {
  __typename?: 'RecentOrderTracking';
  address?: Maybe<Address>;
  consignment?: Maybe<ScurriConsignment>;
  orderDeliveryDate?: Maybe<Scalars['String']['output']>;
};

export type RecipeSurcharge = {
  __typename?: 'RecipeSurcharge';
  amount: Scalars['Int']['output'];
  planSize: Scalars['Int']['output'];
};

export enum RecipeSurchargeCalculation {
  /** Calculate surcharge per_pouch */
  per_pouch = 'per_pouch',
  /** Calculate surcharge per_serving */
  per_serving = 'per_serving'
}

export type Recommendation = {
  __typename?: 'Recommendation';
  dailyCalories?: Maybe<Scalars['Int']['output']>;
  dog: Dog;
  notRecommendedFlavours: Array<NewFlavour>;
  otherFlavours: Array<NewFlavour>;
  recommendedFlavours: Array<NewFlavour>;
  shippingCountry: ShippingCountry;
};

export type RecommendationReason = {
  __typename?: 'RecommendationReason';
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type RecommendedCareDetails = {
  __typename?: 'RecommendedCareDetails';
  careType: Scalars['String']['output'];
  petCareProfessional: PetCareProfessional;
};

export type RecurringOrder = {
  __typename?: 'RecurringOrder';
  deliveryFee: Scalars['Int']['output'];
  physicalOrderProducts: Array<OrderProduct>;
  physicalProductsTotal: Scalars['Int']['output'];
  planTotal: Scalars['Int']['output'];
  planTotalPerDay: Scalars['Int']['output'];
  recurringOrderProducts: Array<RecurringOrderProduct>;
  subtotal: Scalars['Int']['output'];
  subtotalPricePerDay: Scalars['Int']['output'];
  surchargeTotal: Scalars['Int']['output'];
  totalPrice: Scalars['Int']['output'];
};

export type RecurringOrderProduct = Node & {
  __typename?: 'RecurringOrderProduct';
  frequency: Frequency;
  id: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  requiresPayment: Scalars['Boolean']['output'];
};

export type Referral = {
  __typename?: 'Referral';
  refereeDogNames: Array<Scalars['String']['output']>;
  refereeFirstName: Scalars['String']['output'];
  refereeSignUpDate: Scalars['ISO8601DateTime']['output'];
  referrerDiscount?: Maybe<ApplicableDiscount>;
};

export type Referrer = {
  firstName: Scalars['String']['output'];
  referralDiscountMessage: Scalars['String']['output'];
};

/** Autogenerated return type of RegisterForPushNotifications */
export type RegisterForPushNotificationsPayload = {
  __typename?: 'RegisterForPushNotificationsPayload';
  status: Scalars['String']['output'];
  user: User;
};

/** Autogenerated return type of RemoveSurchargedRecipes */
export type RemoveSurchargedRecipesPayload = {
  __typename?: 'RemoveSurchargedRecipesPayload';
  user: User;
};

export type RepRowDetails = {
  dsRepName: Scalars['String']['output'];
  teamName: Scalars['String']['output'];
};

export type ReplacementBoxDetails = CustomerIssueResolutionDetails & {
  __typename?: 'ReplacementBoxDetails';
  availableDeliveryDates: Array<CalendarDate>;
  defaultAddress: Address;
  type: CustomerIssueResolutionDetailsTypeField;
};

/** Autogenerated return type of ReplacementBoxSubmission */
export type ReplacementBoxSubmissionPayload = {
  __typename?: 'ReplacementBoxSubmissionPayload';
  resolutionApplicationConfirmation: CustomerIssueResolutionAcceptanceApplicationConfirmation;
  user: User;
};

/** Autogenerated return type of ReportEntriesSubmission */
export type ReportEntriesSubmissionPayload = {
  __typename?: 'ReportEntriesSubmissionPayload';
  reportId: Scalars['ID']['output'];
  resolutions: Array<CustomerIssueResolution>;
};

export type Reportable = Node & {
  __typename?: 'Reportable';
  id: Scalars['ID']['output'];
  isoDeliveryDate: Scalars['ISO8601Date']['output'];
  potentialMissingItems: Array<PotentialMissingItem>;
  price: Scalars['Int']['output'];
};

export type RetentionData = {
  __typename?: 'RetentionData';
  data: Array<RetentionRow>;
  personalData: Array<RetentionRow>;
};

export type RetentionRow = RepRowDetails & {
  __typename?: 'RetentionRow';
  dsRepName: Scalars['String']['output'];
  retentionPercentage: Scalars['Int']['output'];
  sales: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
};

/** Autogenerated return type of RetrialSubscriptionReactivation */
export type RetrialSubscriptionReactivationPayload = {
  __typename?: 'RetrialSubscriptionReactivationPayload';
  dsRepTeam: Scalars['String']['output'];
  dsRepTrackingId: Scalars['String']['output'];
  firstDeliveryDate: Scalars['ISO8601Date']['output'];
  firstInvoiceStatus: InvoiceStatus;
  referralLinkUrl: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  userSignInUrl: Scalars['String']['output'];
};

export enum RetrialVariant {
  active = 'active',
  mismatched_shipping_country = 'mismatched_shipping_country',
  reactivation = 'reactivation',
  retrial = 'retrial',
  suspended = 'suspended'
}

/** Autogenerated return type of RevolutCreateOrder */
export type RevolutCreateOrderPayload = {
  __typename?: 'RevolutCreateOrderPayload';
  orderId: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
};

export type SalesData = {
  __typename?: 'SalesData';
  data: Array<SalesRow>;
  personalData: Array<SalesRow>;
};

export type SalesPerShiftData = {
  __typename?: 'SalesPerShiftData';
  data: Array<SalesPerShiftRow>;
  personalData: Array<SalesPerShiftRow>;
};

export type SalesPerShiftRow = RepRowDetails & {
  __typename?: 'SalesPerShiftRow';
  dsRepName: Scalars['String']['output'];
  salesPerShift: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
};

export type SalesRow = RepRowDetails & {
  __typename?: 'SalesRow';
  dsRepName: Scalars['String']['output'];
  sales: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
};

export type ScurriConsignment = {
  __typename?: 'ScurriConsignment';
  barcodeNumber?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type SelectedMarketingMethodPurpose = Node & {
  __typename?: 'SelectedMarketingMethodPurpose';
  id: Scalars['ID']['output'];
  supportedMarketingMethodPurpose: SupportedMarketingMethodPurpose;
};

/** Autogenerated return type of SendAppSMS */
export type SendAppSMSPayload = {
  __typename?: 'SendAppSMSPayload';
  errorMessage?: Maybe<MutationMessage>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SendCalendlyCancellation */
export type SendCalendlyCancellationPayload = {
  __typename?: 'SendCalendlyCancellationPayload';
  appointment: Appointment;
};

/** Autogenerated return type of SendNudgeToPendingReferrals */
export type SendNudgeToPendingReferralsPayload = {
  __typename?: 'SendNudgeToPendingReferralsPayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SendRafSMSFromSoc */
export type SendRafSMSFromSocPayload = {
  __typename?: 'SendRafSMSFromSocPayload';
  errorMessage?: Maybe<MutationMessage>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SendRafSMS */
export type SendRafSMSPayload = {
  __typename?: 'SendRafSMSPayload';
  errorMessage?: Maybe<MutationMessage>;
  success: Scalars['Boolean']['output'];
};

export type SepaDirectDebit = {
  __typename?: 'SepaDirectDebit';
  accountLastFour?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: PaymentMethodable;
};

export enum Serving {
  half_pouch = 'half_pouch',
  quarter_pouch = 'quarter_pouch',
  single_serve = 'single_serve',
  standard_serving = 'standard_serving'
}

export type Setting = {
  __typename?: 'Setting';
  name: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type ShippingCountry = Node & {
  __typename?: 'ShippingCountry';
  active: Scalars['Boolean']['output'];
  availableLanguages: Array<Language>;
  availablePaymentMethodSetupMediums: Array<PaymentMethodSetupMedium>;
  availableRecipesCount: Scalars['Int']['output'];
  brand: Brand;
  code: Code;
  contactInformation?: Maybe<ContactInformation>;
  currency: Currency;
  defaultLanguage: Language;
  domain: Scalars['String']['output'];
  footerLinks: Array<FooterLink>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scaEnforced: Scalars['Boolean']['output'];
  showAddDogProfile: Scalars['Boolean']['output'];
  showCare: Scalars['Boolean']['output'];
  showExtras: Scalars['Boolean']['output'];
  showInvoiceDownloadDirections: Scalars['Boolean']['output'];
  showRafCharityButton: Scalars['Boolean']['output'];
  showUpcomingOrderSeeMoreExtras: Scalars['Boolean']['output'];
  trustpilotBusinessUnitId?: Maybe<Scalars['String']['output']>;
  vetNurseCalendlyUrl: Scalars['String']['output'];
};

/** Autogenerated return type of SignInAuthorisedSubscribedCheckoutUser */
export type SignInAuthorisedSubscribedCheckoutUserPayload = {
  __typename?: 'SignInAuthorisedSubscribedCheckoutUserPayload';
  token: Scalars['String']['output'];
};

export type SignupInfluencerInput = {
  dogs: Array<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of Signup */
export type SignupPayload = {
  __typename?: 'SignupPayload';
  influencer?: Maybe<InfluencerSignupPayload>;
};

export enum SnackingHabit {
  eats_lots_of_snacks = 'eats_lots_of_snacks',
  eats_no_snacks = 'eats_no_snacks',
  eats_some_snacks = 'eats_some_snacks',
  unknown_snacking_habits = 'unknown_snacking_habits'
}

export enum Status {
  allocated = 'allocated',
  attempted_delivery = 'attempted_delivery',
  cancelled = 'cancelled',
  delivered = 'delivered',
  exception = 'exception',
  in = 'in',
  manifested = 'manifested',
  out = 'out',
  printed = 'printed',
  unallocated = 'unallocated',
  unknown = 'unknown'
}

/** Autogenerated return type of StripeChargeBoxOneAndSetupPaymentMethod */
export type StripeChargeBoxOneAndSetupPaymentMethodPayload = {
  __typename?: 'StripeChargeBoxOneAndSetupPaymentMethodPayload';
  boxCanBeCharged: Scalars['Boolean']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  stripeSecretToken?: Maybe<Scalars['String']['output']>;
};

export type StripeInitiateChargeInput = {
  chargeDescription: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  paymentMethodType: Scalars['String']['input'];
  setupFutureUsage: Scalars['Boolean']['input'];
};

/** Autogenerated return type of StripeUserParamsSetupIntentCreate */
export type StripeUserParamsSetupIntentCreatePayload = {
  __typename?: 'StripeUserParamsSetupIntentCreatePayload';
  paymentIntentId: Scalars['String']['output'];
};

export enum Style {
  column = 'column',
  row = 'row'
}

/** Autogenerated return type of SubmitAnswers */
export type SubmitAnswersPayload = {
  __typename?: 'SubmitAnswersPayload';
  answers: Array<Answer>;
};

export type Subscription = Node & PlanPriceable & {
  __typename?: 'Subscription';
  accountType: Account;
  activeBoostedMembership?: Maybe<Membership>;
  activePaymentMethodType?: Maybe<PaymentMethodable>;
  activeRafCampaignRedeemed: Scalars['Boolean']['output'];
  activeRafCampaignVariant?: Maybe<RafCampaignVariant>;
  /** Returns an unspent but redeemed reactivation campaign */
  alreadyRedeemedReactivationCampaign?: Maybe<ReactivationCampaign>;
  box?: Maybe<Box>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditCard?: Maybe<CreditCard>;
  /** @deprecated Use default_reactivation_campaign instead */
  currentEligibleReactivationCampaign?: Maybe<ReactivationCampaign>;
  currentPause?: Maybe<Pause>;
  defaultReactivationCampaign?: Maybe<ReactivationCampaign>;
  deliveriesReceived: Scalars['Int']['output'];
  deliveriesReceivedAsOfYesterday: Scalars['Int']['output'];
  firstBox: Box;
  /** Returns an array of product variants */
  freeLoyaltyProductVariants: Array<ProductVariant>;
  hasAppliedPsfDiscount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  idealAllPlan?: Maybe<Plan>;
  idealMixPlan?: Maybe<Plan>;
  idealPlan: Plan;
  /**
   * Returns the plan that the subscription will be switched to if the customer
   *                       chooses to increase their delivery cadence
   */
  increasedDeliveryCadencePlan?: Maybe<Plan>;
  lastBox?: Maybe<Box>;
  /** @deprecated This field is deprecated and will be removed in a future release. */
  likelihoodToChurnIn28Days?: Maybe<Scalars['Float']['output']>;
  meal?: Maybe<Array<Meal>>;
  mealSelectionType: MealSelectionType;
  /** @deprecated Not behaving as expected */
  mealSelectionTypeChangedInLastRequest?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Not behaving as expected */
  mealSelectionTypeLastChangedTo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use conditional logic in the query instead */
  nextBox?: Maybe<Box>;
  nextBoxWasDelayed: Scalars['Boolean']['output'];
  nextEditableBox?: Maybe<Box>;
  nextNBoxes: Array<Box>;
  numberOfPreviousIssues: Scalars['Int']['output'];
  pauseUrl?: Maybe<Scalars['String']['output']>;
  pauses?: Maybe<Array<Pause>>;
  paymentMethods: Array<PaymentMethod>;
  plan: Plan;
  /**
   * Counter for how many times the plan has been changed by the customer. Counter
   *                        starts at 0 when subscription is created, 1 when the plan is changed for the
   *                        first time, and so on.
   */
  planChangesCount: Scalars['Int']['output'];
  /** @deprecated Prefer UserType#available_plans */
  planOptions: Array<Plan>;
  planPricePerDay: Scalars['Int']['output'];
  planPricePerPouch: Scalars['Int']['output'];
  planPriceTotal: Scalars['Int']['output'];
  pouchesConsumed: Scalars['Int']['output'];
  previewUncreatedFutureBox: PreviewBox;
  previousNBoxes: Array<Box>;
  projectedNextDeliveryDate: Scalars['ISO8601Date']['output'];
  purchaseEventId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Table removed and replaced by reactivation campaigns */
  reactivationDiscount?: Maybe<DiscountCode>;
  recurringOrder: RecurringOrder;
  referralLink: ClientReferralLink;
  retrialVariant: RetrialVariant;
  status: SubscriptionStatus;
  suspendedForInsufficientFunds: Scalars['Boolean']['output'];
  upsellableSampleProduct?: Maybe<ProductVariant>;
};


export type SubscriptionboxArgs = {
  boxId: Scalars['ID']['input'];
};


export type SubscriptionnextNBoxesArgs = {
  num: Scalars['Int']['input'];
};


export type SubscriptionnumberOfPreviousIssuesArgs = {
  prevBoxes?: InputMaybe<Scalars['Int']['input']>;
};


export type SubscriptionpauseUrlArgs = {
  urlOverrides?: InputMaybe<Scalars['JSON']['input']>;
};


export type SubscriptionpausesArgs = {
  numberOfPauses?: InputMaybe<Scalars['Int']['input']>;
};


export type SubscriptionpaymentMethodsArgs = {
  archivedType?: InputMaybe<ArchivedType>;
};


export type SubscriptionplanOptionsArgs = {
  scopeType?: InputMaybe<AvailablePlansScopeType>;
};


export type SubscriptionpreviewUncreatedFutureBoxArgs = {
  withDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionpreviousNBoxesArgs = {
  num: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SubscriptionretrialVariantArgs = {
  shippingCountryId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SubscriptionCreate */
export type SubscriptionCreatePayload = {
  __typename?: 'SubscriptionCreatePayload';
  redirectUrl: Scalars['String']['output'];
};

export type SubscriptionDataInput = {
  additionalProductIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  deliveryCadence: Scalars['String']['input'];
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  mealBreakdown: MealInput;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethodIdentifierType: Scalars['String']['input'];
  paymentMethodType: Payment;
  paymentProvider: Provider;
  planId: Scalars['ID']['input'];
  targetFirstDeliveryDate: Scalars['ISO8601Date']['input'];
  user: UserSubscriptionDataInput;
};

export type SubscriptionInput = {
  mealBreakdown: MealInput;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethodType: PaymentMethodable;
  paymentProvider: Provider;
  planId: Scalars['ID']['input'];
  productVariantInputs?: InputMaybe<Array<ProductVariantInput>>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  targetFirstDeliveryDate: Scalars['ISO8601Date']['input'];
};

export enum SubscriptionStatus {
  active = 'active',
  paused = 'paused',
  suspended = 'suspended'
}

export type SupportedMarketingMethodPurpose = Node & {
  __typename?: 'SupportedMarketingMethodPurpose';
  id: Scalars['ID']['output'];
  marketingMethod: MarketingMethod;
  marketingPurpose: MarketingPurpose;
  preselect: Scalars['Boolean']['output'];
  shippingCountry: ShippingCountry;
};

export type Survey = {
  __typename?: 'Survey';
  finishedMessage: Scalars['String']['output'];
  finishedUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  questions: Array<Question>;
  /** @deprecated Use 'id' instead */
  slug: Scalars['String']['output'];
  startingUrl?: Maybe<Scalars['String']['output']>;
};

export type TailmailData = {
  __typename?: 'TailmailData';
  data: Array<TailmailRow>;
  personalData: Array<TailmailRow>;
};

export type TailmailRow = RepRowDetails & {
  __typename?: 'TailmailRow';
  dsRepName: Scalars['String']['output'];
  tailmailCount: Scalars['Int']['output'];
  teamName: Scalars['String']['output'];
};

export type TextCategory = OrderIssueCategory & {
  __typename?: 'TextCategory';
  fields: Array<Field>;
  /** A non-humanized string */
  name: Scalars['String']['output'];
};

export enum Tier {
  deprecated = 'deprecated',
  hidden_on_signup = 'hidden_on_signup',
  primary = 'primary',
  secondary = 'secondary',
  unavailable_to_add = 'unavailable_to_add'
}

export enum TimePeriod {
  ALL = 'ALL',
  THIS_MONTH = 'THIS_MONTH',
  THIS_WEEK = 'THIS_WEEK',
  THIS_YEAR = 'THIS_YEAR',
  TODAY = 'TODAY'
}

/** Autogenerated return type of TrackPushNotificationOpen */
export type TrackPushNotificationOpenPayload = {
  __typename?: 'TrackPushNotificationOpenPayload';
  status: Scalars['String']['output'];
  user: User;
};

export enum Trait {
  clever_clogs = 'clever_clogs',
  goofball = 'goofball',
  shy = 'shy',
  sweet = 'sweet'
}

export type TraitsInput = {
  dogId: Scalars['ID']['input'];
  traits: Array<Trait>;
};

export enum TypeOfPlan {
  all = 'all',
  half = 'half',
  most = 'most',
  some = 'some'
}

export type UnavailableObject = {
  __typename?: 'UnavailableObject';
  hidden: Scalars['Boolean']['output'];
  reason: UnavailableObjectReason;
  reasonCopy: Scalars['String']['output'];
};

export enum UnavailableObjectReason {
  coming_soon = 'coming_soon',
  out_of_stock_hidden = 'out_of_stock_hidden',
  out_of_stock_shown = 'out_of_stock_shown'
}

export type User = Node & {
  __typename?: 'User';
  acquisitionChannel?: Maybe<Scalars['String']['output']>;
  address: Address;
  affiliateType: Affiliate;
  appointment: Appointment;
  appointments: Array<Appointment>;
  availableMarketingMethodPurposes: Array<SupportedMarketingMethodPurpose>;
  availablePlans: Array<Plan>;
  basket?: Maybe<Basket>;
  calorieFulfilmentCategorisation: TypeOfPlan;
  calorieFulfilmentPercentage: Scalars['Int']['output'];
  currentDeliveryAreaPreference?: Maybe<DeliveryArea>;
  deliveryAreaOptions: Array<DeliveryArea>;
  dogs?: Maybe<Array<Dog>>;
  eligibleForChefsChoice: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  friendsReferred?: Maybe<Scalars['Int']['output']>;
  goalSegment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intercomUserHash: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  marketingPreference: MarketingPreferences;
  nonCoreOrder: NonCoreOrder;
  nonCoreOrders: Array<NonCoreOrder>;
  numericalCreatedAt: Scalars['Int']['output'];
  orders: Array<OrderUnion>;
  ordersByDate: Array<OrderUnion>;
  phone?: Maybe<Scalars['String']['output']>;
  planPricePerDayPerDog?: Maybe<Array<PlanPricePerDayPerDog>>;
  planRecommendation?: Maybe<PlanRecommendation>;
  preferredLanguage: Language;
  recentOrderTracking: RecentOrderTracking;
  referralsSinceLastLoginCount?: Maybe<Scalars['Int']['output']>;
  reportable?: Maybe<Reportable>;
  selectedMarketingMethodPurposes: Array<SelectedMarketingMethodPurpose>;
  shippingCountry: ShippingCountry;
  shippingCountryCode: Code;
  shouldSendSmsDeliveryReminder: Scalars['Boolean']['output'];
  shouldSupportSca: Scalars['Boolean']['output'];
  subscription: Subscription;
  token: Scalars['String']['output'];
  totalDogCalories?: Maybe<Scalars['Int']['output']>;
  trackingId: Scalars['ID']['output'];
};


export type UserappointmentArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type UserappointmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<AppointmentStatus>>;
};


export type UseravailablePlansArgs = {
  scopeType?: InputMaybe<AvailablePlansScopeType>;
};


export type UsercalorieFulfilmentCategorisationArgs = {
  planId?: InputMaybe<Scalars['ID']['input']>;
};


export type UsercalorieFulfilmentPercentageArgs = {
  planId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserintercomUserHashArgs = {
  deviceType?: InputMaybe<Scalars['String']['input']>;
};


export type UsernonCoreOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type UsernonCoreOrdersArgs = {
  invoiceStatus?: InputMaybe<Scalars['String']['input']>;
};


export type UserordersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserordersByDateArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type UserplanPricePerDayPerDogArgs = {
  discountCodePartId?: InputMaybe<Scalars['ID']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserreportableArgs = {
  reportableId: Scalars['ID']['input'];
  reportableType: CustomerIssueManagementReportable;
};

export type UserDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserLogout */
export type UserLogoutPayload = {
  __typename?: 'UserLogoutPayload';
  authenticatable: Authenticatable;
};

export type UserSearchParamsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
};

export type UserSubscriptionDataInput = {
  addressAttributes: AddressInput;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  shouldSupportSca: Scalars['Boolean']['input'];
};

/** Allow possible user types */
export type UserUnion = Guest | PreWizardGuest | User;

export enum ValidMutationCode {
  box_three_save_offer = 'box_three_save_offer',
  raf_box_two_save_offer = 'raf_box_two_save_offer'
}

export enum VariantDelivery {
  on_demand = 'on_demand',
  one_off = 'one_off',
  recurring = 'recurring'
}

export type View = {
  __typename?: 'View';
  data: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
};

export enum VisibilityScope {
  hidden = 'hidden',
  mentionable = 'mentionable',
  presentable = 'presentable'
}

export type ContactFormInitialDataVariables = Exact<{ [key: string]: never; }>;


export type ContactFormInitialData = { __typename?: 'Query', shippingCountries: Array<{ __typename?: 'ShippingCountry', id: string, code: Code, contactInformation?: { __typename?: 'ContactInformation', id: string, contactHours?: string | null, whatsappContactHours?: string | null, contactNumber?: string | null, displayContactNumber?: string | null, whatsappNumber?: string | null, displayWhatsappNumber?: string | null } | null }>, user: { __typename?: 'User', id: string, firstName: string, lastName: string, preferredLanguage: Language, email: string, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string }> | null }, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }> };

export type ContactFormInitialDataPreWizardGuestVariables = Exact<{ [key: string]: never; }>;


export type ContactFormInitialDataPreWizardGuest = { __typename?: 'Query', shippingCountries: Array<{ __typename?: 'ShippingCountry', id: string, code: Code, contactInformation?: { __typename?: 'ContactInformation', id: string, contactHours?: string | null, whatsappContactHours?: string | null, contactNumber?: string | null, displayContactNumber?: string | null, whatsappNumber?: string | null, displayWhatsappNumber?: string | null } | null }>, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }> };

export type addDiscountedExtrasCountdownCardQueryVariables = Exact<{ [key: string]: never; }>;


export type addDiscountedExtrasCountdownCardQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, nextEditableBox?: { __typename?: 'Box', isoDeliveryDate: any, hoursUntilCutOff: number, order: { __typename?: 'Order', discountTotalPercentage?: number | null } } | null } } };

export type BannersVariables = Exact<{ [key: string]: never; }>;


export type Banners = { __typename?: 'Query', banners: Array<{ __typename?: 'Banner', id: string, slug: string, link?: string | null, order: number, template: string, text: string, liveDate: any, endDate?: any | null, showAgainAfterXDays?: number | null }>, currentUser?: { __typename: 'Guest', id: string } | { __typename: 'PreWizardGuest' } | { __typename: 'User', id: string } | null };

export type ShopItemFragment = { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string }, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null };

export type BoxSummaryVariables = Exact<{ [key: string]: never; }>;


export type BoxSummary = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, planPortionInGrams: number, gender: Gender }> | null, subscription: { __typename?: 'Subscription', id: string, recurringOrder: { __typename?: 'RecurringOrder', deliveryFee: number, surchargeTotal: number, physicalProductsTotal: number, totalPrice: number, planTotal: number, planTotalPerDay: number }, plan: { __typename?: 'Plan', numberOfPouches: number, pouchSize: number, pouchesPerDay: number, price: number, durationInDays: number, typeOfPlanForCustomer: TypeOfPlan, pricesPerDayPerDogs: Array<{ __typename?: 'DogPricing', name: string, pricePerDayWithoutDiscount: number }> } } } };

export type BreedSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type BreedSelectorQuery = { __typename?: 'Query', breeds: Array<{ __typename?: 'Breed', id: string, name: string, key: string, popular: boolean }> };

export type CalendarDatesDataVariables = Exact<{
  calendarInitDate: Scalars['ISO8601Date']['input'];
  nDays?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  shipmentType: Scalars['String']['input'];
  shouldAttemptToOfferNextDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CalendarDatesData = { __typename?: 'Query', calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean }> };

export type CalendarDatesV2Fragment = { __typename?: 'CalendarDate', date: any, deliverable: boolean, replacementDate?: any | null, endOfLeadTime: any };

export type CourierFragment = { __typename?: 'DeliveryArea', id: string, regularDeliveryDaysOfWeek: Array<number>, preferredCarrierService: { __typename?: 'CarrierService', id: string, deliveryNotesLimit: number, carrier: { __typename?: 'Carrier', name?: string | null } }, calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, replacementDate?: any | null, endOfLeadTime: any }> };

export type BoxPhysicalOrderProducts = { __typename?: 'Box', physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, requiresPayment: boolean, quantity: number, frequency: Frequency, price: number, discountedPrice: number, nonPaymentReason?: NonPaymentReason | null, productVariant: { __typename?: 'ProductVariant', id: string, name: string, discountedPrice?: number | null, grossPrice: number, subscribeAndSaveable: boolean, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', adjustedGrossPrice: number, netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, slug: string, name: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> } } }> };

export type EditExtrasUserFragment = { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, shippingCountry: { __typename?: 'ShippingCountry', id: string, showUpcomingOrderSeeMoreExtras: boolean, showExtras: boolean } };

export type EditExtrasBoxFragment = { __typename?: 'Box', id: string, isoDeliveryDate: any, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, frequency: Frequency, quantity: number, price: number, discountedPrice: number, requiresPayment: boolean, nonPaymentReason?: NonPaymentReason | null, productVariant: { __typename?: 'ProductVariant', id: string, grossPrice: number, subscribeAndSaveable: boolean, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string }> }, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null } }> };

export type RecommendedOrderProductsCreateVariables = Exact<{
  userId: Scalars['ID']['input'];
  productVariantInput: ProductVariantInput;
  boxId: Scalars['ID']['input'];
}>;


export type RecommendedOrderProductsCreate = { __typename?: 'Mutation', orderProductsCreate?: { __typename?: 'OrderProductsCreatePayload', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, requiresPayment: boolean, quantity: number, frequency: Frequency, price: number, discountedPrice: number, nonPaymentReason?: NonPaymentReason | null, productVariant: { __typename?: 'ProductVariant', id: string, name: string, discountedPrice?: number | null, grossPrice: number, subscribeAndSaveable: boolean, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', adjustedGrossPrice: number, netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, slug: string, name: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> } } }> } | null } } } | null };

export type UpdateOrderProductsVariables = Exact<{
  userId: Scalars['ID']['input'];
  boxId: Scalars['ID']['input'];
  orderProducts: Array<ProductInput> | ProductInput;
  returnBox: Scalars['Boolean']['input'];
}>;


export type UpdateOrderProducts = { __typename?: 'Mutation', orderProductsUpdate?: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', descriptor: Descriptor, amendable: boolean, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, requiresPayment: boolean, quantity: number, frequency: Frequency, price: number, discountedPrice: number, nonPaymentReason?: NonPaymentReason | null, productVariant: { __typename?: 'ProductVariant', id: string, name: string, discountedPrice?: number | null, grossPrice: number, subscribeAndSaveable: boolean, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', adjustedGrossPrice: number, netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, slug: string, name: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> } } }>, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string }> } } | null } | null };

export type UpdateRecurringOrderProductsVariables = Exact<{
  userId: Scalars['ID']['input'];
  boxId: Scalars['ID']['input'];
  recurringOrderProducts: Array<ProductInput> | ProductInput;
  returnBox: Scalars['Boolean']['input'];
}>;


export type UpdateRecurringOrderProducts = { __typename?: 'Mutation', recurringOrderProductsUpdate?: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', id: string, descriptor: Descriptor, amendable: boolean, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, requiresPayment: boolean, quantity: number, frequency: Frequency, price: number, discountedPrice: number, nonPaymentReason?: NonPaymentReason | null, productVariant: { __typename?: 'ProductVariant', id: string, name: string, discountedPrice?: number | null, grossPrice: number, subscribeAndSaveable: boolean, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', adjustedGrossPrice: number, netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, slug: string, name: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> } } }>, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string }> } } | null } | null };

export type ExtrasModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ExtrasModalQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', gender: Gender, name: string }> | null } };

export type EditExtrasQueryVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type EditExtrasQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, box?: { __typename?: 'Box', id: string, isoDeliveryDate: any, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, frequency: Frequency, quantity: number, price: number, discountedPrice: number, requiresPayment: boolean, nonPaymentReason?: NonPaymentReason | null, productVariant: { __typename?: 'ProductVariant', id: string, grossPrice: number, subscribeAndSaveable: boolean, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string }> }, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null } }> } | null }, shippingCountry: { __typename?: 'ShippingCountry', id: string, showUpcomingOrderSeeMoreExtras: boolean, showExtras: boolean } } };

export type EditExtrasNoBoxIdQueryVariables = Exact<{ [key: string]: never; }>;


export type EditExtrasNoBoxIdQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, previewUncreatedFutureBox: { __typename?: 'PreviewBox', isoDeliveryDate: any, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', frequency: Frequency, quantity: number, price: number, discountedPrice: number, requiresPayment: boolean, nonPaymentReason?: NonPaymentReason | null, productVariant: { __typename?: 'ProductVariant', grossPrice: number, subscribeAndSaveable: boolean, id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string }> }, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null } }> }, nextEditableBox?: { __typename?: 'Box', id: string, isoDeliveryDate: any, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, frequency: Frequency, quantity: number, price: number, discountedPrice: number, requiresPayment: boolean, nonPaymentReason?: NonPaymentReason | null, productVariant: { __typename?: 'ProductVariant', id: string, grossPrice: number, subscribeAndSaveable: boolean, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string }> }, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null } }> } | null }, shippingCountry: { __typename?: 'ShippingCountry', id: string, showUpcomingOrderSeeMoreExtras: boolean, showExtras: boolean } } };

export type FooterQueryVariables = Exact<{ [key: string]: never; }>;


export type FooterQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus }, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code, brand: Brand, footerLinks: Array<{ __typename?: 'FooterLink', footerColumn: FooterColumn, title: string, url: string, availableForStatuses: Array<SubscriptionStatus> }> } } };

export type HowToFeedModalTriggerDogFragment = { __typename?: 'Dog', id: string, name: string };

export type HowToFeedModalTriggerPlanFragment = { __typename?: 'Plan', id: string, pouchSize: number, pouchesPerDay: number, servingInformation: { __typename?: 'PlanServingInformation', gramsPerDay: number, numberOfServings: number, pouchesPerServing: number, roundedCaloriesPerDay: number, servingSize: number, servingType: Serving } };

export type PlanDetailsQueryVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type PlanDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, gender: Gender }> | null, subscription: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', id: string, editable: boolean, plan: { __typename?: 'Plan', id: string, typeOfPlanForCustomer: TypeOfPlan, numberOfPouches: number, pouchSize: number, durationInDays: number } } | null } } };

export type PuppyDiscountModalQueryVariables = Exact<{
  discountCodeId: Scalars['ID']['input'];
}>;


export type PuppyDiscountModalQuery = { __typename?: 'Query', discountCode: { __typename?: 'DiscountCode', id: string, code: string, discountBasis: DiscountCodePartDiscountBasis, value: number, channel?: string | null, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> } };

export type recipeCardFlavourFragment = { __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, recipeSurcharge?: number | null, standardPricePerDay: number, primaryImage: { __typename?: 'Image', src: string } };

export type recipeCardPlanFragment = { __typename?: 'Plan', id: string, pricePerDay: number, trialDiscountedPricePerDay: number };

export type ShareModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ShareModalQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountryCode: Code, dogs?: Array<{ __typename?: 'Dog', name: string }> | null, subscription: { __typename?: 'Subscription', referralLink: { __typename?: 'ClientReferralLink', referralLinkTypeName: string, referralDiscountsTotalValue: number, url: string, referralDiscount: { __typename?: 'DiscountCode', code: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, n?: number | null }> }, referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', value: number, discountBasis: ApplicableDiscountPartDiscountBasis, n: number, discountType: ApplicableDiscountPartDiscount }> } | null, referrals: Array<{ __typename?: 'Referral', refereeFirstName: string, refereeDogNames: Array<string>, refereeSignUpDate: any }> } } }, whatsAppSingleDog: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string }, whatsAppMultipleDogs: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string } };

export type BrightbackInitialiserQueryVariables = Exact<{ [key: string]: never; }>;


export type BrightbackInitialiserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, deliveriesReceived: number, pouchesConsumed: number, hasAppliedPsfDiscount: boolean, status: SubscriptionStatus, pauseUrl?: string | null, referralLink: { __typename?: 'ClientReferralLink', referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', value: number, discountBasis: ApplicableDiscountPartDiscountBasis }> } | null, referralDiscount: { __typename?: 'DiscountCode', value: number, discountBasis: DiscountCodePartDiscountBasis }, referrals: Array<{ __typename?: 'Referral', refereeFirstName: string }> }, plan: { __typename?: 'Plan', id: string }, nextNBoxes: Array<{ __typename?: 'Box', id: string, discountValue: number, isNextEditableBox: boolean, editable: boolean }> } } };

export type SubscriptionDetailsCardQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionDetailsCardQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, ageInMonths: number, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null, breed: { __typename?: 'Breed', id: string, name: string } }> | null, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, plan: { __typename?: 'Plan', id: string, numberOfPouches: number, durationInDays: number, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', gramsPerDay: number, dogId: string, name: string }> } } } };

export type SubscriptionOverviewFragment = { __typename?: 'User', dogs?: Array<{ __typename?: 'Dog', id: string, name: string, planPortionInGrams: number, gender: Gender, ageInMonths: number, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, plan: { __typename?: 'Plan', id: string, pouchSize: number, pouchesPerDay: number, servingInformation: { __typename?: 'PlanServingInformation', gramsPerDay: number, numberOfServings: number, pouchesPerServing: number, roundedCaloriesPerDay: number, servingSize: number, servingType: Serving } } } };

export type SubmitSurveyAnswersVariables = Exact<{
  answers: Array<AnswerInput> | AnswerInput;
}>;


export type SubmitSurveyAnswers = { __typename?: 'Mutation', submitSurveyAnswers?: { __typename?: 'SubmitAnswersPayload', answers: Array<{ __typename?: 'Answer', id: number, value: number, option: { __typename?: 'Option', text: string }, question: { __typename?: 'Question', id: number, text: string } }> } | null };

export type SurveyCardQueryVariables = Exact<{
  startingUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type SurveyCardQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language }, survey?: { __typename?: 'Survey', id: number, name: string, slug: string, startingUrl?: string | null, finishedMessage: string, questions: Array<{ __typename?: 'Question', id: number, text: string, ctaText?: string | null, ctaDestination?: string | null, questionType: string, order: number, options: Array<{ __typename?: 'Option', id: number, text: string }> }> } | null };

export type TopNavDiscountQueryVariables = Exact<{
  discountCodeId: Scalars['ID']['input'];
}>;


export type TopNavDiscountQuery = { __typename?: 'Query', discountCode: { __typename?: 'DiscountCode', id: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number, discountBasis: DiscountCodePartDiscountBasis, discountType: DiscountCodePartDiscount, n?: number | null }> } };

export type AdditionalProductQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type AdditionalProductQuery = { __typename?: 'Query', productCollection: { __typename?: 'ProductCollection', id: string, name: string, about: string, description: string, images: Array<{ __typename?: 'Image', src: string }>, productBenefits: Array<{ __typename?: 'ProductBenefit', id: string, name: string, image?: { __typename?: 'Image', src: string } | null }> } };

export type BottomNavQueryVariables = Exact<{ [key: string]: never; }>;


export type BottomNavQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, affiliateType: Affiliate, referralsSinceLastLoginCount?: number | null, dogs?: Array<{ __typename?: 'Dog', id: string }> | null } };

export type DashboardFooterQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardFooterQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code } };

export type TopNavQueryVariables = Exact<{ [key: string]: never; }>;


export type TopNavQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, affiliateType: Affiliate, referralsSinceLastLoginCount?: number | null, dogs?: Array<{ __typename?: 'Dog', id: string }> | null } };

export type DeliverableDatesDataVariables = Exact<{
  calendarInitDate: Scalars['ISO8601Date']['input'];
  nDays?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  shouldAttemptToOfferNextDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentType?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeliverableDatesData = { __typename?: 'Query', calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, endOfLeadTime: any }> };

export type BoxTrackingQueryVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type BoxTrackingQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender }> | null, subscription: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', id: string, isoDeliveryDate: any, consignment?: { __typename?: 'Consignment', id: string, updatedAt: any, status?: Status | null, carrierName?: string | null, trackingUrl?: string | null } | null } | null } } };

export type NcoTrackingQueryVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type NcoTrackingQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender }> | null, nonCoreOrder: { __typename?: 'NonCoreOrder', id: string, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliveryDate: any, consignment?: { __typename?: 'Consignment', id: string, updatedAt: any, status?: Status | null, carrierName?: string | null, trackingUrl?: string | null } | null }> } } };

export type ReferAFriendUpsertVariables = Exact<{
  userId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReferAFriendUpsert = { __typename?: 'Mutation', referAFriendUpsert?: { __typename?: 'User', id: string } | null };

export type FlavourQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type FlavourQuery = { __typename?: 'Query', flavour: { __typename?: 'NewFlavour', name: string, longDescription: string, composition: string, additives: string, storage: string, images: Array<{ __typename?: 'Image', src: string }>, primaryImage: { __typename?: 'Image', src: string }, productBenefits: Array<{ __typename?: 'ProductBenefit', name: string, image?: { __typename?: 'Image', src: string } | null }>, flavourConstituents: Array<{ __typename?: 'FlavourConstituent', percentage: number, constituent: { __typename?: 'Constituent', name: string } }> } };

export type marketingPreferenceFragment = { __typename?: 'User', id: string, selectedMarketingMethodPurposes: Array<{ __typename?: 'SelectedMarketingMethodPurpose', id: string, supportedMarketingMethodPurpose: { __typename?: 'SupportedMarketingMethodPurpose', marketingMethod: { __typename?: 'MarketingMethod', id: string, name: string }, marketingPurpose: { __typename?: 'MarketingPurpose', id: string, name: string, description: string } } }>, availableMarketingMethodPurposes: Array<{ __typename?: 'SupportedMarketingMethodPurpose', id: string, preselect: boolean, shippingCountry: { __typename?: 'ShippingCountry', id: string }, marketingMethod: { __typename?: 'MarketingMethod', id: string, name: string }, marketingPurpose: { __typename?: 'MarketingPurpose', id: string, name: string, description: string } }> };

export type MarketingMethodPurposeUpdateVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  authenticationStrategy: AuthenticationStrategy;
  trackingId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  attribute?: InputMaybe<Scalars['String']['input']>;
  shaType?: InputMaybe<Scalars['String']['input']>;
  encryptionKey?: InputMaybe<Scalars['String']['input']>;
  purposeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarketingMethodPurposeUpdate = { __typename?: 'Mutation', marketingMethodPurposeUpdate?: { __typename?: 'User', id: string, selectedMarketingMethodPurposes: Array<{ __typename?: 'SelectedMarketingMethodPurpose', id: string, supportedMarketingMethodPurpose: { __typename?: 'SupportedMarketingMethodPurpose', marketingMethod: { __typename?: 'MarketingMethod', id: string, name: string }, marketingPurpose: { __typename?: 'MarketingPurpose', id: string, name: string, description: string } } }>, availableMarketingMethodPurposes: Array<{ __typename?: 'SupportedMarketingMethodPurpose', id: string, preselect: boolean, shippingCountry: { __typename?: 'ShippingCountry', id: string }, marketingMethod: { __typename?: 'MarketingMethod', id: string, name: string }, marketingPurpose: { __typename?: 'MarketingPurpose', id: string, name: string, description: string } }> } | null };

export type MarketingPreferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingPreferenceQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, selectedMarketingMethodPurposes: Array<{ __typename?: 'SelectedMarketingMethodPurpose', id: string, supportedMarketingMethodPurpose: { __typename?: 'SupportedMarketingMethodPurpose', marketingMethod: { __typename?: 'MarketingMethod', id: string, name: string }, marketingPurpose: { __typename?: 'MarketingPurpose', id: string, name: string, description: string } } }>, availableMarketingMethodPurposes: Array<{ __typename?: 'SupportedMarketingMethodPurpose', id: string, preselect: boolean, shippingCountry: { __typename?: 'ShippingCountry', id: string }, marketingMethod: { __typename?: 'MarketingMethod', id: string, name: string }, marketingPurpose: { __typename?: 'MarketingPurpose', id: string, name: string, description: string } }> } };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, link: string, altText?: string | null, order: number, text: string, image?: { __typename?: 'Image', src: string } | null }>, user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, subscription: { __typename?: 'Subscription', id: string, activeRafCampaignVariant?: { __typename?: 'RafCampaignVariant', rafCampaign: { __typename?: 'RafCampaign', name: string } } | null, referralLink: { __typename?: 'ClientReferralLink', referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number }> } | null } } } };

export type MerchRafCardQueryVariables = Exact<{ [key: string]: never; }>;


export type MerchRafCardQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, subscription: { __typename?: 'Subscription', id: string, referralLink: { __typename?: 'ClientReferralLink', referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number }> } | null } } } };

export type NavQueryVariables = Exact<{ [key: string]: never; }>;


export type NavQuery = { __typename?: 'Query', currentUser?: { __typename: 'Guest' } | { __typename: 'PreWizardGuest' } | { __typename: 'User' } | null };

export type GetUpsellableProductsVariables = Exact<{
  deliveryType?: InputMaybe<VariantDelivery>;
  num: Scalars['Int']['input'];
}>;


export type GetUpsellableProducts = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, preferredLanguage: Language, shippingCountryCode: Code, dogs?: Array<{ __typename?: 'Dog', id: string, name: string }> | null, subscription: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, isoDeliveryDate: any, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, frequency: Frequency, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string } }> }> } }, extrasUpsellRecommendations: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, slug: string, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', adjustedGrossPrice: number } | null, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', adjustedGrossPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, slug: string, name: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> } }> };

export type OrderProductsUpdateVariables = Exact<{
  userId: Scalars['ID']['input'];
  boxId: Scalars['ID']['input'];
  orderProducts: Array<ProductInput> | ProductInput;
}>;


export type OrderProductsUpdate = { __typename?: 'Mutation', orderProductsUpdate?: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', id: string, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> } | null } | null };

export type RecurringOrderProductsUpdateVariables = Exact<{
  userId: Scalars['ID']['input'];
  recurringOrderProducts: Array<ProductInput> | ProductInput;
  num: Scalars['Int']['input'];
}>;


export type RecurringOrderProductsUpdate = { __typename?: 'Mutation', recurringOrderProductsUpdate?: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> } | null };

export type WelcomeBackCardQueryVariables = Exact<{ [key: string]: never; }>;


export type WelcomeBackCardQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, subscription: { __typename?: 'Subscription', id: string, nextEditableBox?: { __typename?: 'Box', id: string, cutOffDate: any, amendable: boolean } | null } } };

export type BoxOrderSummaryModalFragment = { __typename?: 'Box', id: string, netPrice: number, price: number, order: { __typename?: 'Order', id?: string | null, deliveryFee: number, discountTotal?: number | null, physicalProductsTotal?: number | null, planTotal: number, planTotalPerDay: number, subtotal?: number | null, surchargeTotal: number, totalPrice: number } };

export type NonCoreOrderOrderSummaryModalFragment = { __typename?: 'NonCoreOrder', id: string, invoice: { __typename?: 'NonCoreInvoice', id: string, discountTotal: number, discountedPrice: number, grossPrice: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, orderProductsTotal: number, smallOrderSurcharge: number }> };

type OrderSummaryModalFragment_Box = { __typename?: 'Box', id: string, netPrice: number, price: number, order: { __typename?: 'Order', id?: string | null, deliveryFee: number, discountTotal?: number | null, physicalProductsTotal?: number | null, planTotal: number, planTotalPerDay: number, subtotal?: number | null, surchargeTotal: number, totalPrice: number } };

type OrderSummaryModalFragment_NonCoreOrder = { __typename?: 'NonCoreOrder', id: string, invoice: { __typename?: 'NonCoreInvoice', id: string, discountTotal: number, discountedPrice: number, grossPrice: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, orderProductsTotal: number, smallOrderSurcharge: number }> };

export type OrderSummaryModalFragment = OrderSummaryModalFragment_Box | OrderSummaryModalFragment_NonCoreOrder;

export type WhereToStartFragment = { __typename?: 'Dog', id: string, name: string, gender: Gender, possessivePronoun?: string | null, caloriesFedByPlan: number };

export type AddressFragment = { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } };

export type UserAddressFragment = { __typename?: 'User', id: string, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } };

export type UpdateDefaultAddressVariables = Exact<{
  userId: Scalars['ID']['input'];
  address: AddressInput;
  num: Scalars['Int']['input'];
}>;


export type UpdateDefaultAddress = { __typename?: 'Mutation', response?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', nextNBoxes: Array<{ __typename?: 'Box', id: string, isoDeliveryDate: any, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } }> }, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } } | null };

export type reactivationCampaignFragment = { __typename?: 'ReactivationCampaign', name: string, isActive: boolean, expiryDate?: any | null, description?: string | null, currentUserIsEligible: boolean, image?: { __typename?: 'Image', src: string } | null, discountCode: { __typename?: 'DiscountCode', id: string, code: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, discountType: DiscountCodePartDiscount, n?: number | null, value: number }> } };

export type ClientInitQueryVariables = Exact<{
  archivedType: ArchivedType;
}>;


export type ClientInitQuery = { __typename?: 'Query', nonCoreOrderDeliveryFee: number, nonCoreOrderSmallOrderFee: number, nonCoreOrderSmallOrderMinimumOrderValue: number, systemShouldShowAppContent?: string | null, shouldSeeXmasTheme?: string | null, shouldSeeOnlyMoveThisBoxCheckbox?: string | null, shouldSeePlanManagementPhase3?: string | null, shouldTrackErrorsOnErrorState?: string | null, shouldSeeUpcomingPriceRiseInfo?: string | null, shouldSeeSelfResolutions?: string | null, shouldSeeStap?: string | null, shouldSeeSwapToMFITBPlanOfferPage?: string | null, shouldSeeThankYouPagev3?: string | null, shouldSeeIntercom?: string | null, shouldSeePriceSensitivePausedPage?: string | null, shouldSeeSegmentedPausedPage?: string | null, shouldSeeNextDayDeliveryAvailableOnReactivation?: string | null, settings: Array<{ __typename?: 'Setting', name: string, value: boolean }>, notifications: Array<{ __typename?: 'Notification', id: string }>, currentAdminUser?: { __typename?: 'AdminUser', id: string } | null, user: { __typename?: 'User', id: string, firstName: string, affiliateType: Affiliate, preferredLanguage: Language, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, ageInMonths: number, eaterType: Eater }> | null, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, deliveriesReceived: number, increasedDeliveryCadencePlan?: { __typename?: 'Plan', id: string } | null, plan: { __typename?: 'Plan', id: string, durationInWeeks: number, numberOfPouches: number, pouchSize: number, swappablePlan?: { __typename?: 'Plan', id: string } | null, downsizeablePlan?: { __typename?: 'Plan', id: string } | null }, paymentMethods: Array<{ __typename?: 'BillingAgreement', id: string, active: boolean } | { __typename?: 'CreditCardPaymentMethod', id: string, active: boolean } | { __typename?: 'MerchantInitiatedPayment', id: string, active: boolean } | { __typename?: 'SepaDirectDebit', id: string, active: boolean }> }, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code, showExtras: boolean, showCare: boolean, defaultLanguage: Language } } };

export type DeliveryDateUserFragment = { __typename?: 'User', id: string, shippingCountry: { __typename?: 'ShippingCountry', id: string, showUpcomingOrderSeeMoreExtras: boolean }, subscription: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, isoDeliveryDate: any, editable: boolean }>, box?: { __typename?: 'Box', id: string, isoDeliveryDate: any, editable: boolean } | null } };

export type UpsellModalFragment = { __typename?: 'User', id: string, shippingCountryCode: Code, shippingCountry: { __typename?: 'ShippingCountry', id: string, showUpcomingOrderSeeMoreExtras: boolean }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string }> | null };

export type DeliveryDateUpdateVariables = Exact<{
  userId: Scalars['ID']['input'];
  boxId: Scalars['ID']['input'];
  selectedDeliveryDate: Scalars['ISO8601Date']['input'];
  deliveryAreaId?: InputMaybe<Scalars['ID']['input']>;
  adjustFutureBoxDates: Scalars['Boolean']['input'];
  triggerEvents?: InputMaybe<Scalars['Boolean']['input']>;
  nextNBoxes: Scalars['Int']['input'];
}>;


export type DeliveryDateUpdate = { __typename?: 'Mutation', boxDeliveryDateUpdate?: { __typename?: 'User', id: string, currentDeliveryAreaPreference?: { __typename?: 'DeliveryArea', id: string, preferredCarrierService: { __typename?: 'CarrierService', id: string, carrier: { __typename?: 'Carrier', name?: string | null } } } | null, subscription: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, isoDeliveryDate: any, editable: boolean }>, box?: { __typename?: 'Box', id: string, isoDeliveryDate: any } | null } } | null };

export type CourierDeliveryDatesQueryVariables = Exact<{
  boxId: Scalars['ID']['input'];
  nextNBoxes: Scalars['Int']['input'];
  calendarInitDate: Scalars['ISO8601Date']['input'];
  nDays: Scalars['Int']['input'];
  shouldAttemptToOfferNextDayDelivery: Scalars['Boolean']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CourierDeliveryDatesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, currentDeliveryAreaPreference?: { __typename?: 'DeliveryArea', id: string } | null, deliveryAreaOptions: Array<{ __typename?: 'DeliveryArea', id: string, regularDeliveryDaysOfWeek: Array<number>, preferredCarrierService: { __typename?: 'CarrierService', id: string, deliveryNotesLimit: number, carrier: { __typename?: 'Carrier', name?: string | null } }, calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, replacementDate?: any | null, endOfLeadTime: any }> }>, shippingCountry: { __typename?: 'ShippingCountry', id: string, showUpcomingOrderSeeMoreExtras: boolean }, subscription: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, isoDeliveryDate: any, editable: boolean }>, box?: { __typename?: 'Box', id: string, isoDeliveryDate: any, editable: boolean } | null } }, calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, replacementDate?: any | null, endOfLeadTime: any }> };

export type DeliveryDateQueryVariables = Exact<{
  boxId: Scalars['ID']['input'];
  nextNBoxes: Scalars['Int']['input'];
  calendarInitDate: Scalars['ISO8601Date']['input'];
  nDays?: InputMaybe<Scalars['Int']['input']>;
  shouldAttemptToOfferNextDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeliveryDateQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountry: { __typename?: 'ShippingCountry', id: string, showUpcomingOrderSeeMoreExtras: boolean }, subscription: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, isoDeliveryDate: any, editable: boolean }>, box?: { __typename?: 'Box', id: string, isoDeliveryDate: any, editable: boolean } | null } }, calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, replacementDate?: any | null, endOfLeadTime: any }> };

export type DeliveryDateModalQueryVariables = Exact<{
  calendarInitDate: Scalars['ISO8601Date']['input'];
  nDays?: InputMaybe<Scalars['Int']['input']>;
  city: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  shouldAttemptToOfferNextDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeliveryDateModalQuery = { __typename?: 'Query', calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, endOfLeadTime: any }> };

export type DeliveryDateModalWithCourierQueryVariables = Exact<{
  calendarInitDate: Scalars['ISO8601Date']['input'];
  nDays: Scalars['Int']['input'];
  city: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  shouldAttemptToOfferNextDayDelivery: Scalars['Boolean']['input'];
}>;


export type DeliveryDateModalWithCourierQuery = { __typename?: 'Query', deliveryAreaOptions: Array<{ __typename?: 'DeliveryArea', id: string, regularDeliveryDaysOfWeek: Array<number>, preferredCarrierService: { __typename?: 'CarrierService', id: string, deliveryNotesLimit: number, carrier: { __typename?: 'Carrier', name?: string | null } }, calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, replacementDate?: any | null, endOfLeadTime: any }> }>, calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, replacementDate?: any | null, endOfLeadTime: any }> };

export type PostcodeIsDeliverableQueryVariables = Exact<{
  postcode: Scalars['String']['input'];
}>;


export type PostcodeIsDeliverableQuery = { __typename?: 'Query', postcodeIsDeliverable: boolean };

export type CheckoutCurrentDiscountCodeVariables = Exact<{
  discountCodeId: Scalars['ID']['input'];
}>;


export type CheckoutCurrentDiscountCode = { __typename?: 'Query', discountCode: { __typename?: 'DiscountCode', id: string, code: string, discountBasis: DiscountCodePartDiscountBasis, value: number, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> } };

export type CheckoutAddDiscountToGuestVariables = Exact<{
  discountCode: Scalars['String']['input'];
}>;


export type CheckoutAddDiscountToGuest = { __typename?: 'Mutation', addDiscountToGuest?: { __typename?: 'AddDiscountToGuestPayload', guest: { __typename?: 'Guest', discountCode?: { __typename?: 'DiscountCode', id: string, code: string, discountBasis: DiscountCodePartDiscountBasis, value: number, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> } | null } } | null };

export type RedeemDiscountVariables = Exact<{
  userId: Scalars['ID']['input'];
  discountCode: Scalars['String']['input'];
}>;


export type RedeemDiscount = { __typename?: 'Mutation', redeemReactivationDiscount?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, alreadyRedeemedReactivationCampaign?: { __typename?: 'ReactivationCampaign', name: string, expiryDate?: any | null, description?: string | null, discountCode: { __typename?: 'DiscountCode', id: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> } } | null, previewUncreatedFutureBox: { __typename?: 'PreviewBox', isoDeliveryDate: any, order: { __typename?: 'Order', id?: string | null, totalPrice: number, surchargeTotal: number, planTotal: number, deliveryFee: number, subtotal?: number | null, discountTotal?: number | null, discountedSubtotalPricePerDay: number, subtotalPricePerDay: number } } } } | null };

export type RedeemedDiscountCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type RedeemedDiscountCodeQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, alreadyRedeemedReactivationCampaign?: { __typename?: 'ReactivationCampaign', name: string, expiryDate?: any | null, description?: string | null, discountCode: { __typename?: 'DiscountCode', id: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> } } | null } } };

export type orderSummaryFlavourFragment = { __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, primaryImage: { __typename?: 'Image', src: string }, recipeSurcharges: Array<{ __typename?: 'RecipeSurcharge', planSize: number, amount: number }> };

export type StripeChargeBoxOneAndSetupPaymentMethodVariables = Exact<{
  paymentMethodType: Scalars['String']['input'];
}>;


export type StripeChargeBoxOneAndSetupPaymentMethod = { __typename?: 'Mutation', stripeChargeBoxOneAndSetupPaymentMethod?: { __typename?: 'StripeChargeBoxOneAndSetupPaymentMethodPayload', stripeSecretToken?: string | null, paymentIntentId?: string | null, boxCanBeCharged: boolean } | null };

export type StripeUserParamsSetupIntentCreateVariables = Exact<{
  subscriptionData: SubscriptionDataInput;
  authenticationType: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
}>;


export type StripeUserParamsSetupIntentCreate = { __typename?: 'Mutation', stripeUserParamsSetupIntentCreate?: { __typename?: 'StripeUserParamsSetupIntentCreatePayload', paymentIntentId: string } | null };

export type ChargeIdFromPaymentIntentIdVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
  paymentMethodType: PaymentMethodType;
}>;


export type ChargeIdFromPaymentIntentId = { __typename?: 'Query', chargeIdFromPaymentIntentId: string };

export type SepaPaymentMethodIdFromIntentSecretVariables = Exact<{
  intentSecret: Scalars['String']['input'];
  intentType: IntentType;
}>;


export type SepaPaymentMethodIdFromIntentSecret = { __typename?: 'Query', sepaPaymentMethodIdFromIntentSecret: string };

export type billingRequestFlowCreateVariables = Exact<{
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  exitUrl?: InputMaybe<Scalars['String']['input']>;
  existingCustomerId?: InputMaybe<Scalars['String']['input']>;
  address: AddressInput;
  email: Scalars['String']['input'];
}>;


export type billingRequestFlowCreate = { __typename?: 'Mutation', billingRequestFlowCreate?: { __typename?: 'BillingRequestFlowCreatePayload', billingRequestId: string, billingRequestFlowId: string } | null };

export type CheckoutPageVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type CheckoutPage = { __typename?: 'Query', shouldSeeApplePay?: string | null, shouldSeeGooglePay?: string | null, shouldSeeFetchifyOnCheckout?: string | null, shouldSeeAltCountdown?: string | null, shouldSeeTabbedStripeCheckout?: string | null, shouldSeePayPal?: string | null, shouldSeeRequiredPhoneNumber?: string | null, shouldSeeSubscriptionInfo?: string | null, shippingCountries: Array<{ __typename?: 'ShippingCountry', active: boolean, availableLanguages: Array<Language>, code: Code, currency: Currency, defaultLanguage: Language, domain: string, id: string, name: string, scaEnforced: boolean, showExtras: boolean, trustpilotBusinessUnitId?: string | null }>, guest: { __typename?: 'Guest', id: string, firstName: string, lastName?: string | null, email?: string | null, numberOfAffiliateFreeBoxes: number, requiresPaymentDetailsOnCheckout: boolean, referredByAmbassador?: boolean | null, referredByInfluencer?: boolean | null, marketingPreference: MarketingPreferences, affiliateType: Affiliate, shouldSupportSca: boolean, assumedShippingCountry: { __typename?: 'ShippingCountry', active: boolean, availableLanguages: Array<Language>, code: Code, currency: Currency, defaultLanguage: Language, domain: string, id: string, name: string, scaEnforced: boolean, showExtras: boolean, trustpilotBusinessUnitId?: string | null }, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, discountBasis: DiscountCodePartDiscountBasis, value: number, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> } | null, dogs: Array<{ __typename?: 'Dog', name: string, dailyCalories: number, pouchSizeInGrams: number }>, pendingSubscription: { __typename?: 'PendingSubscription', plan: { __typename?: 'Plan', durationInDays: number, durationInWeeks: number, numberOfPouches: number, pouchSize: number, id: string, pouchesPerDay: number, trial: { __typename?: 'PlanTrial', lengthInDays: number }, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', dogId: string, gramsPerDay: number, name: string }>, nextUpcomingPrice?: { __typename?: 'ProductPrice', effectiveFrom: any } | null }, productVariants: Array<{ __typename?: 'PendingSubscriptionsProductVariant', discountedPrice?: number | null, productVariant: { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, netPrice: number }>, productCollection: { __typename?: 'ProductCollection', name: string, merchandisingImage: { __typename?: 'Image', src: string } } } }>, pendingSubscriptionFlavours: Array<{ __typename?: 'PendingSubscriptionFlavour', id: string, servings: number, sevenDayServings: number, trialBoxServings: number, flavour: { __typename?: 'NewFlavour', standardPricePerDay: number, id: string, name: string, slug: string, shortDescription: string, primaryImage: { __typename?: 'Image', src: string }, recipeSurcharges: Array<{ __typename?: 'RecipeSurcharge', planSize: number, amount: number }> } }> } } };

export type CheckoutPendingSubscriptionOrderPricingQueryVariables = Exact<{
  expectedFirstShippingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  planId: Scalars['ID']['input'];
}>;


export type CheckoutPendingSubscriptionOrderPricingQuery = { __typename?: 'Query', shouldSeeUpcomingPriceRiseInfo?: string | null, guest: { __typename?: 'Guest', id: string, pendingSubscription: { __typename?: 'PendingSubscription', id: string, standardOrderPricing: { __typename?: 'PendingSubscriptionOrderPricing', grossTotalPrice: number, netTotalPrice: number, netTotalPricePerDay: number, totalDiscountedAmount: number, grossCoreFoodPrice: number, grossCoreFoodPricePerDay: number, netCoreFoodPrice: number, coreFoodDiscountedAmount: number, grossRecipeSurchargePrice: number, netRecipeSurchargePrice: number, recipeSurchargeDiscountedAmount: number, grossDeliverySurchargePrice: number, netDeliverySurchargePrice: number, deliverySurchargeDiscountedAmount: number, grossAdditionalProductsPrice: number, netAdditionalProductsPrice: number, additionalProductsDiscountedAmount: number, totalSavedAmount: number, standardOrderCoreFoodGrossPrice: number, standardOrderCoreFoodGrossPricePerDay: number, flavourPricings: Array<{ __typename?: 'PendingSubscriptionOrderFlavourPricing', flavourName: string, servings: number, netStandardOrderPricePerServing: number, grossStandardOrderPricePerServing: number, netFirstOrderPricePerServing: number }> }, firstOrderPricing: { __typename?: 'PendingSubscriptionOrderPricing', grossTotalPrice: number, netTotalPrice: number, netTotalPricePerDay: number, totalDiscountedAmount: number, grossCoreFoodPrice: number, grossCoreFoodPricePerDay: number, netCoreFoodPrice: number, coreFoodDiscountedAmount: number, grossRecipeSurchargePrice: number, netRecipeSurchargePrice: number, recipeSurchargeDiscountedAmount: number, grossDeliverySurchargePrice: number, netDeliverySurchargePrice: number, deliverySurchargeDiscountedAmount: number, grossAdditionalProductsPrice: number, netAdditionalProductsPrice: number, additionalProductsDiscountedAmount: number, totalSavedAmount: number, standardOrderCoreFoodGrossPrice: number, standardOrderCoreFoodGrossPricePerDay: number, flavourPricings: Array<{ __typename?: 'PendingSubscriptionOrderFlavourPricing', flavourName: string, servings: number, netStandardOrderPricePerServing: number, grossStandardOrderPricePerServing: number, netFirstOrderPricePerServing: number }> }, secondOrderPricing: { __typename?: 'PendingSubscriptionOrderPricing', grossTotalPrice: number, netTotalPrice: number, netTotalPricePerDay: number, totalDiscountedAmount: number, grossCoreFoodPrice: number, grossCoreFoodPricePerDay: number, netCoreFoodPrice: number, coreFoodDiscountedAmount: number, grossRecipeSurchargePrice: number, netRecipeSurchargePrice: number, recipeSurchargeDiscountedAmount: number, grossDeliverySurchargePrice: number, netDeliverySurchargePrice: number, deliverySurchargeDiscountedAmount: number, grossAdditionalProductsPrice: number, netAdditionalProductsPrice: number, additionalProductsDiscountedAmount: number, totalSavedAmount: number, standardOrderCoreFoodGrossPrice: number, standardOrderCoreFoodGrossPricePerDay: number, flavourPricings: Array<{ __typename?: 'PendingSubscriptionOrderFlavourPricing', flavourName: string, servings: number, netStandardOrderPricePerServing: number, grossStandardOrderPricePerServing: number, netFirstOrderPricePerServing: number }> }, plan: { __typename?: 'Plan', durationInDays: number, numberOfPouches: number, pouchSize: number, id: string, pouchesPerDay: number, trial: { __typename?: 'PlanTrial', lengthInDays: number }, nextUpcomingPrice?: { __typename?: 'ProductPrice', effectiveFrom: any } | null }, pendingSubscriptionFlavours: Array<{ __typename?: 'PendingSubscriptionFlavour', id: string, flavour: { __typename?: 'NewFlavour', id: string, standardPricePerDay: number } }>, productVariants: Array<{ __typename?: 'PendingSubscriptionsProductVariant', discountedPrice?: number | null, productVariant: { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, netPrice: number }>, productCollection: { __typename?: 'ProductCollection', name: string, merchandisingImage: { __typename?: 'Image', src: string } } } }> } } };

export type DeliveryDatesVariables = Exact<{
  postcode: Scalars['String']['input'];
  city: Scalars['String']['input'];
}>;


export type DeliveryDates = { __typename?: 'Query', standardDeliveryFee: number, defaultSelectedDate: { __typename?: 'CalendarDate', date: any, deliverable: boolean, endOfLeadTime: any } };

export type DiscountCopyQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscountCopyQuery = { __typename?: 'Query', guest: { __typename?: 'Guest', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, discountType: DiscountCodePartDiscount, n?: number | null, value: number }> } | null } };

export type discountCodeFragment = { __typename?: 'DiscountCode', id: string, code: string, discountBasis: DiscountCodePartDiscountBasis, value: number, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> };

export type featureFlagFragment = { __typename?: 'Query', shouldSeeApplePay?: string | null, shouldSeeGooglePay?: string | null, shouldSeeFetchifyOnCheckout?: string | null, shouldSeeAltCountdown?: string | null, shouldSeeTabbedStripeCheckout?: string | null, shouldSeePayPal?: string | null, shouldSeeRequiredPhoneNumber?: string | null, shouldSeeSubscriptionInfo?: string | null };

export type pendingSubscriptionOrderPricingFragment = { __typename?: 'PendingSubscriptionOrderPricing', grossTotalPrice: number, netTotalPrice: number, netTotalPricePerDay: number, totalDiscountedAmount: number, grossCoreFoodPrice: number, grossCoreFoodPricePerDay: number, netCoreFoodPrice: number, coreFoodDiscountedAmount: number, grossRecipeSurchargePrice: number, netRecipeSurchargePrice: number, recipeSurchargeDiscountedAmount: number, grossDeliverySurchargePrice: number, netDeliverySurchargePrice: number, deliverySurchargeDiscountedAmount: number, grossAdditionalProductsPrice: number, netAdditionalProductsPrice: number, additionalProductsDiscountedAmount: number, totalSavedAmount: number, standardOrderCoreFoodGrossPrice: number, standardOrderCoreFoodGrossPricePerDay: number, flavourPricings: Array<{ __typename?: 'PendingSubscriptionOrderFlavourPricing', flavourName: string, servings: number, netStandardOrderPricePerServing: number, grossStandardOrderPricePerServing: number, netFirstOrderPricePerServing: number }> };

export type productVariantFragment = { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, netPrice: number }>, productCollection: { __typename?: 'ProductCollection', name: string, merchandisingImage: { __typename?: 'Image', src: string } } };

export type shippingCountryFragment = { __typename?: 'ShippingCountry', active: boolean, availableLanguages: Array<Language>, code: Code, currency: Currency, defaultLanguage: Language, domain: string, id: string, name: string, scaEnforced: boolean, showExtras: boolean, trustpilotBusinessUnitId?: string | null };

export type gocardlessUserParamCreateVariables = Exact<{
  planId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  userParams: Scalars['String']['input'];
}>;


export type gocardlessUserParamCreate = { __typename?: 'Mutation', gocardlessUserParamCreate?: { __typename?: 'GocardlessUserParamCreatePayload', gocardlessUserParam: { __typename?: 'GocardlessUserParam', id: string } } | null };

export type LoginUserVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginUser = { __typename?: 'Mutation', signInAuthorisedSubscribedCheckoutUser?: { __typename?: 'SignInAuthorisedSubscribedCheckoutUserPayload', token: string } | null };

export type UserTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTypeQuery = { __typename?: 'Query', currentUser?: { __typename: 'Guest' } | { __typename: 'PreWizardGuest' } | { __typename: 'User' } | null };

export type PlanConfirmationQueryVariables = Exact<{
  numOfBoxes: Scalars['Int']['input'];
}>;


export type PlanConfirmationQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, nextNBoxes: Array<{ __typename?: 'Box', id: string, isoDeliveryDate: any, editable: boolean }>, nextEditableBox?: { __typename?: 'Box', isoDeliveryDate: any } | null } } };

export type SmsDeliveryReminderMutationVariables = Exact<{
  smsDeliveryReminder: Scalars['Boolean']['input'];
}>;


export type SmsDeliveryReminderMutation = { __typename?: 'Mutation', smsDeliveryReminderUpdate?: { __typename?: 'User', id: string, shouldSendSmsDeliveryReminder: boolean } | null };

export type SmsDeliveryReminderQueryVariables = Exact<{ [key: string]: never; }>;


export type SmsDeliveryReminderQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shouldSendSmsDeliveryReminder: boolean } };

export type applyDiscount = { __typename?: 'CustomerIssueManagementResolutionDetailsApplyDiscount', discountCode: { __typename?: 'DiscountCode', id: string, code: string, value: number } };

export type replaceBox = { __typename?: 'CustomerIssueManagementResolutionDetailsReplaceBox', availableDeliveryDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, endOfLeadTime: any }>, defaultAddress: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } };

export type CustomerIssueEntryInputsCreateVariables = Exact<{
  reporterableType: CustomerIssueManagementReporterable;
  reporterableId: Scalars['ID']['input'];
  entryId: Scalars['ID']['input'];
  reasonId?: InputMaybe<Scalars['ID']['input']>;
  inputs: Array<CustomerIssueManagementInputInput> | CustomerIssueManagementInputInput;
}>;


export type CustomerIssueEntryInputsCreate = { __typename?: 'Mutation', response?: { __typename?: 'CustomerIssueEntryInputsCreatePayload', entryId: string, reportId: string, resolutionOffering?: { __typename?: 'CustomerIssueManagementResolutionOffering', id: string, resolutionType: CustomerIssueManagementResolutionResolutionType, details: { __typename?: 'CustomerIssueManagementResolutionDetailsApplyDiscount', discountCode: { __typename?: 'DiscountCode', id: string, code: string, value: number } } | { __typename?: 'CustomerIssueManagementResolutionDetailsHelpCentreArticle' } | { __typename?: 'CustomerIssueManagementResolutionDetailsReplaceBox', availableDeliveryDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, endOfLeadTime: any }>, defaultAddress: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } } | { __typename?: 'CustomerIssueManagementResolutionDetailsTrackOrder' } } | null } | null };

export type trackOrderResolutionDetailsFields = { __typename?: 'CustomerIssueManagementResolutionDetailsTrackOrder', boxId: string, trackingId?: string | null, trackingUrl: string, courierName: string, address1: string, address2: string };

export type helpCentreArticleResolutionDetailsFields = { __typename?: 'CustomerIssueManagementResolutionDetailsHelpCentreArticle', articleId: string };

export type CustomerIssueReportCreateVariables = Exact<{
  reportableType: CustomerIssueManagementReportable;
  reportableId: Scalars['ID']['input'];
  reporterableType: CustomerIssueManagementReporterable;
  reporterableId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
}>;


export type CustomerIssueReportCreate = { __typename?: 'Mutation', response?: { __typename?: 'CustomerIssueReportCreatePayload', entryId: string, reportId: string, categoryReasons?: Array<{ __typename?: 'CustomerIssueManagementCategoryReason', id: string, presentationalOrder: number, reasons: Array<{ __typename?: 'CustomerIssueManagementReason', description: string, id: string, key: string, name: string, parentId?: string | null, presentationalOrder?: number | null }> }> | null, inputFields?: Array<{ __typename: 'CustomerIssueManagementInputFieldAssociation', associationType: CustomerIssueManagementInputFieldAssociationAssociationType, associationDisplayType: CustomerIssueManagementInputFieldAssociationDisplayType, id: string, dataType: CustomerIssueManagementInputFieldDataType, description?: string | null, key: string, name: string, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat, allowedAssociationValues?: Array<{ __typename: 'Product', id: string }> | null } | { __typename: 'CustomerIssueManagementInputFieldBoolean', booleanDisplayType: CustomerIssueManagementInputFieldBooleanDisplayType, id: string, dataType: CustomerIssueManagementInputFieldDataType, description?: string | null, key: string, name: string, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat } | { __typename: 'CustomerIssueManagementInputFieldInteger', allowedIntegerValues?: Array<number> | null, integerDisplayType: CustomerIssueManagementInputFieldIntegerDisplayType, id: string, dataType: CustomerIssueManagementInputFieldDataType, description?: string | null, key: string, name: string, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat } | { __typename: 'CustomerIssueManagementInputFieldMultifield', multifieldDisplayType: CustomerIssueManagementInputFieldMultifieldDisplayType, id: string, dataType: CustomerIssueManagementInputFieldDataType, description?: string | null, key: string, name: string, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat, fields: Array<{ __typename: 'CustomerIssueManagementInputFieldAssociation', associationType: CustomerIssueManagementInputFieldAssociationAssociationType, associationDisplayType: CustomerIssueManagementInputFieldAssociationDisplayType, id: string, name: string, dataType: CustomerIssueManagementInputFieldDataType, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat, allowedAssociationValues?: Array<{ __typename: 'Product', id: string }> | null } | { __typename: 'CustomerIssueManagementInputFieldBoolean', booleanDisplayType: CustomerIssueManagementInputFieldBooleanDisplayType, id: string, name: string, dataType: CustomerIssueManagementInputFieldDataType, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat } | { __typename: 'CustomerIssueManagementInputFieldInteger', allowedIntegerValues?: Array<number> | null, integerDisplayType: CustomerIssueManagementInputFieldIntegerDisplayType, id: string, name: string, dataType: CustomerIssueManagementInputFieldDataType, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat } | { __typename: 'CustomerIssueManagementInputFieldMultifield', name: string, dataType: CustomerIssueManagementInputFieldDataType, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat } | { __typename: 'CustomerIssueManagementInputFieldString', allowedStringValues?: Array<string> | null, stringDisplayType: CustomerIssueManagementInputFieldStringDisplayType, id: string, name: string, dataType: CustomerIssueManagementInputFieldDataType, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat }> } | { __typename: 'CustomerIssueManagementInputFieldString', allowedStringValues?: Array<string> | null, stringDisplayType: CustomerIssueManagementInputFieldStringDisplayType, id: string, dataType: CustomerIssueManagementInputFieldDataType, description?: string | null, key: string, name: string, presentationalOrder: number, selectionFormat: CustomerIssueManagementInputFieldSelectionFormat }> | null, resolutionOffering?: { __typename?: 'CustomerIssueManagementResolutionOffering', id: string, resolutionType: CustomerIssueManagementResolutionResolutionType, details: { __typename?: 'CustomerIssueManagementResolutionDetailsApplyDiscount', type: CustomerIssueManagementResolutionResolutionType } | { __typename?: 'CustomerIssueManagementResolutionDetailsHelpCentreArticle', type: CustomerIssueManagementResolutionResolutionType, articleId: string } | { __typename?: 'CustomerIssueManagementResolutionDetailsReplaceBox', type: CustomerIssueManagementResolutionResolutionType } | { __typename?: 'CustomerIssueManagementResolutionDetailsTrackOrder', type: CustomerIssueManagementResolutionResolutionType, boxId: string, trackingId?: string | null, trackingUrl: string, courierName: string, address1: string, address2: string } } | null } | null };

export type CustomerIssueResolutionOfferingAcceptVariables = Exact<{
  acceptanceDetails: CustomerIssueManagementResolutionOfferingAcceptanceDetailsInput;
}>;


export type CustomerIssueResolutionOfferingAccept = { __typename?: 'Mutation', response?: { __typename?: 'CustomerIssueResolutionOfferingAcceptPayload', applicationDetails: { __typename?: 'CustomerIssueManagementResolutionApplicationDetailsApplyDiscount', type: CustomerIssueManagementResolutionResolutionType, resolutionRemnant: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', value: number }> } } | { __typename?: 'CustomerIssueManagementResolutionApplicationDetailsReplaceBox', type: CustomerIssueManagementResolutionResolutionType, resolutionRemnant: { __typename?: 'Box', id: string, isoDeliveryDate: any } }, user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language } } | null };

export type CustomerIssueResolutionOfferingRejectVariables = Exact<{
  rejectionDetails: CustomerIssueManagementResolutionOfferingRejectionDetailsInput;
}>;


export type CustomerIssueResolutionOfferingReject = { __typename?: 'Mutation', response?: { __typename?: 'CustomerIssueResolutionOfferingRejectPayload', resolutionOffering: { __typename?: 'CustomerIssueManagementResolutionOffering', id: string } } | null };

export type CustomerIssueManagementInitialDataQueryVariables = Exact<{
  reportableType: CustomerIssueManagementReportable;
  reportableId: Scalars['ID']['input'];
}>;


export type CustomerIssueManagementInitialDataQuery = { __typename?: 'Query', shouldSeeSelfResolutions?: string | null, user: { __typename?: 'User', id: string, preferredLanguage: Language, reportable?: { __typename?: 'Reportable', isoDeliveryDate: any, price: number, potentialMissingItems: Array<{ __typename?: 'PotentialMissingItem', name: string, category: string, quantity: number, price: number, thumbnail: string, productVariant: { __typename?: 'ProductVariant', id: string } }> } | null, dogs?: Array<{ __typename?: 'Dog', name: string }> | null }, categories?: Array<{ __typename?: 'CustomerIssueManagementCategory', description: string, id: string, key: string, name: string, parentId?: string | null, presentationalOrder: number }> | null };

export type FeedingTipsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedingTipsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, dogs?: Array<{ __typename?: 'Dog', id: string, eaterType: Eater }> | null } };

export type SuspendedSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type SuspendedSectionQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, suspendedForInsufficientFunds: boolean, activePaymentMethodType?: PaymentMethodable | null, increasedDeliveryCadencePlan?: { __typename?: 'Plan', id: string } | null } } };

export type BoxOrderFragment = { __typename?: 'Box', descriptor: Descriptor, amendable: boolean, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string }> } };

export type sampleProductUpsellableQueryVariables = Exact<{ [key: string]: never; }>;


export type sampleProductUpsellableQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, dogs?: Array<{ __typename?: 'Dog', gender: Gender, name: string }> | null, subscription: { __typename?: 'Subscription', upsellableSampleProduct?: { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', adjustedGrossPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, slug: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } | null } } };

export type upcomingBoxOrderFragment = { __typename?: 'Box', numberOfPouches: number, durationInDays: number, id: string, descriptor: Descriptor, deliveryDateAdjustedBySystem: boolean, isOneOffBox: boolean, isoDeliveryDate: any, shouldOfferSelfService: boolean, cutOffDate: any, shippingDate: any, isFreeBox: boolean, isTrialBox: boolean, isReplacementBox: boolean, isNextEditableBox: boolean, productSpacesFree: number, planPricePerDay: number, amendable: boolean, discounts: Array<{ __typename?: 'Discount', applicableDiscountPart?: { __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null }>, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, requiresPayment: boolean, visibilityScope: VisibilityScope, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number } };

export type nonCoreUpcomingOrderFragment = { __typename?: 'NonCoreOrder', id: string, descriptor: Descriptor, invoice: { __typename?: 'NonCoreInvoice', id: string, status: NonCoreInvoiceStatus, grossPrice: number, discountedPrice: number, discountTotal: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, smallOrderSurcharge: number, orderProductsTotal: number, deliveryDate: any, shippingDate: any, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> };

export type upcomingBoxQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type upcomingBoxQuery = { __typename?: 'Query', shouldSeeDeliveryTracking?: string | null, settings: Array<{ __typename?: 'Setting', name: string, value: boolean }>, user: { __typename?: 'User', id: string, currentDeliveryAreaPreference?: { __typename?: 'DeliveryArea', id: string, name: string, preferredCarrierService: { __typename?: 'CarrierService', id: string, carrier: { __typename?: 'Carrier', name?: string | null } } } | null, ordersByDate: Array<{ __typename?: 'Box', numberOfPouches: number, durationInDays: number, id: string, descriptor: Descriptor, deliveryDateAdjustedBySystem: boolean, isOneOffBox: boolean, isoDeliveryDate: any, shouldOfferSelfService: boolean, cutOffDate: any, shippingDate: any, isFreeBox: boolean, isTrialBox: boolean, isReplacementBox: boolean, isNextEditableBox: boolean, productSpacesFree: number, planPricePerDay: number, amendable: boolean, discounts: Array<{ __typename?: 'Discount', applicableDiscountPart?: { __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null }>, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, requiresPayment: boolean, visibilityScope: VisibilityScope, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number } } | { __typename?: 'NonCoreOrder', id: string, descriptor: Descriptor, invoice: { __typename?: 'NonCoreInvoice', id: string, status: NonCoreInvoiceStatus, grossPrice: number, discountedPrice: number, discountTotal: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, smallOrderSurcharge: number, orderProductsTotal: number, deliveryDate: any, shippingDate: any, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> }>, subscription: { __typename?: 'Subscription', id: string, firstBox: { __typename?: 'Box', id: string }, plan: { __typename?: 'Plan', id: string, pricePerDay: number, nextUpcomingPrice?: { __typename?: 'ProductPrice', value: number, effectiveFrom: any } | null } } } };

export type PetCareSectionDogsFragment = { __typename?: 'Dog', id: string, name: string, ageInMonths: number, breed: { __typename?: 'Breed', id: string, name: string }, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null };

export type DashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code, currency: Currency }, subscription: { __typename?: 'Subscription', id: string } } };

export type BoxOrderFragmentV3 = { __typename?: 'Box', descriptor: Descriptor, amendable: boolean, order: { __typename?: 'Order', id?: string | null, orderProducts: Array<{ __typename?: 'OrderProduct', id: string }> } };

export type UpdateBoxDeliveryAddressV3Variables = Exact<{
  userId: Scalars['ID']['input'];
  boxId: Scalars['ID']['input'];
  address: AddressInput;
  num: Scalars['Int']['input'];
}>;


export type UpdateBoxDeliveryAddressV3 = { __typename?: 'Mutation', boxAddressUpdate?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', id: string, isoDeliveryDate: any, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null, deliveryCarrier?: string | null } } | null, nextNBoxes: Array<{ __typename?: 'Box', id: string, isoDeliveryDate: any }> } } | null };

export type editBoxDeliveryAddressV3QueryVariables = Exact<{ [key: string]: never; }>;


export type editBoxDeliveryAddressV3Query = { __typename?: 'Query', user: { __typename?: 'User', id: string, currentDeliveryAreaPreference?: { __typename?: 'DeliveryArea', id: string, preferredCarrierService: { __typename?: 'CarrierService', id: string, deliveryNotesLimit: number } } | null, subscription: { __typename?: 'Subscription', id: string, nextEditableBox?: { __typename?: 'Box', id: string, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null } } | null }, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } };

export type upcomingBoxOrderFragmentV3 = { __typename?: 'Box', numberOfPouches: number, id: string, descriptor: Descriptor, movedFromUndeliverableDeliveryDate: boolean, isOneOffBox: boolean, isoDeliveryDate: any, cutOffDate: any, shippingDate: any, isFreeBox: boolean, isTrialBox: boolean, isReplacementBox: boolean, isNextEditableBox: boolean, productSpacesFree: number, planPricePerDay: number, amendable: boolean, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null }, invoices: Array<{ __typename?: 'NewInvoice', id: string, issueDate?: any | null, corrective: boolean, grossTotal: number }>, invoice: { __typename?: 'Invoice', id: string }, discounts: Array<{ __typename?: 'Discount', applicableDiscountPart?: { __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null }>, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, visibilityScope: VisibilityScope, requiresPayment: boolean, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } }> | null };

export type nonCoreUpcomingOrderFragmentV3 = { __typename?: 'NonCoreOrder', id: string, descriptor: Descriptor, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null }, invoice: { __typename?: 'NonCoreInvoice', id: string, status: NonCoreInvoiceStatus, grossPrice: number, discountedPrice: number, discountTotal: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, smallOrderSurcharge: number, orderProductsTotal: number, deliveryDate: any, shippingDate: any, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> };

export type upcomingBoxQueryV3Variables = Exact<{
  offset: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type upcomingBoxQueryV3 = { __typename?: 'Query', shouldSeeDeliveryTracking?: string | null, settings: Array<{ __typename?: 'Setting', name: string, value: boolean }>, user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountryCode: Code, currentDeliveryAreaPreference?: { __typename?: 'DeliveryArea', id: string, name: string, preferredCarrierService: { __typename?: 'CarrierService', id: string, carrier: { __typename?: 'Carrier', name?: string | null } } } | null, orders: Array<{ __typename?: 'Box', numberOfPouches: number, id: string, descriptor: Descriptor, movedFromUndeliverableDeliveryDate: boolean, isOneOffBox: boolean, isoDeliveryDate: any, cutOffDate: any, shippingDate: any, isFreeBox: boolean, isTrialBox: boolean, isReplacementBox: boolean, isNextEditableBox: boolean, productSpacesFree: number, planPricePerDay: number, amendable: boolean, netPrice: number, price: number, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null }, invoices: Array<{ __typename?: 'NewInvoice', id: string, issueDate?: any | null, corrective: boolean, grossTotal: number }>, invoice: { __typename?: 'Invoice', id: string }, discounts: Array<{ __typename?: 'Discount', applicableDiscountPart?: { __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null }>, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, subtotal?: number | null, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, visibilityScope: VisibilityScope, requiresPayment: boolean, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } }> | null } | { __typename?: 'NonCoreOrder', id: string, descriptor: Descriptor, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null }, invoice: { __typename?: 'NonCoreInvoice', id: string, status: NonCoreInvoiceStatus, grossPrice: number, discountedPrice: number, discountTotal: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, smallOrderSurcharge: number, orderProductsTotal: number, deliveryDate: any, shippingDate: any, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> }>, shippingCountry: { __typename?: 'ShippingCountry', id: string, showInvoiceDownloadDirections: boolean }, subscription: { __typename?: 'Subscription', id: string, firstBox: { __typename?: 'Box', id: string } } } };

export type fetchMoreOrdersQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type fetchMoreOrdersQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, orders: Array<{ __typename?: 'Box', numberOfPouches: number, id: string, descriptor: Descriptor, movedFromUndeliverableDeliveryDate: boolean, isOneOffBox: boolean, isoDeliveryDate: any, cutOffDate: any, shippingDate: any, isFreeBox: boolean, isTrialBox: boolean, isReplacementBox: boolean, isNextEditableBox: boolean, productSpacesFree: number, planPricePerDay: number, amendable: boolean, netPrice: number, price: number, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null }, invoices: Array<{ __typename?: 'NewInvoice', id: string, issueDate?: any | null, corrective: boolean, grossTotal: number }>, invoice: { __typename?: 'Invoice', id: string }, discounts: Array<{ __typename?: 'Discount', applicableDiscountPart?: { __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null }>, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, subtotal?: number | null, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, visibilityScope: VisibilityScope, requiresPayment: boolean, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } }> | null } | { __typename?: 'NonCoreOrder', id: string, descriptor: Descriptor, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null }, invoice: { __typename?: 'NonCoreInvoice', id: string, status: NonCoreInvoiceStatus, grossPrice: number, discountedPrice: number, discountTotal: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, smallOrderSurcharge: number, orderProductsTotal: number, deliveryDate: any, shippingDate: any, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> }> } };

export type DashboardV3QueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardV3Query = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code, currency: Currency }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, planPortionInGrams: number, gender: Gender, ageInMonths: number, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, plan: { __typename?: 'Plan', id: string, pouchSize: number, pouchesPerDay: number, servingInformation: { __typename?: 'PlanServingInformation', gramsPerDay: number, numberOfServings: number, pouchesPerServing: number, roundedCaloriesPerDay: number, servingSize: number, servingType: Serving } } } } };

export type DirectSalesStripeUserParamsSetupIntentCreateVariables = Exact<{
  subscriptionData: SubscriptionDataInput;
  authenticationType: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
}>;


export type DirectSalesStripeUserParamsSetupIntentCreate = { __typename?: 'Mutation', stripeUserParamsSetupIntentCreate?: { __typename?: 'StripeUserParamsSetupIntentCreatePayload', paymentIntentId: string } | null };

export type DirectSalesStripeCustomerCreateVariables = Exact<{
  email: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
}>;


export type DirectSalesStripeCustomerCreate = { __typename?: 'Mutation', directSalesStripeCustomerCreate?: { __typename?: 'DirectSalesStripeCustomerCreatePayload', paymentIntentId: string } | null };

export type DirectSalesAppSubscriptionCreateVariables = Exact<{
  email: Scalars['String']['input'];
  discountCodeId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  address: AddressInput;
  subscriptionInput: SubscriptionInput;
  chargedOnBoxOne?: InputMaybe<Scalars['Boolean']['input']>;
  supportedMarketingMethodPurposeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type DirectSalesAppSubscriptionCreate = { __typename?: 'Mutation', directSalesSubscriptionCreate?: { __typename?: 'DirectSalesSubscriptionCreatePayload', firstDeliveryDate: any, userSignInUrl: string, userId: string, referralLinkUrl: string, firstInvoiceStatus: InvoiceStatus, dsRepTrackingId: string, dsRepTeam: string } | null };

export type SendAppSMSVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type SendAppSMS = { __typename?: 'Mutation', sendAppSms?: { __typename?: 'SendAppSMSPayload', success: boolean, errorMessage?: MutationMessage | null } | null };

export type SendRafSMSVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type SendRafSMS = { __typename?: 'Mutation', sendRafSms?: { __typename?: 'SendRafSMSPayload', success: boolean, errorMessage?: MutationMessage | null } | null };

export type DirectSalesPaymentQueryVariables = Exact<{
  pendingSubscriptionId: Scalars['ID']['input'];
}>;


export type DirectSalesPaymentQuery = { __typename?: 'Query', directSalesPendingSubscription: { __typename?: 'DirectSalesPendingSubscription', consentedToMarketing: boolean, marketingPreferences: MarketingPreferences, phoneNumber: string, pendingSubscription: { __typename?: 'PendingSubscription', id: string, user: { __typename?: 'Guest', id: string, email?: string | null, preferredLanguage: Language, firstName: string, lastName?: string | null, dogs: Array<{ __typename?: 'Dog', gender: Gender, name: string, id: string, ageInMonths: number, dailyCalories: number, dailyGrams: number, eaterType: Eater, neutered: boolean, possessivePronoun?: string | null, pouchSizeInGrams: number, weightInGrams: number, breed: { __typename?: 'Breed', id: string, key: string, name: string }, dogProfile?: { __typename?: 'DogProfile', avatarUrl?: string | null, description?: string | null } | null }> }, plan: { __typename?: 'Plan', id: string, numberOfPouches: number, pouchSize: number, pouchesPerDay: number, price: number, durationInDays: number, typeOfPlanForCustomer: TypeOfPlan, trialLengthInDays: number, pricesPerDayPerDogs: Array<{ __typename?: 'DogPricing', name: string, pricePerDayWithoutDiscount: number, pricePerDayWithDiscount: number }> }, pendingSubscriptionFlavours: Array<{ __typename?: 'PendingSubscriptionFlavour', id: string, trialBoxServings: number, sevenDayServings: number, flavour: { __typename?: 'NewFlavour', name: string, slug: string, themeColour: string, thumbnail: { __typename?: 'Image', src: string } } }>, productVariants: Array<{ __typename?: 'PendingSubscriptionsProductVariant', discountedPrice?: number | null, productVariant: { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, discountedPrice?: number | null, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number, adjustedGrossPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, name: string } } }> }, address: { __typename?: 'Address', address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', code: Code, id: string, currency: Currency } }, discountCode?: { __typename?: 'DiscountCode', id: string, discountBasis: DiscountCodePartDiscountBasis, value: number, n?: number | null, discountType: DiscountCodePartDiscount, code: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number, discountBasis: DiscountCodePartDiscountBasis, discountType: DiscountCodePartDiscount, n?: number | null }> } | null } };

export type DirectSalesPendingSubscriptionOrderPricesVariables = Exact<{
  planId: Scalars['ID']['input'];
  discountCodeId: Scalars['ID']['input'];
  productVariantIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  flavourQuantities: MealInput;
  oneOffProductsPresent: Scalars['Boolean']['input'];
}>;


export type DirectSalesPendingSubscriptionOrderPrices = { __typename?: 'Query', pendingSubscriptionOrderPrices: Array<{ __typename?: 'PendingSubscriptionOrderPricing', grossTotalPrice: number, netTotalPrice: number, netTotalPricePerDay: number, totalDiscountedAmount: number, grossCoreFoodPrice: number, netCoreFoodPrice: number, coreFoodDiscountedAmount: number, grossCoreFoodPricePerDay: number, netCoreFoodPricePerDay: number, grossRecipeSurchargePrice: number, netRecipeSurchargePrice: number, recipeSurchargeDiscountedAmount: number, grossDeliverySurchargePrice: number, netDeliverySurchargePrice: number, deliverySurchargeDiscountedAmount: number, grossOneOffAdditionalProductsPrice: number, additionalProductsDiscountedAmount: number, netOneOffAdditionalProductsPrice: number, grossAdditionalProductsPrice: number, netAdditionalProductsPrice: number, additionalProductPrices: Array<{ __typename?: 'PendingSubscriptionOrderPricingExtras', id: string, recurringPrice: number, oneOffPrice: number, discountedRecurringPrice: number, discountedOneOffPrice: number }> }> };

export type DirectSalesChargeIdFromPaymentIntentIdVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
  paymentMethodType: PaymentMethodType;
}>;


export type DirectSalesChargeIdFromPaymentIntentId = { __typename?: 'Query', chargeIdFromPaymentIntentId: string };

export type DirectSalesSepaPaymentMethodIdFromIntentSecretVariables = Exact<{
  intentSecret: Scalars['String']['input'];
  intentType: IntentType;
}>;


export type DirectSalesSepaPaymentMethodIdFromIntentSecret = { __typename?: 'Query', sepaPaymentMethodIdFromIntentSecret: string };

export type RetrieveRafUrlVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetrieveRafUrl = { __typename?: 'Query', user: { __typename?: 'User', subscription: { __typename?: 'Subscription', referralLink: { __typename?: 'ClientReferralLink', url: string } } } };

export type ArchiveDogProfileActionDogFragment = { __typename?: 'Dog', id: string, name: string, gender: Gender };

export type ArchiveDogProfileActionQueryFragment = { __typename?: 'Query', archiveReasons: Array<string> };

export type ArchiveDogProfileMutationVariables = Exact<{
  dogIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  archiveReason: Scalars['String']['input'];
}>;


export type ArchiveDogProfileMutation = { __typename?: 'Mutation', archiveDogs?: { __typename?: 'ArchiveDogsPayload', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string }> | null } } | null };

export type CalorieDetailsFragment = { __typename?: 'Dog', id: string, name: string, gender: Gender, possessivePronoun?: string | null, planPortionInGrams: number, roundedDailyCaloriesExceededByPlanPortion: number, roundedDailyCaloriesExceededByPlanPortionInPercentage: number, roundedPlanPortionInCalories: number, roundedPlanPortionInPercentage: number, roundedUncappedPlanPortionInPercentage: number, snackingHabits: SnackingHabit, roundedDailyCaloriesUnfulfilledByPlanPortionLowerBoundary: number, roundedDailyCaloriesUnfulfilledByPlanPortionUpperBoundary: number, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number };

export type DailyPortionSizeFragment = { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, possessivePronoun?: string | null, gender: Gender, planPortionInGrams: number, roundedDailyCaloriesExceededByPlanPortion: number, roundedDailyCaloriesExceededByPlanPortionInPercentage: number, roundedPlanPortionInCalories: number, roundedPlanPortionInPercentage: number, roundedUncappedPlanPortionInPercentage: number, snackingHabits: SnackingHabit, roundedDailyCaloriesUnfulfilledByPlanPortionLowerBoundary: number, roundedDailyCaloriesUnfulfilledByPlanPortionUpperBoundary: number, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number }> | null };

export type DogProfilePictureFragment = { __typename?: 'Dog', id: string, name: string, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null, avatarImageAttached: boolean } | null };

export type DogSelectionFragment = { __typename?: 'Dog', id: string, name: string, ageInMonths: number, breed: { __typename?: 'Breed', id: string, name: string, key: string }, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null };

export type SelectableDogAvatarFragment = { __typename?: 'Dog', id: string, name: string, ageInMonths: number, breed: { __typename?: 'Breed', id: string, name: string, key: string }, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null };

export type ShareProfileFragment = { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, referralLink: { __typename?: 'ClientReferralLink', url: string } }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, possessivePronoun?: string | null, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null, favouriteGame?: FavouriteGame | null, dogActivities: Array<{ __typename?: 'DogActivity', activity: Activity }>, dogPersonalityTraits: Array<{ __typename?: 'DogPersonalityTrait', trait: Trait }> } | null }> | null };

export type ShareRafPassFragment = { __typename?: 'User', id: string, shippingCountryCode: Code, subscription: { __typename?: 'Subscription', id: string, referralLink: { __typename?: 'ClientReferralLink', referralLinkTypeName: string, referralDiscountsTotalValue: number, url: string, referralDiscount: { __typename?: 'DiscountCode', id: string, code: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, n?: number | null }> }, referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', value: number, discountBasis: ApplicableDiscountPartDiscountBasis, n: number, discountType: ApplicableDiscountPartDiscount }> } | null, referrals: Array<{ __typename?: 'Referral', refereeFirstName: string, refereeDogNames: Array<string>, refereeSignUpDate: any }> } }, dogs?: Array<{ __typename?: 'Dog', id: string, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null };

export type CreateDogProfileMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  dogIdsInput: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateDogProfileMutation = { __typename?: 'Mutation', dogProfilesCreate?: { __typename?: 'Subscription', id: string } | null };

export type UpdateDogProfilePictureMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  avatarsInput: Array<AvatarInput> | AvatarInput;
}>;


export type UpdateDogProfilePictureMutation = { __typename?: 'Mutation', avatarsUpdate?: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null } | null };

export type DogProfileQueryVariables = Exact<{
  caloriesMultipleOf: Scalars['Int']['input'];
  percentageMultipleOf: Scalars['Int']['input'];
  lowerPercentage: Scalars['Int']['input'];
  upperPercentage: Scalars['Int']['input'];
}>;


export type DogProfileQuery = { __typename?: 'Query', archiveReasons: Array<string>, user: { __typename?: 'User', id: string, firstName: string, shippingCountryCode: Code, preferredLanguage: Language, shippingCountry: { __typename?: 'ShippingCountry', id: string, showCare: boolean, vetNurseCalendlyUrl: string }, dogs?: Array<{ __typename?: 'Dog', id: string, gender: Gender, eaterType: Eater, snackingHabits: SnackingHabit, possessivePronoun?: string | null, weightInGrams: number, bodyShape: BodyShape, exercise: Exercise, neutered: boolean, name: string, planPortionInGrams: number, roundedDailyCaloriesExceededByPlanPortion: number, roundedDailyCaloriesExceededByPlanPortionInPercentage: number, roundedPlanPortionInCalories: number, roundedPlanPortionInPercentage: number, roundedUncappedPlanPortionInPercentage: number, ageInMonths: number, roundedDailyCaloriesUnfulfilledByPlanPortionLowerBoundary: number, roundedDailyCaloriesUnfulfilledByPlanPortionUpperBoundary: number, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number, breed: { __typename?: 'Breed', id: string, key: string, name: string }, healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string }>, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }>, recommendedCareDetails: { __typename?: 'RecommendedCareDetails', careType: string }, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null, favouriteGame?: FavouriteGame | null, avatarImageAttached: boolean, dogActivities: Array<{ __typename?: 'DogActivity', activity: Activity }>, dogPersonalityTraits: Array<{ __typename?: 'DogPersonalityTrait', trait: Trait }> } | null }> | null, subscription: { __typename?: 'Subscription', id: string, referralLink: { __typename?: 'ClientReferralLink', url: string, referralLinkTypeName: string, referralDiscountsTotalValue: number, referralDiscount: { __typename?: 'DiscountCode', id: string, code: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, n?: number | null }> }, referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', value: number, discountBasis: ApplicableDiscountPartDiscountBasis, n: number, discountType: ApplicableDiscountPartDiscount }> } | null, referrals: Array<{ __typename?: 'Referral', refereeFirstName: string, refereeDogNames: Array<string>, refereeSignUpDate: any }> } } } };

export type DogProfileMedicalFragment = { __typename?: 'Dog', id: string, name: string, possessivePronoun?: string | null, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }>, healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string }>, recommendedCareDetails: { __typename?: 'RecommendedCareDetails', careType: string } };

export type DogProfilePersonalityDetailsFragment = { __typename?: 'Dog', id: string, ageInMonths: number, name: string, neutered: boolean, gender: Gender, possessivePronoun?: string | null, planPortionInGrams: number, roundedPlanPortionInCalories: number, breed: { __typename?: 'Breed', id: string, key: string, name: string } };

export type DogProfileWeightAndAppetiteFragment = { __typename?: 'Dog', id: string, weightInGrams: number, bodyShape: BodyShape, exercise: Exercise, eaterType: Eater, snackingHabits: SnackingHabit };

export type DogProfileV2QueryVariables = Exact<{
  caloriesMultipleOf: Scalars['Int']['input'];
}>;


export type DogProfileV2Query = { __typename?: 'Query', archiveReasons: Array<string>, user: { __typename?: 'User', id: string, firstName: string, shippingCountryCode: Code, preferredLanguage: Language, shippingCountry: { __typename?: 'ShippingCountry', id: string, showCare: boolean, vetNurseCalendlyUrl: string }, subscription: { __typename?: 'Subscription', id: string, plan: { __typename?: 'Plan', id: string, pouchSize: number, pouchesPerDay: number, servingInformation: { __typename?: 'PlanServingInformation', gramsPerDay: number, numberOfServings: number, pouchesPerServing: number, roundedCaloriesPerDay: number, servingSize: number, servingType: Serving } }, referralLink: { __typename?: 'ClientReferralLink', url: string, referralLinkTypeName: string, referralDiscountsTotalValue: number, referralDiscount: { __typename?: 'DiscountCode', id: string, code: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, n?: number | null }> }, referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', value: number, discountBasis: ApplicableDiscountPartDiscountBasis, n: number, discountType: ApplicableDiscountPartDiscount }> } | null, referrals: Array<{ __typename?: 'Referral', refereeFirstName: string, refereeDogNames: Array<string>, refereeSignUpDate: any }> } }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, possessivePronoun?: string | null, ageInMonths: number, neutered: boolean, gender: Gender, planPortionInGrams: number, roundedPlanPortionInCalories: number, weightInGrams: number, bodyShape: BodyShape, exercise: Exercise, eaterType: Eater, snackingHabits: SnackingHabit, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null, favouriteGame?: FavouriteGame | null, avatarImageAttached: boolean, dogActivities: Array<{ __typename?: 'DogActivity', activity: Activity }>, dogPersonalityTraits: Array<{ __typename?: 'DogPersonalityTrait', trait: Trait }> } | null, breed: { __typename?: 'Breed', id: string, key: string, name: string }, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }>, healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string }>, recommendedCareDetails: { __typename?: 'RecommendedCareDetails', careType: string } }> | null } };

export type DownsizeAndSavePageQueryVariables = Exact<{ [key: string]: never; }>;


export type DownsizeAndSavePageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, dogs?: Array<{ __typename?: 'Dog', id: string, gender: Gender }> | null, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, recurringOrder: { __typename?: 'RecurringOrder', deliveryFee: number, planTotal: number, planTotalPerDay: number }, plan: { __typename?: 'Plan', id: string, pouchSize: number, numberOfPouches: number, durationInDays: number, typeOfPlanForCustomer: TypeOfPlan, servingSize: number, downsizeablePlan?: { __typename?: 'Plan', id: string, price: number, pricePerDay: number, pouchSize: number, numberOfPouches: number, durationInDays: number, typeOfPlanForCustomer: TypeOfPlan, servingSize: number } | null } } } };

export type EditDailyAmountDogFragment = { __typename?: 'Dog', id: string, name: string, ageInMonths: number, gender: Gender, possessivePronoun?: string | null, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number, caloriesFedByPlan: number, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null };

export type EditDailyAmountPlanFragment = { __typename?: 'Plan', id: string, pouchSize: number, durationInWeeks: number, numberOfPouches: number, pricePerDay: number, pouchesPerDay: number, servingInformation: { __typename?: 'PlanServingInformation', roundedCaloriesPerDay: number, gramsPerDay: number }, portioningForDogs: Array<{ __typename?: 'DogPlanPortioning', dogId: string, portionInGrams: number, roundedPortionInCalories: number }> };

export type EditDailyAmountFragment = { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, ageInMonths: number, gender: Gender, possessivePronoun?: string | null, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number, caloriesFedByPlan: number, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null, availablePlans: Array<{ __typename?: 'Plan', id: string, pouchSize: number, durationInWeeks: number, numberOfPouches: number, pricePerDay: number, pouchesPerDay: number, servingInformation: { __typename?: 'PlanServingInformation', roundedCaloriesPerDay: number, gramsPerDay: number }, portioningForDogs: Array<{ __typename?: 'DogPlanPortioning', dogId: string, portionInGrams: number, roundedPortionInCalories: number }> }>, subscription: { __typename?: 'Subscription', id: string, plan: { __typename?: 'Plan', id: string, pouchSize: number, durationInWeeks: number, numberOfPouches: number, pricePerDay: number, pouchesPerDay: number, servingInformation: { __typename?: 'PlanServingInformation', roundedCaloriesPerDay: number, gramsPerDay: number }, portioningForDogs: Array<{ __typename?: 'DogPlanPortioning', dogId: string, portionInGrams: number, roundedPortionInCalories: number }> } } };

export type EditDailyAmountQueryVariables = Exact<{
  scopeType?: InputMaybe<AvailablePlansScopeType>;
  caloriesMultipleOf: Scalars['Int']['input'];
  lowerPercentage: Scalars['Int']['input'];
  upperPercentage: Scalars['Int']['input'];
}>;


export type EditDailyAmountQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, ageInMonths: number, gender: Gender, possessivePronoun?: string | null, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number, caloriesFedByPlan: number, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null, availablePlans: Array<{ __typename?: 'Plan', id: string, pouchSize: number, durationInWeeks: number, numberOfPouches: number, pricePerDay: number, pouchesPerDay: number, servingInformation: { __typename?: 'PlanServingInformation', roundedCaloriesPerDay: number, gramsPerDay: number }, portioningForDogs: Array<{ __typename?: 'DogPlanPortioning', dogId: string, portionInGrams: number, roundedPortionInCalories: number }> }>, subscription: { __typename?: 'Subscription', id: string, plan: { __typename?: 'Plan', id: string, pouchSize: number, durationInWeeks: number, numberOfPouches: number, pricePerDay: number, pouchesPerDay: number, servingInformation: { __typename?: 'PlanServingInformation', roundedCaloriesPerDay: number, gramsPerDay: number }, portioningForDogs: Array<{ __typename?: 'DogPlanPortioning', dogId: string, portionInGrams: number, roundedPortionInCalories: number }> } } } };

export type EditDeliveryFrequencyFragment = { __typename?: 'User', id: string, availablePlans: Array<{ __typename?: 'Plan', id: string, numberOfPouches: number, durationInWeeks: number, pricePerDay: number, pouchSize: number }> };

export type EditDeliveryFrequencyPlanFragment = { __typename?: 'Plan', id: string, numberOfPouches: number, durationInWeeks: number, pricePerDay: number, pouchSize: number };

export type EditDeliveryFrequencyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  nextNBoxesNum: Scalars['Int']['input'];
}>;


export type EditDeliveryFrequencyMutation = { __typename?: 'Mutation', subscriptionPlanUpdate?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, plan: { __typename?: 'Plan', id: string, numberOfPouches: number, durationInWeeks: number, pricePerDay: number, pouchSize: number }, nextNBoxes: Array<{ __typename?: 'Box', id: string, numberOfPouches: number, durationInDays: number, isoDeliveryDate: any, editable: boolean, netPrice: number, price: number, plan: { __typename?: 'Plan', id: string, pouchSize: number }, order: { __typename?: 'Order', id?: string | null, deliveryFee: number, discountTotal?: number | null, physicalProductsTotal?: number | null, planTotal: number, planTotalPerDay: number, subtotal?: number | null, surchargeTotal: number, totalPrice: number } }> } } | null };

export type EditDeliveryFrequencyQueryVariables = Exact<{
  scopeType?: InputMaybe<AvailablePlansScopeType>;
}>;


export type EditDeliveryFrequencyQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, availablePlans: Array<{ __typename?: 'Plan', id: string, numberOfPouches: number, durationInWeeks: number, pricePerDay: number, pouchSize: number }> } };

export type DogDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type DogDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, ageInMonths: number, weightInGrams: number, bodyShape: BodyShape, exercise: Exercise, neutered: boolean, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null, breed: { __typename?: 'Breed', id: string, key: string, name: string }, healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string }>, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }> }> | null }, healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string, warning: boolean, information: string }>, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }> };

export type DogsUpdateVariables = Exact<{
  userId: Scalars['ID']['input'];
  attributes: Array<DogUpdateInput> | DogUpdateInput;
}>;


export type DogsUpdate = { __typename?: 'Mutation', dogsUpdate?: { __typename?: 'User', dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, ageInMonths: number, ageClassificationByUserWhenCreated: AgeClassificationByUserWhenCreated, dailyCalories: number, weightInGrams: number, bodyShape: BodyShape, exercise: Exercise, neutered: boolean, healthIssues: Array<{ __typename?: 'HealthIssue', id: string }>, allergens: Array<{ __typename?: 'Allergen', id: string }>, dogProfile?: { __typename?: 'DogProfile', avatarUrl?: string | null } | null }> | null, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', id: string, numberOfPouches: number, durationInDays: number, pricePerPouch: number, pouchSize: number, group: Group, pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } } } } | null };

export type EditPlanPageQueryVariables = Exact<{ [key: string]: never; }>;


export type EditPlanPageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountryCode: Code, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, planPortionInGrams: number }> | null, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, meal?: Array<{ __typename?: 'Meal', quantity: number, flavour: { __typename?: 'NewFlavour', id: string, slug: string, thumbnail: { __typename?: 'Image', src: string } } }> | null, previewUncreatedFutureBox: { __typename?: 'PreviewBox', isoDeliveryDate: any, plan: { __typename?: 'Plan', pricePerDay: number, id: string } } } } };

export type SaveFreshMealsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  meal: MealInput;
}>;


export type SaveFreshMealsMutation = { __typename?: 'Mutation', mealUpdate?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, recipeSurcharge?: number | null } }> | null };

export type MealFlavoursQueryVariables = Exact<{
  num: Scalars['Int']['input'];
  calculationType?: InputMaybe<RecipeSurchargeCalculation>;
}>;


export type MealFlavoursQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountry: { __typename?: 'ShippingCountry', id: string, showUpcomingOrderSeeMoreExtras: boolean }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, allergens: Array<{ __typename?: 'Allergen', id: string, name: string, flavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string }> }> }> | null, subscription: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, isNextEditableBox: boolean, isoDeliveryDate: any, amendable: boolean }>, plan: { __typename?: 'Plan', id: string, numberOfPouches: number, servingType: Serving, pouchSize: number, servingInformation: { __typename?: 'PlanServingInformation', pouchesPerServing: number } }, meal?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, slug: string, flavour: { __typename?: 'NewFlavour', id: string, slug: string, recipeSurcharge?: number | null, name: string, longDescription: string, composition: string, additives: string, flavourPriority: { __typename?: 'FlavourPriority', priority: number }, productBenefits: Array<{ __typename?: 'ProductBenefit', name: string, id: string, image?: { __typename?: 'Image', src: string } | null }>, thumbnail: { __typename?: 'Image', src: string }, flavourConstituents: Array<{ __typename?: 'FlavourConstituent', percentage: number, constituent: { __typename?: 'Constituent', name: string } }>, images: Array<{ __typename?: 'Image', src: string }>, primaryImage: { __typename?: 'Image', src: string } } }> | null } } };

export type SaveFreshMealsUpdateQueryVariables = Exact<{ [key: string]: never; }>;


export type SaveFreshMealsUpdateQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number }> | null }>, meal?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number }> | null } } };

export type BasketButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type BasketButtonQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, basket?: { __typename?: 'Basket', id: string, basketProducts: Array<{ __typename?: 'BasketProduct', id: string, quantity: number }> } | null } };

export type BasketProductsUpdateVariables = Exact<{
  userId: Scalars['ID']['input'];
  basketProductVariants: Array<ProductVariantInput> | ProductVariantInput;
}>;


export type BasketProductsUpdate = { __typename?: 'Mutation', basketProductsUpdate?: { __typename?: 'BasketProductsUpdatePayload', user: { __typename?: 'User', id: string, basket?: { __typename?: 'Basket', basketProducts: Array<{ __typename?: 'BasketProduct', id: string }> } | null } } | null };

export type nonCoreOrderCreateVariables = Exact<{
  userId: Scalars['ID']['input'];
  deliveryAddress: AddressInput;
  deliveryDate: Scalars['ISO8601Date']['input'];
}>;


export type nonCoreOrderCreate = { __typename?: 'Mutation', nonCoreOrderCreate?: { __typename?: 'NonCoreOrderCreatePayload', order: { __typename?: 'NonCoreOrder', id: string } } | null };

export type BasketPageQueryVariables = Exact<{ [key: string]: never; }>;


export type BasketPageQuery = { __typename?: 'Query', nonCoreOrderDeliveryFee: number, user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountryCode: Code, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, deliveriesReceived: number, activePaymentMethodType?: PaymentMethodable | null, paymentMethods: Array<{ __typename?: 'BillingAgreement' } | { __typename: 'CreditCardPaymentMethod', id: string, lastFourDigits: string, active: boolean } | { __typename?: 'MerchantInitiatedPayment' } | { __typename?: 'SepaDirectDebit' }> }, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string }, nonCoreOrders: Array<{ __typename?: 'NonCoreOrder', id: string }>, basket?: { __typename?: 'Basket', id: string, discountedPrice: number, grossPrice: number, smallOrderFee: number, basketProducts: Array<{ __typename?: 'BasketProduct', id: string, grossPrice: number, discountedPrice: number, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> } | null } };

export type ConfirmationPageQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type ConfirmationPageQuery = { __typename?: 'Query', user: { __typename?: 'User', shippingCountryCode: Code, preferredLanguage: Language, subscription: { __typename?: 'Subscription', activePaymentMethodType?: PaymentMethodable | null, paymentMethods: Array<{ __typename?: 'BillingAgreement' } | { __typename: 'CreditCardPaymentMethod', lastFourDigits: string, active: boolean } | { __typename?: 'MerchantInitiatedPayment' } | { __typename?: 'SepaDirectDebit' }> }, nonCoreOrder: { __typename?: 'NonCoreOrder', address: { __typename?: 'Address', recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null, deliveryCarrier?: string | null }, invoice: { __typename?: 'NonCoreInvoice', grossPrice: number, discountedPrice: number, status: NonCoreInvoiceStatus }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliveryDate: any, deliverySurcharge: number, smallOrderSurcharge: number, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', discountedPrice: number, grossPrice: number, quantity: number, productVariant: { __typename?: 'ProductVariant', name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> } } };

export type ExtrasListQueryVariables = Exact<{ [key: string]: never; }>;


export type ExtrasListQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language }, productGroups: Array<{ __typename?: 'ProductGroup', id: string, name: string, slug: string, description: string, thumbnail: { __typename?: 'Image', src: string }, productCollections: Array<{ __typename?: 'ProductCollection', id: string, slug: string, name: string, unavailableObject?: { __typename?: 'UnavailableObject', reason: UnavailableObjectReason, reasonCopy: string } | null, productSticker?: { __typename?: 'ProductSticker', image: { __typename?: 'Image', src: string } } | null, discount?: { __typename?: 'Discount', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null, productLabel?: { __typename?: 'ProductLabel', id: string, name: string } | null, primaryImage?: { __typename?: 'Image', src: string } | null, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, discountedPrice?: number | null, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> }> }> };

export type PriceFragment = { __typename?: 'ProductVariant', id: string, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> };

export type orderProductsCreateVariables = Exact<{
  userId: Scalars['ID']['input'];
  productVariantInput: ProductVariantInput;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type orderProductsCreate = { __typename?: 'Mutation', orderProductsCreate?: { __typename?: 'OrderProductsCreatePayload', user: { __typename?: 'User', ordersByDate: Array<{ __typename?: 'Box', numberOfPouches: number, durationInDays: number, id: string, descriptor: Descriptor, deliveryDateAdjustedBySystem: boolean, isOneOffBox: boolean, isoDeliveryDate: any, shouldOfferSelfService: boolean, cutOffDate: any, shippingDate: any, isFreeBox: boolean, isTrialBox: boolean, isReplacementBox: boolean, isNextEditableBox: boolean, productSpacesFree: number, planPricePerDay: number, amendable: boolean, discounts: Array<{ __typename?: 'Discount', applicableDiscountPart?: { __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null }>, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, requiresPayment: boolean, visibilityScope: VisibilityScope, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number } } | { __typename?: 'NonCoreOrder', id: string, descriptor: Descriptor, invoice: { __typename?: 'NonCoreInvoice', id: string, status: NonCoreInvoiceStatus, grossPrice: number, discountedPrice: number, discountTotal: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, smallOrderSurcharge: number, orderProductsTotal: number, deliveryDate: any, shippingDate: any, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> }>, basket?: { __typename?: 'Basket', id: string, basketProducts: Array<{ __typename?: 'BasketProduct', id: string, quantity: number }> } | null } } | null };

export type ProductCollectionQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ProductCollectionQuery = { __typename?: 'Query', nonCoreOrderDeliveryFee: number, user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, email: string, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, nextEditableBox?: { __typename?: 'Box', id: string } | null }, basket?: { __typename?: 'Basket', id: string, basketProducts: Array<{ __typename?: 'BasketProduct', id: string, quantity: number }> } | null, dogs?: Array<{ __typename?: 'Dog', id: string, weightInGrams: number }> | null }, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string, sizeGuide?: string | null, averageCustomerRating?: number | null, countOfCustomerRatings: number, about: string, description: string, images: Array<{ __typename?: 'Image', src: string }>, productSticker?: { __typename?: 'ProductSticker', id: string, image: { __typename?: 'Image', src: string } } | null, productBenefits: Array<{ __typename?: 'ProductBenefit', id: string, name: string, image?: { __typename?: 'Image', src: string } | null }>, publicCustomerReviews: Array<{ __typename?: 'CustomerReview', id: string, author: string, rating: number, createdAt: any, description?: string | null }>, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, slug: string, grossPrice: number, discountedPrice?: number | null, subscribeAndSaveable: boolean, bundleItems?: Array<{ __typename?: 'BundleItem', quantity: number, constituent: { __typename?: 'ProductVariant', id: string, grossPrice: number } }> | null, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }>, unavailableObject?: { __typename?: 'UnavailableObject', reason: UnavailableObjectReason, reasonCopy: string } | null }> } };

export type SignupInfluencerMutationVariables = Exact<{
  influencer: SignupInfluencerInput;
}>;


export type SignupInfluencerMutation = { __typename?: 'Mutation', signupInfluencer?: { __typename?: 'SignupPayload', influencer?: { __typename?: 'InfluencerSignupPayload', token: string } | null } | null };

export type MFITBPlanOfferQueryVariables = Exact<{ [key: string]: never; }>;


export type MFITBPlanOfferQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, subscription: { __typename?: 'Subscription', id: string, increasedDeliveryCadencePlan?: { __typename?: 'Plan', id: string, durationInWeeks: number, pricePerWeek: number } | null, plan: { __typename?: 'Plan', id: string, durationInWeeks: number, pricePerWeek: number } } } };

export type userFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone?: string | null, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } };

export type MyDetailsInitialDataQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDetailsInitialDataQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, shouldSupportSca: boolean, email: string, shippingCountryCode: Code, affiliateType: Affiliate, preferredLanguage: Language, token: string, subscription: { __typename?: 'Subscription', id: string, accountType: Account, status: SubscriptionStatus } } };

export type MyDetailsPersonalDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDetailsPersonalDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone?: string | null, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } } };

export type AddPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type AddPaymentMethodQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, token: string, preferredLanguage: Language, shippingCountryCode: Code, affiliateType: Affiliate, acquisitionChannel?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, currency: Currency, availablePaymentMethodSetupMediums: Array<{ __typename?: 'PaymentMethodSetupMedium', inputType: PaymentMethodSetupMediumInputType }> }, subscription: { __typename?: 'Subscription', id: string, deliveriesReceived: number } } };

export type BillingAgreementFragment = { __typename: 'BillingAgreement', id: string, type: PaymentMethodable, active: boolean, paypalEmail?: string | null };

export type CreditCardPaymentMethodFragment = { __typename: 'CreditCardPaymentMethod', id: string, type: PaymentMethodable, active: boolean, lastFourDigits: string, expMonth: string, expYear: string };

export type SepaDirectDebitFragment = { __typename: 'SepaDirectDebit', id: string, type: PaymentMethodable, active: boolean, accountLastFour?: string | null };

export type MerchantInitiatedPaymentFragment = { __typename: 'MerchantInitiatedPayment', id: string, type: PaymentMethodable, active: boolean, merchantInitiatedType: string };

export type PaymentMethodsFragment = { __typename: 'User', id: string, subscription: { __typename: 'Subscription', id: string, status: SubscriptionStatus, paymentMethods: Array<{ __typename: 'BillingAgreement', id: string, type: PaymentMethodable, active: boolean, paypalEmail?: string | null } | { __typename: 'CreditCardPaymentMethod', id: string, type: PaymentMethodable, active: boolean, lastFourDigits: string, expMonth: string, expYear: string } | { __typename: 'MerchantInitiatedPayment', id: string, type: PaymentMethodable, active: boolean, merchantInitiatedType: string } | { __typename: 'SepaDirectDebit', id: string, type: PaymentMethodable, active: boolean, accountLastFour?: string | null }> } };

export type ArchivePaymentMethodVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
  archivedType: ArchivedType;
}>;


export type ArchivePaymentMethod = { __typename?: 'Mutation', response?: { __typename?: 'ArchivePaymentMethodPayload', user: { __typename: 'User', id: string, subscription: { __typename: 'Subscription', id: string, status: SubscriptionStatus, paymentMethods: Array<{ __typename: 'BillingAgreement', id: string, type: PaymentMethodable, active: boolean, paypalEmail?: string | null } | { __typename: 'CreditCardPaymentMethod', id: string, type: PaymentMethodable, active: boolean, lastFourDigits: string, expMonth: string, expYear: string } | { __typename: 'MerchantInitiatedPayment', id: string, type: PaymentMethodable, active: boolean, merchantInitiatedType: string } | { __typename: 'SepaDirectDebit', id: string, type: PaymentMethodable, active: boolean, accountLastFour?: string | null }> } } } | null };

export type AuthenticationSetupCreateMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  authenticationType: Scalars['String']['input'];
  provider: Scalars['String']['input'];
}>;


export type AuthenticationSetupCreateMutation = { __typename?: 'Mutation', authenticationSetupCreate?: { __typename?: 'AuthenticationSetupCreatePayload', authenticationSetup: { __typename?: 'AuthenticationSetup', id: string, redirectUrl?: string | null } } | null };

export type CreatePaymentMethodMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  archivedType?: InputMaybe<ArchivedType>;
  paymentMethods: Array<PaymentMethodInput> | PaymentMethodInput;
}>;


export type CreatePaymentMethodMutation = { __typename?: 'Mutation', paymentMethodsCreate?: { __typename: 'User', id: string, subscription: { __typename: 'Subscription', id: string, status: SubscriptionStatus, paymentMethods: Array<{ __typename: 'BillingAgreement', id: string, type: PaymentMethodable, active: boolean, paypalEmail?: string | null } | { __typename: 'CreditCardPaymentMethod', id: string, type: PaymentMethodable, active: boolean, lastFourDigits: string, expMonth: string, expYear: string } | { __typename: 'MerchantInitiatedPayment', id: string, type: PaymentMethodable, active: boolean, merchantInitiatedType: string } | { __typename: 'SepaDirectDebit', id: string, type: PaymentMethodable, active: boolean, accountLastFour?: string | null }> } } | null };

export type instantChargeSetupCreateVariables = Exact<{
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type instantChargeSetupCreate = { __typename?: 'Mutation', instantChargeSetupCreate?: { __typename?: 'InstantChargeSetupCreatePayload', instantChargeSetupToken: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string } } | null };

export type payOverdueInvoicesAndUnsuspendVariables = Exact<{
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentResourceId?: InputMaybe<Scalars['String']['input']>;
  paymentResourceType?: InputMaybe<PaymentResourceType>;
  provider: Scalars['String']['input'];
}>;


export type payOverdueInvoicesAndUnsuspend = { __typename?: 'Mutation', payOverdueInvoicesAndUnsuspend?: { __typename?: 'PayOverdueInvoicesAndUnsuspendPayload', user: { __typename?: 'User', id: string } } | null };

export type PaymentMethodSetActiveVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
  archivedType: ArchivedType;
}>;


export type PaymentMethodSetActive = { __typename?: 'Mutation', response?: { __typename: 'User', id: string, subscription: { __typename: 'Subscription', id: string, status: SubscriptionStatus, paymentMethods: Array<{ __typename: 'BillingAgreement', id: string, type: PaymentMethodable, active: boolean, paypalEmail?: string | null } | { __typename: 'CreditCardPaymentMethod', id: string, type: PaymentMethodable, active: boolean, lastFourDigits: string, expMonth: string, expYear: string } | { __typename: 'MerchantInitiatedPayment', id: string, type: PaymentMethodable, active: boolean, merchantInitiatedType: string } | { __typename: 'SepaDirectDebit', id: string, type: PaymentMethodable, active: boolean, accountLastFour?: string | null }> } } | null };

export type SubscriptionUnsuspensionAttemptMutationVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionUnsuspensionAttemptMutation = { __typename?: 'Mutation', subscriptionUnsuspensionAttempt?: { __typename?: 'User', id: string } | null };

export type PaymentMethodsQueryVariables = Exact<{
  archivedType?: InputMaybe<ArchivedType>;
  num: Scalars['Int']['input'];
}>;


export type PaymentMethodsQuery = { __typename?: 'Query', user: { __typename: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, dogs?: Array<{ __typename?: 'Dog', id: string, name: string }> | null, subscription: { __typename: 'Subscription', id: string, status: SubscriptionStatus, activePaymentMethodType?: PaymentMethodable | null, deliveriesReceived: number, nextNBoxes: Array<{ __typename?: 'Box', id: string, isNextEditableBox: boolean, isFreeBox: boolean }>, paymentMethods: Array<{ __typename: 'BillingAgreement', id: string, type: PaymentMethodable, active: boolean, paypalEmail?: string | null } | { __typename: 'CreditCardPaymentMethod', id: string, type: PaymentMethodable, active: boolean, lastFourDigits: string, expMonth: string, expYear: string } | { __typename: 'MerchantInitiatedPayment', id: string, type: PaymentMethodable, active: boolean, merchantInitiatedType: string } | { __typename: 'SepaDirectDebit', id: string, type: PaymentMethodable, active: boolean, accountLastFour?: string | null }> } } };

export type productCollectionFragment = { __typename?: 'ProductCollection', id: string, slug: string, name: string, unavailableObject?: { __typename?: 'UnavailableObject', reason: UnavailableObjectReason, reasonCopy: string } | null, productSticker?: { __typename?: 'ProductSticker', image: { __typename?: 'Image', src: string } } | null, discount?: { __typename?: 'Discount', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null, productLabel?: { __typename?: 'ProductLabel', id: string, name: string } | null, primaryImage?: { __typename?: 'Image', src: string } | null, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, discountedPrice?: number | null, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> };

export type NoDogsHeroQueryVariables = Exact<{ [key: string]: never; }>;


export type NoDogsHeroQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, pauses?: Array<{ __typename?: 'Pause', id: string, subreason?: string | null, createdAt: any }> | null } } };

export type ProductSectionQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductSectionQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountryCode: Code, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus } }, upsellableProductCollections: Array<{ __typename?: 'ProductCollection', id: string, slug: string, name: string, unavailableObject?: { __typename?: 'UnavailableObject', reason: UnavailableObjectReason, reasonCopy: string } | null, productSticker?: { __typename?: 'ProductSticker', image: { __typename?: 'Image', src: string } } | null, discount?: { __typename?: 'Discount', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null, productLabel?: { __typename?: 'ProductLabel', id: string, name: string } | null, primaryImage?: { __typename?: 'Image', src: string } | null, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, discountedPrice?: number | null, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> }> };

export type NoDogsPageDataVariables = Exact<{ [key: string]: never; }>;


export type NoDogsPageData = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, pauses?: Array<{ __typename?: 'Pause', id: string, subreason?: string | null, createdAt: any }> | null } } };

export type NoPaymentMethodPageDataVariables = Exact<{ [key: string]: never; }>;


export type NoPaymentMethodPageData = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountryCode: Code, email: string, token: string, shouldSupportSca: boolean, dogs?: Array<{ __typename?: 'Dog', name: string }> | null, subscription: { __typename?: 'Subscription', plan: { __typename?: 'Plan', durationInDays: number }, firstBox: { __typename?: 'Box', price: number, cutOffDate: any } } } };

export type oneOffBoxQueryVariables = Exact<{ [key: string]: never; }>;


export type oneOffBoxQuery = { __typename?: 'Query', shouldSeeRecipeSurchargeTooltips?: string | null, shouldSeeRecipeSurchargePriceIncreasePl?: string | null, user: { __typename: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender }> | null, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null }, subscription: { __typename?: 'Subscription', id: string, plan: { __typename?: 'Plan', id: string, pouchSize: number, numberOfPouches: number, durationInDays: number, pouchesPerDay: number }, meal?: Array<{ __typename?: 'Meal', quantity: number, flavour: { __typename?: 'NewFlavour', id: string, slug: string, themeColour: string, name: string, recipeSurcharge?: number | null, thumbnail: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', id: string, name: string, themeColour: string }> | null } }> | null, previewUncreatedFutureBox: { __typename?: 'PreviewBox', isoDeliveryDate: any, editable: boolean, cutOffDate: any, order: { __typename?: 'Order', deliveryFee: number, physicalProductsTotal?: number | null, planTotal: number, planTotalPerDay: number, subtotal?: number | null, totalPrice: number, surchargeTotal: number, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', quantity: number, price: number, frequency: Frequency, requiresPayment: boolean, nonPaymentReason?: NonPaymentReason | null, discountedPrice: number, productVariant: { __typename?: 'ProductVariant', subscribeAndSaveable: boolean, name: string, grossPrice: number, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', name: string, thumbnail: { __typename?: 'Image', src: string } } } }> } } } } };

export type calendarDatesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  nDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type calendarDatesQuery = { __typename?: 'Query', calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean }> };

export type OneOffBoxesCreateVariables = Exact<{
  userId: Scalars['ID']['input'];
  deliveryDate: Scalars['ISO8601Date']['input'];
  address: AddressInput;
}>;


export type OneOffBoxesCreate = { __typename?: 'Mutation', oneOffBoxCreate?: { __typename?: 'User', id: string } | null };

export type BoxDeliveryAddressUpdateVariables = Exact<{
  userId: Scalars['ID']['input'];
  boxId: Scalars['ID']['input'];
  address: AddressInput;
}>;


export type BoxDeliveryAddressUpdate = { __typename?: 'Mutation', boxAddressUpdate?: { __typename?: 'User', subscription: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null, deliveryCarrier?: string | null } } | null } } | null };

export type BoxDeliveryDateUpdateVariables = Exact<{
  userId: Scalars['ID']['input'];
  boxId: Scalars['ID']['input'];
  selectedDeliveryDate: Scalars['ISO8601Date']['input'];
  adjustFutureBoxDates: Scalars['Boolean']['input'];
  triggerEvents?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BoxDeliveryDateUpdate = { __typename?: 'Mutation', boxDeliveryDateUpdate?: { __typename?: 'User', subscription: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', id: string, isoDeliveryDate: any, cutOffDate: any } | null } } | null };

export type boxQueryVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type boxQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, shippingCountry: { __typename?: 'ShippingCountry', id: string, showUpcomingOrderSeeMoreExtras: boolean, showExtras: boolean, showInvoiceDownloadDirections: boolean }, dogs?: Array<{ __typename?: 'Dog', gender: Gender, name: string }> | null, subscription: { __typename?: 'Subscription', id: string, upsellableSampleProduct?: { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', adjustedGrossPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, slug: string, name: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> } } | null, plan: { __typename?: 'Plan', id: string, pouchSize: number }, nextNBoxes: Array<{ __typename?: 'Box', id: string, isNextEditableBox: boolean }>, box?: { __typename?: 'Box', id: string, descriptor: Descriptor, isFreeBox: boolean, isReplacementBox: boolean, shouldOfferSelfService: boolean, totalGrams: number, editable: boolean, amendable: boolean, cutOffDate: any, isoDeliveryDate: any, invoices: Array<{ __typename?: 'NewInvoice', id: string, issueDate?: any | null, corrective: boolean, grossTotal: number }>, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number }> | null, invoice: { __typename?: 'Invoice', id: string }, consignment?: { __typename?: 'Consignment', id: string, trackingUrl?: string | null, status?: Status | null } | null, address: { __typename?: 'Address', id: string, recipientName: string, address1: string, address2?: string | null, city: string, postcode: string, deliveryNotes?: string | null, deliveryCarrier?: string | null }, order: { __typename?: 'Order', id?: string | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, physicalProductsTotal?: number | null, planTotal: number, planTotalPerDay: number, subtotal?: number | null, totalPrice: number, surchargeTotal: number }, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, requiresPayment: boolean, nonPaymentReason?: NonPaymentReason | null, quantity: number, frequency: Frequency, price: number, discountedPrice: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, subscribeAndSaveable: boolean, oneOffDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', adjustedGrossPrice: number, netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, slug: string, name: string, thumbnail: { __typename?: 'Image', src: string }, productVariants: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, adjustedGrossPrice: number, netPrice: number }> }> } } }> } | null } } };

export type mealsQueryVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type mealsQuery = { __typename?: 'Query', shouldSeeRecipeSurchargeTooltips?: string | null, shouldSeeRecipeSurchargePriceIncreasePl?: string | null, user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, box?: { __typename?: 'Box', id: string, editable: boolean, meals?: Array<{ __typename?: 'Meal', quantity: number, flavour: { __typename?: 'NewFlavour', id: string, themeColour: string, name: string, slug: string, recipeSurcharge?: number | null, thumbnail: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', id: string, name: string, themeColour: string }> | null } }> | null } | null } } };

export type boxOrderFragment = { __typename?: 'Box', id: string, isoDeliveryDate: any, cutOffDate: any, isReplacementBox: boolean, isFreeBox: boolean, amendable: boolean, isNextEditableBox: boolean, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, discountTotalPercentage?: number | null, subtotal?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null }> }, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }>, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, slug: string } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number } };

export type nonCoreOrderFragment = { __typename?: 'NonCoreOrder', id: string, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliveryDate: any, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> };

export type pastOrderQueryVariables = Exact<{
  to: Scalars['ISO8601Date']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type pastOrderQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, ordersByDate: Array<{ __typename: 'Box', id: string, isoDeliveryDate: any, cutOffDate: any, isReplacementBox: boolean, isFreeBox: boolean, amendable: boolean, isNextEditableBox: boolean, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, discountTotalPercentage?: number | null, subtotal?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null }> }, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }>, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, slug: string } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number } } | { __typename: 'NonCoreOrder', id: string, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliveryDate: any, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> }> } };

export type upcomingOrderQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type upcomingOrderQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, ordersByDate: Array<{ __typename: 'Box', id: string, isoDeliveryDate: any, cutOffDate: any, isReplacementBox: boolean, isFreeBox: boolean, amendable: boolean, isNextEditableBox: boolean, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, discountTotalPercentage?: number | null, subtotal?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null }> }, physicalOrderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }>, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, slug: string } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number } } | { __typename: 'NonCoreOrder', id: string, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliveryDate: any, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> }> }, shippingCountries: Array<{ __typename?: 'ShippingCountry', id: string, code: Code, showUpcomingOrderSeeMoreExtras: boolean }> };

export type PauseFlowStartedEventCreateVariables = Exact<{
  properties: Scalars['Boolean']['input'];
}>;


export type PauseFlowStartedEventCreate = { __typename?: 'Mutation', pauseFlowStartedEventCreate?: { __typename?: 'Subscription', id: string, status: SubscriptionStatus } | null };

export type personalDetailsFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone?: string | null };

export type UpdatePersonalDetailsVariables = Exact<{
  userId: Scalars['ID']['input'];
  userDetails: UserDetailsInput;
}>;


export type UpdatePersonalDetails = { __typename?: 'Mutation', response?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone?: string | null } | null };

export type PersonalDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonalDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', preferredLanguage: Language, shippingCountryCode: Code, id: string, firstName: string, lastName: string, email: string, phone?: string | null, currentDeliveryAreaPreference?: { __typename?: 'DeliveryArea', id: string, preferredCarrierService: { __typename?: 'CarrierService', id: string, deliveryNotesLimit: number } } | null, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, pauseUrl?: string | null, previewUncreatedFutureBox: { __typename?: 'PreviewBox', editable: boolean, isoDeliveryDate: any, order: { __typename?: 'Order', id?: string | null, discountTotal?: number | null, discountTotalPercentage?: number | null }, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } }, nextEditableBox?: { __typename?: 'Box', id: string, editable: boolean, isoDeliveryDate: any, order: { __typename?: 'Order', id?: string | null, discountTotal?: number | null, discountTotalPercentage?: number | null }, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } | null }, address: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, postcode: string, recipientName: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code } } } };

export type CurrentDiscountCodeVariables = Exact<{
  discountCodeId: Scalars['ID']['input'];
}>;


export type CurrentDiscountCode = { __typename?: 'Query', discountCode: { __typename?: 'DiscountCode', id: string, code: string } };

export type AddDiscountToGuestVariables = Exact<{
  discountCode: Scalars['String']['input'];
}>;


export type AddDiscountToGuest = { __typename?: 'Mutation', addDiscountToGuest?: { __typename?: 'AddDiscountToGuestPayload', guest: { __typename?: 'Guest', discountCode?: { __typename?: 'DiscountCode', code: string, id: string } | null } } | null };

export type CreatePendingSubscriptionVariables = Exact<{
  pendingSubscription: PendingSubscriptionInput;
}>;


export type CreatePendingSubscription = { __typename?: 'Mutation', createPendingSubscription?: { __typename?: 'CreatePendingSubscriptionPayload', user: { __typename?: 'Guest', id: string }, pendingSubscription: { __typename?: 'PendingSubscription', pendingSubscriptionFlavours: Array<{ __typename?: 'PendingSubscriptionFlavour', sevenDayServings: number, flavour: { __typename?: 'NewFlavour', name: string } }> } } | null };

export type UpdatePlanVariables = Exact<{
  userId: Scalars['ID']['input'];
  meal: MealInput;
  planId: Scalars['ID']['input'];
}>;


export type UpdatePlan = { __typename?: 'Mutation', mealUpdate?: Array<{ __typename?: 'Meal', flavour: { __typename?: 'NewFlavour', name: string } }> | null, subscriptionPlanUpdate?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', plan: { __typename?: 'Plan', id: string } } } | null };

export type recommendedExtraProductVariantsFields = { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, discountedPrice?: number | null, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, netPrice: number, priceAdjustment?: { __typename?: 'PriceAdjustment', value: number } | null }>, productCollection: { __typename?: 'ProductCollection', slug: string, name: string, merchandisingImage: { __typename?: 'Image', src: string }, productLabel?: { __typename?: 'ProductLabel', name: string, themeColour: string } | null } };

export type GuestQueryVariables = Exact<{ [key: string]: never; }>;


export type GuestQuery = { __typename?: 'Query', currentUser?: { __typename: 'Guest', id: string, preferredLanguage: Language, assumedShippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code }, planRecommendation?: { __typename?: 'PlanRecommendation', recommendedExtraProductVariants?: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, discountedPrice?: number | null, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, netPrice: number, priceAdjustment?: { __typename?: 'PriceAdjustment', value: number } | null }>, productCollection: { __typename?: 'ProductCollection', slug: string, name: string, merchandisingImage: { __typename?: 'Image', src: string }, productLabel?: { __typename?: 'ProductLabel', name: string, themeColour: string } | null } }> | null } | null } | { __typename: 'PreWizardGuest' } | { __typename: 'User', id: string, address: { __typename?: 'Address', postcode: string }, planRecommendation?: { __typename?: 'PlanRecommendation', recommendedExtraProductVariants?: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, discountedPrice?: number | null, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, netPrice: number, priceAdjustment?: { __typename?: 'PriceAdjustment', value: number } | null }>, productCollection: { __typename?: 'ProductCollection', slug: string, name: string, merchandisingImage: { __typename?: 'Image', src: string }, productLabel?: { __typename?: 'ProductLabel', name: string, themeColour: string } | null } }> | null } | null } | null };

export type pendingSubscriptionProductVariantFields = { __typename?: 'PendingSubscriptionsProductVariant', discountedPrice?: number | null, productVariant: { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, netPrice: number, priceAdjustment?: { __typename?: 'PriceAdjustment', value: number } | null }>, productCollection: { __typename?: 'ProductCollection', name: string, slug: string, merchandisingImage: { __typename?: 'Image', src: string } } } };

export type ReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewQuery = { __typename?: 'Query', standardDeliveryFee: number, currentUser?: { __typename: 'Guest', id: string, preferredLanguage: Language, assumedShippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code }, discountCode?: { __typename?: 'DiscountCode', id: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', n?: number | null, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, value: number }> } | null, planRecommendation?: { __typename?: 'PlanRecommendation', individual: Array<{ __typename?: 'Recommendation', dog: { __typename?: 'Dog', id: string, name: string, createdAt: any, gender: Gender, dailyGrams: number, dogProfile?: { __typename?: 'DogProfile', avatarUrl?: string | null } | null } }> } | null } | { __typename: 'PreWizardGuest' } | { __typename: 'User', id: string, preferredLanguage: Language, shippingCountry: { __typename?: 'ShippingCountry', code: Code }, dogs?: Array<{ __typename?: 'Dog', name: string }> | null, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, planPricePerDay: number, planPriceTotal: number, plan: { __typename?: 'Plan', pouchSize: number, numberOfPouches: number, durationInDays: number, pouchesPerDay: number, typeOfPlanForCustomer: TypeOfPlan }, meal?: Array<{ __typename?: 'Meal', quantity: number, flavour: { __typename?: 'NewFlavour', id: string, slug: string, name: string, themeColour: string, thumbnail: { __typename?: 'Image', src: string } } }> | null, recurringOrder: { __typename?: 'RecurringOrder', surchargeTotal: number } }, planRecommendation?: { __typename?: 'PlanRecommendation', individual: Array<{ __typename?: 'Recommendation', dog: { __typename?: 'Dog', id: string, name: string, createdAt: any, gender: Gender, dailyGrams: number, dogProfile?: { __typename?: 'DogProfile', avatarUrl?: string | null } | null } }> } | null } | null, pendingSubscription: { __typename?: 'PendingSubscription', standardOrderPricing: { __typename?: 'PendingSubscriptionOrderPricing', grossTotalPrice: number, netTotalPrice: number, netTotalPricePerDay: number, totalDiscountedAmount: number, grossCoreFoodPrice: number, grossCoreFoodPricePerDay: number, netCoreFoodPrice: number, coreFoodDiscountedAmount: number, grossRecipeSurchargePrice: number, netRecipeSurchargePrice: number, recipeSurchargeDiscountedAmount: number, grossDeliverySurchargePrice: number, netDeliverySurchargePrice: number, deliverySurchargeDiscountedAmount: number, grossAdditionalProductsPrice: number, netAdditionalProductsPrice: number, additionalProductsDiscountedAmount: number, totalSavedAmount: number, standardOrderCoreFoodGrossPrice: number, standardOrderCoreFoodGrossPricePerDay: number, flavourPricings: Array<{ __typename?: 'PendingSubscriptionOrderFlavourPricing', flavourName: string, servings: number, netStandardOrderPricePerServing: number, grossStandardOrderPricePerServing: number, netFirstOrderPricePerServing: number }> }, firstOrderPricing: { __typename?: 'PendingSubscriptionOrderPricing', grossTotalPrice: number, netTotalPrice: number, netTotalPricePerDay: number, totalDiscountedAmount: number, grossCoreFoodPrice: number, grossCoreFoodPricePerDay: number, netCoreFoodPrice: number, coreFoodDiscountedAmount: number, grossRecipeSurchargePrice: number, netRecipeSurchargePrice: number, recipeSurchargeDiscountedAmount: number, grossDeliverySurchargePrice: number, netDeliverySurchargePrice: number, deliverySurchargeDiscountedAmount: number, grossAdditionalProductsPrice: number, netAdditionalProductsPrice: number, additionalProductsDiscountedAmount: number, totalSavedAmount: number, standardOrderCoreFoodGrossPrice: number, standardOrderCoreFoodGrossPricePerDay: number, flavourPricings: Array<{ __typename?: 'PendingSubscriptionOrderFlavourPricing', flavourName: string, servings: number, netStandardOrderPricePerServing: number, grossStandardOrderPricePerServing: number, netFirstOrderPricePerServing: number }> }, secondOrderPricing: { __typename?: 'PendingSubscriptionOrderPricing', grossTotalPrice: number, netTotalPrice: number, netTotalPricePerDay: number, totalDiscountedAmount: number, grossCoreFoodPrice: number, grossCoreFoodPricePerDay: number, netCoreFoodPrice: number, coreFoodDiscountedAmount: number, grossRecipeSurchargePrice: number, netRecipeSurchargePrice: number, recipeSurchargeDiscountedAmount: number, grossDeliverySurchargePrice: number, netDeliverySurchargePrice: number, deliverySurchargeDiscountedAmount: number, grossAdditionalProductsPrice: number, netAdditionalProductsPrice: number, additionalProductsDiscountedAmount: number, totalSavedAmount: number, standardOrderCoreFoodGrossPrice: number, standardOrderCoreFoodGrossPricePerDay: number, flavourPricings: Array<{ __typename?: 'PendingSubscriptionOrderFlavourPricing', flavourName: string, servings: number, netStandardOrderPricePerServing: number, grossStandardOrderPricePerServing: number, netFirstOrderPricePerServing: number }> }, trialDiscountCodePart?: { __typename?: 'DiscountCodePart', value: number } | null, productVariants: Array<{ __typename?: 'PendingSubscriptionsProductVariant', discountedPrice?: number | null, productVariant: { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productVariantDeliveryTypes: Array<{ __typename?: 'ProductVariantDeliveryType', deliveryType: VariantDelivery, netPrice: number, priceAdjustment?: { __typename?: 'PriceAdjustment', value: number } | null }>, productCollection: { __typename?: 'ProductCollection', name: string, slug: string, merchandisingImage: { __typename?: 'Image', src: string } } } }>, plan: { __typename?: 'Plan', id: string, numberOfPouches: number, durationInDays: number, trialLengthInDays: number, pouchesPerDay: number, typeOfPlanForCustomer: TypeOfPlan, pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string }, pricesPerDayPerDogs: Array<{ __typename?: 'DogPricing', name: string, pricePerDayWithDiscount: number, pricePerDayWithoutDiscount: number }> }, pendingSubscriptionFlavours: Array<{ __typename?: 'PendingSubscriptionFlavour', servings: number, trialBoxServings: number, sevenDayServings: number, flavour: { __typename?: 'NewFlavour', name: string, slug: string, themeColour: string, thumbnail: { __typename?: 'Image', src: string } } }> } };

export type planFields = { __typename?: 'Plan', id: string, pouchSize: number, durationInDays: number, pricePerDay: number, trialLengthInDays: number, trialDiscountedPricePerDay: number, numberOfPouches: number, typeOfPlanForCustomer: TypeOfPlan, gramsPerDay: number, pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } };

export type flavourFields = { __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, longDescription: string, fussyApproved?: boolean | null, primaryImage: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', name: string, themeColour: string }> | null, recipeSurcharges: Array<{ __typename?: 'RecipeSurcharge', planSize: number, amount: number }> };

export type RecommendationQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendationQuery = { __typename?: 'Query', flavours: Array<{ __typename?: 'NewFlavour', productBenefits: Array<{ __typename?: 'ProductBenefit', id: string, name: string, image?: { __typename?: 'Image', src: string } | null }> }>, currentUser?: { __typename: 'Guest', id: string, preferredLanguage: Language, assumedShippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code }, discountCode?: { __typename?: 'DiscountCode', id: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', n?: number | null, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, value: number }> } | null, planRecommendation?: { __typename?: 'PlanRecommendation', idealGramsAmount?: number | null, combinedRecommendedFlavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, longDescription: string, fussyApproved?: boolean | null, primaryImage: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', name: string, themeColour: string }> | null, recipeSurcharges: Array<{ __typename?: 'RecipeSurcharge', planSize: number, amount: number }> }>, combinedOtherFlavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, longDescription: string, fussyApproved?: boolean | null, primaryImage: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', name: string, themeColour: string }> | null, recipeSurcharges: Array<{ __typename?: 'RecipeSurcharge', planSize: number, amount: number }> }>, combinedNotRecommendedFlavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, longDescription: string, fussyApproved?: boolean | null, primaryImage: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', name: string, themeColour: string }> | null, recipeSurcharges: Array<{ __typename?: 'RecipeSurcharge', planSize: number, amount: number }> }>, plans?: Array<{ __typename?: 'Plan', id: string, pouchSize: number, durationInDays: number, pricePerDay: number, trialLengthInDays: number, trialDiscountedPricePerDay: number, numberOfPouches: number, typeOfPlanForCustomer: TypeOfPlan, gramsPerDay: number, pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } }> | null, recommendationReasons: Array<{ __typename?: 'RecommendationReason', id: number, text: string }>, individual: Array<{ __typename?: 'Recommendation', dog: { __typename?: 'Dog', id: string, name: string, dailyCalories: number, gender: Gender, eaterType: Eater } }> } | null } | { __typename: 'PreWizardGuest' } | { __typename: 'User', id: string, preferredLanguage: Language, shippingCountry: { __typename?: 'ShippingCountry', code: Code }, planRecommendation?: { __typename?: 'PlanRecommendation', idealGramsAmount?: number | null, combinedRecommendedFlavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, longDescription: string, fussyApproved?: boolean | null, primaryImage: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', name: string, themeColour: string }> | null, recipeSurcharges: Array<{ __typename?: 'RecipeSurcharge', planSize: number, amount: number }> }>, combinedOtherFlavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, longDescription: string, fussyApproved?: boolean | null, primaryImage: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', name: string, themeColour: string }> | null, recipeSurcharges: Array<{ __typename?: 'RecipeSurcharge', planSize: number, amount: number }> }>, combinedNotRecommendedFlavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, longDescription: string, fussyApproved?: boolean | null, primaryImage: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', name: string, themeColour: string }> | null, recipeSurcharges: Array<{ __typename?: 'RecipeSurcharge', planSize: number, amount: number }> }>, plans?: Array<{ __typename?: 'Plan', id: string, pouchSize: number, durationInDays: number, pricePerDay: number, trialLengthInDays: number, trialDiscountedPricePerDay: number, numberOfPouches: number, typeOfPlanForCustomer: TypeOfPlan, gramsPerDay: number, pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } }> | null, recommendationReasons: Array<{ __typename?: 'RecommendationReason', id: number, text: string }>, individual: Array<{ __typename?: 'Recommendation', dog: { __typename?: 'Dog', id: string, name: string, dailyCalories: number, gender: Gender, eaterType: Eater } }> } | null } | null };

export type PriceSensitivePausedPageQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
}>;


export type PriceSensitivePausedPageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountryCode: Code, ordersByDate: Array<{ __typename?: 'Box', numberOfPouches: number, durationInDays: number, id: string, descriptor: Descriptor, deliveryDateAdjustedBySystem: boolean, isOneOffBox: boolean, isoDeliveryDate: any, shouldOfferSelfService: boolean, cutOffDate: any, shippingDate: any, isFreeBox: boolean, isTrialBox: boolean, isReplacementBox: boolean, isNextEditableBox: boolean, productSpacesFree: number, planPricePerDay: number, amendable: boolean, discounts: Array<{ __typename?: 'Discount', applicableDiscountPart?: { __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null }>, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, requiresPayment: boolean, visibilityScope: VisibilityScope, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number } } | { __typename?: 'NonCoreOrder', id: string, descriptor: Descriptor, invoice: { __typename?: 'NonCoreInvoice', id: string, status: NonCoreInvoiceStatus, grossPrice: number, discountedPrice: number, discountTotal: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, smallOrderSurcharge: number, orderProductsTotal: number, deliveryDate: any, shippingDate: any, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> }>, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, activePaymentMethodType?: PaymentMethodable | null, previewUncreatedFutureBox: { __typename?: 'PreviewBox', order: { __typename?: 'Order', id?: string | null, deliveryFee: number, subtotal?: number | null, discountTotalPercentage?: number | null } }, plan: { __typename?: 'Plan', id: string, durationInWeeks: number, pouchSize: number, numberOfPouches: number, pouchesPerDay: number, pricePerWeek: number }, increasedDeliveryCadencePlan?: { __typename?: 'Plan', id: string, durationInWeeks: number, pouchSize: number, numberOfPouches: number, pouchesPerDay: number, pricePerWeek: number } | null, currentPause?: { __typename?: 'Pause', id: string, priceSensitiveTreatments: Array<string> } | null } } };

export type ReferAFriendPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferAFriendPageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, firstName: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null, subscription: { __typename?: 'Subscription', id: string, activeRafCampaignRedeemed: boolean, referralLink: { __typename?: 'ClientReferralLink', referralLinkTypeName: string, referralDiscountsTotalValue: number, url: string, referralDiscount: { __typename?: 'DiscountCode', id: string, code: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, n?: number | null }> }, referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', value: number, discountBasis: ApplicableDiscountPartDiscountBasis, n: number, discountType: ApplicableDiscountPartDiscount }> } | null, referrals: Array<{ __typename?: 'Referral', refereeFirstName: string, refereeDogNames: Array<string>, refereeSignUpDate: any }> }, activeRafCampaignVariant?: { __typename?: 'RafCampaignVariant', name: string, rafCampaign: { __typename?: 'RafCampaign', name: string, endDate: any }, view?: { __typename?: 'View', data: any } | null } | null } }, shippingCountries: Array<{ __typename?: 'ShippingCountry', code: Code, showRafCharityButton: boolean }>, whatsAppSingleDog: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string }, whatsAppMultipleDogs: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string } };

export type ReviewPlanChangesFragment = { __typename?: 'Plan', id: string, durationInWeeks: number, numberOfPouches: number, pricePerDay: number, pouchesPerDay: number, pouchSize: number, servingInformation: { __typename?: 'PlanServingInformation', roundedCaloriesPerDay: number, gramsPerDay: number } };

export type ReviewPlanChangesMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  nextNBoxesNum: Scalars['Int']['input'];
}>;


export type ReviewPlanChangesMutation = { __typename?: 'Mutation', subscriptionPlanUpdate?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, plan: { __typename?: 'Plan', id: string, numberOfPouches: number, durationInWeeks: number, pricePerDay: number, pouchSize: number, servingInformation: { __typename?: 'PlanServingInformation', gramsPerDay: number } }, nextNBoxes: Array<{ __typename?: 'Box', id: string, numberOfPouches: number, durationInDays: number, isoDeliveryDate: any, editable: boolean, netPrice: number, price: number, plan: { __typename?: 'Plan', id: string, pouchSize: number }, order: { __typename?: 'Order', id?: string | null, deliveryFee: number, discountTotal?: number | null, physicalProductsTotal?: number | null, planTotal: number, planTotalPerDay: number, subtotal?: number | null, surchargeTotal: number, totalPrice: number } }> } } | null };

export type SegmentedPausedPageQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
}>;


export type SegmentedPausedPageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountryCode: Code, ordersByDate: Array<{ __typename?: 'Box', numberOfPouches: number, durationInDays: number, id: string, descriptor: Descriptor, deliveryDateAdjustedBySystem: boolean, isOneOffBox: boolean, isoDeliveryDate: any, shouldOfferSelfService: boolean, cutOffDate: any, shippingDate: any, isFreeBox: boolean, isTrialBox: boolean, isReplacementBox: boolean, isNextEditableBox: boolean, productSpacesFree: number, planPricePerDay: number, amendable: boolean, discounts: Array<{ __typename?: 'Discount', applicableDiscountPart?: { __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null }>, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, requiresPayment: boolean, visibilityScope: VisibilityScope, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number } } | { __typename?: 'NonCoreOrder', id: string, descriptor: Descriptor, invoice: { __typename?: 'NonCoreInvoice', id: string, status: NonCoreInvoiceStatus, grossPrice: number, discountedPrice: number, discountTotal: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, smallOrderSurcharge: number, orderProductsTotal: number, deliveryDate: any, shippingDate: any, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> }>, address: { __typename?: 'Address', id: string, deliverable: boolean, postcode: string }, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, activePaymentMethodType?: PaymentMethodable | null, previewUncreatedFutureBox: { __typename?: 'PreviewBox', isoDeliveryDate: any, plan: { __typename?: 'Plan', durationInWeeks: number, pouchesPerDay: number, pouchSize: number, pricePerDay: number, id: string }, order: { __typename?: 'Order', id?: string | null, deliveryFee: number, subtotal?: number | null, discountTotalPercentage?: number | null } }, currentPause?: { __typename?: 'Pause', id: string, segmentedTreatments: Array<string> } | null } } };

export type orderTrackingNumberFields = { __typename?: 'OrderTrackingNumber', boxId: string, trackingId?: string | null, trackingUrl: string, courierName: string, address1: string, address2: string };

export type CustomerIssueCategorySubmissionVariables = Exact<{
  userId: Scalars['ID']['input'];
  boxId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
}>;


export type CustomerIssueCategorySubmission = { __typename?: 'Mutation', response?: { __typename?: 'CategorySubmissionPayload', reportId: string, entryId: string, resolutions?: Array<{ __typename?: 'CustomerIssueResolution', key: CustomerIssueResolutionKey, requiresAction: boolean, resolutionType: CustomerIssueResolutionResolution, details: { __typename: 'ApplyDiscounts' } | { __typename: 'OrderTrackingNumber', type: CustomerIssueResolutionDetailsTypeField, boxId: string, trackingId?: string | null, trackingUrl: string, courierName: string, address1: string, address2: string } | { __typename: 'ReplacementBoxDetails' } }> | null, fields: Array<{ __typename: 'CustomerIssueEntryFieldAssociation', associationType?: CustomerIssueEntryFieldTypesAssociationAssociationType | null, associationDisplayType: CustomerIssueEntryFieldTypesAssociationDisplayType, id: string, name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat, allowedAssociationValues?: Array<{ __typename: 'CustomerIssueCategory', id: string, description: string, name: string, key: string, selfServable?: boolean | null, parentId?: string | null } | { __typename: 'Product', id: string }> | null } | { __typename: 'CustomerIssueEntryFieldBoolean', booleanDisplayType: CustomerIssueEntryFieldTypesBooleanDisplayType, id: string, name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat } | { __typename: 'CustomerIssueEntryFieldInteger', allowedIntegerValues?: Array<number> | null, integerDisplayType: CustomerIssueEntryFieldTypesIntegerDisplayType, id: string, name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat } | { __typename: 'CustomerIssueEntryFieldMultifield', multifieldDisplayType: CustomerIssueEntryFieldTypesMultifieldDisplayType, id: string, name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat, fields: Array<{ __typename: 'CustomerIssueEntryFieldAssociation', associationType?: CustomerIssueEntryFieldTypesAssociationAssociationType | null, associationDisplayType: CustomerIssueEntryFieldTypesAssociationDisplayType, id: string, name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat, allowedAssociationValues?: Array<{ __typename: 'CustomerIssueCategory', id: string, description: string, name: string, key: string, selfServable?: boolean | null, parentId?: string | null } | { __typename: 'Product', id: string }> | null } | { __typename: 'CustomerIssueEntryFieldBoolean', booleanDisplayType: CustomerIssueEntryFieldTypesBooleanDisplayType, id: string, name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat } | { __typename: 'CustomerIssueEntryFieldInteger', allowedIntegerValues?: Array<number> | null, integerDisplayType: CustomerIssueEntryFieldTypesIntegerDisplayType, id: string, name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat } | { __typename: 'CustomerIssueEntryFieldMultifield', name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat } | { __typename: 'CustomerIssueEntryFieldString', allowedStringValues?: Array<string> | null, stringDisplayType: CustomerIssueEntryFieldTypesStringDisplayType, id: string, name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat }> } | { __typename: 'CustomerIssueEntryFieldString', allowedStringValues?: Array<string> | null, stringDisplayType: CustomerIssueEntryFieldTypesStringDisplayType, id: string, name: string, dataType: CustomerIssueEntryFieldData, presentationalOrder: number, selectionFormat: CustomerIssueEntryFieldSelectionFormat }>, reasons?: Array<{ __typename?: 'CustomerIssueReason', id: string, name?: string | null, presentationalOrder: number }> | null } | null };

export type CustomerIssueReportEntriesSubmissionVariables = Exact<{
  userId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  entryFieldInputs: Array<CustomerIssueReportEntryInputInput> | CustomerIssueReportEntryInputInput;
  reasonId: Scalars['ID']['input'];
}>;


export type CustomerIssueReportEntriesSubmission = { __typename?: 'Mutation', response?: { __typename?: 'ReportEntriesSubmissionPayload', reportId: string, resolutions: Array<{ __typename?: 'CustomerIssueResolution', key: CustomerIssueResolutionKey, details: { __typename: 'ApplyDiscounts', discountCode: { __typename?: 'DiscountCode', discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number }> } } | { __typename: 'OrderTrackingNumber' } | { __typename: 'ReplacementBoxDetails', type: CustomerIssueResolutionDetailsTypeField, availableDeliveryDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean }>, defaultAddress: { __typename?: 'Address', address1: string, address2?: string | null, city: string, country: string, deliveryNotes?: string | null, deliveryCarrier?: string | null, postcode: string, recipientName: string, shippingCountry: { __typename?: 'ShippingCountry', active: boolean, code: Code, name: string, id: string } } } }> } | null };

export type CustomerIssueResolutionAcceptanceApplyDiscountVariables = Exact<{
  userId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
}>;


export type CustomerIssueResolutionAcceptanceApplyDiscount = { __typename?: 'Mutation', response?: { __typename?: 'ApplyDiscountPayload', resolutionApplicationConfirmation: { __typename?: 'CustomerIssueResolutionAcceptanceApplicationConfirmationApplyDiscount', type: CustomerIssueResolutionDetailsTypeField } | { __typename?: 'CustomerIssueResolutionAcceptanceApplicationConfirmationReplacementBox', type: CustomerIssueResolutionDetailsTypeField } } | null };

export type CustomerIssueResolutionAcceptanceReplacementBoxSubmissionVariables = Exact<{
  userId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  replacementBoxDetails: CustomerIssueResolutionAcceptanceReplacementBoxDetailsInput;
}>;


export type CustomerIssueResolutionAcceptanceReplacementBoxSubmission = { __typename?: 'Mutation', response?: { __typename?: 'ReplacementBoxSubmissionPayload', resolutionApplicationConfirmation: { __typename?: 'CustomerIssueResolutionAcceptanceApplicationConfirmationApplyDiscount', type: CustomerIssueResolutionDetailsTypeField } | { __typename?: 'CustomerIssueResolutionAcceptanceApplicationConfirmationReplacementBox', type: CustomerIssueResolutionDetailsTypeField } } | null };

export type SelfResolutionCategoriesVariables = Exact<{
  boxId: Scalars['ID']['input'];
}>;


export type SelfResolutionCategories = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, subscription: { __typename?: 'Subscription', box?: { __typename?: 'Box', hasPreviousOrderIssue: boolean, isoDeliveryDate: any, price: number, potentialMissingItems: Array<{ __typename?: 'PotentialMissingItem', name: string, productId: string, productCode: string, category: string, thumbnail: string, quantity: number, price: number }> } | null } }, categories: Array<{ __typename?: 'CustomerIssueCategory', id: string, name: string, description: string, key: string, selfServable?: boolean | null, parentId?: string | null }> };

export type addDogsVariables = Exact<{
  dogs: Array<DogInput> | DogInput;
}>;


export type addDogs = { __typename?: 'Mutation', addDogs?: { __typename?: 'AddDogsPayload', mealSelectionTypeSwitched: boolean, dogs: Array<{ __typename?: 'Dog', id: string }> } | null };

export type AllergensVariables = Exact<{ [key: string]: never; }>;


export type Allergens = { __typename?: 'Query', allergens: Array<{ __typename?: 'Allergen', id: string, name: string }> };

export type FoodCategoriesVariables = Exact<{ [key: string]: never; }>;


export type FoodCategories = { __typename?: 'Query', foodCategories: Array<{ __typename?: 'FoodCategory', id: string, name: string }> };

export type ShippingCountriesVariables = Exact<{ [key: string]: never; }>;


export type ShippingCountries = { __typename?: 'Query', settings: Array<{ __typename?: 'Setting', value: boolean, name: string }>, shippingCountries: Array<{ __typename?: 'ShippingCountry', id: string, name: string, code: Code, currency: Currency, active: boolean, scaEnforced: boolean }>, availableMarketingMethodPurposes: Array<{ __typename?: 'SupportedMarketingMethodPurpose', id: string, marketingPurpose: { __typename?: 'MarketingPurpose', id: string, key: string, name: string, encouraged: boolean } }> };

export type CurrentUserVariables = Exact<{ [key: string]: never; }>;


export type CurrentUser = { __typename?: 'Query', currentUser?: { __typename: 'Guest' } | { __typename: 'PreWizardGuest' } | { __typename: 'User', id: string, marketingPreference: MarketingPreferences } | null, availableMarketingMethodPurposes: Array<{ __typename?: 'SupportedMarketingMethodPurpose', id: string, marketingPurpose: { __typename?: 'MarketingPurpose', id: string, key: string, name: string, encouraged: boolean } }> };

export type HealthIssuesVariables = Exact<{ [key: string]: never; }>;


export type HealthIssues = { __typename?: 'Query', healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string, information: string, warning: boolean, slug: string }> };

export type UpdateDiscountCodeVariables = Exact<{
  discountCode: Scalars['String']['input'];
}>;


export type UpdateDiscountCode = { __typename?: 'Mutation', addDiscountToGuest?: { __typename?: 'AddDiscountToGuestPayload', guest: { __typename?: 'Guest', discountCode?: { __typename?: 'DiscountCode', id: string, code: string, discountBasis: DiscountCodePartDiscountBasis, value: number, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> } | null } } | null };

export type SimplifiedCreatePendingSubscriptionVariables = Exact<{
  pendingSubscription: PendingSubscriptionInput;
}>;


export type SimplifiedCreatePendingSubscription = { __typename?: 'Mutation', createPendingSubscription?: { __typename?: 'CreatePendingSubscriptionPayload', user: { __typename?: 'Guest', id: string }, pendingSubscription: { __typename?: 'PendingSubscription', id: string, firstOrderPricing: { __typename?: 'PendingSubscriptionOrderPricing', netTotalPrice: number, standardOrderCoreFoodGrossPrice: number, grossAdditionalProductsPrice: number }, pendingSubscriptionFlavours: Array<{ __typename?: 'PendingSubscriptionFlavour', sevenDayServings: number, flavour: { __typename?: 'NewFlavour', name: string, slug: string, themeColour: string, thumbnail: { __typename?: 'Image', src: string } } }> } } | null };

export type ExtrasScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type ExtrasScreenQuery = { __typename?: 'Query', guest: { __typename?: 'Guest', id: string, planRecommendation?: { __typename?: 'PlanRecommendation', recommendedExtraProductVariants?: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string, merchandisingImage: { __typename?: 'Image', src: string } } }> | null } | null } };

export type FunnelGiftCampaignQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type FunnelGiftCampaignQuery = { __typename?: 'Query', funnelGiftCampaign?: { __typename?: 'FunnelGiftCampaign', productVariant: { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string, merchandisingImage: { __typename?: 'Image', src: string } } } } | null };

export type SimplifiedGuestQueryVariables = Exact<{ [key: string]: never; }>;


export type SimplifiedGuestQuery = { __typename?: 'Query', shouldSeePuppyDiscountModal?: string | null, shouldSeePlansMultivariateTest?: string | null, currentUser?: { __typename: 'Guest', id: string, numberOfAffiliateFreeBoxes: number, preferredLanguage: Language, assumedShippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code, showExtras: boolean, trustpilotBusinessUnitId?: string | null }, dogs: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, previousFoodTypes: Array<{ __typename?: 'PreviousFood', foodItem: Food }> }>, discountCode?: { __typename?: 'DiscountCode', id: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', n?: number | null, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, value: number }> } | null } | { __typename: 'PreWizardGuest' } | { __typename: 'User' } | null };

export type idealPlanFragment = { __typename?: 'Plan', boxKind: BoxKind, typeOfPlanForCustomer: TypeOfPlan, pouchSize: number, pouchesPerDay: number, id: string, pricePerDay: number, trialDiscountedPricePerDay: number, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', dogId: string, gramsPerDay: number, name: string }>, servingInformation: { __typename?: 'PlanServingInformation', gramsPerDay: number }, trial: { __typename?: 'PlanTrial', lengthInDays: number } };

export type IdealPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type IdealPlanQuery = { __typename?: 'Query', guest: { __typename?: 'Guest', id: string, planRecommendation?: { __typename?: 'PlanRecommendation', idealMixPlan?: { __typename?: 'Plan', boxKind: BoxKind, typeOfPlanForCustomer: TypeOfPlan, pouchSize: number, pouchesPerDay: number, id: string, pricePerDay: number, trialDiscountedPricePerDay: number, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', dogId: string, gramsPerDay: number, name: string }>, servingInformation: { __typename?: 'PlanServingInformation', gramsPerDay: number }, trial: { __typename?: 'PlanTrial', lengthInDays: number } } | null, idealAllPlan?: { __typename?: 'Plan', boxKind: BoxKind, typeOfPlanForCustomer: TypeOfPlan, pouchSize: number, pouchesPerDay: number, id: string, pricePerDay: number, trialDiscountedPricePerDay: number, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', dogId: string, gramsPerDay: number, name: string }>, servingInformation: { __typename?: 'PlanServingInformation', gramsPerDay: number }, trial: { __typename?: 'PlanTrial', lengthInDays: number } } | null } | null } };

export type PendingSubscriptionOrderPricingQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
  productVariantIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  flavourQuantities: MealInput;
  discountCodeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PendingSubscriptionOrderPricingQuery = { __typename?: 'Query', pendingSubscriptionOrderPrices: Array<{ __typename?: 'PendingSubscriptionOrderPricing', standardOrderCoreFoodGrossPricePerDay: number }> };

export type RecipesScreenQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type RecipesScreenQuery = { __typename?: 'Query', guest: { __typename?: 'Guest', id: string, planRecommendation?: { __typename?: 'PlanRecommendation', idealGramsAmount?: number | null, individual: Array<{ __typename?: 'Recommendation', dog: { __typename?: 'Dog', id: string, allergens: Array<{ __typename?: 'Allergen', id: string, name: string, flavours: Array<{ __typename?: 'NewFlavour', id: string, name: string }> }>, healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string, flavours: Array<{ __typename?: 'NewFlavour', id: string, name: string }> }> } }>, recommendedExtraProductVariants?: Array<{ __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string, merchandisingImage: { __typename?: 'Image', src: string } } }> | null, combinedRecommendedFlavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, recipeSurcharge?: number | null, standardPricePerDay: number, primaryImage: { __typename?: 'Image', src: string } }>, combinedNotRecommendedFlavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, recipeSurcharge?: number | null, standardPricePerDay: number, primaryImage: { __typename?: 'Image', src: string } }>, combinedOtherFlavours: Array<{ __typename?: 'NewFlavour', id: string, name: string, slug: string, shortDescription: string, recipeSurcharge?: number | null, standardPricePerDay: number, primaryImage: { __typename?: 'Image', src: string } }> } | null } };

export type recommendedExtrasFragment = { __typename?: 'ProductVariant', id: string, name: string, grossPrice: number, recurringDeliveryType?: { __typename?: 'ProductVariantDeliveryType', netPrice: number } | null, productCollection: { __typename?: 'ProductCollection', id: string, name: string, slug: string, merchandisingImage: { __typename?: 'Image', src: string } } };

export type SurveyPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type SurveyPageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, possessivePronoun?: string | null, breed: { __typename?: 'Breed', id: string, key: string, name: string }, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null }, survey?: { __typename?: 'Survey', id: number, name: string, finishedUrl: string, finishedMessage: string, questions: Array<{ __typename?: 'Question', id: number, text: string, questionType: string, options: Array<{ __typename?: 'Option', id: number, text: string, goodOption?: boolean | null, image?: { __typename?: 'Image', src: string } | null }> }> } | null };

export type SubscriptionPlanUpdateVariables = Exact<{
  userId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
}>;


export type SubscriptionPlanUpdate = { __typename?: 'Mutation', subscriptionPlanUpdate?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', plan: { __typename?: 'Plan', id: string } } } | null };

export type SwapAndSavePageQueryVariables = Exact<{ [key: string]: never; }>;


export type SwapAndSavePageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, dogs?: Array<{ __typename?: 'Dog', id: string, gender: Gender }> | null, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, recurringOrder: { __typename?: 'RecurringOrder', deliveryFee: number, planTotal: number, planTotalPerDay: number }, plan: { __typename?: 'Plan', id: string, pouchSize: number, numberOfPouches: number, durationInDays: number, typeOfPlanForCustomer: TypeOfPlan, servingSize: number, swappablePlan?: { __typename?: 'Plan', id: string, price: number, pricePerDay: number, pouchSize: number, numberOfPouches: number, durationInDays: number, typeOfPlanForCustomer: TypeOfPlan, servingSize: number } | null } } } };

export type DogPlanPortionQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type DogPlanPortionQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, planPortionInGrams: number, planPortionInGramsForPlan: number, gender: Gender }> | null } };

export type UpdatePlanAndResumeVariables = Exact<{
  userId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
}>;


export type UpdatePlanAndResume = { __typename?: 'Mutation', subscriptionPlanUpdate?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, plan: { __typename?: 'Plan', id: string } } } | null, subscriptionResume?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus } } | null };

export type RemoveSurchargedRecipesVariables = Exact<{ [key: string]: never; }>;


export type RemoveSurchargedRecipes = { __typename?: 'Mutation', removeSurchargedRecipes?: { __typename?: 'RemoveSurchargedRecipesPayload', user: { __typename?: 'User', id: string } } | null };

export type SwitchAndSavePageQueryVariables = Exact<{ [key: string]: never; }>;


export type SwitchAndSavePageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, recurringOrder: { __typename?: 'RecurringOrder', deliveryFee: number, planTotal: number, planTotalPerDay: number, surchargeTotal: number }, meal?: Array<{ __typename?: 'Meal', quantity: number, flavour: { __typename?: 'NewFlavour', slug: string, name: string, recipeSurcharge?: number | null, thumbnail: { __typename?: 'Image', src: string } } }> | null } } };

export type thankYouQueryVariables = Exact<{
  headerSlug: Scalars['String']['input'];
  whatsappSingleDogSlug: Scalars['String']['input'];
  whatsappMultipleDogsSlug: Scalars['String']['input'];
}>;


export type thankYouQuery = { __typename?: 'Query', systemShouldShowAppContent?: string | null, user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, dogs?: Array<{ __typename?: 'Dog', gender: Gender, name: string, id: string, ageInMonths: number, dailyCalories: number, dailyGrams: number, eaterType: Eater, neutered: boolean, possessivePronoun?: string | null, pouchSizeInGrams: number, weightInGrams: number, breed: { __typename?: 'Breed', id: string, key: string, name: string }, dogProfile?: { __typename?: 'DogProfile', avatarUrl?: string | null, description?: string | null } | null }> | null, subscription: { __typename?: 'Subscription', referralLink: { __typename?: 'ClientReferralLink', url: string }, nextNBoxes: Array<{ __typename?: 'Box', id: string, cutOffDate: any, isoDeliveryDate: any }> } }, header: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string }, whatsAppSingleDog: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string }, whatsAppMultipleDogs: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string } };

export type thankYouQueryV3Variables = Exact<{
  headerSlug: Scalars['String']['input'];
  whatsappSingleDogSlug: Scalars['String']['input'];
  whatsappMultipleDogsSlug: Scalars['String']['input'];
}>;


export type thankYouQueryV3 = { __typename?: 'Query', systemShouldShowAppContent?: string | null, user: { __typename?: 'User', id: string, shippingCountryCode: Code, preferredLanguage: Language, dogs?: Array<{ __typename?: 'Dog', gender: Gender, name: string, id: string, ageInMonths: number, possessivePronoun?: string | null, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null, description?: string | null } | null }> | null, subscription: { __typename?: 'Subscription', id: string, referralLink: { __typename?: 'ClientReferralLink', referralLinkTypeName: string, referralDiscountsTotalValue: number, url: string, referralDiscount: { __typename?: 'DiscountCode', id: string, code: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, n?: number | null }> }, referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', value: number, discountBasis: ApplicableDiscountPartDiscountBasis, n: number, discountType: ApplicableDiscountPartDiscount }> } | null, referrals: Array<{ __typename?: 'Referral', refereeFirstName: string, refereeDogNames: Array<string>, refereeSignUpDate: any }> } } }, header: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string }, whatsAppSingleDog: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string }, whatsAppMultipleDogs: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string } };

export type PausedCalendarDatesDataVariables = Exact<{
  calendarInitDate: Scalars['ISO8601Date']['input'];
  nDays?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  shipmentType: Scalars['String']['input'];
  shouldAttemptToOfferNextDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PausedCalendarDatesData = { __typename?: 'Query', user: { __typename?: 'User', id: string, shippingCountryCode: Code, subscription: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, isoDeliveryDate: any, editable: boolean }> } }, calendarDates: Array<{ __typename?: 'CalendarDate', date: any, deliverable: boolean, replacementDate?: any | null }> };

export type TreatmentsPausedFutureBoxesQueryVariables = Exact<{ [key: string]: never; }>;


export type TreatmentsPausedFutureBoxesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, previewUncreatedFutureBox: { __typename?: 'PreviewBox', isoDeliveryDate: any, order: { __typename?: 'Order', id?: string | null, totalPrice: number, surchargeTotal: number, planTotal: number, deliveryFee: number, subtotal?: number | null, discountTotal?: number | null, discountedSubtotalPricePerDay: number, subtotalPricePerDay: number } } } } };

export type TreatmentsPausedPageQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
}>;


export type TreatmentsPausedPageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, preferredLanguage: Language, shippingCountryCode: Code, shippingCountry: { __typename?: 'ShippingCountry', id: string, code: Code }, address: { __typename?: 'Address', id: string, deliverable: boolean, postcode: string }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender }> | null, ordersByDate: Array<{ __typename?: 'Box', numberOfPouches: number, durationInDays: number, id: string, descriptor: Descriptor, deliveryDateAdjustedBySystem: boolean, isOneOffBox: boolean, isoDeliveryDate: any, shouldOfferSelfService: boolean, cutOffDate: any, shippingDate: any, isFreeBox: boolean, isTrialBox: boolean, isReplacementBox: boolean, isNextEditableBox: boolean, productSpacesFree: number, planPricePerDay: number, amendable: boolean, discounts: Array<{ __typename?: 'Discount', applicableDiscountPart?: { __typename?: 'ApplicableDiscountPart', discountBasis: ApplicableDiscountPartDiscountBasis, value: number } | null }>, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, order: { __typename?: 'Order', id?: string | null, planTotalPerDay: number, planTotal: number, surchargeTotal: number, physicalProductsTotal?: number | null, deliveryFee: number, discountTotal?: number | null, discountTotalPercentage?: number | null, totalPrice: number, orderProducts: Array<{ __typename?: 'OrderProduct', id: string, nonPaymentReason?: NonPaymentReason | null, quantity: number, requiresPayment: boolean, visibilityScope: VisibilityScope, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } } }> }, meals?: Array<{ __typename?: 'Meal', id?: string | null, quantity: number, flavour: { __typename?: 'NewFlavour', id: string, name: string, thumbnail: { __typename?: 'Image', src: string } } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number } } | { __typename?: 'NonCoreOrder', id: string, descriptor: Descriptor, invoice: { __typename?: 'NonCoreInvoice', id: string, status: NonCoreInvoiceStatus, grossPrice: number, discountedPrice: number, discountTotal: number }, orderParts: Array<{ __typename?: 'NonCoreOrderPart', deliverySurcharge: number, smallOrderSurcharge: number, orderProductsTotal: number, deliveryDate: any, shippingDate: any, consignment?: { __typename?: 'Consignment', id: string, status?: Status | null } | null, orderProducts: Array<{ __typename?: 'NonCoreOrderProduct', id: string, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, name: string, productCollection: { __typename?: 'ProductCollection', id: string, thumbnail: { __typename?: 'Image', src: string } } } }> }> }>, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, activePaymentMethodType?: PaymentMethodable | null, previewUncreatedFutureBox: { __typename?: 'PreviewBox', isoDeliveryDate: any, order: { __typename?: 'Order', id?: string | null, totalPrice: number, surchargeTotal: number, planTotal: number, deliveryFee: number, subtotal?: number | null, discountTotal?: number | null, discountedSubtotalPricePerDay: number, subtotalPricePerDay: number } }, meal?: Array<{ __typename?: 'Meal', quantity: number, flavour: { __typename?: 'NewFlavour', id: string, slug: string, themeColour: string, name: string, recipeSurcharge?: number | null, thumbnail: { __typename?: 'Image', src: string }, productLabels?: Array<{ __typename?: 'ProductLabel', id: string, name: string, themeColour: string }> | null } }> | null, plan: { __typename?: 'Plan', id: string, pouchSize: number, numberOfPouches: number, durationInDays: number, swappablePlan?: { __typename?: 'Plan', id: string, pouchSize: number, price: number } | null, downsizeablePlan?: { __typename?: 'Plan', id: string, price: number } | null }, currentPause?: { __typename?: 'Pause', id: string, treatments: Array<string> } | null, defaultReactivationCampaign?: { __typename?: 'ReactivationCampaign', name: string, expiryDate?: any | null, description?: string | null, discountCode: { __typename?: 'DiscountCode', id: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> } } | null, alreadyRedeemedReactivationCampaign?: { __typename?: 'ReactivationCampaign', name: string, expiryDate?: any | null, description?: string | null, discountCode: { __typename?: 'DiscountCode', id: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', discountBasis: DiscountCodePartDiscountBasis, value: number, discountType: DiscountCodePartDiscount, n?: number | null }> } } | null } } };

export type UpdateDogAboutInfoMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  attributes: Array<DogUpdateInput> | DogUpdateInput;
}>;


export type UpdateDogAboutInfoMutation = { __typename?: 'Mutation', dogsUpdate?: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, ageInMonths: number, gender: Gender, breed: { __typename?: 'Breed', key: string, name: string } }> | null, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } }, plan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } } } } | null };

export type DogAboutInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type DogAboutInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, ageInMonths: number, gender: Gender, neutered: boolean, breed: { __typename?: 'Breed', id: string, key: string, name: string } }> | null }, breeds: Array<{ __typename?: 'Breed', id: string, key: string, name: string }> };

export type UpdateDogBasicInformationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  attributes: Array<DogUpdateInput> | DogUpdateInput;
}>;


export type UpdateDogBasicInformationMutation = { __typename?: 'Mutation', dogsUpdate?: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, ageInMonths: number, gender: Gender, neutered: boolean, breed: { __typename?: 'Breed', key: string, name: string } }> | null, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } }, plan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } } } } | null };

export type UpdateDogBasicInfoMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  attributes: Array<DogUpdateInput> | DogUpdateInput;
  caloriesMultipleOf: Scalars['Int']['input'];
  percentageMultipleOf: Scalars['Int']['input'];
  lowerPercentage: Scalars['Int']['input'];
  upperPercentage: Scalars['Int']['input'];
}>;


export type UpdateDogBasicInfoMutation = { __typename?: 'Mutation', dogsUpdate?: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, weightInGrams: number, bodyShape: BodyShape, exercise: Exercise, neutered: boolean, possessivePronoun?: string | null, planPortionInGrams: number, roundedDailyCaloriesExceededByPlanPortion: number, roundedDailyCaloriesExceededByPlanPortionInPercentage: number, roundedPlanPortionInCalories: number, roundedPlanPortionInPercentage: number, roundedUncappedPlanPortionInPercentage: number, snackingHabits: SnackingHabit, roundedDailyCaloriesUnfulfilledByPlanPortionLowerBoundary: number, roundedDailyCaloriesUnfulfilledByPlanPortionUpperBoundary: number, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number }> | null, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } }, plan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } } } } | null };

export type DogBasicInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type DogBasicInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } }, plan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } } }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, weightInGrams: number, bodyShape: BodyShape, exercise: Exercise, neutered: boolean }> | null } };

export type UpdateDogEatingHabitsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  attributes: Array<DogUpdateInput> | DogUpdateInput;
}>;


export type UpdateDogEatingHabitsMutation = { __typename?: 'Mutation', dogsUpdate?: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, eaterType: Eater, snackingHabits: SnackingHabit }> | null, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } }, plan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } } } } | null };

export type DogEatingHabitsQueryVariables = Exact<{ [key: string]: never; }>;


export type DogEatingHabitsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, eaterType: Eater, snackingHabits: SnackingHabit }> | null } };

export type UpdateMedicalInfoMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  attributes: Array<DogUpdateInput> | DogUpdateInput;
}>;


export type UpdateMedicalInfoMutation = { __typename?: 'Mutation', dogsUpdate?: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, possessivePronoun?: string | null, healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string, warning: boolean, information: string }>, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }> }> | null, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', id: string, pricingCurve: { __typename?: 'PricingCurve', id: string, pricingCohort: string } }, plan: { __typename?: 'Plan', id: string, pricingCurve: { __typename?: 'PricingCurve', id: string, pricingCohort: string } } } } | null };

export type MedicalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MedicalInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', id: string, pricingCurve: { __typename?: 'PricingCurve', id: string, pricingCohort: string } }, plan: { __typename?: 'Plan', id: string, pricingCurve: { __typename?: 'PricingCurve', id: string, pricingCohort: string } } }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, possessivePronoun?: string | null, healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string, warning: boolean, information: string }>, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }> }> | null }, healthIssues: Array<{ __typename?: 'HealthIssue', id: string, name: string, warning: boolean, information: string }>, allergens: Array<{ __typename?: 'Allergen', id: string, name: string }> };

export type CreateDogProfilesMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  dogIdsInput: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateDogProfilesMutation = { __typename?: 'Mutation', dogProfilesCreate?: { __typename?: 'Subscription', id: string } | null };

export type UpdateDogPersonalityMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  traitsInput: Array<TraitsInput> | TraitsInput;
  activitiesInput: Array<ActivitiesInput> | ActivitiesInput;
  favouriteGamesInput: Array<FavouriteGameInput> | FavouriteGameInput;
}>;


export type UpdateDogPersonalityMutation = { __typename?: 'Mutation', traitsUpdate?: { __typename?: 'Subscription', id: string } | null, activitiesUpdate?: { __typename?: 'Subscription', id: string } | null, favouriteGamesUpdate?: { __typename?: 'Subscription', id: string } | null };

export type DogPersonalityQueryVariables = Exact<{ [key: string]: never; }>;


export type DogPersonalityQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, dogProfile?: { __typename?: 'DogProfile', id: string, favouriteGame?: FavouriteGame | null, dogActivities: Array<{ __typename?: 'DogActivity', activity: Activity }>, dogPersonalityTraits: Array<{ __typename?: 'DogPersonalityTrait', trait: Trait }> } | null }> | null } };

export type UpdateDogWeightAndAppetiteMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  attributes: Array<DogUpdateInput> | DogUpdateInput;
  caloriesMultipleOf: Scalars['Int']['input'];
  percentageMultipleOf: Scalars['Int']['input'];
  lowerPercentage: Scalars['Int']['input'];
  upperPercentage: Scalars['Int']['input'];
}>;


export type UpdateDogWeightAndAppetiteMutation = { __typename?: 'Mutation', dogsUpdate?: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, weightInGrams: number, bodyShape: BodyShape, exercise: Exercise, neutered: boolean, eaterType: Eater, snackingHabits: SnackingHabit, possessivePronoun?: string | null, planPortionInGrams: number, roundedDailyCaloriesExceededByPlanPortion: number, roundedDailyCaloriesExceededByPlanPortionInPercentage: number, roundedPlanPortionInCalories: number, roundedPlanPortionInPercentage: number, roundedUncappedPlanPortionInPercentage: number, roundedDailyCaloriesUnfulfilledByPlanPortionLowerBoundary: number, roundedDailyCaloriesUnfulfilledByPlanPortionUpperBoundary: number, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number }> | null, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', id: string, pricingCurve: { __typename?: 'PricingCurve', id: string, pricingCohort: string } }, plan: { __typename?: 'Plan', id: string, pricingCurve: { __typename?: 'PricingCurve', id: string, pricingCohort: string } } } } | null };

export type DogWeightAndAppetiteQueryVariables = Exact<{ [key: string]: never; }>;


export type DogWeightAndAppetiteQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, idealPlan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } }, plan: { __typename?: 'Plan', pricingCurve: { __typename?: 'PricingCurve', pricingCohort: string } } }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, weightInGrams: number, bodyShape: BodyShape, exercise: Exercise, neutered: boolean, eaterType: Eater, snackingHabits: SnackingHabit }> | null } };

export type PreWizardGuestIterableUpsertMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type PreWizardGuestIterableUpsertMutation = { __typename?: 'Mutation', preWizardGuestIterableUpsert?: { __typename?: 'PreWizardGuest', trackingId?: string | null } | null };

export type HomeBreedSelectorQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  popular?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HomeBreedSelectorQuery = { __typename?: 'Query', breeds: Array<{ __typename?: 'Breed', id: string, name: string, key: string, popular: boolean }> };

export type PreWizardGuestIterableUpsertWithRecaptchaMutationVariables = Exact<{
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
}>;


export type PreWizardGuestIterableUpsertWithRecaptchaMutation = { __typename?: 'Mutation', preWizardGuestIterableUpsertWithRecaptcha?: { __typename?: 'PreWizardGuest', trackingId?: string | null } | null };

export type SaveLanguageUpdateVariables = Exact<{
  language: Language;
}>;


export type SaveLanguageUpdate = { __typename?: 'Mutation', languageUpdate?: { __typename: 'Guest', id: string } | { __typename: 'PreWizardGuest' } | { __typename: 'User', id: string } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', currentUser?: { __typename: 'Guest', preferredLanguage: Language } | { __typename: 'PreWizardGuest' } | { __typename: 'User', preferredLanguage: Language } | null };

export type SubscriptionResumeMutationVariables = Exact<{
  numOfBoxes: Scalars['Int']['input'];
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
}>;


export type SubscriptionResumeMutation = { __typename?: 'Mutation', subscriptionResumeWithDeliveryDate?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus, increasedDeliveryCadencePlan?: { __typename?: 'Plan', id: string } | null, nextNBoxes: Array<{ __typename?: 'Box', id: string, cutOffDate: any, isTrialBox: boolean, isoDeliveryDate: any, editable: boolean, descriptor: Descriptor }> } } | null };

export type CreateDogProfileMutationHookVariables = Exact<{
  userId: Scalars['ID']['input'];
  dogIdsInput: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateDogProfileMutationHook = { __typename?: 'Mutation', dogProfilesCreate?: { __typename?: 'Subscription', id: string } | null };

export type UpdateDogProfilePictureMutationHookVariables = Exact<{
  userId: Scalars['ID']['input'];
  avatarsInput: Array<AvatarInput> | AvatarInput;
}>;


export type UpdateDogProfilePictureMutationHook = { __typename?: 'Mutation', avatarsUpdate?: { __typename?: 'User', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null } | null };

export type InAccountRafQueryVariables = Exact<{ [key: string]: never; }>;


export type InAccountRafQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, shippingCountryCode: Code, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null, subscription: { __typename?: 'Subscription', id: string, activeRafCampaignRedeemed: boolean, referralLink: { __typename?: 'ClientReferralLink', referralLinkTypeName: string, referralDiscountsTotalValue: number, url: string, referralDiscount: { __typename?: 'DiscountCode', id: string, code: string, discountCodeParts: Array<{ __typename?: 'DiscountCodePart', value: number, discountType: DiscountCodePartDiscount, discountBasis: DiscountCodePartDiscountBasis, n?: number | null }> }, referrerDiscount?: { __typename?: 'ApplicableDiscount', applicableDiscountParts: Array<{ __typename?: 'ApplicableDiscountPart', value: number, discountBasis: ApplicableDiscountPartDiscountBasis, n: number, discountType: ApplicableDiscountPartDiscount }> } | null, referrals: Array<{ __typename?: 'Referral', refereeFirstName: string, refereeDogNames: Array<string>, refereeSignUpDate: any }> }, activeRafCampaignVariant?: { __typename?: 'RafCampaignVariant', name: string, rafCampaign: { __typename?: 'RafCampaign', name: string, endDate: any }, view?: { __typename?: 'View', data: any } | null } | null } }, shippingCountries: Array<{ __typename?: 'ShippingCountry', id: string, code: Code, showRafCharityButton: boolean }>, whatsAppSingleDog: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string }, whatsAppMultipleDogs: { __typename?: 'ClientReferralLinkTypeCopyEntry', text: string } };

export type IntercomPersonalDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntercomPersonalDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, numericalCreatedAt: number, intercomUserHash: string, trackingId: string } };

export type PlanFragment = { __typename?: 'Plan', id: string, gramsPerDay: number, roundedCaloriesPerDay: number, servingType: Serving, typeOfPlanForCustomer: TypeOfPlan, numberOfPouches: number, durationInDays: number, pouchSize: number, pricePerDay: number, pricePerWeek: number, price: number, pricePerPouch: number, pouchesPerDay: number, servingSize: number, numberOfServings: number, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', dogId: string, name: string, gramsPerDay: number }> };

export type DogPlanFragment = { __typename?: 'Dog', id: string, name: string, gender: Gender, ageInMonths: number, roundedDailyCalories: number, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number, breed: { __typename?: 'Breed', id: string, name: string, key: string }, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null };

export type UsePlanQueryVariables = Exact<{
  caloriesMultipleOf: Scalars['Int']['input'];
  lowerPercentage: Scalars['Int']['input'];
  upperPercentage: Scalars['Int']['input'];
}>;


export type UsePlanQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, deliveriesReceived: number, recurringOrder: { __typename?: 'RecurringOrder', deliveryFee: number, physicalProductsTotal: number, surchargeTotal: number }, planOptions: Array<{ __typename?: 'Plan', id: string, gramsPerDay: number, roundedCaloriesPerDay: number, servingType: Serving, typeOfPlanForCustomer: TypeOfPlan, numberOfPouches: number, durationInDays: number, pouchSize: number, pricePerDay: number, pricePerWeek: number, price: number, pricePerPouch: number, pouchesPerDay: number, servingSize: number, numberOfServings: number, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', dogId: string, name: string, gramsPerDay: number }> }>, plan: { __typename?: 'Plan', id: string, gramsPerDay: number, roundedCaloriesPerDay: number, servingType: Serving, typeOfPlanForCustomer: TypeOfPlan, numberOfPouches: number, durationInDays: number, pouchSize: number, pricePerDay: number, pricePerWeek: number, price: number, pricePerPouch: number, pouchesPerDay: number, servingSize: number, numberOfServings: number, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', dogId: string, name: string, gramsPerDay: number }> }, idealPlan: { __typename?: 'Plan', id: string, gramsPerDay: number, roundedCaloriesPerDay: number, servingType: Serving, typeOfPlanForCustomer: TypeOfPlan, numberOfPouches: number, durationInDays: number, pouchSize: number, pricePerDay: number, pricePerWeek: number, price: number, pricePerPouch: number, pouchesPerDay: number, servingSize: number, numberOfServings: number, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', dogId: string, name: string, gramsPerDay: number }> } }, dogs?: Array<{ __typename?: 'Dog', id: string, name: string, gender: Gender, ageInMonths: number, roundedDailyCalories: number, roundedDailyCaloriesLowerBoundary: number, roundedDailyCaloriesUpperBoundary: number, breed: { __typename?: 'Breed', id: string, name: string, key: string }, dogProfile?: { __typename?: 'DogProfile', id: string, avatarUrl?: string | null } | null }> | null } };

export type UpdatePlanMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  numOfBoxes: Scalars['Int']['input'];
}>;


export type UpdatePlanMutation = { __typename?: 'Mutation', subscriptionPlanUpdate?: { __typename?: 'User', id: string, subscription: { __typename?: 'Subscription', id: string, nextNBoxes: Array<{ __typename?: 'Box', id: string, numberOfPouches: number, durationInDays: number, plan: { __typename?: 'Plan', id: string, pouchSize: number } }>, plan: { __typename?: 'Plan', id: string, gramsPerDay: number, roundedCaloriesPerDay: number, servingType: Serving, typeOfPlanForCustomer: TypeOfPlan, numberOfPouches: number, durationInDays: number, pouchSize: number, pricePerDay: number, pricePerWeek: number, price: number, pricePerPouch: number, pouchesPerDay: number, servingSize: number, numberOfServings: number, gramsPerDayPerDogs: Array<{ __typename?: 'DogPortion', dogId: string, name: string, gramsPerDay: number }> } } } | null };

export type MockQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type MockQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string } };

export const CalendarDatesV2Fragment = gql`
    fragment CalendarDatesV2Fragment on CalendarDate {
  date
  deliverable
  replacementDate
  endOfLeadTime
}
    `;
export const CourierFragment = gql`
    fragment CourierFragment on DeliveryArea {
  id
  regularDeliveryDaysOfWeek
  preferredCarrierService {
    id
    carrier {
      name
    }
    deliveryNotesLimit
  }
  calendarDates(
    startDate: $calendarInitDate
    nDays: $nDays
    shouldAttemptToOfferNextDayDelivery: $shouldAttemptToOfferNextDayDelivery
  ) {
    ...CalendarDatesV2Fragment
  }
}
    ${CalendarDatesV2Fragment}`;
export const PriceFragment = gql`
    fragment PriceFragment on ProductVariant {
  id
  grossPrice
  productVariantDeliveryTypes {
    deliveryType
    adjustedGrossPrice
    netPrice
  }
}
    `;
export const BoxPhysicalOrderProducts = gql`
    fragment BoxPhysicalOrderProducts on Box {
  physicalOrderProducts {
    id
    requiresPayment
    quantity
    frequency
    price
    discountedPrice
    nonPaymentReason
    productVariant {
      id
      name
      discountedPrice
      grossPrice
      oneOffDeliveryType {
        netPrice
      }
      recurringDeliveryType {
        adjustedGrossPrice
        netPrice
      }
      subscribeAndSaveable
      productCollection {
        id
        slug
        name
        thumbnail {
          src
        }
        productVariants {
          id
          name
          ...PriceFragment
        }
      }
    }
  }
}
    ${PriceFragment}`;
export const EditExtrasUserFragment = gql`
    fragment EditExtrasUserFragment on User {
  id
  shippingCountryCode
  shippingCountry {
    id
    showUpcomingOrderSeeMoreExtras
    showExtras
  }
  preferredLanguage
}
    `;
export const ShopItemFragment = gql`
    fragment ShopItemFragment on ProductVariant {
  id
  name
  productCollection {
    id
    name
    slug
  }
  recurringDeliveryType {
    netPrice
  }
  oneOffDeliveryType {
    netPrice
  }
}
    `;
export const EditExtrasBoxFragment = gql`
    fragment EditExtrasBoxFragment on Box {
  id
  isoDeliveryDate
  physicalOrderProducts {
    id
    frequency
    quantity
    price
    discountedPrice
    requiresPayment
    nonPaymentReason
    productVariant {
      id
      grossPrice
      subscribeAndSaveable
      productCollection {
        id
        thumbnail {
          src
        }
        productVariants {
          id
          name
        }
      }
      ...ShopItemFragment
    }
  }
}
    ${ShopItemFragment}`;
export const recipeCardFlavourFragment = gql`
    fragment recipeCardFlavourFragment on NewFlavour {
  id
  name
  slug
  shortDescription(includeHtml: true)
  recipeSurcharge(planId: $planId)
  standardPricePerDay(planId: $planId)
  primaryImage {
    src
  }
}
    `;
export const HowToFeedModalTriggerDogFragment = gql`
    fragment HowToFeedModalTriggerDogFragment on Dog {
  id
  name
}
    `;
export const HowToFeedModalTriggerPlanFragment = gql`
    fragment HowToFeedModalTriggerPlanFragment on Plan {
  id
  pouchSize
  pouchesPerDay
  servingInformation {
    gramsPerDay
    numberOfServings
    pouchesPerServing
    roundedCaloriesPerDay
    servingSize
    servingType
  }
}
    `;
export const SubscriptionOverviewFragment = gql`
    fragment SubscriptionOverviewFragment on User {
  dogs {
    id
    name
    planPortionInGrams
    gender
    ageInMonths
    dogProfile {
      id
      avatarUrl
    }
    ...HowToFeedModalTriggerDogFragment
  }
  subscription {
    id
    status
    plan {
      id
      ...HowToFeedModalTriggerPlanFragment
    }
  }
}
    ${HowToFeedModalTriggerDogFragment}
${HowToFeedModalTriggerPlanFragment}`;
export const marketingPreferenceFragment = gql`
    fragment marketingPreferenceFragment on User {
  id
  selectedMarketingMethodPurposes {
    id
    supportedMarketingMethodPurpose {
      marketingMethod {
        id
        name
      }
      marketingPurpose {
        id
        name
        description
      }
    }
  }
  availableMarketingMethodPurposes {
    id
    preselect
    shippingCountry {
      id
    }
    marketingMethod {
      id
      name
    }
    marketingPurpose {
      id
      name
      description
    }
  }
}
    `;
export const BoxOrderSummaryModalFragment = gql`
    fragment BoxOrderSummaryModalFragment on Box {
  id
  netPrice
  price
  order {
    id
    deliveryFee
    discountTotal
    physicalProductsTotal
    planTotal
    planTotalPerDay
    subtotal
    surchargeTotal
    totalPrice
  }
}
    `;
export const NonCoreOrderOrderSummaryModalFragment = gql`
    fragment NonCoreOrderOrderSummaryModalFragment on NonCoreOrder {
  id
  invoice {
    id
    discountTotal
    discountedPrice
    grossPrice
  }
  orderParts {
    deliverySurcharge
    orderProductsTotal
    smallOrderSurcharge
  }
}
    `;
export const OrderSummaryModalFragment = gql`
    fragment OrderSummaryModalFragment on OrderUnion {
  ... on Box {
    ...BoxOrderSummaryModalFragment
  }
  ... on NonCoreOrder {
    ...NonCoreOrderOrderSummaryModalFragment
  }
}
    ${BoxOrderSummaryModalFragment}
${NonCoreOrderOrderSummaryModalFragment}`;
export const reactivationCampaignFragment = gql`
    fragment reactivationCampaignFragment on ReactivationCampaign {
  name
  isActive
  expiryDate
  description
  currentUserIsEligible
  image {
    src
  }
  discountCode {
    id
    code
    discountCodeParts {
      discountBasis
      discountType
      n
      value
    }
  }
}
    `;
export const DeliveryDateUserFragment = gql`
    fragment DeliveryDateUserFragment on User {
  id
  shippingCountry {
    id
    showUpcomingOrderSeeMoreExtras
  }
  subscription {
    id
    nextNBoxes(num: $nextNBoxes) {
      id
      isoDeliveryDate
      editable
    }
    box(boxId: $boxId) {
      id
      isoDeliveryDate
      editable
    }
  }
}
    `;
export const UpsellModalFragment = gql`
    fragment UpsellModalFragment on User {
  id
  shippingCountryCode
  shippingCountry {
    id
    showUpcomingOrderSeeMoreExtras
  }
  dogs {
    id
    name
  }
}
    `;
export const orderSummaryFlavourFragment = gql`
    fragment orderSummaryFlavourFragment on NewFlavour {
  id
  name
  slug
  shortDescription
  primaryImage {
    src
  }
  recipeSurcharges {
    planSize
    amount
  }
}
    `;
export const discountCodeFragment = gql`
    fragment discountCodeFragment on DiscountCode {
  id
  code
  discountBasis
  value
  discountCodeParts {
    discountBasis
    value
    discountType
    n
  }
}
    `;
export const featureFlagFragment = gql`
    fragment featureFlagFragment on Query {
  shouldSeeApplePay: featureFlag(
    flag: "system-should-see-apple-pay"
    fallback: "false"
  )
  shouldSeeGooglePay: featureFlag(
    flag: "system-should-see-google-pay"
    fallback: "false"
  )
  shouldSeeFetchifyOnCheckout: featureFlag(
    flag: "system_see_fetchify_on_checkout"
    fallback: "false"
  )
  shouldSeeAltCountdown: featureFlag(
    flag: "should_see_alt_countdown"
    fallback: "false"
  )
  shouldSeeTabbedStripeCheckout: featureFlag(
    flag: "should_see_tabbed_stripe_checkout"
    fallback: "not_in_cohort"
  )
  shouldSeePayPal: featureFlag(
    flag: "system-should-see-paypal"
    fallback: "control"
  )
  shouldSeeRequiredPhoneNumber: featureFlag(
    flag: "should_see_required_phone_number"
    fallback: "control"
  )
  shouldSeeSubscriptionInfo: featureFlag(
    flag: "should_see_subscription_info_on_checkout"
    fallback: "not_in_cohort"
  )
}
    `;
export const pendingSubscriptionOrderPricingFragment = gql`
    fragment pendingSubscriptionOrderPricingFragment on PendingSubscriptionOrderPricing {
  grossTotalPrice
  netTotalPrice
  netTotalPricePerDay
  totalDiscountedAmount
  grossCoreFoodPrice
  grossCoreFoodPricePerDay
  netCoreFoodPrice
  coreFoodDiscountedAmount
  grossRecipeSurchargePrice
  netRecipeSurchargePrice
  recipeSurchargeDiscountedAmount
  grossDeliverySurchargePrice
  netDeliverySurchargePrice
  deliverySurchargeDiscountedAmount
  grossAdditionalProductsPrice
  netAdditionalProductsPrice
  additionalProductsDiscountedAmount
  totalSavedAmount
  standardOrderCoreFoodGrossPrice
  standardOrderCoreFoodGrossPricePerDay
  flavourPricings {
    flavourName
    servings
    netStandardOrderPricePerServing
    grossStandardOrderPricePerServing
    netFirstOrderPricePerServing
  }
}
    `;
export const productVariantFragment = gql`
    fragment productVariantFragment on ProductVariant {
  id
  name
  grossPrice
  recurringDeliveryType {
    netPrice
  }
  productVariantDeliveryTypes {
    deliveryType
    netPrice
  }
  productCollection {
    name
    merchandisingImage {
      src
    }
  }
}
    `;
export const shippingCountryFragment = gql`
    fragment shippingCountryFragment on ShippingCountry {
  active
  availableLanguages
  code
  currency
  defaultLanguage
  domain
  id
  name
  scaEnforced
  showExtras
  trustpilotBusinessUnitId
}
    `;
export const applyDiscount = gql`
    fragment applyDiscount on CustomerIssueManagementResolutionDetailsApplyDiscount {
  discountCode {
    id
    code
    value
  }
}
    `;
export const replaceBox = gql`
    fragment replaceBox on CustomerIssueManagementResolutionDetailsReplaceBox {
  availableDeliveryDates {
    date
    deliverable
    endOfLeadTime
  }
  defaultAddress {
    address1
    address2
    city
    shippingCountry {
      id
      code
    }
    postcode
    recipientName
    deliveryNotes
    deliveryCarrier
  }
}
    `;
export const trackOrderResolutionDetailsFields = gql`
    fragment trackOrderResolutionDetailsFields on CustomerIssueManagementResolutionDetailsTrackOrder {
  boxId
  trackingId
  trackingUrl
  courierName
  address1
  address2
}
    `;
export const helpCentreArticleResolutionDetailsFields = gql`
    fragment helpCentreArticleResolutionDetailsFields on CustomerIssueManagementResolutionDetailsHelpCentreArticle {
  articleId
}
    `;
export const BoxOrderFragment = gql`
    fragment BoxOrderFragment on Box {
  order {
    id
    orderProducts {
      id
    }
    planTotalPerDay
    planTotal
    surchargeTotal
    physicalProductsTotal
    deliveryFee
    discountTotal
    discountTotalPercentage
    totalPrice
  }
  descriptor
  amendable
}
    `;
export const upcomingBoxOrderFragment = gql`
    fragment upcomingBoxOrderFragment on Box {
  numberOfPouches
  durationInDays
  id
  descriptor
  deliveryDateAdjustedBySystem
  isOneOffBox
  isoDeliveryDate
  shouldOfferSelfService
  cutOffDate
  shippingDate
  isFreeBox
  isTrialBox
  isReplacementBox
  isNextEditableBox
  productSpacesFree
  discounts {
    applicableDiscountPart {
      discountBasis
      value
    }
  }
  consignment {
    id
    status
  }
  planPricePerDay
  order {
    id
    orderProducts {
      id
      nonPaymentReason
      quantity
      requiresPayment
      visibilityScope
      productVariant {
        id
        name
        productCollection {
          id
          name
          thumbnail {
            src
          }
        }
      }
    }
    planTotalPerDay
    planTotal
    surchargeTotal
    physicalProductsTotal
    deliveryFee
    discountTotal
    discountTotalPercentage
    totalPrice
  }
  amendable
  meals {
    id
    flavour {
      id
      name
      thumbnail {
        src
      }
    }
    quantity
  }
  plan {
    id
    pouchSize
  }
}
    `;
export const nonCoreUpcomingOrderFragment = gql`
    fragment nonCoreUpcomingOrderFragment on NonCoreOrder {
  id
  descriptor
  invoice {
    id
    status
    grossPrice
    discountedPrice
    discountTotal
  }
  orderParts {
    deliverySurcharge
    smallOrderSurcharge
    orderProductsTotal
    consignment {
      id
      status
    }
    deliveryDate
    shippingDate
    orderProducts {
      id
      quantity
      productVariant {
        id
        name
        productCollection {
          id
          thumbnail {
            src
          }
        }
      }
    }
  }
}
    `;
export const PetCareSectionDogsFragment = gql`
    fragment PetCareSectionDogsFragment on Dog {
  id
  name
  breed {
    id
    name
  }
  ageInMonths
  dogProfile {
    id
    avatarUrl
  }
}
    `;
export const BoxOrderFragmentV3 = gql`
    fragment BoxOrderFragmentV3 on Box {
  order {
    id
    orderProducts {
      id
    }
  }
  descriptor
  amendable
}
    `;
export const upcomingBoxOrderFragmentV3 = gql`
    fragment upcomingBoxOrderFragmentV3 on Box {
  numberOfPouches
  id
  descriptor
  movedFromUndeliverableDeliveryDate
  address {
    id
    recipientName
    address1
    address2
    city
    postcode
    deliveryNotes
  }
  invoices {
    id
    issueDate
    corrective
    grossTotal
  }
  invoice {
    id
  }
  isOneOffBox
  isoDeliveryDate
  cutOffDate
  shippingDate
  isFreeBox
  isTrialBox
  isReplacementBox
  isNextEditableBox
  productSpacesFree
  discounts {
    applicableDiscountPart {
      discountBasis
      value
    }
  }
  consignment {
    id
    status
  }
  planPricePerDay
  order {
    id
    orderProducts {
      id
      nonPaymentReason
      quantity
      visibilityScope
      requiresPayment
      productVariant {
        id
        name
        productCollection {
          id
          name
          thumbnail {
            src
          }
        }
      }
    }
    planTotalPerDay
    planTotal
    surchargeTotal
    physicalProductsTotal
    deliveryFee
    discountTotal
    discountTotalPercentage
    totalPrice
  }
  amendable
  numberOfPouches
  meals {
    id
    flavour {
      id
      name
      thumbnail {
        src
      }
    }
    quantity
  }
}
    `;
export const nonCoreUpcomingOrderFragmentV3 = gql`
    fragment nonCoreUpcomingOrderFragmentV3 on NonCoreOrder {
  id
  descriptor
  address {
    id
    recipientName
    address1
    address2
    city
    postcode
    deliveryNotes
  }
  invoice {
    id
    status
    grossPrice
    discountedPrice
    discountTotal
  }
  orderParts {
    deliverySurcharge
    smallOrderSurcharge
    orderProductsTotal
    consignment {
      id
      status
    }
    deliveryDate
    shippingDate
    orderProducts {
      id
      quantity
      productVariant {
        id
        name
        productCollection {
          id
          thumbnail {
            src
          }
        }
      }
    }
  }
}
    `;
export const ArchiveDogProfileActionDogFragment = gql`
    fragment ArchiveDogProfileActionDogFragment on Dog {
  id
  name
  gender
}
    `;
export const ArchiveDogProfileActionQueryFragment = gql`
    fragment ArchiveDogProfileActionQueryFragment on Query {
  archiveReasons
}
    `;
export const CalorieDetailsFragment = gql`
    fragment CalorieDetailsFragment on Dog {
  id
  name
  gender
  possessivePronoun
  planPortionInGrams
  roundedDailyCaloriesUnfulfilledByPlanPortionLowerBoundary: roundedDailyCaloriesPercentageUnfulfilledByPlanPortion(
    multipleOf: $caloriesMultipleOf
    percentage: $lowerPercentage
  )
  roundedDailyCaloriesUnfulfilledByPlanPortionUpperBoundary: roundedDailyCaloriesPercentageUnfulfilledByPlanPortion(
    multipleOf: $caloriesMultipleOf
    percentage: $upperPercentage
  )
  roundedDailyCaloriesLowerBoundary: roundedPercentageOfDailyCalories(
    multipleOf: $caloriesMultipleOf
    percentage: $lowerPercentage
  )
  roundedDailyCaloriesUpperBoundary: roundedPercentageOfDailyCalories(
    multipleOf: $caloriesMultipleOf
    percentage: $upperPercentage
  )
  roundedDailyCaloriesExceededByPlanPortion(multipleOf: $caloriesMultipleOf)
  roundedDailyCaloriesExceededByPlanPortionInPercentage(
    multipleOf: $percentageMultipleOf
  )
  roundedPlanPortionInCalories(multipleOf: $caloriesMultipleOf)
  roundedPlanPortionInPercentage(multipleOf: $percentageMultipleOf)
  roundedUncappedPlanPortionInPercentage(multipleOf: $percentageMultipleOf)
  snackingHabits
}
    `;
export const DailyPortionSizeFragment = gql`
    fragment DailyPortionSizeFragment on User {
  id
  dogs {
    id
    name
    possessivePronoun
    gender
    planPortionInGrams
    ...CalorieDetailsFragment
  }
}
    ${CalorieDetailsFragment}`;
export const DogProfilePictureFragment = gql`
    fragment DogProfilePictureFragment on Dog {
  id
  name
  dogProfile {
    id
    avatarUrl
    avatarImageAttached
  }
}
    `;
export const SelectableDogAvatarFragment = gql`
    fragment SelectableDogAvatarFragment on Dog {
  id
  name
  breed {
    id
    name
    key
  }
  ageInMonths
  dogProfile {
    id
    avatarUrl
  }
}
    `;
export const DogSelectionFragment = gql`
    fragment DogSelectionFragment on Dog {
  id
  ...SelectableDogAvatarFragment
}
    ${SelectableDogAvatarFragment}`;
export const ShareProfileFragment = gql`
    fragment ShareProfileFragment on User {
  id
  subscription {
    id
    referralLink {
      url
    }
  }
  dogs {
    id
    name
    possessivePronoun
    dogProfile {
      id
      avatarUrl
      dogActivities {
        activity
      }
      dogPersonalityTraits {
        trait
      }
      favouriteGame
    }
  }
}
    `;
export const ShareRafPassFragment = gql`
    fragment ShareRafPassFragment on User {
  id
  shippingCountryCode
  subscription {
    id
    referralLink {
      referralLinkTypeName
      referralDiscountsTotalValue
      url
      referralDiscount {
        id
        code
        discountCodeParts {
          value
          discountType
          discountBasis
          n
        }
      }
      referrerDiscount {
        applicableDiscountParts {
          value
          discountBasis
          n
          discountType
        }
      }
      referrals {
        refereeFirstName
        refereeDogNames
        refereeSignUpDate
      }
    }
  }
  dogs {
    id
    dogProfile {
      id
      avatarUrl
    }
  }
}
    `;
export const DogProfileMedicalFragment = gql`
    fragment DogProfileMedicalFragment on Dog {
  id
  allergens {
    id
    name
  }
  healthIssues {
    id
    name
  }
  recommendedCareDetails {
    careType
  }
  name
  possessivePronoun
}
    `;
export const DogProfilePersonalityDetailsFragment = gql`
    fragment DogProfilePersonalityDetailsFragment on Dog {
  id
  ageInMonths
  breed {
    id
    key
    name
  }
  name
  neutered
  gender
  possessivePronoun
  planPortionInGrams
  roundedPlanPortionInCalories(multipleOf: $caloriesMultipleOf)
}
    `;
export const DogProfileWeightAndAppetiteFragment = gql`
    fragment DogProfileWeightAndAppetiteFragment on Dog {
  id
  weightInGrams
  bodyShape
  exercise
  eaterType
  snackingHabits
}
    `;
export const WhereToStartFragment = gql`
    fragment WhereToStartFragment on Dog {
  id
  name
  gender
  possessivePronoun
  caloriesFedByPlan: roundedPlanPortionInCalories(multipleOf: $caloriesMultipleOf)
}
    `;
export const EditDailyAmountDogFragment = gql`
    fragment EditDailyAmountDogFragment on Dog {
  id
  name
  ageInMonths
  dogProfile {
    id
    avatarUrl
  }
  roundedDailyCaloriesLowerBoundary: roundedPercentageOfDailyCalories(
    multipleOf: $caloriesMultipleOf
    percentage: $lowerPercentage
  )
  roundedDailyCaloriesUpperBoundary: roundedPercentageOfDailyCalories(
    multipleOf: $caloriesMultipleOf
    percentage: $upperPercentage
  )
  ...WhereToStartFragment
}
    ${WhereToStartFragment}`;
export const ReviewPlanChangesFragment = gql`
    fragment ReviewPlanChangesFragment on Plan {
  id
  durationInWeeks
  numberOfPouches
  pricePerDay
  pouchesPerDay
  pouchSize
  servingInformation {
    roundedCaloriesPerDay
    gramsPerDay
  }
}
    `;
export const EditDailyAmountPlanFragment = gql`
    fragment EditDailyAmountPlanFragment on Plan {
  id
  pouchSize
  servingInformation {
    roundedCaloriesPerDay
    gramsPerDay
  }
  portioningForDogs {
    dogId
    portionInGrams
    roundedPortionInCalories(multipleOf: $caloriesMultipleOf)
  }
  ...ReviewPlanChangesFragment
}
    ${ReviewPlanChangesFragment}`;
export const EditDailyAmountFragment = gql`
    fragment EditDailyAmountFragment on User {
  id
  dogs {
    ...EditDailyAmountDogFragment
  }
  availablePlans(scopeType: $scopeType) {
    ...EditDailyAmountPlanFragment
  }
  subscription {
    id
    plan {
      ...EditDailyAmountPlanFragment
    }
  }
}
    ${EditDailyAmountDogFragment}
${EditDailyAmountPlanFragment}`;
export const EditDeliveryFrequencyFragment = gql`
    fragment EditDeliveryFrequencyFragment on User {
  id
  availablePlans(scopeType: $scopeType) {
    id
    numberOfPouches
    durationInWeeks
    pricePerDay
    pouchSize
  }
}
    `;
export const EditDeliveryFrequencyPlanFragment = gql`
    fragment EditDeliveryFrequencyPlanFragment on Plan {
  id
  numberOfPouches
  durationInWeeks
  pricePerDay
  pouchSize
}
    `;
export const personalDetailsFragment = gql`
    fragment personalDetailsFragment on User {
  id
  firstName
  lastName
  email
  phone
}
    `;
export const AddressFragment = gql`
    fragment AddressFragment on Address {
  id
  address1
  address2
  city
  postcode
  shippingCountry {
    id
    code
  }
  recipientName
  deliveryNotes
  deliveryCarrier
}
    `;
export const UserAddressFragment = gql`
    fragment UserAddressFragment on User {
  id
  address {
    ...AddressFragment
  }
}
    ${AddressFragment}`;
export const userFragment = gql`
    fragment userFragment on User {
  id
  ...personalDetailsFragment
  ...UserAddressFragment
}
    ${personalDetailsFragment}
${UserAddressFragment}`;
export const BillingAgreementFragment = gql`
    fragment BillingAgreementFragment on BillingAgreement {
  __typename
  id
  type
  active
  paypalEmail
}
    `;
export const CreditCardPaymentMethodFragment = gql`
    fragment CreditCardPaymentMethodFragment on CreditCardPaymentMethod {
  __typename
  id
  type
  active
  lastFourDigits
  expMonth
  expYear
}
    `;
export const SepaDirectDebitFragment = gql`
    fragment SepaDirectDebitFragment on SepaDirectDebit {
  __typename
  id
  type
  active
  accountLastFour
}
    `;
export const MerchantInitiatedPaymentFragment = gql`
    fragment MerchantInitiatedPaymentFragment on MerchantInitiatedPayment {
  __typename
  id
  type
  active
  merchantInitiatedType
}
    `;
export const PaymentMethodsFragment = gql`
    fragment PaymentMethodsFragment on User {
  __typename
  id
  subscription {
    __typename
    id
    status
    paymentMethods(archivedType: $archivedType) {
      ... on BillingAgreement {
        ...BillingAgreementFragment
      }
      ... on CreditCardPaymentMethod {
        ...CreditCardPaymentMethodFragment
      }
      ... on SepaDirectDebit {
        ...SepaDirectDebitFragment
      }
      ... on MerchantInitiatedPayment {
        ...MerchantInitiatedPaymentFragment
      }
    }
  }
}
    ${BillingAgreementFragment}
${CreditCardPaymentMethodFragment}
${SepaDirectDebitFragment}
${MerchantInitiatedPaymentFragment}`;
export const productCollectionFragment = gql`
    fragment productCollectionFragment on ProductCollection {
  id
  slug
  unavailableObject {
    reason
    reasonCopy
  }
  productSticker {
    image {
      src
    }
  }
  name
  discount {
    discountBasis
    value
  }
  productLabel {
    id
    name
  }
  primaryImage {
    src
  }
  productVariants {
    id
    name
    discountedPrice
    grossPrice
    productVariantDeliveryTypes {
      deliveryType
      adjustedGrossPrice
      netPrice
    }
  }
}
    `;
export const boxOrderFragment = gql`
    fragment boxOrderFragment on Box {
  id
  isoDeliveryDate
  cutOffDate
  consignment {
    id
    status
  }
  order {
    id
    discountTotalPercentage
    subtotal
    totalPrice
    orderProducts {
      id
      nonPaymentReason
    }
  }
  isReplacementBox
  isFreeBox
  amendable
  isNextEditableBox
  physicalOrderProducts {
    id
    nonPaymentReason
    quantity
    productVariant {
      id
      name
      productCollection {
        id
        name
        thumbnail {
          src
        }
      }
    }
  }
  meals {
    id
    flavour {
      id
      slug
    }
    quantity
  }
  plan {
    id
    pouchSize
  }
}
    `;
export const nonCoreOrderFragment = gql`
    fragment nonCoreOrderFragment on NonCoreOrder {
  id
  orderParts {
    deliveryDate
    orderProducts {
      id
      quantity
      productVariant {
        id
        productCollection {
          id
          thumbnail {
            src
          }
        }
      }
    }
  }
}
    `;
export const recommendedExtraProductVariantsFields = gql`
    fragment recommendedExtraProductVariantsFields on ProductVariant {
  id
  name
  recurringDeliveryType {
    netPrice
  }
  productVariantDeliveryTypes {
    deliveryType
    netPrice
    priceAdjustment {
      value
    }
  }
  productCollection {
    slug
    name
    merchandisingImage {
      src
    }
    productLabel {
      name
      themeColour
    }
  }
  grossPrice
  discountedPrice
}
    `;
export const pendingSubscriptionProductVariantFields = gql`
    fragment pendingSubscriptionProductVariantFields on PendingSubscriptionsProductVariant {
  discountedPrice
  productVariant {
    id
    name
    grossPrice
    recurringDeliveryType {
      netPrice
    }
    productVariantDeliveryTypes {
      deliveryType
      netPrice
      priceAdjustment {
        value
      }
    }
    productCollection {
      name
      slug
      merchandisingImage {
        src
      }
    }
  }
}
    `;
export const planFields = gql`
    fragment planFields on Plan {
  id
  pouchSize
  durationInDays
  pricePerDay
  trialLengthInDays
  trialDiscountedPricePerDay
  numberOfPouches
  typeOfPlanForCustomer
  gramsPerDay
  pricingCurve {
    pricingCohort
  }
}
    `;
export const flavourFields = gql`
    fragment flavourFields on NewFlavour {
  id
  name
  slug
  shortDescription
  longDescription
  fussyApproved
  primaryImage {
    src
  }
  productLabels {
    name
    themeColour
  }
  recipeSurcharges {
    planSize
    amount
  }
}
    `;
export const orderTrackingNumberFields = gql`
    fragment orderTrackingNumberFields on OrderTrackingNumber {
  boxId
  trackingId
  trackingUrl
  courierName
  address1
  address2
}
    `;
export const recipeCardPlanFragment = gql`
    fragment recipeCardPlanFragment on Plan {
  id
  pricePerDay
  trialDiscountedPricePerDay
}
    `;
export const idealPlanFragment = gql`
    fragment idealPlanFragment on Plan {
  ...recipeCardPlanFragment
  boxKind
  typeOfPlanForCustomer
  gramsPerDayPerDogs {
    dogId
    gramsPerDay
    name
  }
  pouchSize
  pouchesPerDay
  servingInformation {
    gramsPerDay
  }
  trial {
    lengthInDays
  }
}
    ${recipeCardPlanFragment}`;
export const recommendedExtrasFragment = gql`
    fragment recommendedExtrasFragment on ProductVariant {
  id
  name
  recurringDeliveryType {
    netPrice
  }
  productCollection {
    id
    name
    merchandisingImage {
      src
    }
    slug
  }
  grossPrice
}
    `;
export const PlanFragment = gql`
    fragment PlanFragment on Plan {
  id
  gramsPerDay
  gramsPerDayPerDogs {
    dogId
    name
    gramsPerDay
  }
  roundedCaloriesPerDay
  servingType
  typeOfPlanForCustomer
  numberOfPouches
  durationInDays
  pouchSize
  pricePerDay
  pricePerWeek
  price
  pricePerPouch
  pouchesPerDay
  servingSize
  numberOfServings
}
    `;
export const DogPlanFragment = gql`
    fragment DogPlanFragment on Dog {
  id
  name
  gender
  ageInMonths
  breed {
    id
    name
    key
  }
  dogProfile {
    id
    avatarUrl
  }
  roundedDailyCalories(multipleOf: $caloriesMultipleOf)
  roundedDailyCaloriesLowerBoundary: roundedPercentageOfDailyCalories(
    multipleOf: $caloriesMultipleOf
    percentage: $lowerPercentage
  )
  roundedDailyCaloriesUpperBoundary: roundedPercentageOfDailyCalories(
    multipleOf: $caloriesMultipleOf
    percentage: $upperPercentage
  )
}
    `;
export const ContactFormInitialDataDocument = gql`
    query ContactFormInitialData {
  shippingCountries {
    id
    code
    contactInformation {
      id
      contactHours
      whatsappContactHours
      contactNumber
      displayContactNumber
      whatsappNumber
      displayWhatsappNumber
    }
  }
  user {
    id
    firstName
    lastName
    preferredLanguage
    email
    shippingCountry {
      id
      code
    }
    dogs {
      id
      name
    }
  }
  allergens {
    id
    name
  }
}
    `;

/**
 * __useContactFormInitialData__
 *
 * To run a query within a React component, call `useContactFormInitialData` and pass it any options that fit your needs.
 * When your component renders, `useContactFormInitialData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactFormInitialData({
 *   variables: {
 *   },
 * });
 */
export function useContactFormInitialData(baseOptions?: Apollo.QueryHookOptions<ContactFormInitialData, ContactFormInitialDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactFormInitialData, ContactFormInitialDataVariables>(ContactFormInitialDataDocument, options);
      }
export function useContactFormInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactFormInitialData, ContactFormInitialDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactFormInitialData, ContactFormInitialDataVariables>(ContactFormInitialDataDocument, options);
        }
export function useContactFormInitialDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactFormInitialData, ContactFormInitialDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactFormInitialData, ContactFormInitialDataVariables>(ContactFormInitialDataDocument, options);
        }
export type ContactFormInitialDataHookResult = ReturnType<typeof useContactFormInitialData>;
export type ContactFormInitialDataLazyQueryHookResult = ReturnType<typeof useContactFormInitialDataLazyQuery>;
export type ContactFormInitialDataSuspenseQueryHookResult = ReturnType<typeof useContactFormInitialDataSuspenseQuery>;
export type ContactFormInitialDataQueryResult = Apollo.QueryResult<ContactFormInitialData, ContactFormInitialDataVariables>;
export const ContactFormInitialDataPreWizardGuestDocument = gql`
    query ContactFormInitialDataPreWizardGuest {
  shippingCountries {
    id
    code
    contactInformation {
      id
      contactHours
      whatsappContactHours
      contactNumber
      displayContactNumber
      whatsappNumber
      displayWhatsappNumber
    }
  }
  allergens {
    id
    name
  }
}
    `;

/**
 * __useContactFormInitialDataPreWizardGuest__
 *
 * To run a query within a React component, call `useContactFormInitialDataPreWizardGuest` and pass it any options that fit your needs.
 * When your component renders, `useContactFormInitialDataPreWizardGuest` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactFormInitialDataPreWizardGuest({
 *   variables: {
 *   },
 * });
 */
export function useContactFormInitialDataPreWizardGuest(baseOptions?: Apollo.QueryHookOptions<ContactFormInitialDataPreWizardGuest, ContactFormInitialDataPreWizardGuestVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactFormInitialDataPreWizardGuest, ContactFormInitialDataPreWizardGuestVariables>(ContactFormInitialDataPreWizardGuestDocument, options);
      }
export function useContactFormInitialDataPreWizardGuestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactFormInitialDataPreWizardGuest, ContactFormInitialDataPreWizardGuestVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactFormInitialDataPreWizardGuest, ContactFormInitialDataPreWizardGuestVariables>(ContactFormInitialDataPreWizardGuestDocument, options);
        }
export function useContactFormInitialDataPreWizardGuestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactFormInitialDataPreWizardGuest, ContactFormInitialDataPreWizardGuestVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactFormInitialDataPreWizardGuest, ContactFormInitialDataPreWizardGuestVariables>(ContactFormInitialDataPreWizardGuestDocument, options);
        }
export type ContactFormInitialDataPreWizardGuestHookResult = ReturnType<typeof useContactFormInitialDataPreWizardGuest>;
export type ContactFormInitialDataPreWizardGuestLazyQueryHookResult = ReturnType<typeof useContactFormInitialDataPreWizardGuestLazyQuery>;
export type ContactFormInitialDataPreWizardGuestSuspenseQueryHookResult = ReturnType<typeof useContactFormInitialDataPreWizardGuestSuspenseQuery>;
export type ContactFormInitialDataPreWizardGuestQueryResult = Apollo.QueryResult<ContactFormInitialDataPreWizardGuest, ContactFormInitialDataPreWizardGuestVariables>;
export const addDiscountedExtrasCountdownCardQueryDocument = gql`
    query addDiscountedExtrasCountdownCardQuery {
  user {
    id
    subscription {
      id
      nextEditableBox {
        isoDeliveryDate
        hoursUntilCutOff
        order {
          discountTotalPercentage
        }
      }
    }
  }
}
    `;

/**
 * __useaddDiscountedExtrasCountdownCardQuery__
 *
 * To run a query within a React component, call `useaddDiscountedExtrasCountdownCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useaddDiscountedExtrasCountdownCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useaddDiscountedExtrasCountdownCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useaddDiscountedExtrasCountdownCardQuery(baseOptions?: Apollo.QueryHookOptions<addDiscountedExtrasCountdownCardQuery, addDiscountedExtrasCountdownCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<addDiscountedExtrasCountdownCardQuery, addDiscountedExtrasCountdownCardQueryVariables>(addDiscountedExtrasCountdownCardQueryDocument, options);
      }
export function useaddDiscountedExtrasCountdownCardQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<addDiscountedExtrasCountdownCardQuery, addDiscountedExtrasCountdownCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<addDiscountedExtrasCountdownCardQuery, addDiscountedExtrasCountdownCardQueryVariables>(addDiscountedExtrasCountdownCardQueryDocument, options);
        }
export function useaddDiscountedExtrasCountdownCardQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<addDiscountedExtrasCountdownCardQuery, addDiscountedExtrasCountdownCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<addDiscountedExtrasCountdownCardQuery, addDiscountedExtrasCountdownCardQueryVariables>(addDiscountedExtrasCountdownCardQueryDocument, options);
        }
export type addDiscountedExtrasCountdownCardQueryHookResult = ReturnType<typeof useaddDiscountedExtrasCountdownCardQuery>;
export type addDiscountedExtrasCountdownCardQueryLazyQueryHookResult = ReturnType<typeof useaddDiscountedExtrasCountdownCardQueryLazyQuery>;
export type addDiscountedExtrasCountdownCardQuerySuspenseQueryHookResult = ReturnType<typeof useaddDiscountedExtrasCountdownCardQuerySuspenseQuery>;
export type addDiscountedExtrasCountdownCardQueryQueryResult = Apollo.QueryResult<addDiscountedExtrasCountdownCardQuery, addDiscountedExtrasCountdownCardQueryVariables>;
export const BannersDocument = gql`
    query Banners {
  banners {
    id
    slug
    link
    order
    template
    text
    liveDate
    endDate
    showAgainAfterXDays
  }
  currentUser {
    __typename
    ... on User {
      id
    }
    ... on Guest {
      id
    }
  }
}
    `;

/**
 * __useBanners__
 *
 * To run a query within a React component, call `useBanners` and pass it any options that fit your needs.
 * When your component renders, `useBanners` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBanners({
 *   variables: {
 *   },
 * });
 */
export function useBanners(baseOptions?: Apollo.QueryHookOptions<Banners, BannersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Banners, BannersVariables>(BannersDocument, options);
      }
export function useBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Banners, BannersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Banners, BannersVariables>(BannersDocument, options);
        }
export function useBannersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Banners, BannersVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Banners, BannersVariables>(BannersDocument, options);
        }
export type BannersHookResult = ReturnType<typeof useBanners>;
export type BannersLazyQueryHookResult = ReturnType<typeof useBannersLazyQuery>;
export type BannersSuspenseQueryHookResult = ReturnType<typeof useBannersSuspenseQuery>;
export type BannersQueryResult = Apollo.QueryResult<Banners, BannersVariables>;
export const BoxSummaryDocument = gql`
    query BoxSummary {
  user {
    id
    shippingCountryCode
    preferredLanguage
    dogs {
      id
      name
      planPortionInGrams
      gender
    }
    subscription {
      id
      recurringOrder {
        deliveryFee
        surchargeTotal
        physicalProductsTotal
        totalPrice
        planTotal
        planTotalPerDay
      }
      plan {
        numberOfPouches
        pouchSize
        pouchesPerDay
        price
        durationInDays
        typeOfPlanForCustomer
        pricesPerDayPerDogs {
          name
          pricePerDayWithoutDiscount
        }
      }
    }
  }
}
    `;

/**
 * __useBoxSummary__
 *
 * To run a query within a React component, call `useBoxSummary` and pass it any options that fit your needs.
 * When your component renders, `useBoxSummary` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoxSummary({
 *   variables: {
 *   },
 * });
 */
export function useBoxSummary(baseOptions?: Apollo.QueryHookOptions<BoxSummary, BoxSummaryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoxSummary, BoxSummaryVariables>(BoxSummaryDocument, options);
      }
export function useBoxSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoxSummary, BoxSummaryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoxSummary, BoxSummaryVariables>(BoxSummaryDocument, options);
        }
export function useBoxSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BoxSummary, BoxSummaryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BoxSummary, BoxSummaryVariables>(BoxSummaryDocument, options);
        }
export type BoxSummaryHookResult = ReturnType<typeof useBoxSummary>;
export type BoxSummaryLazyQueryHookResult = ReturnType<typeof useBoxSummaryLazyQuery>;
export type BoxSummarySuspenseQueryHookResult = ReturnType<typeof useBoxSummarySuspenseQuery>;
export type BoxSummaryQueryResult = Apollo.QueryResult<BoxSummary, BoxSummaryVariables>;
export const BreedSelectorQueryDocument = gql`
    query BreedSelectorQuery {
  breeds {
    id
    name
    key
    popular
  }
}
    `;

/**
 * __useBreedSelectorQuery__
 *
 * To run a query within a React component, call `useBreedSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useBreedSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBreedSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useBreedSelectorQuery(baseOptions?: Apollo.QueryHookOptions<BreedSelectorQuery, BreedSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BreedSelectorQuery, BreedSelectorQueryVariables>(BreedSelectorQueryDocument, options);
      }
export function useBreedSelectorQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BreedSelectorQuery, BreedSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BreedSelectorQuery, BreedSelectorQueryVariables>(BreedSelectorQueryDocument, options);
        }
export function useBreedSelectorQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BreedSelectorQuery, BreedSelectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BreedSelectorQuery, BreedSelectorQueryVariables>(BreedSelectorQueryDocument, options);
        }
export type BreedSelectorQueryHookResult = ReturnType<typeof useBreedSelectorQuery>;
export type BreedSelectorQueryLazyQueryHookResult = ReturnType<typeof useBreedSelectorQueryLazyQuery>;
export type BreedSelectorQuerySuspenseQueryHookResult = ReturnType<typeof useBreedSelectorQuerySuspenseQuery>;
export type BreedSelectorQueryQueryResult = Apollo.QueryResult<BreedSelectorQuery, BreedSelectorQueryVariables>;
export const CalendarDatesDataDocument = gql`
    query CalendarDatesData($calendarInitDate: ISO8601Date!, $nDays: Int, $city: String, $shipmentType: String!, $shouldAttemptToOfferNextDayDelivery: Boolean, $postcode: String, $userId: ID) {
  calendarDates(
    startDate: $calendarInitDate
    nDays: $nDays
    city: $city
    shipmentType: $shipmentType
    shouldAttemptToOfferNextDayDelivery: $shouldAttemptToOfferNextDayDelivery
    postcode: $postcode
    userId: $userId
  ) {
    date
    deliverable
  }
}
    `;

/**
 * __useCalendarDatesData__
 *
 * To run a query within a React component, call `useCalendarDatesData` and pass it any options that fit your needs.
 * When your component renders, `useCalendarDatesData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarDatesData({
 *   variables: {
 *      calendarInitDate: // value for 'calendarInitDate'
 *      nDays: // value for 'nDays'
 *      city: // value for 'city'
 *      shipmentType: // value for 'shipmentType'
 *      shouldAttemptToOfferNextDayDelivery: // value for 'shouldAttemptToOfferNextDayDelivery'
 *      postcode: // value for 'postcode'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCalendarDatesData(baseOptions: Apollo.QueryHookOptions<CalendarDatesData, CalendarDatesDataVariables> & ({ variables: CalendarDatesDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarDatesData, CalendarDatesDataVariables>(CalendarDatesDataDocument, options);
      }
export function useCalendarDatesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarDatesData, CalendarDatesDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarDatesData, CalendarDatesDataVariables>(CalendarDatesDataDocument, options);
        }
export function useCalendarDatesDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalendarDatesData, CalendarDatesDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalendarDatesData, CalendarDatesDataVariables>(CalendarDatesDataDocument, options);
        }
export type CalendarDatesDataHookResult = ReturnType<typeof useCalendarDatesData>;
export type CalendarDatesDataLazyQueryHookResult = ReturnType<typeof useCalendarDatesDataLazyQuery>;
export type CalendarDatesDataSuspenseQueryHookResult = ReturnType<typeof useCalendarDatesDataSuspenseQuery>;
export type CalendarDatesDataQueryResult = Apollo.QueryResult<CalendarDatesData, CalendarDatesDataVariables>;
export const RecommendedOrderProductsCreateDocument = gql`
    mutation RecommendedOrderProductsCreate($userId: ID!, $productVariantInput: ProductVariantInput!, $boxId: ID!) {
  orderProductsCreate(userId: $userId, productVariantInput: $productVariantInput) {
    user {
      id
      subscription {
        id
        box(boxId: $boxId) {
          ...BoxPhysicalOrderProducts
        }
      }
    }
  }
}
    ${BoxPhysicalOrderProducts}`;
export type RecommendedOrderProductsCreateMutationFn = Apollo.MutationFunction<RecommendedOrderProductsCreate, RecommendedOrderProductsCreateVariables>;

/**
 * __useRecommendedOrderProductsCreate__
 *
 * To run a mutation, you first call `useRecommendedOrderProductsCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecommendedOrderProductsCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recommendedOrderProductsCreate, { data, loading, error }] = useRecommendedOrderProductsCreate({
 *   variables: {
 *      userId: // value for 'userId'
 *      productVariantInput: // value for 'productVariantInput'
 *      boxId: // value for 'boxId'
 *   },
 * });
 */
export function useRecommendedOrderProductsCreate(baseOptions?: Apollo.MutationHookOptions<RecommendedOrderProductsCreate, RecommendedOrderProductsCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecommendedOrderProductsCreate, RecommendedOrderProductsCreateVariables>(RecommendedOrderProductsCreateDocument, options);
      }
export type RecommendedOrderProductsCreateHookResult = ReturnType<typeof useRecommendedOrderProductsCreate>;
export type RecommendedOrderProductsCreateMutationResult = Apollo.MutationResult<RecommendedOrderProductsCreate>;
export type RecommendedOrderProductsCreateMutationOptions = Apollo.BaseMutationOptions<RecommendedOrderProductsCreate, RecommendedOrderProductsCreateVariables>;
export const UpdateOrderProductsDocument = gql`
    mutation UpdateOrderProducts($userId: ID!, $boxId: ID!, $orderProducts: [ProductInput!]!, $returnBox: Boolean!) {
  orderProductsUpdate(
    userId: $userId
    boxId: $boxId
    orderProducts: $orderProducts
  ) {
    id
    box(boxId: $boxId) @include(if: $returnBox) {
      ...BoxPhysicalOrderProducts
      ...BoxOrderFragment
    }
  }
}
    ${BoxPhysicalOrderProducts}
${BoxOrderFragment}`;
export type UpdateOrderProductsMutationFn = Apollo.MutationFunction<UpdateOrderProducts, UpdateOrderProductsVariables>;

/**
 * __useUpdateOrderProducts__
 *
 * To run a mutation, you first call `useUpdateOrderProducts` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderProducts` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderProducts, { data, loading, error }] = useUpdateOrderProducts({
 *   variables: {
 *      userId: // value for 'userId'
 *      boxId: // value for 'boxId'
 *      orderProducts: // value for 'orderProducts'
 *      returnBox: // value for 'returnBox'
 *   },
 * });
 */
export function useUpdateOrderProducts(baseOptions?: Apollo.MutationHookOptions<UpdateOrderProducts, UpdateOrderProductsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderProducts, UpdateOrderProductsVariables>(UpdateOrderProductsDocument, options);
      }
export type UpdateOrderProductsHookResult = ReturnType<typeof useUpdateOrderProducts>;
export type UpdateOrderProductsMutationResult = Apollo.MutationResult<UpdateOrderProducts>;
export type UpdateOrderProductsMutationOptions = Apollo.BaseMutationOptions<UpdateOrderProducts, UpdateOrderProductsVariables>;
export const UpdateRecurringOrderProductsDocument = gql`
    mutation UpdateRecurringOrderProducts($userId: ID!, $boxId: ID!, $recurringOrderProducts: [ProductInput!]!, $returnBox: Boolean!) {
  recurringOrderProductsUpdate(
    userId: $userId
    recurringOrderProducts: $recurringOrderProducts
  ) {
    id
    box(boxId: $boxId) @include(if: $returnBox) {
      id
      ...BoxPhysicalOrderProducts
      ...BoxOrderFragment
    }
  }
}
    ${BoxPhysicalOrderProducts}
${BoxOrderFragment}`;
export type UpdateRecurringOrderProductsMutationFn = Apollo.MutationFunction<UpdateRecurringOrderProducts, UpdateRecurringOrderProductsVariables>;

/**
 * __useUpdateRecurringOrderProducts__
 *
 * To run a mutation, you first call `useUpdateRecurringOrderProducts` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringOrderProducts` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringOrderProducts, { data, loading, error }] = useUpdateRecurringOrderProducts({
 *   variables: {
 *      userId: // value for 'userId'
 *      boxId: // value for 'boxId'
 *      recurringOrderProducts: // value for 'recurringOrderProducts'
 *      returnBox: // value for 'returnBox'
 *   },
 * });
 */
export function useUpdateRecurringOrderProducts(baseOptions?: Apollo.MutationHookOptions<UpdateRecurringOrderProducts, UpdateRecurringOrderProductsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecurringOrderProducts, UpdateRecurringOrderProductsVariables>(UpdateRecurringOrderProductsDocument, options);
      }
export type UpdateRecurringOrderProductsHookResult = ReturnType<typeof useUpdateRecurringOrderProducts>;
export type UpdateRecurringOrderProductsMutationResult = Apollo.MutationResult<UpdateRecurringOrderProducts>;
export type UpdateRecurringOrderProductsMutationOptions = Apollo.BaseMutationOptions<UpdateRecurringOrderProducts, UpdateRecurringOrderProductsVariables>;
export const ExtrasModalQueryDocument = gql`
    query ExtrasModalQuery {
  user {
    id
    dogs {
      gender
      name
    }
  }
}
    `;

/**
 * __useExtrasModalQuery__
 *
 * To run a query within a React component, call `useExtrasModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtrasModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtrasModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useExtrasModalQuery(baseOptions?: Apollo.QueryHookOptions<ExtrasModalQuery, ExtrasModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtrasModalQuery, ExtrasModalQueryVariables>(ExtrasModalQueryDocument, options);
      }
export function useExtrasModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtrasModalQuery, ExtrasModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtrasModalQuery, ExtrasModalQueryVariables>(ExtrasModalQueryDocument, options);
        }
export function useExtrasModalQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtrasModalQuery, ExtrasModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtrasModalQuery, ExtrasModalQueryVariables>(ExtrasModalQueryDocument, options);
        }
export type ExtrasModalQueryHookResult = ReturnType<typeof useExtrasModalQuery>;
export type ExtrasModalQueryLazyQueryHookResult = ReturnType<typeof useExtrasModalQueryLazyQuery>;
export type ExtrasModalQuerySuspenseQueryHookResult = ReturnType<typeof useExtrasModalQuerySuspenseQuery>;
export type ExtrasModalQueryQueryResult = Apollo.QueryResult<ExtrasModalQuery, ExtrasModalQueryVariables>;
export const EditExtrasQueryDocument = gql`
    query EditExtrasQuery($boxId: ID!) {
  user {
    ...EditExtrasUserFragment
    subscription {
      id
      status
      box(boxId: $boxId) {
        ...EditExtrasBoxFragment
      }
    }
  }
}
    ${EditExtrasUserFragment}
${EditExtrasBoxFragment}`;

/**
 * __useEditExtrasQuery__
 *
 * To run a query within a React component, call `useEditExtrasQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditExtrasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditExtrasQuery({
 *   variables: {
 *      boxId: // value for 'boxId'
 *   },
 * });
 */
export function useEditExtrasQuery(baseOptions: Apollo.QueryHookOptions<EditExtrasQuery, EditExtrasQueryVariables> & ({ variables: EditExtrasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditExtrasQuery, EditExtrasQueryVariables>(EditExtrasQueryDocument, options);
      }
export function useEditExtrasQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditExtrasQuery, EditExtrasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditExtrasQuery, EditExtrasQueryVariables>(EditExtrasQueryDocument, options);
        }
export function useEditExtrasQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditExtrasQuery, EditExtrasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditExtrasQuery, EditExtrasQueryVariables>(EditExtrasQueryDocument, options);
        }
export type EditExtrasQueryHookResult = ReturnType<typeof useEditExtrasQuery>;
export type EditExtrasQueryLazyQueryHookResult = ReturnType<typeof useEditExtrasQueryLazyQuery>;
export type EditExtrasQuerySuspenseQueryHookResult = ReturnType<typeof useEditExtrasQuerySuspenseQuery>;
export type EditExtrasQueryQueryResult = Apollo.QueryResult<EditExtrasQuery, EditExtrasQueryVariables>;
export const EditExtrasNoBoxIdQueryDocument = gql`
    query EditExtrasNoBoxIdQuery {
  user {
    ...EditExtrasUserFragment
    subscription {
      id
      status
      previewUncreatedFutureBox {
        isoDeliveryDate
        physicalOrderProducts {
          frequency
          quantity
          price
          discountedPrice
          requiresPayment
          nonPaymentReason
          productVariant {
            grossPrice
            subscribeAndSaveable
            productCollection {
              id
              thumbnail {
                src
              }
              productVariants {
                id
                name
              }
            }
            ...ShopItemFragment
          }
        }
      }
      nextEditableBox {
        ...EditExtrasBoxFragment
      }
    }
  }
}
    ${EditExtrasUserFragment}
${ShopItemFragment}
${EditExtrasBoxFragment}`;

/**
 * __useEditExtrasNoBoxIdQuery__
 *
 * To run a query within a React component, call `useEditExtrasNoBoxIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditExtrasNoBoxIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditExtrasNoBoxIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditExtrasNoBoxIdQuery(baseOptions?: Apollo.QueryHookOptions<EditExtrasNoBoxIdQuery, EditExtrasNoBoxIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditExtrasNoBoxIdQuery, EditExtrasNoBoxIdQueryVariables>(EditExtrasNoBoxIdQueryDocument, options);
      }
export function useEditExtrasNoBoxIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditExtrasNoBoxIdQuery, EditExtrasNoBoxIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditExtrasNoBoxIdQuery, EditExtrasNoBoxIdQueryVariables>(EditExtrasNoBoxIdQueryDocument, options);
        }
export function useEditExtrasNoBoxIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditExtrasNoBoxIdQuery, EditExtrasNoBoxIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditExtrasNoBoxIdQuery, EditExtrasNoBoxIdQueryVariables>(EditExtrasNoBoxIdQueryDocument, options);
        }
export type EditExtrasNoBoxIdQueryHookResult = ReturnType<typeof useEditExtrasNoBoxIdQuery>;
export type EditExtrasNoBoxIdQueryLazyQueryHookResult = ReturnType<typeof useEditExtrasNoBoxIdQueryLazyQuery>;
export type EditExtrasNoBoxIdQuerySuspenseQueryHookResult = ReturnType<typeof useEditExtrasNoBoxIdQuerySuspenseQuery>;
export type EditExtrasNoBoxIdQueryQueryResult = Apollo.QueryResult<EditExtrasNoBoxIdQuery, EditExtrasNoBoxIdQueryVariables>;
export const FooterQueryDocument = gql`
    query FooterQuery {
  user {
    id
    subscription {
      id
      status
    }
    shippingCountry {
      id
      code
      brand
      footerLinks {
        footerColumn
        title
        url
        availableForStatuses
      }
    }
  }
}
    `;

/**
 * __useFooterQuery__
 *
 * To run a query within a React component, call `useFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterQuery({
 *   variables: {
 *   },
 * });
 */
export function useFooterQuery(baseOptions?: Apollo.QueryHookOptions<FooterQuery, FooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FooterQuery, FooterQueryVariables>(FooterQueryDocument, options);
      }
export function useFooterQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FooterQuery, FooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FooterQuery, FooterQueryVariables>(FooterQueryDocument, options);
        }
export function useFooterQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FooterQuery, FooterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FooterQuery, FooterQueryVariables>(FooterQueryDocument, options);
        }
export type FooterQueryHookResult = ReturnType<typeof useFooterQuery>;
export type FooterQueryLazyQueryHookResult = ReturnType<typeof useFooterQueryLazyQuery>;
export type FooterQuerySuspenseQueryHookResult = ReturnType<typeof useFooterQuerySuspenseQuery>;
export type FooterQueryQueryResult = Apollo.QueryResult<FooterQuery, FooterQueryVariables>;
export const PlanDetailsQueryDocument = gql`
    query PlanDetailsQuery($boxId: ID!) {
  user {
    id
    dogs {
      id
      gender
    }
    subscription {
      id
      box(boxId: $boxId) {
        id
        editable
        plan {
          id
          typeOfPlanForCustomer
          numberOfPouches
          pouchSize
          durationInDays
        }
      }
    }
  }
}
    `;

/**
 * __usePlanDetailsQuery__
 *
 * To run a query within a React component, call `usePlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanDetailsQuery({
 *   variables: {
 *      boxId: // value for 'boxId'
 *   },
 * });
 */
export function usePlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<PlanDetailsQuery, PlanDetailsQueryVariables> & ({ variables: PlanDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanDetailsQuery, PlanDetailsQueryVariables>(PlanDetailsQueryDocument, options);
      }
export function usePlanDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanDetailsQuery, PlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanDetailsQuery, PlanDetailsQueryVariables>(PlanDetailsQueryDocument, options);
        }
export function usePlanDetailsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanDetailsQuery, PlanDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanDetailsQuery, PlanDetailsQueryVariables>(PlanDetailsQueryDocument, options);
        }
export type PlanDetailsQueryHookResult = ReturnType<typeof usePlanDetailsQuery>;
export type PlanDetailsQueryLazyQueryHookResult = ReturnType<typeof usePlanDetailsQueryLazyQuery>;
export type PlanDetailsQuerySuspenseQueryHookResult = ReturnType<typeof usePlanDetailsQuerySuspenseQuery>;
export type PlanDetailsQueryQueryResult = Apollo.QueryResult<PlanDetailsQuery, PlanDetailsQueryVariables>;
export const PuppyDiscountModalQueryDocument = gql`
    query PuppyDiscountModalQuery($discountCodeId: ID!) {
  discountCode(discountCodeId: $discountCodeId) {
    id
    code
    discountBasis
    value
    channel
    discountCodeParts {
      discountBasis
      value
      discountType
      n
    }
  }
}
    `;

/**
 * __usePuppyDiscountModalQuery__
 *
 * To run a query within a React component, call `usePuppyDiscountModalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePuppyDiscountModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePuppyDiscountModalQuery({
 *   variables: {
 *      discountCodeId: // value for 'discountCodeId'
 *   },
 * });
 */
export function usePuppyDiscountModalQuery(baseOptions: Apollo.QueryHookOptions<PuppyDiscountModalQuery, PuppyDiscountModalQueryVariables> & ({ variables: PuppyDiscountModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PuppyDiscountModalQuery, PuppyDiscountModalQueryVariables>(PuppyDiscountModalQueryDocument, options);
      }
export function usePuppyDiscountModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PuppyDiscountModalQuery, PuppyDiscountModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PuppyDiscountModalQuery, PuppyDiscountModalQueryVariables>(PuppyDiscountModalQueryDocument, options);
        }
export function usePuppyDiscountModalQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PuppyDiscountModalQuery, PuppyDiscountModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PuppyDiscountModalQuery, PuppyDiscountModalQueryVariables>(PuppyDiscountModalQueryDocument, options);
        }
export type PuppyDiscountModalQueryHookResult = ReturnType<typeof usePuppyDiscountModalQuery>;
export type PuppyDiscountModalQueryLazyQueryHookResult = ReturnType<typeof usePuppyDiscountModalQueryLazyQuery>;
export type PuppyDiscountModalQuerySuspenseQueryHookResult = ReturnType<typeof usePuppyDiscountModalQuerySuspenseQuery>;
export type PuppyDiscountModalQueryQueryResult = Apollo.QueryResult<PuppyDiscountModalQuery, PuppyDiscountModalQueryVariables>;
export const ShareModalQueryDocument = gql`
    query ShareModalQuery {
  user {
    id
    preferredLanguage
    shippingCountryCode
    dogs {
      name
    }
    subscription {
      referralLink {
        referralLinkTypeName
        referralDiscountsTotalValue
        url
        referralDiscount {
          code
          discountCodeParts {
            value
            discountType
            discountBasis
            n
          }
        }
        referrerDiscount {
          applicableDiscountParts {
            value
            discountBasis
            n
            discountType
          }
        }
        referrals {
          refereeFirstName
          refereeDogNames
          refereeSignUpDate
        }
      }
    }
  }
  whatsAppSingleDog: copyEntry(slug: "whatsapp_single_dog") {
    text
  }
  whatsAppMultipleDogs: copyEntry(slug: "whatsapp_multiple_dogs") {
    text
  }
}
    `;

/**
 * __useShareModalQuery__
 *
 * To run a query within a React component, call `useShareModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useShareModalQuery(baseOptions?: Apollo.QueryHookOptions<ShareModalQuery, ShareModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShareModalQuery, ShareModalQueryVariables>(ShareModalQueryDocument, options);
      }
export function useShareModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShareModalQuery, ShareModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShareModalQuery, ShareModalQueryVariables>(ShareModalQueryDocument, options);
        }
export function useShareModalQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShareModalQuery, ShareModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShareModalQuery, ShareModalQueryVariables>(ShareModalQueryDocument, options);
        }
export type ShareModalQueryHookResult = ReturnType<typeof useShareModalQuery>;
export type ShareModalQueryLazyQueryHookResult = ReturnType<typeof useShareModalQueryLazyQuery>;
export type ShareModalQuerySuspenseQueryHookResult = ReturnType<typeof useShareModalQuerySuspenseQuery>;
export type ShareModalQueryQueryResult = Apollo.QueryResult<ShareModalQuery, ShareModalQueryVariables>;
export const BrightbackInitialiserQueryDocument = gql`
    query BrightbackInitialiserQuery {
  user {
    id
    subscription {
      id
      deliveriesReceived
      pouchesConsumed
      hasAppliedPsfDiscount
      status
      pauseUrl
      referralLink {
        referrerDiscount {
          applicableDiscountParts {
            value
            discountBasis
          }
        }
        referralDiscount {
          value
          discountBasis
        }
        referrals {
          refereeFirstName
        }
      }
      plan {
        id
      }
      nextNBoxes(num: 1) {
        id
        discountValue
        isNextEditableBox
        editable
      }
    }
  }
}
    `;

/**
 * __useBrightbackInitialiserQuery__
 *
 * To run a query within a React component, call `useBrightbackInitialiserQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrightbackInitialiserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrightbackInitialiserQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrightbackInitialiserQuery(baseOptions?: Apollo.QueryHookOptions<BrightbackInitialiserQuery, BrightbackInitialiserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrightbackInitialiserQuery, BrightbackInitialiserQueryVariables>(BrightbackInitialiserQueryDocument, options);
      }
export function useBrightbackInitialiserQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrightbackInitialiserQuery, BrightbackInitialiserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrightbackInitialiserQuery, BrightbackInitialiserQueryVariables>(BrightbackInitialiserQueryDocument, options);
        }
export function useBrightbackInitialiserQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrightbackInitialiserQuery, BrightbackInitialiserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrightbackInitialiserQuery, BrightbackInitialiserQueryVariables>(BrightbackInitialiserQueryDocument, options);
        }
export type BrightbackInitialiserQueryHookResult = ReturnType<typeof useBrightbackInitialiserQuery>;
export type BrightbackInitialiserQueryLazyQueryHookResult = ReturnType<typeof useBrightbackInitialiserQueryLazyQuery>;
export type BrightbackInitialiserQuerySuspenseQueryHookResult = ReturnType<typeof useBrightbackInitialiserQuerySuspenseQuery>;
export type BrightbackInitialiserQueryQueryResult = Apollo.QueryResult<BrightbackInitialiserQuery, BrightbackInitialiserQueryVariables>;
export const SubscriptionDetailsCardQueryDocument = gql`
    query SubscriptionDetailsCardQuery {
  user {
    id
    dogs {
      id
      name
      dogProfile {
        id
        avatarUrl
      }
      breed {
        id
        name
      }
      ageInMonths
    }
    subscription {
      id
      plan {
        id
        numberOfPouches
        durationInDays
        gramsPerDayPerDogs {
          gramsPerDay
          dogId
          name
        }
      }
      status
    }
  }
}
    `;

/**
 * __useSubscriptionDetailsCardQuery__
 *
 * To run a query within a React component, call `useSubscriptionDetailsCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionDetailsCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionDetailsCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionDetailsCardQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionDetailsCardQuery, SubscriptionDetailsCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionDetailsCardQuery, SubscriptionDetailsCardQueryVariables>(SubscriptionDetailsCardQueryDocument, options);
      }
export function useSubscriptionDetailsCardQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionDetailsCardQuery, SubscriptionDetailsCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionDetailsCardQuery, SubscriptionDetailsCardQueryVariables>(SubscriptionDetailsCardQueryDocument, options);
        }
export function useSubscriptionDetailsCardQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionDetailsCardQuery, SubscriptionDetailsCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionDetailsCardQuery, SubscriptionDetailsCardQueryVariables>(SubscriptionDetailsCardQueryDocument, options);
        }
export type SubscriptionDetailsCardQueryHookResult = ReturnType<typeof useSubscriptionDetailsCardQuery>;
export type SubscriptionDetailsCardQueryLazyQueryHookResult = ReturnType<typeof useSubscriptionDetailsCardQueryLazyQuery>;
export type SubscriptionDetailsCardQuerySuspenseQueryHookResult = ReturnType<typeof useSubscriptionDetailsCardQuerySuspenseQuery>;
export type SubscriptionDetailsCardQueryQueryResult = Apollo.QueryResult<SubscriptionDetailsCardQuery, SubscriptionDetailsCardQueryVariables>;
export const SubmitSurveyAnswersDocument = gql`
    mutation SubmitSurveyAnswers($answers: [AnswerInput!]!) {
  submitSurveyAnswers(answers: $answers) {
    answers {
      id
      option {
        text
      }
      question {
        id
        text
      }
      value
    }
  }
}
    `;
export type SubmitSurveyAnswersMutationFn = Apollo.MutationFunction<SubmitSurveyAnswers, SubmitSurveyAnswersVariables>;

/**
 * __useSubmitSurveyAnswers__
 *
 * To run a mutation, you first call `useSubmitSurveyAnswers` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSurveyAnswers` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSurveyAnswers, { data, loading, error }] = useSubmitSurveyAnswers({
 *   variables: {
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useSubmitSurveyAnswers(baseOptions?: Apollo.MutationHookOptions<SubmitSurveyAnswers, SubmitSurveyAnswersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSurveyAnswers, SubmitSurveyAnswersVariables>(SubmitSurveyAnswersDocument, options);
      }
export type SubmitSurveyAnswersHookResult = ReturnType<typeof useSubmitSurveyAnswers>;
export type SubmitSurveyAnswersMutationResult = Apollo.MutationResult<SubmitSurveyAnswers>;
export type SubmitSurveyAnswersMutationOptions = Apollo.BaseMutationOptions<SubmitSurveyAnswers, SubmitSurveyAnswersVariables>;
export const SurveyCardQueryDocument = gql`
    query SurveyCardQuery($startingUrl: String) {
  user {
    id
    preferredLanguage
  }
  survey(startingUrl: $startingUrl) {
    id
    name
    slug
    startingUrl
    finishedMessage
    questions {
      id
      text
      ctaText
      ctaDestination
      questionType
      order
      options {
        id
        text
      }
    }
  }
}
    `;

/**
 * __useSurveyCardQuery__
 *
 * To run a query within a React component, call `useSurveyCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyCardQuery({
 *   variables: {
 *      startingUrl: // value for 'startingUrl'
 *   },
 * });
 */
export function useSurveyCardQuery(baseOptions?: Apollo.QueryHookOptions<SurveyCardQuery, SurveyCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyCardQuery, SurveyCardQueryVariables>(SurveyCardQueryDocument, options);
      }
export function useSurveyCardQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyCardQuery, SurveyCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyCardQuery, SurveyCardQueryVariables>(SurveyCardQueryDocument, options);
        }
export function useSurveyCardQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyCardQuery, SurveyCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyCardQuery, SurveyCardQueryVariables>(SurveyCardQueryDocument, options);
        }
export type SurveyCardQueryHookResult = ReturnType<typeof useSurveyCardQuery>;
export type SurveyCardQueryLazyQueryHookResult = ReturnType<typeof useSurveyCardQueryLazyQuery>;
export type SurveyCardQuerySuspenseQueryHookResult = ReturnType<typeof useSurveyCardQuerySuspenseQuery>;
export type SurveyCardQueryQueryResult = Apollo.QueryResult<SurveyCardQuery, SurveyCardQueryVariables>;
export const TopNavDiscountQueryDocument = gql`
    query TopNavDiscountQuery($discountCodeId: ID!) {
  discountCode(discountCodeId: $discountCodeId) {
    id
    discountCodeParts {
      value
      discountBasis
      discountType
      n
    }
  }
}
    `;

/**
 * __useTopNavDiscountQuery__
 *
 * To run a query within a React component, call `useTopNavDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopNavDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopNavDiscountQuery({
 *   variables: {
 *      discountCodeId: // value for 'discountCodeId'
 *   },
 * });
 */
export function useTopNavDiscountQuery(baseOptions: Apollo.QueryHookOptions<TopNavDiscountQuery, TopNavDiscountQueryVariables> & ({ variables: TopNavDiscountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopNavDiscountQuery, TopNavDiscountQueryVariables>(TopNavDiscountQueryDocument, options);
      }
export function useTopNavDiscountQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopNavDiscountQuery, TopNavDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopNavDiscountQuery, TopNavDiscountQueryVariables>(TopNavDiscountQueryDocument, options);
        }
export function useTopNavDiscountQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopNavDiscountQuery, TopNavDiscountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopNavDiscountQuery, TopNavDiscountQueryVariables>(TopNavDiscountQueryDocument, options);
        }
export type TopNavDiscountQueryHookResult = ReturnType<typeof useTopNavDiscountQuery>;
export type TopNavDiscountQueryLazyQueryHookResult = ReturnType<typeof useTopNavDiscountQueryLazyQuery>;
export type TopNavDiscountQuerySuspenseQueryHookResult = ReturnType<typeof useTopNavDiscountQuerySuspenseQuery>;
export type TopNavDiscountQueryQueryResult = Apollo.QueryResult<TopNavDiscountQuery, TopNavDiscountQueryVariables>;
export const AdditionalProductQueryDocument = gql`
    query AdditionalProductQuery($slug: String!) {
  productCollection(slug: $slug) {
    id
    name
    images {
      src
    }
    productBenefits {
      id
      name
      image {
        src
      }
    }
    about
    description
  }
}
    `;

/**
 * __useAdditionalProductQuery__
 *
 * To run a query within a React component, call `useAdditionalProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalProductQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAdditionalProductQuery(baseOptions: Apollo.QueryHookOptions<AdditionalProductQuery, AdditionalProductQueryVariables> & ({ variables: AdditionalProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalProductQuery, AdditionalProductQueryVariables>(AdditionalProductQueryDocument, options);
      }
export function useAdditionalProductQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalProductQuery, AdditionalProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalProductQuery, AdditionalProductQueryVariables>(AdditionalProductQueryDocument, options);
        }
export function useAdditionalProductQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdditionalProductQuery, AdditionalProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdditionalProductQuery, AdditionalProductQueryVariables>(AdditionalProductQueryDocument, options);
        }
export type AdditionalProductQueryHookResult = ReturnType<typeof useAdditionalProductQuery>;
export type AdditionalProductQueryLazyQueryHookResult = ReturnType<typeof useAdditionalProductQueryLazyQuery>;
export type AdditionalProductQuerySuspenseQueryHookResult = ReturnType<typeof useAdditionalProductQuerySuspenseQuery>;
export type AdditionalProductQueryQueryResult = Apollo.QueryResult<AdditionalProductQuery, AdditionalProductQueryVariables>;
export const BottomNavQueryDocument = gql`
    query BottomNavQuery {
  user {
    id
    affiliateType
    referralsSinceLastLoginCount
    dogs {
      id
    }
  }
}
    `;

/**
 * __useBottomNavQuery__
 *
 * To run a query within a React component, call `useBottomNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useBottomNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBottomNavQuery({
 *   variables: {
 *   },
 * });
 */
export function useBottomNavQuery(baseOptions?: Apollo.QueryHookOptions<BottomNavQuery, BottomNavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BottomNavQuery, BottomNavQueryVariables>(BottomNavQueryDocument, options);
      }
export function useBottomNavQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BottomNavQuery, BottomNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BottomNavQuery, BottomNavQueryVariables>(BottomNavQueryDocument, options);
        }
export function useBottomNavQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BottomNavQuery, BottomNavQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BottomNavQuery, BottomNavQueryVariables>(BottomNavQueryDocument, options);
        }
export type BottomNavQueryHookResult = ReturnType<typeof useBottomNavQuery>;
export type BottomNavQueryLazyQueryHookResult = ReturnType<typeof useBottomNavQueryLazyQuery>;
export type BottomNavQuerySuspenseQueryHookResult = ReturnType<typeof useBottomNavQuerySuspenseQuery>;
export type BottomNavQueryQueryResult = Apollo.QueryResult<BottomNavQuery, BottomNavQueryVariables>;
export const DashboardFooterQueryDocument = gql`
    query DashboardFooterQuery {
  user {
    id
    shippingCountryCode
  }
}
    `;

/**
 * __useDashboardFooterQuery__
 *
 * To run a query within a React component, call `useDashboardFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardFooterQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardFooterQuery(baseOptions?: Apollo.QueryHookOptions<DashboardFooterQuery, DashboardFooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardFooterQuery, DashboardFooterQueryVariables>(DashboardFooterQueryDocument, options);
      }
export function useDashboardFooterQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardFooterQuery, DashboardFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardFooterQuery, DashboardFooterQueryVariables>(DashboardFooterQueryDocument, options);
        }
export function useDashboardFooterQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardFooterQuery, DashboardFooterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardFooterQuery, DashboardFooterQueryVariables>(DashboardFooterQueryDocument, options);
        }
export type DashboardFooterQueryHookResult = ReturnType<typeof useDashboardFooterQuery>;
export type DashboardFooterQueryLazyQueryHookResult = ReturnType<typeof useDashboardFooterQueryLazyQuery>;
export type DashboardFooterQuerySuspenseQueryHookResult = ReturnType<typeof useDashboardFooterQuerySuspenseQuery>;
export type DashboardFooterQueryQueryResult = Apollo.QueryResult<DashboardFooterQuery, DashboardFooterQueryVariables>;
export const TopNavQueryDocument = gql`
    query TopNavQuery {
  user {
    id
    firstName
    affiliateType
    referralsSinceLastLoginCount
    dogs {
      id
    }
  }
}
    `;

/**
 * __useTopNavQuery__
 *
 * To run a query within a React component, call `useTopNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopNavQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopNavQuery(baseOptions?: Apollo.QueryHookOptions<TopNavQuery, TopNavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopNavQuery, TopNavQueryVariables>(TopNavQueryDocument, options);
      }
export function useTopNavQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopNavQuery, TopNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopNavQuery, TopNavQueryVariables>(TopNavQueryDocument, options);
        }
export function useTopNavQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopNavQuery, TopNavQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopNavQuery, TopNavQueryVariables>(TopNavQueryDocument, options);
        }
export type TopNavQueryHookResult = ReturnType<typeof useTopNavQuery>;
export type TopNavQueryLazyQueryHookResult = ReturnType<typeof useTopNavQueryLazyQuery>;
export type TopNavQuerySuspenseQueryHookResult = ReturnType<typeof useTopNavQuerySuspenseQuery>;
export type TopNavQueryQueryResult = Apollo.QueryResult<TopNavQuery, TopNavQueryVariables>;
export const DeliverableDatesDataDocument = gql`
    query DeliverableDatesData($calendarInitDate: ISO8601Date!, $nDays: Int, $city: String, $shouldAttemptToOfferNextDayDelivery: Boolean, $shipmentType: String, $postcode: String, $userId: ID) {
  calendarDates(
    startDate: $calendarInitDate
    nDays: $nDays
    city: $city
    shouldAttemptToOfferNextDayDelivery: $shouldAttemptToOfferNextDayDelivery
    shipmentType: $shipmentType
    postcode: $postcode
    userId: $userId
  ) {
    date
    deliverable
    endOfLeadTime
  }
}
    `;

/**
 * __useDeliverableDatesData__
 *
 * To run a query within a React component, call `useDeliverableDatesData` and pass it any options that fit your needs.
 * When your component renders, `useDeliverableDatesData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliverableDatesData({
 *   variables: {
 *      calendarInitDate: // value for 'calendarInitDate'
 *      nDays: // value for 'nDays'
 *      city: // value for 'city'
 *      shouldAttemptToOfferNextDayDelivery: // value for 'shouldAttemptToOfferNextDayDelivery'
 *      shipmentType: // value for 'shipmentType'
 *      postcode: // value for 'postcode'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeliverableDatesData(baseOptions: Apollo.QueryHookOptions<DeliverableDatesData, DeliverableDatesDataVariables> & ({ variables: DeliverableDatesDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliverableDatesData, DeliverableDatesDataVariables>(DeliverableDatesDataDocument, options);
      }
export function useDeliverableDatesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliverableDatesData, DeliverableDatesDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliverableDatesData, DeliverableDatesDataVariables>(DeliverableDatesDataDocument, options);
        }
export function useDeliverableDatesDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeliverableDatesData, DeliverableDatesDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeliverableDatesData, DeliverableDatesDataVariables>(DeliverableDatesDataDocument, options);
        }
export type DeliverableDatesDataHookResult = ReturnType<typeof useDeliverableDatesData>;
export type DeliverableDatesDataLazyQueryHookResult = ReturnType<typeof useDeliverableDatesDataLazyQuery>;
export type DeliverableDatesDataSuspenseQueryHookResult = ReturnType<typeof useDeliverableDatesDataSuspenseQuery>;
export type DeliverableDatesDataQueryResult = Apollo.QueryResult<DeliverableDatesData, DeliverableDatesDataVariables>;
export const BoxTrackingQueryDocument = gql`
    query BoxTrackingQuery($boxId: ID!) {
  user {
    id
    dogs {
      id
      name
      gender
    }
    subscription {
      id
      box(boxId: $boxId) {
        id
        isoDeliveryDate
        consignment {
          id
          updatedAt
          status
          carrierName
          trackingUrl
        }
      }
    }
  }
}
    `;

/**
 * __useBoxTrackingQuery__
 *
 * To run a query within a React component, call `useBoxTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoxTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoxTrackingQuery({
 *   variables: {
 *      boxId: // value for 'boxId'
 *   },
 * });
 */
export function useBoxTrackingQuery(baseOptions: Apollo.QueryHookOptions<BoxTrackingQuery, BoxTrackingQueryVariables> & ({ variables: BoxTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoxTrackingQuery, BoxTrackingQueryVariables>(BoxTrackingQueryDocument, options);
      }
export function useBoxTrackingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoxTrackingQuery, BoxTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoxTrackingQuery, BoxTrackingQueryVariables>(BoxTrackingQueryDocument, options);
        }
export function useBoxTrackingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BoxTrackingQuery, BoxTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BoxTrackingQuery, BoxTrackingQueryVariables>(BoxTrackingQueryDocument, options);
        }
export type BoxTrackingQueryHookResult = ReturnType<typeof useBoxTrackingQuery>;
export type BoxTrackingQueryLazyQueryHookResult = ReturnType<typeof useBoxTrackingQueryLazyQuery>;
export type BoxTrackingQuerySuspenseQueryHookResult = ReturnType<typeof useBoxTrackingQuerySuspenseQuery>;
export type BoxTrackingQueryQueryResult = Apollo.QueryResult<BoxTrackingQuery, BoxTrackingQueryVariables>;
export const NcoTrackingQueryDocument = gql`
    query NcoTrackingQuery($boxId: ID!) {
  user {
    id
    dogs {
      id
      name
      gender
    }
    nonCoreOrder(orderId: $boxId) {
      id
      orderParts {
        deliveryDate
        consignment {
          id
          updatedAt
          status
          carrierName
          trackingUrl
        }
      }
    }
  }
}
    `;

/**
 * __useNcoTrackingQuery__
 *
 * To run a query within a React component, call `useNcoTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useNcoTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNcoTrackingQuery({
 *   variables: {
 *      boxId: // value for 'boxId'
 *   },
 * });
 */
export function useNcoTrackingQuery(baseOptions: Apollo.QueryHookOptions<NcoTrackingQuery, NcoTrackingQueryVariables> & ({ variables: NcoTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NcoTrackingQuery, NcoTrackingQueryVariables>(NcoTrackingQueryDocument, options);
      }
export function useNcoTrackingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NcoTrackingQuery, NcoTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NcoTrackingQuery, NcoTrackingQueryVariables>(NcoTrackingQueryDocument, options);
        }
export function useNcoTrackingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NcoTrackingQuery, NcoTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NcoTrackingQuery, NcoTrackingQueryVariables>(NcoTrackingQueryDocument, options);
        }
export type NcoTrackingQueryHookResult = ReturnType<typeof useNcoTrackingQuery>;
export type NcoTrackingQueryLazyQueryHookResult = ReturnType<typeof useNcoTrackingQueryLazyQuery>;
export type NcoTrackingQuerySuspenseQueryHookResult = ReturnType<typeof useNcoTrackingQuerySuspenseQuery>;
export type NcoTrackingQueryQueryResult = Apollo.QueryResult<NcoTrackingQuery, NcoTrackingQueryVariables>;
export const ReferAFriendUpsertDocument = gql`
    mutation ReferAFriendUpsert($userId: ID!, $emails: [String!]!) {
  referAFriendUpsert(userId: $userId, emails: $emails) {
    id
  }
}
    `;
export type ReferAFriendUpsertMutationFn = Apollo.MutationFunction<ReferAFriendUpsert, ReferAFriendUpsertVariables>;

/**
 * __useReferAFriendUpsert__
 *
 * To run a mutation, you first call `useReferAFriendUpsert` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReferAFriendUpsert` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referAFriendUpsert, { data, loading, error }] = useReferAFriendUpsert({
 *   variables: {
 *      userId: // value for 'userId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useReferAFriendUpsert(baseOptions?: Apollo.MutationHookOptions<ReferAFriendUpsert, ReferAFriendUpsertVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReferAFriendUpsert, ReferAFriendUpsertVariables>(ReferAFriendUpsertDocument, options);
      }
export type ReferAFriendUpsertHookResult = ReturnType<typeof useReferAFriendUpsert>;
export type ReferAFriendUpsertMutationResult = Apollo.MutationResult<ReferAFriendUpsert>;
export type ReferAFriendUpsertMutationOptions = Apollo.BaseMutationOptions<ReferAFriendUpsert, ReferAFriendUpsertVariables>;
export const FlavourQueryDocument = gql`
    query FlavourQuery($slug: String!) {
  flavour(slug: $slug) {
    images {
      src
    }
    primaryImage {
      src
    }
    name
    longDescription(includeHtml: true)
    productBenefits {
      name
      image {
        src
      }
    }
    composition(includeHtml: true)
    flavourConstituents {
      percentage
      constituent {
        name
      }
    }
    additives(includeHtml: true)
    storage(includeHtml: true)
  }
}
    `;

/**
 * __useFlavourQuery__
 *
 * To run a query within a React component, call `useFlavourQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlavourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlavourQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useFlavourQuery(baseOptions: Apollo.QueryHookOptions<FlavourQuery, FlavourQueryVariables> & ({ variables: FlavourQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlavourQuery, FlavourQueryVariables>(FlavourQueryDocument, options);
      }
export function useFlavourQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlavourQuery, FlavourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlavourQuery, FlavourQueryVariables>(FlavourQueryDocument, options);
        }
export function useFlavourQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlavourQuery, FlavourQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlavourQuery, FlavourQueryVariables>(FlavourQueryDocument, options);
        }
export type FlavourQueryHookResult = ReturnType<typeof useFlavourQuery>;
export type FlavourQueryLazyQueryHookResult = ReturnType<typeof useFlavourQueryLazyQuery>;
export type FlavourQuerySuspenseQueryHookResult = ReturnType<typeof useFlavourQuerySuspenseQuery>;
export type FlavourQueryQueryResult = Apollo.QueryResult<FlavourQuery, FlavourQueryVariables>;
export const MarketingMethodPurposeUpdateDocument = gql`
    mutation MarketingMethodPurposeUpdate($userId: ID, $authenticationStrategy: AuthenticationStrategy!, $trackingId: String, $token: String, $attribute: String, $shaType: String, $encryptionKey: String, $purposeIds: [ID!]!) {
  marketingMethodPurposeUpdate(
    userId: $userId
    authenticationStrategy: $authenticationStrategy
    trackingId: $trackingId
    token: $token
    attribute: $attribute
    shaType: $shaType
    encryptionKey: $encryptionKey
    purposeIds: $purposeIds
  ) {
    ...marketingPreferenceFragment
  }
}
    ${marketingPreferenceFragment}`;
export type MarketingMethodPurposeUpdateMutationFn = Apollo.MutationFunction<MarketingMethodPurposeUpdate, MarketingMethodPurposeUpdateVariables>;

/**
 * __useMarketingMethodPurposeUpdate__
 *
 * To run a mutation, you first call `useMarketingMethodPurposeUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketingMethodPurposeUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketingMethodPurposeUpdate, { data, loading, error }] = useMarketingMethodPurposeUpdate({
 *   variables: {
 *      userId: // value for 'userId'
 *      authenticationStrategy: // value for 'authenticationStrategy'
 *      trackingId: // value for 'trackingId'
 *      token: // value for 'token'
 *      attribute: // value for 'attribute'
 *      shaType: // value for 'shaType'
 *      encryptionKey: // value for 'encryptionKey'
 *      purposeIds: // value for 'purposeIds'
 *   },
 * });
 */
export function useMarketingMethodPurposeUpdate(baseOptions?: Apollo.MutationHookOptions<MarketingMethodPurposeUpdate, MarketingMethodPurposeUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketingMethodPurposeUpdate, MarketingMethodPurposeUpdateVariables>(MarketingMethodPurposeUpdateDocument, options);
      }
export type MarketingMethodPurposeUpdateHookResult = ReturnType<typeof useMarketingMethodPurposeUpdate>;
export type MarketingMethodPurposeUpdateMutationResult = Apollo.MutationResult<MarketingMethodPurposeUpdate>;
export type MarketingMethodPurposeUpdateMutationOptions = Apollo.BaseMutationOptions<MarketingMethodPurposeUpdate, MarketingMethodPurposeUpdateVariables>;
export const MarketingPreferenceQueryDocument = gql`
    query MarketingPreferenceQuery {
  user {
    ...marketingPreferenceFragment
  }
}
    ${marketingPreferenceFragment}`;

/**
 * __useMarketingPreferenceQuery__
 *
 * To run a query within a React component, call `useMarketingPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingPreferenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketingPreferenceQuery(baseOptions?: Apollo.QueryHookOptions<MarketingPreferenceQuery, MarketingPreferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingPreferenceQuery, MarketingPreferenceQueryVariables>(MarketingPreferenceQueryDocument, options);
      }
export function useMarketingPreferenceQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingPreferenceQuery, MarketingPreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingPreferenceQuery, MarketingPreferenceQueryVariables>(MarketingPreferenceQueryDocument, options);
        }
export function useMarketingPreferenceQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarketingPreferenceQuery, MarketingPreferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarketingPreferenceQuery, MarketingPreferenceQueryVariables>(MarketingPreferenceQueryDocument, options);
        }
export type MarketingPreferenceQueryHookResult = ReturnType<typeof useMarketingPreferenceQuery>;
export type MarketingPreferenceQueryLazyQueryHookResult = ReturnType<typeof useMarketingPreferenceQueryLazyQuery>;
export type MarketingPreferenceQuerySuspenseQueryHookResult = ReturnType<typeof useMarketingPreferenceQuerySuspenseQuery>;
export type MarketingPreferenceQueryQueryResult = Apollo.QueryResult<MarketingPreferenceQuery, MarketingPreferenceQueryVariables>;
export const NotificationsQueryDocument = gql`
    query NotificationsQuery {
  notifications {
    id
    image {
      src
    }
    link
    altText
    order
    text
  }
  user {
    id
    shippingCountryCode
    preferredLanguage
    subscription {
      activeRafCampaignVariant {
        rafCampaign {
          name
        }
      }
      id
      referralLink {
        referrerDiscount {
          applicableDiscountParts {
            discountBasis
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsQueryDocument, options);
      }
export function useNotificationsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsQueryDocument, options);
        }
export function useNotificationsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsQueryDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsQueryLazyQueryHookResult = ReturnType<typeof useNotificationsQueryLazyQuery>;
export type NotificationsQuerySuspenseQueryHookResult = ReturnType<typeof useNotificationsQuerySuspenseQuery>;
export type NotificationsQueryQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const MerchRafCardQueryDocument = gql`
    query MerchRafCardQuery {
  user {
    id
    shippingCountryCode
    preferredLanguage
    subscription {
      id
      referralLink {
        referrerDiscount {
          applicableDiscountParts {
            discountBasis
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMerchRafCardQuery__
 *
 * To run a query within a React component, call `useMerchRafCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchRafCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchRafCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useMerchRafCardQuery(baseOptions?: Apollo.QueryHookOptions<MerchRafCardQuery, MerchRafCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchRafCardQuery, MerchRafCardQueryVariables>(MerchRafCardQueryDocument, options);
      }
export function useMerchRafCardQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchRafCardQuery, MerchRafCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchRafCardQuery, MerchRafCardQueryVariables>(MerchRafCardQueryDocument, options);
        }
export function useMerchRafCardQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchRafCardQuery, MerchRafCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchRafCardQuery, MerchRafCardQueryVariables>(MerchRafCardQueryDocument, options);
        }
export type MerchRafCardQueryHookResult = ReturnType<typeof useMerchRafCardQuery>;
export type MerchRafCardQueryLazyQueryHookResult = ReturnType<typeof useMerchRafCardQueryLazyQuery>;
export type MerchRafCardQuerySuspenseQueryHookResult = ReturnType<typeof useMerchRafCardQuerySuspenseQuery>;
export type MerchRafCardQueryQueryResult = Apollo.QueryResult<MerchRafCardQuery, MerchRafCardQueryVariables>;
export const NavQueryDocument = gql`
    query NavQuery {
  currentUser {
    __typename
  }
}
    `;

/**
 * __useNavQuery__
 *
 * To run a query within a React component, call `useNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavQuery(baseOptions?: Apollo.QueryHookOptions<NavQuery, NavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavQuery, NavQueryVariables>(NavQueryDocument, options);
      }
export function useNavQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavQuery, NavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavQuery, NavQueryVariables>(NavQueryDocument, options);
        }
export function useNavQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavQuery, NavQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavQuery, NavQueryVariables>(NavQueryDocument, options);
        }
export type NavQueryHookResult = ReturnType<typeof useNavQuery>;
export type NavQueryLazyQueryHookResult = ReturnType<typeof useNavQueryLazyQuery>;
export type NavQuerySuspenseQueryHookResult = ReturnType<typeof useNavQuerySuspenseQuery>;
export type NavQueryQueryResult = Apollo.QueryResult<NavQuery, NavQueryVariables>;
export const GetUpsellableProductsDocument = gql`
    query GetUpsellableProducts($deliveryType: VariantDelivery, $num: Int!) {
  user {
    id
    firstName
    preferredLanguage
    shippingCountryCode
    dogs {
      id
      name
    }
    subscription {
      id
      nextNBoxes(num: $num) {
        id
        isoDeliveryDate
        physicalOrderProducts {
          id
          frequency
          productVariant {
            id
          }
          quantity
        }
      }
    }
  }
  extrasUpsellRecommendations(
    type: "in_account_upsell"
    deliveryType: $deliveryType
  ) {
    id
    name
    grossPrice
    slug
    recurringDeliveryType {
      adjustedGrossPrice
    }
    oneOffDeliveryType {
      adjustedGrossPrice
    }
    productCollection {
      id
      slug
      name
      thumbnail {
        src
      }
      productVariants {
        id
        name
        ...PriceFragment
      }
    }
  }
}
    ${PriceFragment}`;

/**
 * __useGetUpsellableProducts__
 *
 * To run a query within a React component, call `useGetUpsellableProducts` and pass it any options that fit your needs.
 * When your component renders, `useGetUpsellableProducts` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpsellableProducts({
 *   variables: {
 *      deliveryType: // value for 'deliveryType'
 *      num: // value for 'num'
 *   },
 * });
 */
export function useGetUpsellableProducts(baseOptions: Apollo.QueryHookOptions<GetUpsellableProducts, GetUpsellableProductsVariables> & ({ variables: GetUpsellableProductsVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpsellableProducts, GetUpsellableProductsVariables>(GetUpsellableProductsDocument, options);
      }
export function useGetUpsellableProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpsellableProducts, GetUpsellableProductsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpsellableProducts, GetUpsellableProductsVariables>(GetUpsellableProductsDocument, options);
        }
export function useGetUpsellableProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUpsellableProducts, GetUpsellableProductsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUpsellableProducts, GetUpsellableProductsVariables>(GetUpsellableProductsDocument, options);
        }
export type GetUpsellableProductsHookResult = ReturnType<typeof useGetUpsellableProducts>;
export type GetUpsellableProductsLazyQueryHookResult = ReturnType<typeof useGetUpsellableProductsLazyQuery>;
export type GetUpsellableProductsSuspenseQueryHookResult = ReturnType<typeof useGetUpsellableProductsSuspenseQuery>;
export type GetUpsellableProductsQueryResult = Apollo.QueryResult<GetUpsellableProducts, GetUpsellableProductsVariables>;
export const OrderProductsUpdateDocument = gql`
    mutation OrderProductsUpdate($userId: ID!, $boxId: ID!, $orderProducts: [ProductInput!]!) {
  orderProductsUpdate(
    userId: $userId
    boxId: $boxId
    orderProducts: $orderProducts
  ) {
    id
    box(boxId: $boxId) {
      id
      physicalOrderProducts {
        id
        nonPaymentReason
        quantity
        productVariant {
          id
          name
          productCollection {
            id
            name
            thumbnail {
              src
            }
          }
        }
      }
    }
  }
}
    `;
export type OrderProductsUpdateMutationFn = Apollo.MutationFunction<OrderProductsUpdate, OrderProductsUpdateVariables>;

/**
 * __useOrderProductsUpdate__
 *
 * To run a mutation, you first call `useOrderProductsUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderProductsUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderProductsUpdate, { data, loading, error }] = useOrderProductsUpdate({
 *   variables: {
 *      userId: // value for 'userId'
 *      boxId: // value for 'boxId'
 *      orderProducts: // value for 'orderProducts'
 *   },
 * });
 */
export function useOrderProductsUpdate(baseOptions?: Apollo.MutationHookOptions<OrderProductsUpdate, OrderProductsUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderProductsUpdate, OrderProductsUpdateVariables>(OrderProductsUpdateDocument, options);
      }
export type OrderProductsUpdateHookResult = ReturnType<typeof useOrderProductsUpdate>;
export type OrderProductsUpdateMutationResult = Apollo.MutationResult<OrderProductsUpdate>;
export type OrderProductsUpdateMutationOptions = Apollo.BaseMutationOptions<OrderProductsUpdate, OrderProductsUpdateVariables>;
export const RecurringOrderProductsUpdateDocument = gql`
    mutation RecurringOrderProductsUpdate($userId: ID!, $recurringOrderProducts: [ProductInput!]!, $num: Int!) {
  recurringOrderProductsUpdate(
    userId: $userId
    recurringOrderProducts: $recurringOrderProducts
  ) {
    id
    nextNBoxes(num: $num) {
      id
      physicalOrderProducts {
        id
        nonPaymentReason
        quantity
        productVariant {
          id
          name
          productCollection {
            id
            name
            thumbnail {
              src
            }
          }
        }
      }
    }
  }
}
    `;
export type RecurringOrderProductsUpdateMutationFn = Apollo.MutationFunction<RecurringOrderProductsUpdate, RecurringOrderProductsUpdateVariables>;

/**
 * __useRecurringOrderProductsUpdate__
 *
 * To run a mutation, you first call `useRecurringOrderProductsUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringOrderProductsUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringOrderProductsUpdate, { data, loading, error }] = useRecurringOrderProductsUpdate({
 *   variables: {
 *      userId: // value for 'userId'
 *      recurringOrderProducts: // value for 'recurringOrderProducts'
 *      num: // value for 'num'
 *   },
 * });
 */
export function useRecurringOrderProductsUpdate(baseOptions?: Apollo.MutationHookOptions<RecurringOrderProductsUpdate, RecurringOrderProductsUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringOrderProductsUpdate, RecurringOrderProductsUpdateVariables>(RecurringOrderProductsUpdateDocument, options);
      }
export type RecurringOrderProductsUpdateHookResult = ReturnType<typeof useRecurringOrderProductsUpdate>;
export type RecurringOrderProductsUpdateMutationResult = Apollo.MutationResult<RecurringOrderProductsUpdate>;
export type RecurringOrderProductsUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringOrderProductsUpdate, RecurringOrderProductsUpdateVariables>;
export const WelcomeBackCardQueryDocument = gql`
    query WelcomeBackCardQuery {
  user {
    id
    firstName
    subscription {
      id
      nextEditableBox {
        id
        cutOffDate
        amendable
      }
    }
  }
}
    `;

/**
 * __useWelcomeBackCardQuery__
 *
 * To run a query within a React component, call `useWelcomeBackCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useWelcomeBackCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWelcomeBackCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useWelcomeBackCardQuery(baseOptions?: Apollo.QueryHookOptions<WelcomeBackCardQuery, WelcomeBackCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WelcomeBackCardQuery, WelcomeBackCardQueryVariables>(WelcomeBackCardQueryDocument, options);
      }
export function useWelcomeBackCardQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WelcomeBackCardQuery, WelcomeBackCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WelcomeBackCardQuery, WelcomeBackCardQueryVariables>(WelcomeBackCardQueryDocument, options);
        }
export function useWelcomeBackCardQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WelcomeBackCardQuery, WelcomeBackCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WelcomeBackCardQuery, WelcomeBackCardQueryVariables>(WelcomeBackCardQueryDocument, options);
        }
export type WelcomeBackCardQueryHookResult = ReturnType<typeof useWelcomeBackCardQuery>;
export type WelcomeBackCardQueryLazyQueryHookResult = ReturnType<typeof useWelcomeBackCardQueryLazyQuery>;
export type WelcomeBackCardQuerySuspenseQueryHookResult = ReturnType<typeof useWelcomeBackCardQuerySuspenseQuery>;
export type WelcomeBackCardQueryQueryResult = Apollo.QueryResult<WelcomeBackCardQuery, WelcomeBackCardQueryVariables>;
export const UpdateDefaultAddressDocument = gql`
    mutation UpdateDefaultAddress($userId: ID!, $address: AddressInput!, $num: Int!) {
  response: addressUpdate(userId: $userId, address: $address) {
    ...UserAddressFragment
    subscription {
      nextNBoxes(num: $num) {
        id
        address {
          ...AddressFragment
        }
        isoDeliveryDate
      }
    }
  }
}
    ${UserAddressFragment}
${AddressFragment}`;
export type UpdateDefaultAddressMutationFn = Apollo.MutationFunction<UpdateDefaultAddress, UpdateDefaultAddressVariables>;

/**
 * __useUpdateDefaultAddress__
 *
 * To run a mutation, you first call `useUpdateDefaultAddress` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultAddress` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultAddress, { data, loading, error }] = useUpdateDefaultAddress({
 *   variables: {
 *      userId: // value for 'userId'
 *      address: // value for 'address'
 *      num: // value for 'num'
 *   },
 * });
 */
export function useUpdateDefaultAddress(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultAddress, UpdateDefaultAddressVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultAddress, UpdateDefaultAddressVariables>(UpdateDefaultAddressDocument, options);
      }
export type UpdateDefaultAddressHookResult = ReturnType<typeof useUpdateDefaultAddress>;
export type UpdateDefaultAddressMutationResult = Apollo.MutationResult<UpdateDefaultAddress>;
export type UpdateDefaultAddressMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultAddress, UpdateDefaultAddressVariables>;
export const ClientInitQueryDocument = gql`
    query ClientInitQuery($archivedType: ArchivedType!) {
  systemShouldShowAppContent: featureFlag(
    flag: "system_should_show_app_content"
    fallback: "not_in_cohort"
  )
  shouldSeeXmasTheme: featureFlag(
    flag: "should_see_xmas_theme"
    fallback: "false"
  )
  shouldSeeOnlyMoveThisBoxCheckbox: featureFlag(
    flag: "should-see-move-only-this-box-checkbox"
    fallback: "false"
  )
  shouldSeePlanManagementPhase3: featureFlag(
    flag: "should_see_plan_management_phase_3"
    fallback: "not_in_cohort"
  )
  shouldTrackErrorsOnErrorState: featureFlag(
    flag: "should_track_errors_on_error_state"
    fallback: "false"
  )
  shouldSeeUpcomingPriceRiseInfo: featureFlag(
    flag: "system-should-see-upcoming-price-rise-info"
    fallback: "false"
  )
  shouldSeeSelfResolutions: featureFlag(
    flag: "should_see_self_resolutions"
    fallback: "false"
  )
  shouldSeeStap: featureFlag(flag: "should_see_stap", fallback: "false")
  shouldSeeSwapToMFITBPlanOfferPage: featureFlag(
    flag: "should_see_swap_to_mfitb_plan_offer_page"
    fallback: "not_in_cohort"
  )
  shouldSeeThankYouPagev3: featureFlag(
    flag: "should_see_thank_you_page_v3"
    fallback: "false"
  )
  shouldSeeIntercom: featureFlag(flag: "should_see_intercom", fallback: "false")
  shouldSeePriceSensitivePausedPage: featureFlag(
    flag: "should_see_price_sensitive_paused_page"
    fallback: "not_in_cohort"
  )
  settings(
    names: ["carrier_preferences_enabled", "should_see_sms_delivery_reminders_section"]
  ) {
    name
    value
  }
  shouldSeeSegmentedPausedPage: featureFlag(
    flag: "should_see_segmented_paused_page"
    fallback: "not_in_cohort"
  )
  shouldSeeNextDayDeliveryAvailableOnReactivation: featureFlag(
    flag: "should-see-next-day-delivery-available-on-reactivation"
    fallback: "not_in_cohort"
  )
  notifications {
    id
  }
  currentAdminUser {
    id
  }
  nonCoreOrderDeliveryFee
  nonCoreOrderSmallOrderFee
  nonCoreOrderSmallOrderMinimumOrderValue
  user {
    id
    firstName
    affiliateType
    dogs {
      id
      name
      gender
      ageInMonths
      eaterType
    }
    subscription {
      id
      status
      deliveriesReceived
      increasedDeliveryCadencePlan {
        id
      }
      plan {
        id
        durationInWeeks
        numberOfPouches
        pouchSize
        swappablePlan {
          id
        }
        downsizeablePlan {
          id
        }
      }
      paymentMethods(archivedType: $archivedType) {
        ... on CreditCardPaymentMethod {
          id
          active
        }
        ... on BillingAgreement {
          id
          active
        }
        ... on MerchantInitiatedPayment {
          id
          active
        }
        ... on SepaDirectDebit {
          id
          active
        }
      }
    }
    shippingCountry {
      id
      code
      showExtras
      showCare
      defaultLanguage
    }
    preferredLanguage
  }
}
    `;

/**
 * __useClientInitQuery__
 *
 * To run a query within a React component, call `useClientInitQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientInitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientInitQuery({
 *   variables: {
 *      archivedType: // value for 'archivedType'
 *   },
 * });
 */
export function useClientInitQuery(baseOptions: Apollo.QueryHookOptions<ClientInitQuery, ClientInitQueryVariables> & ({ variables: ClientInitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientInitQuery, ClientInitQueryVariables>(ClientInitQueryDocument, options);
      }
export function useClientInitQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientInitQuery, ClientInitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientInitQuery, ClientInitQueryVariables>(ClientInitQueryDocument, options);
        }
export function useClientInitQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientInitQuery, ClientInitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientInitQuery, ClientInitQueryVariables>(ClientInitQueryDocument, options);
        }
export type ClientInitQueryHookResult = ReturnType<typeof useClientInitQuery>;
export type ClientInitQueryLazyQueryHookResult = ReturnType<typeof useClientInitQueryLazyQuery>;
export type ClientInitQuerySuspenseQueryHookResult = ReturnType<typeof useClientInitQuerySuspenseQuery>;
export type ClientInitQueryQueryResult = Apollo.QueryResult<ClientInitQuery, ClientInitQueryVariables>;
export const DeliveryDateUpdateDocument = gql`
    mutation DeliveryDateUpdate($userId: ID!, $boxId: ID!, $selectedDeliveryDate: ISO8601Date!, $deliveryAreaId: ID, $adjustFutureBoxDates: Boolean!, $triggerEvents: Boolean, $nextNBoxes: Int!) {
  boxDeliveryDateUpdate(
    userId: $userId
    boxId: $boxId
    date: $selectedDeliveryDate
    deliveryAreaId: $deliveryAreaId
    adjustFutureBoxDates: $adjustFutureBoxDates
    triggerEvents: $triggerEvents
  ) {
    id
    currentDeliveryAreaPreference {
      id
      preferredCarrierService {
        id
        carrier {
          name
        }
      }
    }
    subscription {
      id
      nextNBoxes(num: $nextNBoxes) {
        id
        isoDeliveryDate
        editable
      }
      box(boxId: $boxId) {
        id
        isoDeliveryDate
      }
    }
  }
}
    `;
export type DeliveryDateUpdateMutationFn = Apollo.MutationFunction<DeliveryDateUpdate, DeliveryDateUpdateVariables>;

/**
 * __useDeliveryDateUpdate__
 *
 * To run a mutation, you first call `useDeliveryDateUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliveryDateUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliveryDateUpdate, { data, loading, error }] = useDeliveryDateUpdate({
 *   variables: {
 *      userId: // value for 'userId'
 *      boxId: // value for 'boxId'
 *      selectedDeliveryDate: // value for 'selectedDeliveryDate'
 *      deliveryAreaId: // value for 'deliveryAreaId'
 *      adjustFutureBoxDates: // value for 'adjustFutureBoxDates'
 *      triggerEvents: // value for 'triggerEvents'
 *      nextNBoxes: // value for 'nextNBoxes'
 *   },
 * });
 */
export function useDeliveryDateUpdate(baseOptions?: Apollo.MutationHookOptions<DeliveryDateUpdate, DeliveryDateUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeliveryDateUpdate, DeliveryDateUpdateVariables>(DeliveryDateUpdateDocument, options);
      }
export type DeliveryDateUpdateHookResult = ReturnType<typeof useDeliveryDateUpdate>;
export type DeliveryDateUpdateMutationResult = Apollo.MutationResult<DeliveryDateUpdate>;
export type DeliveryDateUpdateMutationOptions = Apollo.BaseMutationOptions<DeliveryDateUpdate, DeliveryDateUpdateVariables>;
export const CourierDeliveryDatesQueryDocument = gql`
    query CourierDeliveryDatesQuery($boxId: ID!, $nextNBoxes: Int!, $calendarInitDate: ISO8601Date!, $nDays: Int!, $shouldAttemptToOfferNextDayDelivery: Boolean!, $userId: ID) {
  user {
    id
    currentDeliveryAreaPreference {
      id
    }
    deliveryAreaOptions {
      ...CourierFragment
    }
    ...DeliveryDateUserFragment
  }
  calendarDates(
    startDate: $calendarInitDate
    nDays: $nDays
    shouldAttemptToOfferNextDayDelivery: $shouldAttemptToOfferNextDayDelivery
    userId: $userId
  ) {
    ...CalendarDatesV2Fragment
  }
}
    ${CourierFragment}
${DeliveryDateUserFragment}
${CalendarDatesV2Fragment}`;

/**
 * __useCourierDeliveryDatesQuery__
 *
 * To run a query within a React component, call `useCourierDeliveryDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourierDeliveryDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourierDeliveryDatesQuery({
 *   variables: {
 *      boxId: // value for 'boxId'
 *      nextNBoxes: // value for 'nextNBoxes'
 *      calendarInitDate: // value for 'calendarInitDate'
 *      nDays: // value for 'nDays'
 *      shouldAttemptToOfferNextDayDelivery: // value for 'shouldAttemptToOfferNextDayDelivery'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCourierDeliveryDatesQuery(baseOptions: Apollo.QueryHookOptions<CourierDeliveryDatesQuery, CourierDeliveryDatesQueryVariables> & ({ variables: CourierDeliveryDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourierDeliveryDatesQuery, CourierDeliveryDatesQueryVariables>(CourierDeliveryDatesQueryDocument, options);
      }
export function useCourierDeliveryDatesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourierDeliveryDatesQuery, CourierDeliveryDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourierDeliveryDatesQuery, CourierDeliveryDatesQueryVariables>(CourierDeliveryDatesQueryDocument, options);
        }
export function useCourierDeliveryDatesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourierDeliveryDatesQuery, CourierDeliveryDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourierDeliveryDatesQuery, CourierDeliveryDatesQueryVariables>(CourierDeliveryDatesQueryDocument, options);
        }
export type CourierDeliveryDatesQueryHookResult = ReturnType<typeof useCourierDeliveryDatesQuery>;
export type CourierDeliveryDatesQueryLazyQueryHookResult = ReturnType<typeof useCourierDeliveryDatesQueryLazyQuery>;
export type CourierDeliveryDatesQuerySuspenseQueryHookResult = ReturnType<typeof useCourierDeliveryDatesQuerySuspenseQuery>;
export type CourierDeliveryDatesQueryQueryResult = Apollo.QueryResult<CourierDeliveryDatesQuery, CourierDeliveryDatesQueryVariables>;
export const DeliveryDateQueryDocument = gql`
    query DeliveryDateQuery($boxId: ID!, $nextNBoxes: Int!, $calendarInitDate: ISO8601Date!, $nDays: Int, $shouldAttemptToOfferNextDayDelivery: Boolean, $userId: ID) {
  user {
    id
    ...DeliveryDateUserFragment
  }
  calendarDates(
    startDate: $calendarInitDate
    nDays: $nDays
    shouldAttemptToOfferNextDayDelivery: $shouldAttemptToOfferNextDayDelivery
    userId: $userId
  ) {
    ...CalendarDatesV2Fragment
  }
}
    ${DeliveryDateUserFragment}
${CalendarDatesV2Fragment}`;

/**
 * __useDeliveryDateQuery__
 *
 * To run a query within a React component, call `useDeliveryDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryDateQuery({
 *   variables: {
 *      boxId: // value for 'boxId'
 *      nextNBoxes: // value for 'nextNBoxes'
 *      calendarInitDate: // value for 'calendarInitDate'
 *      nDays: // value for 'nDays'
 *      shouldAttemptToOfferNextDayDelivery: // value for 'shouldAttemptToOfferNextDayDelivery'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeliveryDateQuery(baseOptions: Apollo.QueryHookOptions<DeliveryDateQuery, DeliveryDateQueryVariables> & ({ variables: DeliveryDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryDateQuery, DeliveryDateQueryVariables>(DeliveryDateQueryDocument, options);
      }
export function useDeliveryDateQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryDateQuery, DeliveryDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryDateQuery, DeliveryDateQueryVariables>(DeliveryDateQueryDocument, options);
        }
export function useDeliveryDateQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeliveryDateQuery, DeliveryDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeliveryDateQuery, DeliveryDateQueryVariables>(DeliveryDateQueryDocument, options);
        }
export type DeliveryDateQueryHookResult = ReturnType<typeof useDeliveryDateQuery>;
export type DeliveryDateQueryLazyQueryHookResult = ReturnType<typeof useDeliveryDateQueryLazyQuery>;
export type DeliveryDateQuerySuspenseQueryHookResult = ReturnType<typeof useDeliveryDateQuerySuspenseQuery>;
export type DeliveryDateQueryQueryResult = Apollo.QueryResult<DeliveryDateQuery, DeliveryDateQueryVariables>;
export const DeliveryDateModalQueryDocument = gql`
    query DeliveryDateModalQuery($calendarInitDate: ISO8601Date!, $nDays: Int, $city: String!, $postcode: String!, $shouldAttemptToOfferNextDayDelivery: Boolean) {
  calendarDates(
    startDate: $calendarInitDate
    nDays: $nDays
    city: $city
    postcode: $postcode
    shouldAttemptToOfferNextDayDelivery: $shouldAttemptToOfferNextDayDelivery
  ) {
    date
    deliverable
    endOfLeadTime
  }
}
    `;

/**
 * __useDeliveryDateModalQuery__
 *
 * To run a query within a React component, call `useDeliveryDateModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryDateModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryDateModalQuery({
 *   variables: {
 *      calendarInitDate: // value for 'calendarInitDate'
 *      nDays: // value for 'nDays'
 *      city: // value for 'city'
 *      postcode: // value for 'postcode'
 *      shouldAttemptToOfferNextDayDelivery: // value for 'shouldAttemptToOfferNextDayDelivery'
 *   },
 * });
 */
export function useDeliveryDateModalQuery(baseOptions: Apollo.QueryHookOptions<DeliveryDateModalQuery, DeliveryDateModalQueryVariables> & ({ variables: DeliveryDateModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryDateModalQuery, DeliveryDateModalQueryVariables>(DeliveryDateModalQueryDocument, options);
      }
export function useDeliveryDateModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryDateModalQuery, DeliveryDateModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryDateModalQuery, DeliveryDateModalQueryVariables>(DeliveryDateModalQueryDocument, options);
        }
export function useDeliveryDateModalQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeliveryDateModalQuery, DeliveryDateModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeliveryDateModalQuery, DeliveryDateModalQueryVariables>(DeliveryDateModalQueryDocument, options);
        }
export type DeliveryDateModalQueryHookResult = ReturnType<typeof useDeliveryDateModalQuery>;
export type DeliveryDateModalQueryLazyQueryHookResult = ReturnType<typeof useDeliveryDateModalQueryLazyQuery>;
export type DeliveryDateModalQuerySuspenseQueryHookResult = ReturnType<typeof useDeliveryDateModalQuerySuspenseQuery>;
export type DeliveryDateModalQueryQueryResult = Apollo.QueryResult<DeliveryDateModalQuery, DeliveryDateModalQueryVariables>;
export const DeliveryDateModalWithCourierQueryDocument = gql`
    query DeliveryDateModalWithCourierQuery($calendarInitDate: ISO8601Date!, $nDays: Int!, $city: String!, $postcode: String!, $shouldAttemptToOfferNextDayDelivery: Boolean!) {
  deliveryAreaOptions(city: $city, postcode: $postcode) {
    ...CourierFragment
  }
  calendarDates(
    startDate: $calendarInitDate
    nDays: $nDays
    city: $city
    postcode: $postcode
    shouldAttemptToOfferNextDayDelivery: $shouldAttemptToOfferNextDayDelivery
  ) {
    ...CalendarDatesV2Fragment
  }
}
    ${CourierFragment}
${CalendarDatesV2Fragment}`;

/**
 * __useDeliveryDateModalWithCourierQuery__
 *
 * To run a query within a React component, call `useDeliveryDateModalWithCourierQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryDateModalWithCourierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryDateModalWithCourierQuery({
 *   variables: {
 *      calendarInitDate: // value for 'calendarInitDate'
 *      nDays: // value for 'nDays'
 *      city: // value for 'city'
 *      postcode: // value for 'postcode'
 *      shouldAttemptToOfferNextDayDelivery: // value for 'shouldAttemptToOfferNextDayDelivery'
 *   },
 * });
 */
export function useDeliveryDateModalWithCourierQuery(baseOptions: Apollo.QueryHookOptions<DeliveryDateModalWithCourierQuery, DeliveryDateModalWithCourierQueryVariables> & ({ variables: DeliveryDateModalWithCourierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryDateModalWithCourierQuery, DeliveryDateModalWithCourierQueryVariables>(DeliveryDateModalWithCourierQueryDocument, options);
      }
export function useDeliveryDateModalWithCourierQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryDateModalWithCourierQuery, DeliveryDateModalWithCourierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryDateModalWithCourierQuery, DeliveryDateModalWithCourierQueryVariables>(DeliveryDateModalWithCourierQueryDocument, options);
        }
export function useDeliveryDateModalWithCourierQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeliveryDateModalWithCourierQuery, DeliveryDateModalWithCourierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeliveryDateModalWithCourierQuery, DeliveryDateModalWithCourierQueryVariables>(DeliveryDateModalWithCourierQueryDocument, options);
        }
export type DeliveryDateModalWithCourierQueryHookResult = ReturnType<typeof useDeliveryDateModalWithCourierQuery>;
export type DeliveryDateModalWithCourierQueryLazyQueryHookResult = ReturnType<typeof useDeliveryDateModalWithCourierQueryLazyQuery>;
export type DeliveryDateModalWithCourierQuerySuspenseQueryHookResult = ReturnType<typeof useDeliveryDateModalWithCourierQuerySuspenseQuery>;
export type DeliveryDateModalWithCourierQueryQueryResult = Apollo.QueryResult<DeliveryDateModalWithCourierQuery, DeliveryDateModalWithCourierQueryVariables>;
export const PostcodeIsDeliverableQueryDocument = gql`
    query PostcodeIsDeliverableQuery($postcode: String!) {
  postcodeIsDeliverable(postcode: $postcode)
}
    `;

/**
 * __usePostcodeIsDeliverableQuery__
 *
 * To run a query within a React component, call `usePostcodeIsDeliverableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostcodeIsDeliverableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostcodeIsDeliverableQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function usePostcodeIsDeliverableQuery(baseOptions: Apollo.QueryHookOptions<PostcodeIsDeliverableQuery, PostcodeIsDeliverableQueryVariables> & ({ variables: PostcodeIsDeliverableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostcodeIsDeliverableQuery, PostcodeIsDeliverableQueryVariables>(PostcodeIsDeliverableQueryDocument, options);
      }
export function usePostcodeIsDeliverableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostcodeIsDeliverableQuery, PostcodeIsDeliverableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostcodeIsDeliverableQuery, PostcodeIsDeliverableQueryVariables>(PostcodeIsDeliverableQueryDocument, options);
        }
export function usePostcodeIsDeliverableQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostcodeIsDeliverableQuery, PostcodeIsDeliverableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostcodeIsDeliverableQuery, PostcodeIsDeliverableQueryVariables>(PostcodeIsDeliverableQueryDocument, options);
        }
export type PostcodeIsDeliverableQueryHookResult = ReturnType<typeof usePostcodeIsDeliverableQuery>;
export type PostcodeIsDeliverableQueryLazyQueryHookResult = ReturnType<typeof usePostcodeIsDeliverableQueryLazyQuery>;
export type PostcodeIsDeliverableQuerySuspenseQueryHookResult = ReturnType<typeof usePostcodeIsDeliverableQuerySuspenseQuery>;
export type PostcodeIsDeliverableQueryQueryResult = Apollo.QueryResult<PostcodeIsDeliverableQuery, PostcodeIsDeliverableQueryVariables>;
export const CheckoutCurrentDiscountCodeDocument = gql`
    query CheckoutCurrentDiscountCode($discountCodeId: ID!) {
  discountCode(discountCodeId: $discountCodeId) {
    ...discountCodeFragment
  }
}
    ${discountCodeFragment}`;

/**
 * __useCheckoutCurrentDiscountCode__
 *
 * To run a query within a React component, call `useCheckoutCurrentDiscountCode` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCurrentDiscountCode` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutCurrentDiscountCode({
 *   variables: {
 *      discountCodeId: // value for 'discountCodeId'
 *   },
 * });
 */
export function useCheckoutCurrentDiscountCode(baseOptions: Apollo.QueryHookOptions<CheckoutCurrentDiscountCode, CheckoutCurrentDiscountCodeVariables> & ({ variables: CheckoutCurrentDiscountCodeVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutCurrentDiscountCode, CheckoutCurrentDiscountCodeVariables>(CheckoutCurrentDiscountCodeDocument, options);
      }
export function useCheckoutCurrentDiscountCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutCurrentDiscountCode, CheckoutCurrentDiscountCodeVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutCurrentDiscountCode, CheckoutCurrentDiscountCodeVariables>(CheckoutCurrentDiscountCodeDocument, options);
        }
export function useCheckoutCurrentDiscountCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutCurrentDiscountCode, CheckoutCurrentDiscountCodeVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutCurrentDiscountCode, CheckoutCurrentDiscountCodeVariables>(CheckoutCurrentDiscountCodeDocument, options);
        }
export type CheckoutCurrentDiscountCodeHookResult = ReturnType<typeof useCheckoutCurrentDiscountCode>;
export type CheckoutCurrentDiscountCodeLazyQueryHookResult = ReturnType<typeof useCheckoutCurrentDiscountCodeLazyQuery>;
export type CheckoutCurrentDiscountCodeSuspenseQueryHookResult = ReturnType<typeof useCheckoutCurrentDiscountCodeSuspenseQuery>;
export type CheckoutCurrentDiscountCodeQueryResult = Apollo.QueryResult<CheckoutCurrentDiscountCode, CheckoutCurrentDiscountCodeVariables>;
export const CheckoutAddDiscountToGuestDocument = gql`
    mutation CheckoutAddDiscountToGuest($discountCode: String!) {
  addDiscountToGuest(code: $discountCode) {
    guest {
      discountCode {
        ...discountCodeFragment
      }
    }
  }
}
    ${discountCodeFragment}`;
export type CheckoutAddDiscountToGuestMutationFn = Apollo.MutationFunction<CheckoutAddDiscountToGuest, CheckoutAddDiscountToGuestVariables>;

/**
 * __useCheckoutAddDiscountToGuest__
 *
 * To run a mutation, you first call `useCheckoutAddDiscountToGuest` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutAddDiscountToGuest` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutAddDiscountToGuest, { data, loading, error }] = useCheckoutAddDiscountToGuest({
 *   variables: {
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function useCheckoutAddDiscountToGuest(baseOptions?: Apollo.MutationHookOptions<CheckoutAddDiscountToGuest, CheckoutAddDiscountToGuestVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutAddDiscountToGuest, CheckoutAddDiscountToGuestVariables>(CheckoutAddDiscountToGuestDocument, options);
      }
export type CheckoutAddDiscountToGuestHookResult = ReturnType<typeof useCheckoutAddDiscountToGuest>;
export type CheckoutAddDiscountToGuestMutationResult = Apollo.MutationResult<CheckoutAddDiscountToGuest>;
export type CheckoutAddDiscountToGuestMutationOptions = Apollo.BaseMutationOptions<CheckoutAddDiscountToGuest, CheckoutAddDiscountToGuestVariables>;
export const RedeemDiscountDocument = gql`
    mutation RedeemDiscount($userId: ID!, $discountCode: String!) {
  redeemReactivationDiscount(userId: $userId, discountCode: {code: $discountCode}) {
    id
    subscription {
      id
      alreadyRedeemedReactivationCampaign {
        name
        expiryDate
        description
        discountCode {
          id
          discountCodeParts {
            discountBasis
            value
            discountType
            n
          }
        }
      }
      previewUncreatedFutureBox {
        isoDeliveryDate
        order {
          id
          totalPrice
          surchargeTotal
          planTotal
          deliveryFee
          subtotal
          discountTotal
          discountedSubtotalPricePerDay
          subtotalPricePerDay
        }
      }
    }
  }
}
    `;
export type RedeemDiscountMutationFn = Apollo.MutationFunction<RedeemDiscount, RedeemDiscountVariables>;

/**
 * __useRedeemDiscount__
 *
 * To run a mutation, you first call `useRedeemDiscount` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemDiscount` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemDiscount, { data, loading, error }] = useRedeemDiscount({
 *   variables: {
 *      userId: // value for 'userId'
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function useRedeemDiscount(baseOptions?: Apollo.MutationHookOptions<RedeemDiscount, RedeemDiscountVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemDiscount, RedeemDiscountVariables>(RedeemDiscountDocument, options);
      }
export type RedeemDiscountHookResult = ReturnType<typeof useRedeemDiscount>;
export type RedeemDiscountMutationResult = Apollo.MutationResult<RedeemDiscount>;
export type RedeemDiscountMutationOptions = Apollo.BaseMutationOptions<RedeemDiscount, RedeemDiscountVariables>;
export const RedeemedDiscountCodeQueryDocument = gql`
    query RedeemedDiscountCodeQuery {
  user {
    id
    subscription {
      id
      alreadyRedeemedReactivationCampaign {
        name
        expiryDate
        description
        discountCode {
          id
          discountCodeParts {
            discountBasis
            value
            discountType
            n
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRedeemedDiscountCodeQuery__
 *
 * To run a query within a React component, call `useRedeemedDiscountCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedeemedDiscountCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedeemedDiscountCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useRedeemedDiscountCodeQuery(baseOptions?: Apollo.QueryHookOptions<RedeemedDiscountCodeQuery, RedeemedDiscountCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedeemedDiscountCodeQuery, RedeemedDiscountCodeQueryVariables>(RedeemedDiscountCodeQueryDocument, options);
      }
export function useRedeemedDiscountCodeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedeemedDiscountCodeQuery, RedeemedDiscountCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedeemedDiscountCodeQuery, RedeemedDiscountCodeQueryVariables>(RedeemedDiscountCodeQueryDocument, options);
        }
export function useRedeemedDiscountCodeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedeemedDiscountCodeQuery, RedeemedDiscountCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedeemedDiscountCodeQuery, RedeemedDiscountCodeQueryVariables>(RedeemedDiscountCodeQueryDocument, options);
        }
export type RedeemedDiscountCodeQueryHookResult = ReturnType<typeof useRedeemedDiscountCodeQuery>;
export type RedeemedDiscountCodeQueryLazyQueryHookResult = ReturnType<typeof useRedeemedDiscountCodeQueryLazyQuery>;
export type RedeemedDiscountCodeQuerySuspenseQueryHookResult = ReturnType<typeof useRedeemedDiscountCodeQuerySuspenseQuery>;
export type RedeemedDiscountCodeQueryQueryResult = Apollo.QueryResult<RedeemedDiscountCodeQuery, RedeemedDiscountCodeQueryVariables>;
export const StripeChargeBoxOneAndSetupPaymentMethodDocument = gql`
    mutation StripeChargeBoxOneAndSetupPaymentMethod($paymentMethodType: String!) {
  stripeChargeBoxOneAndSetupPaymentMethod(paymentMethodType: $paymentMethodType) {
    stripeSecretToken
    paymentIntentId
    boxCanBeCharged
  }
}
    `;
export type StripeChargeBoxOneAndSetupPaymentMethodMutationFn = Apollo.MutationFunction<StripeChargeBoxOneAndSetupPaymentMethod, StripeChargeBoxOneAndSetupPaymentMethodVariables>;

/**
 * __useStripeChargeBoxOneAndSetupPaymentMethod__
 *
 * To run a mutation, you first call `useStripeChargeBoxOneAndSetupPaymentMethod` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeChargeBoxOneAndSetupPaymentMethod` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeChargeBoxOneAndSetupPaymentMethod, { data, loading, error }] = useStripeChargeBoxOneAndSetupPaymentMethod({
 *   variables: {
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useStripeChargeBoxOneAndSetupPaymentMethod(baseOptions?: Apollo.MutationHookOptions<StripeChargeBoxOneAndSetupPaymentMethod, StripeChargeBoxOneAndSetupPaymentMethodVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeChargeBoxOneAndSetupPaymentMethod, StripeChargeBoxOneAndSetupPaymentMethodVariables>(StripeChargeBoxOneAndSetupPaymentMethodDocument, options);
      }
export type StripeChargeBoxOneAndSetupPaymentMethodHookResult = ReturnType<typeof useStripeChargeBoxOneAndSetupPaymentMethod>;
export type StripeChargeBoxOneAndSetupPaymentMethodMutationResult = Apollo.MutationResult<StripeChargeBoxOneAndSetupPaymentMethod>;
export type StripeChargeBoxOneAndSetupPaymentMethodMutationOptions = Apollo.BaseMutationOptions<StripeChargeBoxOneAndSetupPaymentMethod, StripeChargeBoxOneAndSetupPaymentMethodVariables>;
export const StripeUserParamsSetupIntentCreateDocument = gql`
    mutation StripeUserParamsSetupIntentCreate($subscriptionData: SubscriptionDataInput!, $authenticationType: String!, $paymentIntentId: String!) {
  stripeUserParamsSetupIntentCreate(
    subscriptionData: $subscriptionData
    authenticationType: $authenticationType
    paymentIntentId: $paymentIntentId
  ) {
    paymentIntentId
  }
}
    `;
export type StripeUserParamsSetupIntentCreateMutationFn = Apollo.MutationFunction<StripeUserParamsSetupIntentCreate, StripeUserParamsSetupIntentCreateVariables>;

/**
 * __useStripeUserParamsSetupIntentCreate__
 *
 * To run a mutation, you first call `useStripeUserParamsSetupIntentCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeUserParamsSetupIntentCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeUserParamsSetupIntentCreate, { data, loading, error }] = useStripeUserParamsSetupIntentCreate({
 *   variables: {
 *      subscriptionData: // value for 'subscriptionData'
 *      authenticationType: // value for 'authenticationType'
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useStripeUserParamsSetupIntentCreate(baseOptions?: Apollo.MutationHookOptions<StripeUserParamsSetupIntentCreate, StripeUserParamsSetupIntentCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeUserParamsSetupIntentCreate, StripeUserParamsSetupIntentCreateVariables>(StripeUserParamsSetupIntentCreateDocument, options);
      }
export type StripeUserParamsSetupIntentCreateHookResult = ReturnType<typeof useStripeUserParamsSetupIntentCreate>;
export type StripeUserParamsSetupIntentCreateMutationResult = Apollo.MutationResult<StripeUserParamsSetupIntentCreate>;
export type StripeUserParamsSetupIntentCreateMutationOptions = Apollo.BaseMutationOptions<StripeUserParamsSetupIntentCreate, StripeUserParamsSetupIntentCreateVariables>;
export const ChargeIdFromPaymentIntentIdDocument = gql`
    query ChargeIdFromPaymentIntentId($paymentIntentId: String!, $paymentMethodType: PaymentMethodType!) {
  chargeIdFromPaymentIntentId(
    paymentIntentId: $paymentIntentId
    paymentMethodType: $paymentMethodType
  )
}
    `;

/**
 * __useChargeIdFromPaymentIntentId__
 *
 * To run a query within a React component, call `useChargeIdFromPaymentIntentId` and pass it any options that fit your needs.
 * When your component renders, `useChargeIdFromPaymentIntentId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeIdFromPaymentIntentId({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useChargeIdFromPaymentIntentId(baseOptions: Apollo.QueryHookOptions<ChargeIdFromPaymentIntentId, ChargeIdFromPaymentIntentIdVariables> & ({ variables: ChargeIdFromPaymentIntentIdVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChargeIdFromPaymentIntentId, ChargeIdFromPaymentIntentIdVariables>(ChargeIdFromPaymentIntentIdDocument, options);
      }
export function useChargeIdFromPaymentIntentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChargeIdFromPaymentIntentId, ChargeIdFromPaymentIntentIdVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChargeIdFromPaymentIntentId, ChargeIdFromPaymentIntentIdVariables>(ChargeIdFromPaymentIntentIdDocument, options);
        }
export function useChargeIdFromPaymentIntentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChargeIdFromPaymentIntentId, ChargeIdFromPaymentIntentIdVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChargeIdFromPaymentIntentId, ChargeIdFromPaymentIntentIdVariables>(ChargeIdFromPaymentIntentIdDocument, options);
        }
export type ChargeIdFromPaymentIntentIdHookResult = ReturnType<typeof useChargeIdFromPaymentIntentId>;
export type ChargeIdFromPaymentIntentIdLazyQueryHookResult = ReturnType<typeof useChargeIdFromPaymentIntentIdLazyQuery>;
export type ChargeIdFromPaymentIntentIdSuspenseQueryHookResult = ReturnType<typeof useChargeIdFromPaymentIntentIdSuspenseQuery>;
export type ChargeIdFromPaymentIntentIdQueryResult = Apollo.QueryResult<ChargeIdFromPaymentIntentId, ChargeIdFromPaymentIntentIdVariables>;
export const SepaPaymentMethodIdFromIntentSecretDocument = gql`
    query SepaPaymentMethodIdFromIntentSecret($intentSecret: String!, $intentType: IntentType!) {
  sepaPaymentMethodIdFromIntentSecret(
    intentSecret: $intentSecret
    intentType: $intentType
  )
}
    `;

/**
 * __useSepaPaymentMethodIdFromIntentSecret__
 *
 * To run a query within a React component, call `useSepaPaymentMethodIdFromIntentSecret` and pass it any options that fit your needs.
 * When your component renders, `useSepaPaymentMethodIdFromIntentSecret` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSepaPaymentMethodIdFromIntentSecret({
 *   variables: {
 *      intentSecret: // value for 'intentSecret'
 *      intentType: // value for 'intentType'
 *   },
 * });
 */
export function useSepaPaymentMethodIdFromIntentSecret(baseOptions: Apollo.QueryHookOptions<SepaPaymentMethodIdFromIntentSecret, SepaPaymentMethodIdFromIntentSecretVariables> & ({ variables: SepaPaymentMethodIdFromIntentSecretVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SepaPaymentMethodIdFromIntentSecret, SepaPaymentMethodIdFromIntentSecretVariables>(SepaPaymentMethodIdFromIntentSecretDocument, options);
      }
export function useSepaPaymentMethodIdFromIntentSecretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SepaPaymentMethodIdFromIntentSecret, SepaPaymentMethodIdFromIntentSecretVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SepaPaymentMethodIdFromIntentSecret, SepaPaymentMethodIdFromIntentSecretVariables>(SepaPaymentMethodIdFromIntentSecretDocument, options);
        }
export function useSepaPaymentMethodIdFromIntentSecretSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SepaPaymentMethodIdFromIntentSecret, SepaPaymentMethodIdFromIntentSecretVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SepaPaymentMethodIdFromIntentSecret, SepaPaymentMethodIdFromIntentSecretVariables>(SepaPaymentMethodIdFromIntentSecretDocument, options);
        }
export type SepaPaymentMethodIdFromIntentSecretHookResult = ReturnType<typeof useSepaPaymentMethodIdFromIntentSecret>;
export type SepaPaymentMethodIdFromIntentSecretLazyQueryHookResult = ReturnType<typeof useSepaPaymentMethodIdFromIntentSecretLazyQuery>;
export type SepaPaymentMethodIdFromIntentSecretSuspenseQueryHookResult = ReturnType<typeof useSepaPaymentMethodIdFromIntentSecretSuspenseQuery>;
export type SepaPaymentMethodIdFromIntentSecretQueryResult = Apollo.QueryResult<SepaPaymentMethodIdFromIntentSecret, SepaPaymentMethodIdFromIntentSecretVariables>;
export const billingRequestFlowCreateDocument = gql`
    mutation billingRequestFlowCreate($redirectUrl: String, $exitUrl: String, $existingCustomerId: String, $address: AddressInput!, $email: String!) {
  billingRequestFlowCreate(
    email: $email
    redirectUrl: $redirectUrl
    exitUrl: $exitUrl
    existingCustomerId: $existingCustomerId
    address: $address
  ) {
    billingRequestId
    billingRequestFlowId
  }
}
    `;
export type billingRequestFlowCreateMutationFn = Apollo.MutationFunction<billingRequestFlowCreate, billingRequestFlowCreateVariables>;

/**
 * __usebillingRequestFlowCreate__
 *
 * To run a mutation, you first call `usebillingRequestFlowCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `usebillingRequestFlowCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingRequestFlowCreate, { data, loading, error }] = usebillingRequestFlowCreate({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *      exitUrl: // value for 'exitUrl'
 *      existingCustomerId: // value for 'existingCustomerId'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *   },
 * });
 */
export function usebillingRequestFlowCreate(baseOptions?: Apollo.MutationHookOptions<billingRequestFlowCreate, billingRequestFlowCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<billingRequestFlowCreate, billingRequestFlowCreateVariables>(billingRequestFlowCreateDocument, options);
      }
export type billingRequestFlowCreateHookResult = ReturnType<typeof usebillingRequestFlowCreate>;
export type billingRequestFlowCreateMutationResult = Apollo.MutationResult<billingRequestFlowCreate>;
export type billingRequestFlowCreateMutationOptions = Apollo.BaseMutationOptions<billingRequestFlowCreate, billingRequestFlowCreateVariables>;
export const CheckoutPageDocument = gql`
    query CheckoutPage($planId: ID!) {
  ...featureFlagFragment
  shippingCountries {
    ...shippingCountryFragment
  }
  guest {
    id
    firstName
    lastName
    email
    assumedShippingCountry {
      ...shippingCountryFragment
    }
    discountCode {
      ...discountCodeFragment
    }
    dogs {
      name
      dailyCalories
      pouchSizeInGrams
    }
    numberOfAffiliateFreeBoxes
    requiresPaymentDetailsOnCheckout
    referredByAmbassador
    referredByInfluencer
    marketingPreference
    affiliateType
    shouldSupportSca
    pendingSubscription {
      plan {
        durationInDays
        durationInWeeks
        numberOfPouches
        pouchSize
        id
        trial {
          lengthInDays
        }
        pouchesPerDay
        gramsPerDayPerDogs {
          dogId
          gramsPerDay
          name
        }
        nextUpcomingPrice {
          effectiveFrom
        }
      }
      productVariants {
        productVariant {
          ...productVariantFragment
        }
        discountedPrice
      }
      pendingSubscriptionFlavours {
        flavour {
          ...orderSummaryFlavourFragment
          standardPricePerDay(planId: $planId)
        }
        id
        servings
        sevenDayServings
        trialBoxServings
      }
    }
  }
}
    ${featureFlagFragment}
${shippingCountryFragment}
${discountCodeFragment}
${productVariantFragment}
${orderSummaryFlavourFragment}`;

/**
 * __useCheckoutPage__
 *
 * To run a query within a React component, call `useCheckoutPage` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPage` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPage({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useCheckoutPage(baseOptions: Apollo.QueryHookOptions<CheckoutPage, CheckoutPageVariables> & ({ variables: CheckoutPageVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutPage, CheckoutPageVariables>(CheckoutPageDocument, options);
      }
export function useCheckoutPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutPage, CheckoutPageVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutPage, CheckoutPageVariables>(CheckoutPageDocument, options);
        }
export function useCheckoutPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutPage, CheckoutPageVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutPage, CheckoutPageVariables>(CheckoutPageDocument, options);
        }
export type CheckoutPageHookResult = ReturnType<typeof useCheckoutPage>;
export type CheckoutPageLazyQueryHookResult = ReturnType<typeof useCheckoutPageLazyQuery>;
export type CheckoutPageSuspenseQueryHookResult = ReturnType<typeof useCheckoutPageSuspenseQuery>;
export type CheckoutPageQueryResult = Apollo.QueryResult<CheckoutPage, CheckoutPageVariables>;
export const CheckoutPendingSubscriptionOrderPricingQueryDocument = gql`
    query CheckoutPendingSubscriptionOrderPricingQuery($expectedFirstShippingDate: ISO8601Date, $planId: ID!) {
  shouldSeeUpcomingPriceRiseInfo: featureFlag(
    flag: "system-should-see-upcoming-price-rise-info"
    fallback: "false"
  )
  guest {
    id
    pendingSubscription {
      id
      standardOrderPricing(expectedFirstShippingDate: $expectedFirstShippingDate) {
        ...pendingSubscriptionOrderPricingFragment
      }
      firstOrderPricing(expectedFirstShippingDate: $expectedFirstShippingDate) {
        ...pendingSubscriptionOrderPricingFragment
      }
      secondOrderPricing(expectedFirstShippingDate: $expectedFirstShippingDate) {
        ...pendingSubscriptionOrderPricingFragment
      }
      plan {
        durationInDays
        numberOfPouches
        pouchSize
        id
        trial {
          lengthInDays
        }
        pouchesPerDay
        nextUpcomingPrice {
          effectiveFrom
        }
      }
      pendingSubscriptionFlavours {
        id
        flavour {
          id
          standardPricePerDay(planId: $planId)
        }
      }
      productVariants {
        productVariant {
          id
          name
          grossPrice
          recurringDeliveryType {
            netPrice
          }
          productVariantDeliveryTypes {
            deliveryType
            netPrice
          }
          productCollection {
            name
            merchandisingImage {
              src
            }
          }
        }
        discountedPrice
      }
    }
  }
}
    ${pendingSubscriptionOrderPricingFragment}`;

/**
 * __useCheckoutPendingSubscriptionOrderPricingQuery__
 *
 * To run a query within a React component, call `useCheckoutPendingSubscriptionOrderPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPendingSubscriptionOrderPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPendingSubscriptionOrderPricingQuery({
 *   variables: {
 *      expectedFirstShippingDate: // value for 'expectedFirstShippingDate'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useCheckoutPendingSubscriptionOrderPricingQuery(baseOptions: Apollo.QueryHookOptions<CheckoutPendingSubscriptionOrderPricingQuery, CheckoutPendingSubscriptionOrderPricingQueryVariables> & ({ variables: CheckoutPendingSubscriptionOrderPricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutPendingSubscriptionOrderPricingQuery, CheckoutPendingSubscriptionOrderPricingQueryVariables>(CheckoutPendingSubscriptionOrderPricingQueryDocument, options);
      }
export function useCheckoutPendingSubscriptionOrderPricingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutPendingSubscriptionOrderPricingQuery, CheckoutPendingSubscriptionOrderPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutPendingSubscriptionOrderPricingQuery, CheckoutPendingSubscriptionOrderPricingQueryVariables>(CheckoutPendingSubscriptionOrderPricingQueryDocument, options);
        }
export function useCheckoutPendingSubscriptionOrderPricingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutPendingSubscriptionOrderPricingQuery, CheckoutPendingSubscriptionOrderPricingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutPendingSubscriptionOrderPricingQuery, CheckoutPendingSubscriptionOrderPricingQueryVariables>(CheckoutPendingSubscriptionOrderPricingQueryDocument, options);
        }
export type CheckoutPendingSubscriptionOrderPricingQueryHookResult = ReturnType<typeof useCheckoutPendingSubscriptionOrderPricingQuery>;
export type CheckoutPendingSubscriptionOrderPricingQueryLazyQueryHookResult = ReturnType<typeof useCheckoutPendingSubscriptionOrderPricingQueryLazyQuery>;
export type CheckoutPendingSubscriptionOrderPricingQuerySuspenseQueryHookResult = ReturnType<typeof useCheckoutPendingSubscriptionOrderPricingQuerySuspenseQuery>;
export type CheckoutPendingSubscriptionOrderPricingQueryQueryResult = Apollo.QueryResult<CheckoutPendingSubscriptionOrderPricingQuery, CheckoutPendingSubscriptionOrderPricingQueryVariables>;
export const DeliveryDatesDocument = gql`
    query DeliveryDates($postcode: String!, $city: String!) {
  defaultSelectedDate(
    postcode: $postcode
    city: $city
    shouldOfferSundayAsDefault: true
  ) {
    date
    deliverable
    endOfLeadTime
  }
  standardDeliveryFee
}
    `;

/**
 * __useDeliveryDates__
 *
 * To run a query within a React component, call `useDeliveryDates` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryDates` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryDates({
 *   variables: {
 *      postcode: // value for 'postcode'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useDeliveryDates(baseOptions: Apollo.QueryHookOptions<DeliveryDates, DeliveryDatesVariables> & ({ variables: DeliveryDatesVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryDates, DeliveryDatesVariables>(DeliveryDatesDocument, options);
      }
export function useDeliveryDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryDates, DeliveryDatesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryDates, DeliveryDatesVariables>(DeliveryDatesDocument, options);
        }
export function useDeliveryDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeliveryDates, DeliveryDatesVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeliveryDates, DeliveryDatesVariables>(DeliveryDatesDocument, options);
        }
export type DeliveryDatesHookResult = ReturnType<typeof useDeliveryDates>;
export type DeliveryDatesLazyQueryHookResult = ReturnType<typeof useDeliveryDatesLazyQuery>;
export type DeliveryDatesSuspenseQueryHookResult = ReturnType<typeof useDeliveryDatesSuspenseQuery>;
export type DeliveryDatesQueryResult = Apollo.QueryResult<DeliveryDates, DeliveryDatesVariables>;
export const DiscountCopyQueryDocument = gql`
    query DiscountCopyQuery {
  guest {
    id
    discountCode {
      id
      discountCodeParts {
        discountBasis
        discountType
        n
        value
      }
    }
  }
}
    `;

/**
 * __useDiscountCopyQuery__
 *
 * To run a query within a React component, call `useDiscountCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountCopyQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiscountCopyQuery(baseOptions?: Apollo.QueryHookOptions<DiscountCopyQuery, DiscountCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountCopyQuery, DiscountCopyQueryVariables>(DiscountCopyQueryDocument, options);
      }
export function useDiscountCopyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountCopyQuery, DiscountCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountCopyQuery, DiscountCopyQueryVariables>(DiscountCopyQueryDocument, options);
        }
export function useDiscountCopyQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountCopyQuery, DiscountCopyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountCopyQuery, DiscountCopyQueryVariables>(DiscountCopyQueryDocument, options);
        }
export type DiscountCopyQueryHookResult = ReturnType<typeof useDiscountCopyQuery>;
export type DiscountCopyQueryLazyQueryHookResult = ReturnType<typeof useDiscountCopyQueryLazyQuery>;
export type DiscountCopyQuerySuspenseQueryHookResult = ReturnType<typeof useDiscountCopyQuerySuspenseQuery>;
export type DiscountCopyQueryQueryResult = Apollo.QueryResult<DiscountCopyQuery, DiscountCopyQueryVariables>;
export const gocardlessUserParamCreateDocument = gql`
    mutation gocardlessUserParamCreate($planId: ID!, $email: String!, $userParams: String!) {
  gocardlessUserParamCreate(
    planId: $planId
    email: $email
    userParams: $userParams
  ) {
    gocardlessUserParam {
      id
    }
  }
}
    `;
export type gocardlessUserParamCreateMutationFn = Apollo.MutationFunction<gocardlessUserParamCreate, gocardlessUserParamCreateVariables>;

/**
 * __usegocardlessUserParamCreate__
 *
 * To run a mutation, you first call `usegocardlessUserParamCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `usegocardlessUserParamCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gocardlessUserParamCreate, { data, loading, error }] = usegocardlessUserParamCreate({
 *   variables: {
 *      planId: // value for 'planId'
 *      email: // value for 'email'
 *      userParams: // value for 'userParams'
 *   },
 * });
 */
export function usegocardlessUserParamCreate(baseOptions?: Apollo.MutationHookOptions<gocardlessUserParamCreate, gocardlessUserParamCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<gocardlessUserParamCreate, gocardlessUserParamCreateVariables>(gocardlessUserParamCreateDocument, options);
      }
export type gocardlessUserParamCreateHookResult = ReturnType<typeof usegocardlessUserParamCreate>;
export type gocardlessUserParamCreateMutationResult = Apollo.MutationResult<gocardlessUserParamCreate>;
export type gocardlessUserParamCreateMutationOptions = Apollo.BaseMutationOptions<gocardlessUserParamCreate, gocardlessUserParamCreateVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($email: String!, $password: String!) {
  signInAuthorisedSubscribedCheckoutUser(email: $email, password: $password) {
    token
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUser, LoginUserVariables>;

/**
 * __useLoginUser__
 *
 * To run a mutation, you first call `useLoginUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUser, { data, loading, error }] = useLoginUser({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUser(baseOptions?: Apollo.MutationHookOptions<LoginUser, LoginUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUser, LoginUserVariables>(LoginUserDocument, options);
      }
export type LoginUserHookResult = ReturnType<typeof useLoginUser>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUser>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUser, LoginUserVariables>;
export const UserTypeQueryDocument = gql`
    query UserTypeQuery {
  currentUser {
    __typename
  }
}
    `;

/**
 * __useUserTypeQuery__
 *
 * To run a query within a React component, call `useUserTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTypeQuery(baseOptions?: Apollo.QueryHookOptions<UserTypeQuery, UserTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTypeQuery, UserTypeQueryVariables>(UserTypeQueryDocument, options);
      }
export function useUserTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTypeQuery, UserTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTypeQuery, UserTypeQueryVariables>(UserTypeQueryDocument, options);
        }
export function useUserTypeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTypeQuery, UserTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserTypeQuery, UserTypeQueryVariables>(UserTypeQueryDocument, options);
        }
export type UserTypeQueryHookResult = ReturnType<typeof useUserTypeQuery>;
export type UserTypeQueryLazyQueryHookResult = ReturnType<typeof useUserTypeQueryLazyQuery>;
export type UserTypeQuerySuspenseQueryHookResult = ReturnType<typeof useUserTypeQuerySuspenseQuery>;
export type UserTypeQueryQueryResult = Apollo.QueryResult<UserTypeQuery, UserTypeQueryVariables>;
export const PlanConfirmationQueryDocument = gql`
    query PlanConfirmationQuery($numOfBoxes: Int!) {
  user {
    id
    subscription {
      id
      status
      nextNBoxes(num: $numOfBoxes) {
        id
        isoDeliveryDate
        editable
      }
      nextEditableBox {
        isoDeliveryDate
      }
    }
  }
}
    `;

/**
 * __usePlanConfirmationQuery__
 *
 * To run a query within a React component, call `usePlanConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanConfirmationQuery({
 *   variables: {
 *      numOfBoxes: // value for 'numOfBoxes'
 *   },
 * });
 */
export function usePlanConfirmationQuery(baseOptions: Apollo.QueryHookOptions<PlanConfirmationQuery, PlanConfirmationQueryVariables> & ({ variables: PlanConfirmationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanConfirmationQuery, PlanConfirmationQueryVariables>(PlanConfirmationQueryDocument, options);
      }
export function usePlanConfirmationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanConfirmationQuery, PlanConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanConfirmationQuery, PlanConfirmationQueryVariables>(PlanConfirmationQueryDocument, options);
        }
export function usePlanConfirmationQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanConfirmationQuery, PlanConfirmationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanConfirmationQuery, PlanConfirmationQueryVariables>(PlanConfirmationQueryDocument, options);
        }
export type PlanConfirmationQueryHookResult = ReturnType<typeof usePlanConfirmationQuery>;
export type PlanConfirmationQueryLazyQueryHookResult = ReturnType<typeof usePlanConfirmationQueryLazyQuery>;
export type PlanConfirmationQuerySuspenseQueryHookResult = ReturnType<typeof usePlanConfirmationQuerySuspenseQuery>;
export type PlanConfirmationQueryQueryResult = Apollo.QueryResult<PlanConfirmationQuery, PlanConfirmationQueryVariables>;
export const SmsDeliveryReminderMutationDocument = gql`
    mutation SmsDeliveryReminderMutation($smsDeliveryReminder: Boolean!) {
  smsDeliveryReminderUpdate(smsDeliveryReminder: $smsDeliveryReminder) {
    id
    shouldSendSmsDeliveryReminder
  }
}
    `;
export type SmsDeliveryReminderMutationMutationFn = Apollo.MutationFunction<SmsDeliveryReminderMutation, SmsDeliveryReminderMutationVariables>;

/**
 * __useSmsDeliveryReminderMutation__
 *
 * To run a mutation, you first call `useSmsDeliveryReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSmsDeliveryReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [smsDeliveryReminderMutation, { data, loading, error }] = useSmsDeliveryReminderMutation({
 *   variables: {
 *      smsDeliveryReminder: // value for 'smsDeliveryReminder'
 *   },
 * });
 */
export function useSmsDeliveryReminderMutation(baseOptions?: Apollo.MutationHookOptions<SmsDeliveryReminderMutation, SmsDeliveryReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SmsDeliveryReminderMutation, SmsDeliveryReminderMutationVariables>(SmsDeliveryReminderMutationDocument, options);
      }
export type SmsDeliveryReminderMutationHookResult = ReturnType<typeof useSmsDeliveryReminderMutation>;
export type SmsDeliveryReminderMutationMutationResult = Apollo.MutationResult<SmsDeliveryReminderMutation>;
export type SmsDeliveryReminderMutationMutationOptions = Apollo.BaseMutationOptions<SmsDeliveryReminderMutation, SmsDeliveryReminderMutationVariables>;
export const SmsDeliveryReminderQueryDocument = gql`
    query SmsDeliveryReminderQuery {
  user {
    id
    shouldSendSmsDeliveryReminder
  }
}
    `;

/**
 * __useSmsDeliveryReminderQuery__
 *
 * To run a query within a React component, call `useSmsDeliveryReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsDeliveryReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsDeliveryReminderQuery({
 *   variables: {
 *   },
 * });
 */
export function useSmsDeliveryReminderQuery(baseOptions?: Apollo.QueryHookOptions<SmsDeliveryReminderQuery, SmsDeliveryReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmsDeliveryReminderQuery, SmsDeliveryReminderQueryVariables>(SmsDeliveryReminderQueryDocument, options);
      }
export function useSmsDeliveryReminderQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsDeliveryReminderQuery, SmsDeliveryReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmsDeliveryReminderQuery, SmsDeliveryReminderQueryVariables>(SmsDeliveryReminderQueryDocument, options);
        }
export function useSmsDeliveryReminderQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmsDeliveryReminderQuery, SmsDeliveryReminderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmsDeliveryReminderQuery, SmsDeliveryReminderQueryVariables>(SmsDeliveryReminderQueryDocument, options);
        }
export type SmsDeliveryReminderQueryHookResult = ReturnType<typeof useSmsDeliveryReminderQuery>;
export type SmsDeliveryReminderQueryLazyQueryHookResult = ReturnType<typeof useSmsDeliveryReminderQueryLazyQuery>;
export type SmsDeliveryReminderQuerySuspenseQueryHookResult = ReturnType<typeof useSmsDeliveryReminderQuerySuspenseQuery>;
export type SmsDeliveryReminderQueryQueryResult = Apollo.QueryResult<SmsDeliveryReminderQuery, SmsDeliveryReminderQueryVariables>;
export const CustomerIssueEntryInputsCreateDocument = gql`
    mutation CustomerIssueEntryInputsCreate($reporterableType: CustomerIssueManagementReporterable!, $reporterableId: ID!, $entryId: ID!, $reasonId: ID, $inputs: [CustomerIssueManagementInputInput!]!) {
  response: customerIssueEntryInputsCreate(
    reporterableType: $reporterableType
    reporterableId: $reporterableId
    entryId: $entryId
    reasonId: $reasonId
    inputs: $inputs
  ) {
    entryId
    reportId
    resolutionOffering {
      details {
        ... on CustomerIssueManagementResolutionDetailsApplyDiscount {
          ...applyDiscount
        }
        ... on CustomerIssueManagementResolutionDetailsReplaceBox {
          ...replaceBox
        }
      }
      id
      resolutionType
    }
  }
}
    ${applyDiscount}
${replaceBox}`;
export type CustomerIssueEntryInputsCreateMutationFn = Apollo.MutationFunction<CustomerIssueEntryInputsCreate, CustomerIssueEntryInputsCreateVariables>;

/**
 * __useCustomerIssueEntryInputsCreate__
 *
 * To run a mutation, you first call `useCustomerIssueEntryInputsCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerIssueEntryInputsCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerIssueEntryInputsCreate, { data, loading, error }] = useCustomerIssueEntryInputsCreate({
 *   variables: {
 *      reporterableType: // value for 'reporterableType'
 *      reporterableId: // value for 'reporterableId'
 *      entryId: // value for 'entryId'
 *      reasonId: // value for 'reasonId'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCustomerIssueEntryInputsCreate(baseOptions?: Apollo.MutationHookOptions<CustomerIssueEntryInputsCreate, CustomerIssueEntryInputsCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerIssueEntryInputsCreate, CustomerIssueEntryInputsCreateVariables>(CustomerIssueEntryInputsCreateDocument, options);
      }
export type CustomerIssueEntryInputsCreateHookResult = ReturnType<typeof useCustomerIssueEntryInputsCreate>;
export type CustomerIssueEntryInputsCreateMutationResult = Apollo.MutationResult<CustomerIssueEntryInputsCreate>;
export type CustomerIssueEntryInputsCreateMutationOptions = Apollo.BaseMutationOptions<CustomerIssueEntryInputsCreate, CustomerIssueEntryInputsCreateVariables>;
export const CustomerIssueReportCreateDocument = gql`
    mutation CustomerIssueReportCreate($reportableType: CustomerIssueManagementReportable!, $reportableId: ID!, $reporterableType: CustomerIssueManagementReporterable!, $reporterableId: ID!, $categoryId: ID!) {
  response: customerIssueReportCreate(
    reportableType: $reportableType
    reportableId: $reportableId
    reporterableType: $reporterableType
    reporterableId: $reporterableId
    categoryId: $categoryId
  ) {
    categoryReasons {
      id
      presentationalOrder
      reasons {
        description
        id
        key
        name
        parentId
        presentationalOrder
      }
    }
    entryId
    inputFields {
      dataType
      description
      key
      name
      presentationalOrder
      selectionFormat
      __typename
      ... on CustomerIssueManagementInputFieldAssociation {
        allowedAssociationValues {
          __typename
          ... on Product {
            id
          }
        }
        associationType
        associationDisplayType
        id
      }
      ... on CustomerIssueManagementInputFieldString {
        allowedStringValues
        stringDisplayType
        id
      }
      ... on CustomerIssueManagementInputFieldInteger {
        allowedIntegerValues
        integerDisplayType
        id
      }
      ... on CustomerIssueManagementInputFieldBoolean {
        booleanDisplayType
        id
      }
      ... on CustomerIssueManagementInputFieldMultifield {
        multifieldDisplayType
        id
        fields {
          name
          dataType
          presentationalOrder
          selectionFormat
          __typename
          ... on CustomerIssueManagementInputFieldAssociation {
            allowedAssociationValues {
              __typename
              ... on Product {
                id
              }
            }
            associationType
            associationDisplayType
            id
          }
          ... on CustomerIssueManagementInputFieldString {
            allowedStringValues
            stringDisplayType
            id
          }
          ... on CustomerIssueManagementInputFieldInteger {
            allowedIntegerValues
            integerDisplayType
            id
          }
          ... on CustomerIssueManagementInputFieldBoolean {
            booleanDisplayType
            id
          }
        }
      }
    }
    reportId
    resolutionOffering {
      id
      details {
        type
        ... on CustomerIssueManagementResolutionDetailsTrackOrder {
          ...trackOrderResolutionDetailsFields
        }
        ... on CustomerIssueManagementResolutionDetailsHelpCentreArticle {
          ...helpCentreArticleResolutionDetailsFields
        }
      }
      resolutionType
    }
  }
}
    ${trackOrderResolutionDetailsFields}
${helpCentreArticleResolutionDetailsFields}`;
export type CustomerIssueReportCreateMutationFn = Apollo.MutationFunction<CustomerIssueReportCreate, CustomerIssueReportCreateVariables>;

/**
 * __useCustomerIssueReportCreate__
 *
 * To run a mutation, you first call `useCustomerIssueReportCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerIssueReportCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerIssueReportCreate, { data, loading, error }] = useCustomerIssueReportCreate({
 *   variables: {
 *      reportableType: // value for 'reportableType'
 *      reportableId: // value for 'reportableId'
 *      reporterableType: // value for 'reporterableType'
 *      reporterableId: // value for 'reporterableId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useCustomerIssueReportCreate(baseOptions?: Apollo.MutationHookOptions<CustomerIssueReportCreate, CustomerIssueReportCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerIssueReportCreate, CustomerIssueReportCreateVariables>(CustomerIssueReportCreateDocument, options);
      }
export type CustomerIssueReportCreateHookResult = ReturnType<typeof useCustomerIssueReportCreate>;
export type CustomerIssueReportCreateMutationResult = Apollo.MutationResult<CustomerIssueReportCreate>;
export type CustomerIssueReportCreateMutationOptions = Apollo.BaseMutationOptions<CustomerIssueReportCreate, CustomerIssueReportCreateVariables>;
export const CustomerIssueResolutionOfferingAcceptDocument = gql`
    mutation CustomerIssueResolutionOfferingAccept($acceptanceDetails: CustomerIssueManagementResolutionOfferingAcceptanceDetailsInput!) {
  response: customerIssueResolutionOfferingAccept(
    acceptanceDetails: $acceptanceDetails
  ) {
    applicationDetails {
      ... on CustomerIssueManagementResolutionApplicationDetailsReplaceBox {
        resolutionRemnant {
          id
          isoDeliveryDate
        }
      }
      ... on CustomerIssueManagementResolutionApplicationDetailsApplyDiscount {
        resolutionRemnant {
          applicableDiscountParts {
            value
          }
        }
      }
      type
    }
    user {
      id
      shippingCountryCode
      preferredLanguage
    }
  }
}
    `;
export type CustomerIssueResolutionOfferingAcceptMutationFn = Apollo.MutationFunction<CustomerIssueResolutionOfferingAccept, CustomerIssueResolutionOfferingAcceptVariables>;

/**
 * __useCustomerIssueResolutionOfferingAccept__
 *
 * To run a mutation, you first call `useCustomerIssueResolutionOfferingAccept` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerIssueResolutionOfferingAccept` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerIssueResolutionOfferingAccept, { data, loading, error }] = useCustomerIssueResolutionOfferingAccept({
 *   variables: {
 *      acceptanceDetails: // value for 'acceptanceDetails'
 *   },
 * });
 */
export function useCustomerIssueResolutionOfferingAccept(baseOptions?: Apollo.MutationHookOptions<CustomerIssueResolutionOfferingAccept, CustomerIssueResolutionOfferingAcceptVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerIssueResolutionOfferingAccept, CustomerIssueResolutionOfferingAcceptVariables>(CustomerIssueResolutionOfferingAcceptDocument, options);
      }
export type CustomerIssueResolutionOfferingAcceptHookResult = ReturnType<typeof useCustomerIssueResolutionOfferingAccept>;
export type CustomerIssueResolutionOfferingAcceptMutationResult = Apollo.MutationResult<CustomerIssueResolutionOfferingAccept>;
export type CustomerIssueResolutionOfferingAcceptMutationOptions = Apollo.BaseMutationOptions<CustomerIssueResolutionOfferingAccept, CustomerIssueResolutionOfferingAcceptVariables>;
export const CustomerIssueResolutionOfferingRejectDocument = gql`
    mutation CustomerIssueResolutionOfferingReject($rejectionDetails: CustomerIssueManagementResolutionOfferingRejectionDetailsInput!) {
  response: customerIssueResolutionOfferingReject(
    rejectionDetails: $rejectionDetails
  ) {
    resolutionOffering {
      id
    }
  }
}
    `;
export type CustomerIssueResolutionOfferingRejectMutationFn = Apollo.MutationFunction<CustomerIssueResolutionOfferingReject, CustomerIssueResolutionOfferingRejectVariables>;

/**
 * __useCustomerIssueResolutionOfferingReject__
 *
 * To run a mutation, you first call `useCustomerIssueResolutionOfferingReject` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerIssueResolutionOfferingReject` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerIssueResolutionOfferingReject, { data, loading, error }] = useCustomerIssueResolutionOfferingReject({
 *   variables: {
 *      rejectionDetails: // value for 'rejectionDetails'
 *   },
 * });
 */
export function useCustomerIssueResolutionOfferingReject(baseOptions?: Apollo.MutationHookOptions<CustomerIssueResolutionOfferingReject, CustomerIssueResolutionOfferingRejectVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerIssueResolutionOfferingReject, CustomerIssueResolutionOfferingRejectVariables>(CustomerIssueResolutionOfferingRejectDocument, options);
      }
export type CustomerIssueResolutionOfferingRejectHookResult = ReturnType<typeof useCustomerIssueResolutionOfferingReject>;
export type CustomerIssueResolutionOfferingRejectMutationResult = Apollo.MutationResult<CustomerIssueResolutionOfferingReject>;
export type CustomerIssueResolutionOfferingRejectMutationOptions = Apollo.BaseMutationOptions<CustomerIssueResolutionOfferingReject, CustomerIssueResolutionOfferingRejectVariables>;
export const CustomerIssueManagementInitialDataQueryDocument = gql`
    query CustomerIssueManagementInitialDataQuery($reportableType: CustomerIssueManagementReportable!, $reportableId: ID!) {
  shouldSeeSelfResolutions: featureFlag(
    flag: "should_see_self_resolutions"
    fallback: "false"
  )
  user {
    id
    preferredLanguage
    reportable(reportableType: $reportableType, reportableId: $reportableId) {
      isoDeliveryDate
      price
      potentialMissingItems {
        name
        productVariant {
          id
        }
        category
        quantity
        price
        thumbnail
      }
    }
    dogs {
      name
    }
  }
  categories: eligibleCustomerIssueCategories(
    reportableType: $reportableType
    reportableId: $reportableId
  ) {
    description
    id
    key
    name
    parentId
    presentationalOrder(reportableType: $reportableType)
  }
}
    `;

/**
 * __useCustomerIssueManagementInitialDataQuery__
 *
 * To run a query within a React component, call `useCustomerIssueManagementInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerIssueManagementInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerIssueManagementInitialDataQuery({
 *   variables: {
 *      reportableType: // value for 'reportableType'
 *      reportableId: // value for 'reportableId'
 *   },
 * });
 */
export function useCustomerIssueManagementInitialDataQuery(baseOptions: Apollo.QueryHookOptions<CustomerIssueManagementInitialDataQuery, CustomerIssueManagementInitialDataQueryVariables> & ({ variables: CustomerIssueManagementInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerIssueManagementInitialDataQuery, CustomerIssueManagementInitialDataQueryVariables>(CustomerIssueManagementInitialDataQueryDocument, options);
      }
export function useCustomerIssueManagementInitialDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerIssueManagementInitialDataQuery, CustomerIssueManagementInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerIssueManagementInitialDataQuery, CustomerIssueManagementInitialDataQueryVariables>(CustomerIssueManagementInitialDataQueryDocument, options);
        }
export function useCustomerIssueManagementInitialDataQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerIssueManagementInitialDataQuery, CustomerIssueManagementInitialDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerIssueManagementInitialDataQuery, CustomerIssueManagementInitialDataQueryVariables>(CustomerIssueManagementInitialDataQueryDocument, options);
        }
export type CustomerIssueManagementInitialDataQueryHookResult = ReturnType<typeof useCustomerIssueManagementInitialDataQuery>;
export type CustomerIssueManagementInitialDataQueryLazyQueryHookResult = ReturnType<typeof useCustomerIssueManagementInitialDataQueryLazyQuery>;
export type CustomerIssueManagementInitialDataQuerySuspenseQueryHookResult = ReturnType<typeof useCustomerIssueManagementInitialDataQuerySuspenseQuery>;
export type CustomerIssueManagementInitialDataQueryQueryResult = Apollo.QueryResult<CustomerIssueManagementInitialDataQuery, CustomerIssueManagementInitialDataQueryVariables>;
export const FeedingTipsQueryDocument = gql`
    query FeedingTipsQuery {
  user {
    id
    shippingCountryCode
    dogs {
      id
      eaterType
    }
  }
}
    `;

/**
 * __useFeedingTipsQuery__
 *
 * To run a query within a React component, call `useFeedingTipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedingTipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedingTipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeedingTipsQuery(baseOptions?: Apollo.QueryHookOptions<FeedingTipsQuery, FeedingTipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedingTipsQuery, FeedingTipsQueryVariables>(FeedingTipsQueryDocument, options);
      }
export function useFeedingTipsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedingTipsQuery, FeedingTipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedingTipsQuery, FeedingTipsQueryVariables>(FeedingTipsQueryDocument, options);
        }
export function useFeedingTipsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedingTipsQuery, FeedingTipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedingTipsQuery, FeedingTipsQueryVariables>(FeedingTipsQueryDocument, options);
        }
export type FeedingTipsQueryHookResult = ReturnType<typeof useFeedingTipsQuery>;
export type FeedingTipsQueryLazyQueryHookResult = ReturnType<typeof useFeedingTipsQueryLazyQuery>;
export type FeedingTipsQuerySuspenseQueryHookResult = ReturnType<typeof useFeedingTipsQuerySuspenseQuery>;
export type FeedingTipsQueryQueryResult = Apollo.QueryResult<FeedingTipsQuery, FeedingTipsQueryVariables>;
export const SuspendedSectionQueryDocument = gql`
    query SuspendedSectionQuery {
  user {
    id
    subscription {
      id
      status
      suspendedForInsufficientFunds
      activePaymentMethodType
      increasedDeliveryCadencePlan {
        id
      }
    }
  }
}
    `;

/**
 * __useSuspendedSectionQuery__
 *
 * To run a query within a React component, call `useSuspendedSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuspendedSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuspendedSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuspendedSectionQuery(baseOptions?: Apollo.QueryHookOptions<SuspendedSectionQuery, SuspendedSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuspendedSectionQuery, SuspendedSectionQueryVariables>(SuspendedSectionQueryDocument, options);
      }
export function useSuspendedSectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuspendedSectionQuery, SuspendedSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuspendedSectionQuery, SuspendedSectionQueryVariables>(SuspendedSectionQueryDocument, options);
        }
export function useSuspendedSectionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuspendedSectionQuery, SuspendedSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuspendedSectionQuery, SuspendedSectionQueryVariables>(SuspendedSectionQueryDocument, options);
        }
export type SuspendedSectionQueryHookResult = ReturnType<typeof useSuspendedSectionQuery>;
export type SuspendedSectionQueryLazyQueryHookResult = ReturnType<typeof useSuspendedSectionQueryLazyQuery>;
export type SuspendedSectionQuerySuspenseQueryHookResult = ReturnType<typeof useSuspendedSectionQuerySuspenseQuery>;
export type SuspendedSectionQueryQueryResult = Apollo.QueryResult<SuspendedSectionQuery, SuspendedSectionQueryVariables>;
export const sampleProductUpsellableQueryDocument = gql`
    query sampleProductUpsellableQuery {
  user {
    id
    shippingCountryCode
    preferredLanguage
    dogs {
      gender
      name
    }
    subscription {
      upsellableSampleProduct {
        id
        name
        grossPrice
        recurringDeliveryType {
          adjustedGrossPrice
        }
        productCollection {
          id
          slug
          name
          thumbnail {
            src
          }
        }
      }
    }
  }
}
    `;

/**
 * __usesampleProductUpsellableQuery__
 *
 * To run a query within a React component, call `usesampleProductUpsellableQuery` and pass it any options that fit your needs.
 * When your component renders, `usesampleProductUpsellableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usesampleProductUpsellableQuery({
 *   variables: {
 *   },
 * });
 */
export function usesampleProductUpsellableQuery(baseOptions?: Apollo.QueryHookOptions<sampleProductUpsellableQuery, sampleProductUpsellableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<sampleProductUpsellableQuery, sampleProductUpsellableQueryVariables>(sampleProductUpsellableQueryDocument, options);
      }
export function usesampleProductUpsellableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<sampleProductUpsellableQuery, sampleProductUpsellableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<sampleProductUpsellableQuery, sampleProductUpsellableQueryVariables>(sampleProductUpsellableQueryDocument, options);
        }
export function usesampleProductUpsellableQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<sampleProductUpsellableQuery, sampleProductUpsellableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<sampleProductUpsellableQuery, sampleProductUpsellableQueryVariables>(sampleProductUpsellableQueryDocument, options);
        }
export type sampleProductUpsellableQueryHookResult = ReturnType<typeof usesampleProductUpsellableQuery>;
export type sampleProductUpsellableQueryLazyQueryHookResult = ReturnType<typeof usesampleProductUpsellableQueryLazyQuery>;
export type sampleProductUpsellableQuerySuspenseQueryHookResult = ReturnType<typeof usesampleProductUpsellableQuerySuspenseQuery>;
export type sampleProductUpsellableQueryQueryResult = Apollo.QueryResult<sampleProductUpsellableQuery, sampleProductUpsellableQueryVariables>;
export const upcomingBoxQueryDocument = gql`
    query upcomingBoxQuery($offset: Int!, $limit: Int!, $order: String) {
  shouldSeeDeliveryTracking: featureFlag(
    flag: "should_see_delivery_tracking_component"
    fallback: "false"
  )
  settings(names: ["carrier_preferences_enabled"]) {
    name
    value
  }
  user {
    id
    currentDeliveryAreaPreference {
      id
      name
      preferredCarrierService {
        id
        carrier {
          name
        }
      }
    }
    ordersByDate(offset: $offset, limit: $limit, order: $order) {
      ...upcomingBoxOrderFragment
      ...nonCoreUpcomingOrderFragment
    }
    subscription {
      id
      firstBox {
        id
      }
      plan {
        id
        pricePerDay
        nextUpcomingPrice {
          value
          effectiveFrom
        }
      }
    }
  }
}
    ${upcomingBoxOrderFragment}
${nonCoreUpcomingOrderFragment}`;

/**
 * __useupcomingBoxQuery__
 *
 * To run a query within a React component, call `useupcomingBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useupcomingBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useupcomingBoxQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useupcomingBoxQuery(baseOptions: Apollo.QueryHookOptions<upcomingBoxQuery, upcomingBoxQueryVariables> & ({ variables: upcomingBoxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<upcomingBoxQuery, upcomingBoxQueryVariables>(upcomingBoxQueryDocument, options);
      }
export function useupcomingBoxQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<upcomingBoxQuery, upcomingBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<upcomingBoxQuery, upcomingBoxQueryVariables>(upcomingBoxQueryDocument, options);
        }
export function useupcomingBoxQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<upcomingBoxQuery, upcomingBoxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<upcomingBoxQuery, upcomingBoxQueryVariables>(upcomingBoxQueryDocument, options);
        }
export type upcomingBoxQueryHookResult = ReturnType<typeof useupcomingBoxQuery>;
export type upcomingBoxQueryLazyQueryHookResult = ReturnType<typeof useupcomingBoxQueryLazyQuery>;
export type upcomingBoxQuerySuspenseQueryHookResult = ReturnType<typeof useupcomingBoxQuerySuspenseQuery>;
export type upcomingBoxQueryQueryResult = Apollo.QueryResult<upcomingBoxQuery, upcomingBoxQueryVariables>;
export const DashboardQueryDocument = gql`
    query DashboardQuery {
  user {
    id
    shippingCountry {
      id
      code
      currency
    }
    preferredLanguage
    subscription {
      id
    }
  }
}
    `;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardQuery(baseOptions?: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardQueryDocument, options);
      }
export function useDashboardQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardQueryDocument, options);
        }
export function useDashboardQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardQuery, DashboardQueryVariables>(DashboardQueryDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardQueryLazyQueryHookResult = ReturnType<typeof useDashboardQueryLazyQuery>;
export type DashboardQuerySuspenseQueryHookResult = ReturnType<typeof useDashboardQuerySuspenseQuery>;
export type DashboardQueryQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const UpdateBoxDeliveryAddressV3Document = gql`
    mutation UpdateBoxDeliveryAddressV3($userId: ID!, $boxId: ID!, $address: AddressInput!, $num: Int!) {
  boxAddressUpdate(userId: $userId, boxId: $boxId, address: $address) {
    id
    subscription {
      id
      box(boxId: $boxId) {
        id
        address {
          id
          recipientName
          address1
          address2
          city
          postcode
          deliveryNotes
          deliveryCarrier
        }
        isoDeliveryDate
      }
      nextNBoxes(num: $num) {
        id
        isoDeliveryDate
      }
    }
  }
}
    `;
export type UpdateBoxDeliveryAddressV3MutationFn = Apollo.MutationFunction<UpdateBoxDeliveryAddressV3, UpdateBoxDeliveryAddressV3Variables>;

/**
 * __useUpdateBoxDeliveryAddressV3__
 *
 * To run a mutation, you first call `useUpdateBoxDeliveryAddressV3` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoxDeliveryAddressV3` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoxDeliveryAddressV3, { data, loading, error }] = useUpdateBoxDeliveryAddressV3({
 *   variables: {
 *      userId: // value for 'userId'
 *      boxId: // value for 'boxId'
 *      address: // value for 'address'
 *      num: // value for 'num'
 *   },
 * });
 */
export function useUpdateBoxDeliveryAddressV3(baseOptions?: Apollo.MutationHookOptions<UpdateBoxDeliveryAddressV3, UpdateBoxDeliveryAddressV3Variables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBoxDeliveryAddressV3, UpdateBoxDeliveryAddressV3Variables>(UpdateBoxDeliveryAddressV3Document, options);
      }
export type UpdateBoxDeliveryAddressV3HookResult = ReturnType<typeof useUpdateBoxDeliveryAddressV3>;
export type UpdateBoxDeliveryAddressV3MutationResult = Apollo.MutationResult<UpdateBoxDeliveryAddressV3>;
export type UpdateBoxDeliveryAddressV3MutationOptions = Apollo.BaseMutationOptions<UpdateBoxDeliveryAddressV3, UpdateBoxDeliveryAddressV3Variables>;
export const editBoxDeliveryAddressV3QueryDocument = gql`
    query editBoxDeliveryAddressV3Query {
  user {
    id
    currentDeliveryAreaPreference {
      id
      preferredCarrierService {
        id
        deliveryNotesLimit
      }
    }
    subscription {
      id
      nextEditableBox {
        id
        address {
          id
          recipientName
          address1
          address2
          city
          postcode
          deliveryNotes
        }
      }
    }
    shippingCountry {
      id
      code
    }
  }
}
    `;

/**
 * __useeditBoxDeliveryAddressV3Query__
 *
 * To run a query within a React component, call `useeditBoxDeliveryAddressV3Query` and pass it any options that fit your needs.
 * When your component renders, `useeditBoxDeliveryAddressV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useeditBoxDeliveryAddressV3Query({
 *   variables: {
 *   },
 * });
 */
export function useeditBoxDeliveryAddressV3Query(baseOptions?: Apollo.QueryHookOptions<editBoxDeliveryAddressV3Query, editBoxDeliveryAddressV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<editBoxDeliveryAddressV3Query, editBoxDeliveryAddressV3QueryVariables>(editBoxDeliveryAddressV3QueryDocument, options);
      }
export function useeditBoxDeliveryAddressV3QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<editBoxDeliveryAddressV3Query, editBoxDeliveryAddressV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<editBoxDeliveryAddressV3Query, editBoxDeliveryAddressV3QueryVariables>(editBoxDeliveryAddressV3QueryDocument, options);
        }
export function useeditBoxDeliveryAddressV3QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<editBoxDeliveryAddressV3Query, editBoxDeliveryAddressV3QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<editBoxDeliveryAddressV3Query, editBoxDeliveryAddressV3QueryVariables>(editBoxDeliveryAddressV3QueryDocument, options);
        }
export type editBoxDeliveryAddressV3QueryHookResult = ReturnType<typeof useeditBoxDeliveryAddressV3Query>;
export type editBoxDeliveryAddressV3QueryLazyQueryHookResult = ReturnType<typeof useeditBoxDeliveryAddressV3QueryLazyQuery>;
export type editBoxDeliveryAddressV3QuerySuspenseQueryHookResult = ReturnType<typeof useeditBoxDeliveryAddressV3QuerySuspenseQuery>;
export type editBoxDeliveryAddressV3QueryQueryResult = Apollo.QueryResult<editBoxDeliveryAddressV3Query, editBoxDeliveryAddressV3QueryVariables>;
export const upcomingBoxQueryV3Document = gql`
    query upcomingBoxQueryV3($offset: Int!, $limit: Int) {
  shouldSeeDeliveryTracking: featureFlag(
    flag: "should_see_delivery_tracking_component"
    fallback: "false"
  )
  settings(names: ["carrier_preferences_enabled"]) {
    name
    value
  }
  user {
    id
    currentDeliveryAreaPreference {
      id
      name
      preferredCarrierService {
        id
        carrier {
          name
        }
      }
    }
    orders(offset: $offset, limit: $limit) {
      ...upcomingBoxOrderFragmentV3
      ...nonCoreUpcomingOrderFragmentV3
      ...OrderSummaryModalFragment
    }
    preferredLanguage
    shippingCountryCode
    shippingCountry {
      id
      showInvoiceDownloadDirections
    }
    subscription {
      id
      firstBox {
        id
      }
    }
  }
}
    ${upcomingBoxOrderFragmentV3}
${nonCoreUpcomingOrderFragmentV3}
${OrderSummaryModalFragment}`;

/**
 * __useupcomingBoxQueryV3__
 *
 * To run a query within a React component, call `useupcomingBoxQueryV3` and pass it any options that fit your needs.
 * When your component renders, `useupcomingBoxQueryV3` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useupcomingBoxQueryV3({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useupcomingBoxQueryV3(baseOptions: Apollo.QueryHookOptions<upcomingBoxQueryV3, upcomingBoxQueryV3Variables> & ({ variables: upcomingBoxQueryV3Variables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<upcomingBoxQueryV3, upcomingBoxQueryV3Variables>(upcomingBoxQueryV3Document, options);
      }
export function useupcomingBoxQueryV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<upcomingBoxQueryV3, upcomingBoxQueryV3Variables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<upcomingBoxQueryV3, upcomingBoxQueryV3Variables>(upcomingBoxQueryV3Document, options);
        }
export function useupcomingBoxQueryV3SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<upcomingBoxQueryV3, upcomingBoxQueryV3Variables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<upcomingBoxQueryV3, upcomingBoxQueryV3Variables>(upcomingBoxQueryV3Document, options);
        }
export type upcomingBoxQueryV3HookResult = ReturnType<typeof useupcomingBoxQueryV3>;
export type upcomingBoxQueryV3LazyQueryHookResult = ReturnType<typeof useupcomingBoxQueryV3LazyQuery>;
export type upcomingBoxQueryV3SuspenseQueryHookResult = ReturnType<typeof useupcomingBoxQueryV3SuspenseQuery>;
export type upcomingBoxQueryV3QueryResult = Apollo.QueryResult<upcomingBoxQueryV3, upcomingBoxQueryV3Variables>;
export const fetchMoreOrdersQueryDocument = gql`
    query fetchMoreOrdersQuery($offset: Int!, $limit: Int) {
  user {
    id
    orders(offset: $offset, limit: $limit) {
      ...upcomingBoxOrderFragmentV3
      ...nonCoreUpcomingOrderFragmentV3
      ...OrderSummaryModalFragment
    }
  }
}
    ${upcomingBoxOrderFragmentV3}
${nonCoreUpcomingOrderFragmentV3}
${OrderSummaryModalFragment}`;

/**
 * __usefetchMoreOrdersQuery__
 *
 * To run a query within a React component, call `usefetchMoreOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usefetchMoreOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usefetchMoreOrdersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usefetchMoreOrdersQuery(baseOptions: Apollo.QueryHookOptions<fetchMoreOrdersQuery, fetchMoreOrdersQueryVariables> & ({ variables: fetchMoreOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<fetchMoreOrdersQuery, fetchMoreOrdersQueryVariables>(fetchMoreOrdersQueryDocument, options);
      }
export function usefetchMoreOrdersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<fetchMoreOrdersQuery, fetchMoreOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<fetchMoreOrdersQuery, fetchMoreOrdersQueryVariables>(fetchMoreOrdersQueryDocument, options);
        }
export function usefetchMoreOrdersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<fetchMoreOrdersQuery, fetchMoreOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<fetchMoreOrdersQuery, fetchMoreOrdersQueryVariables>(fetchMoreOrdersQueryDocument, options);
        }
export type fetchMoreOrdersQueryHookResult = ReturnType<typeof usefetchMoreOrdersQuery>;
export type fetchMoreOrdersQueryLazyQueryHookResult = ReturnType<typeof usefetchMoreOrdersQueryLazyQuery>;
export type fetchMoreOrdersQuerySuspenseQueryHookResult = ReturnType<typeof usefetchMoreOrdersQuerySuspenseQuery>;
export type fetchMoreOrdersQueryQueryResult = Apollo.QueryResult<fetchMoreOrdersQuery, fetchMoreOrdersQueryVariables>;
export const DashboardV3QueryDocument = gql`
    query DashboardV3Query {
  user {
    id
    preferredLanguage
    shippingCountry {
      id
      code
      currency
    }
    ...SubscriptionOverviewFragment
  }
}
    ${SubscriptionOverviewFragment}`;

/**
 * __useDashboardV3Query__
 *
 * To run a query within a React component, call `useDashboardV3Query` and pass it any options that fit your needs.
 * When your component renders, `useDashboardV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardV3Query({
 *   variables: {
 *   },
 * });
 */
export function useDashboardV3Query(baseOptions?: Apollo.QueryHookOptions<DashboardV3Query, DashboardV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardV3Query, DashboardV3QueryVariables>(DashboardV3QueryDocument, options);
      }
export function useDashboardV3QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardV3Query, DashboardV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardV3Query, DashboardV3QueryVariables>(DashboardV3QueryDocument, options);
        }
export function useDashboardV3QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardV3Query, DashboardV3QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardV3Query, DashboardV3QueryVariables>(DashboardV3QueryDocument, options);
        }
export type DashboardV3QueryHookResult = ReturnType<typeof useDashboardV3Query>;
export type DashboardV3QueryLazyQueryHookResult = ReturnType<typeof useDashboardV3QueryLazyQuery>;
export type DashboardV3QuerySuspenseQueryHookResult = ReturnType<typeof useDashboardV3QuerySuspenseQuery>;
export type DashboardV3QueryQueryResult = Apollo.QueryResult<DashboardV3Query, DashboardV3QueryVariables>;
export const DirectSalesStripeUserParamsSetupIntentCreateDocument = gql`
    mutation DirectSalesStripeUserParamsSetupIntentCreate($subscriptionData: SubscriptionDataInput!, $authenticationType: String!, $paymentIntentId: String!) {
  stripeUserParamsSetupIntentCreate(
    subscriptionData: $subscriptionData
    authenticationType: $authenticationType
    paymentIntentId: $paymentIntentId
  ) {
    paymentIntentId
  }
}
    `;
export type DirectSalesStripeUserParamsSetupIntentCreateMutationFn = Apollo.MutationFunction<DirectSalesStripeUserParamsSetupIntentCreate, DirectSalesStripeUserParamsSetupIntentCreateVariables>;

/**
 * __useDirectSalesStripeUserParamsSetupIntentCreate__
 *
 * To run a mutation, you first call `useDirectSalesStripeUserParamsSetupIntentCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectSalesStripeUserParamsSetupIntentCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directSalesStripeUserParamsSetupIntentCreate, { data, loading, error }] = useDirectSalesStripeUserParamsSetupIntentCreate({
 *   variables: {
 *      subscriptionData: // value for 'subscriptionData'
 *      authenticationType: // value for 'authenticationType'
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useDirectSalesStripeUserParamsSetupIntentCreate(baseOptions?: Apollo.MutationHookOptions<DirectSalesStripeUserParamsSetupIntentCreate, DirectSalesStripeUserParamsSetupIntentCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DirectSalesStripeUserParamsSetupIntentCreate, DirectSalesStripeUserParamsSetupIntentCreateVariables>(DirectSalesStripeUserParamsSetupIntentCreateDocument, options);
      }
export type DirectSalesStripeUserParamsSetupIntentCreateHookResult = ReturnType<typeof useDirectSalesStripeUserParamsSetupIntentCreate>;
export type DirectSalesStripeUserParamsSetupIntentCreateMutationResult = Apollo.MutationResult<DirectSalesStripeUserParamsSetupIntentCreate>;
export type DirectSalesStripeUserParamsSetupIntentCreateMutationOptions = Apollo.BaseMutationOptions<DirectSalesStripeUserParamsSetupIntentCreate, DirectSalesStripeUserParamsSetupIntentCreateVariables>;
export const DirectSalesStripeCustomerCreateDocument = gql`
    mutation DirectSalesStripeCustomerCreate($email: String!, $amount: Int!, $paymentMethodType: String) {
  directSalesStripeCustomerCreate(
    email: $email
    amount: $amount
    paymentMethodType: $paymentMethodType
  ) {
    paymentIntentId
  }
}
    `;
export type DirectSalesStripeCustomerCreateMutationFn = Apollo.MutationFunction<DirectSalesStripeCustomerCreate, DirectSalesStripeCustomerCreateVariables>;

/**
 * __useDirectSalesStripeCustomerCreate__
 *
 * To run a mutation, you first call `useDirectSalesStripeCustomerCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectSalesStripeCustomerCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directSalesStripeCustomerCreate, { data, loading, error }] = useDirectSalesStripeCustomerCreate({
 *   variables: {
 *      email: // value for 'email'
 *      amount: // value for 'amount'
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useDirectSalesStripeCustomerCreate(baseOptions?: Apollo.MutationHookOptions<DirectSalesStripeCustomerCreate, DirectSalesStripeCustomerCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DirectSalesStripeCustomerCreate, DirectSalesStripeCustomerCreateVariables>(DirectSalesStripeCustomerCreateDocument, options);
      }
export type DirectSalesStripeCustomerCreateHookResult = ReturnType<typeof useDirectSalesStripeCustomerCreate>;
export type DirectSalesStripeCustomerCreateMutationResult = Apollo.MutationResult<DirectSalesStripeCustomerCreate>;
export type DirectSalesStripeCustomerCreateMutationOptions = Apollo.BaseMutationOptions<DirectSalesStripeCustomerCreate, DirectSalesStripeCustomerCreateVariables>;
export const DirectSalesAppSubscriptionCreateDocument = gql`
    mutation DirectSalesAppSubscriptionCreate($email: String!, $discountCodeId: ID!, $phoneNumber: String, $password: String, $address: AddressInput!, $subscriptionInput: SubscriptionInput!, $chargedOnBoxOne: Boolean, $supportedMarketingMethodPurposeIds: [ID!]) {
  directSalesSubscriptionCreate(
    discountCodeId: $discountCodeId
    email: $email
    phoneNumber: $phoneNumber
    password: $password
    address: $address
    subscriptionInput: $subscriptionInput
    chargedOnBoxOne: $chargedOnBoxOne
    supportedMarketingMethodPurposeIds: $supportedMarketingMethodPurposeIds
  ) {
    firstDeliveryDate
    userSignInUrl
    userId
    referralLinkUrl
    firstInvoiceStatus
    dsRepTrackingId
    dsRepTeam
  }
}
    `;
export type DirectSalesAppSubscriptionCreateMutationFn = Apollo.MutationFunction<DirectSalesAppSubscriptionCreate, DirectSalesAppSubscriptionCreateVariables>;

/**
 * __useDirectSalesAppSubscriptionCreate__
 *
 * To run a mutation, you first call `useDirectSalesAppSubscriptionCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectSalesAppSubscriptionCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directSalesAppSubscriptionCreate, { data, loading, error }] = useDirectSalesAppSubscriptionCreate({
 *   variables: {
 *      email: // value for 'email'
 *      discountCodeId: // value for 'discountCodeId'
 *      phoneNumber: // value for 'phoneNumber'
 *      password: // value for 'password'
 *      address: // value for 'address'
 *      subscriptionInput: // value for 'subscriptionInput'
 *      chargedOnBoxOne: // value for 'chargedOnBoxOne'
 *      supportedMarketingMethodPurposeIds: // value for 'supportedMarketingMethodPurposeIds'
 *   },
 * });
 */
export function useDirectSalesAppSubscriptionCreate(baseOptions?: Apollo.MutationHookOptions<DirectSalesAppSubscriptionCreate, DirectSalesAppSubscriptionCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DirectSalesAppSubscriptionCreate, DirectSalesAppSubscriptionCreateVariables>(DirectSalesAppSubscriptionCreateDocument, options);
      }
export type DirectSalesAppSubscriptionCreateHookResult = ReturnType<typeof useDirectSalesAppSubscriptionCreate>;
export type DirectSalesAppSubscriptionCreateMutationResult = Apollo.MutationResult<DirectSalesAppSubscriptionCreate>;
export type DirectSalesAppSubscriptionCreateMutationOptions = Apollo.BaseMutationOptions<DirectSalesAppSubscriptionCreate, DirectSalesAppSubscriptionCreateVariables>;
export const SendAppSMSDocument = gql`
    mutation SendAppSMS($userId: ID!) {
  sendAppSms(userId: $userId) {
    success
    errorMessage
  }
}
    `;
export type SendAppSMSMutationFn = Apollo.MutationFunction<SendAppSMS, SendAppSMSVariables>;

/**
 * __useSendAppSMS__
 *
 * To run a mutation, you first call `useSendAppSMS` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAppSMS` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAppSms, { data, loading, error }] = useSendAppSMS({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendAppSMS(baseOptions?: Apollo.MutationHookOptions<SendAppSMS, SendAppSMSVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAppSMS, SendAppSMSVariables>(SendAppSMSDocument, options);
      }
export type SendAppSMSHookResult = ReturnType<typeof useSendAppSMS>;
export type SendAppSMSMutationResult = Apollo.MutationResult<SendAppSMS>;
export type SendAppSMSMutationOptions = Apollo.BaseMutationOptions<SendAppSMS, SendAppSMSVariables>;
export const SendRafSMSDocument = gql`
    mutation SendRafSMS($userId: ID!) {
  sendRafSms(userId: $userId) {
    success
    errorMessage
  }
}
    `;
export type SendRafSMSMutationFn = Apollo.MutationFunction<SendRafSMS, SendRafSMSVariables>;

/**
 * __useSendRafSMS__
 *
 * To run a mutation, you first call `useSendRafSMS` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRafSMS` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRafSms, { data, loading, error }] = useSendRafSMS({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendRafSMS(baseOptions?: Apollo.MutationHookOptions<SendRafSMS, SendRafSMSVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRafSMS, SendRafSMSVariables>(SendRafSMSDocument, options);
      }
export type SendRafSMSHookResult = ReturnType<typeof useSendRafSMS>;
export type SendRafSMSMutationResult = Apollo.MutationResult<SendRafSMS>;
export type SendRafSMSMutationOptions = Apollo.BaseMutationOptions<SendRafSMS, SendRafSMSVariables>;
export const DirectSalesPaymentQueryDocument = gql`
    query DirectSalesPaymentQuery($pendingSubscriptionId: ID!) {
  directSalesPendingSubscription(pendingSubscriptionId: $pendingSubscriptionId) {
    pendingSubscription {
      id
      user {
        id
        email
        preferredLanguage
        firstName
        lastName
        dogs {
          gender
          name
          id
          ageInMonths
          breed {
            id
            key
            name
          }
          dogProfile {
            avatarUrl
            description
          }
          dailyCalories
          dailyGrams
          eaterType
          neutered
          possessivePronoun
          pouchSizeInGrams
          weightInGrams
        }
      }
      plan {
        id
        numberOfPouches
        pouchSize
        pouchesPerDay
        price
        durationInDays
        typeOfPlanForCustomer
        trialLengthInDays
        pricesPerDayPerDogs {
          name
          pricePerDayWithoutDiscount
          pricePerDayWithDiscount
        }
      }
      pendingSubscriptionFlavours {
        id
        flavour {
          name
          slug
          themeColour
          thumbnail {
            src
          }
        }
        trialBoxServings
        sevenDayServings
      }
      productVariants {
        productVariant {
          id
          name
          grossPrice
          discountedPrice
          oneOffDeliveryType {
            netPrice
            adjustedGrossPrice
          }
          productCollection {
            id
            name
          }
        }
        discountedPrice
      }
    }
    address {
      address1
      address2
      city
      postcode
      shippingCountry {
        code
        id
        currency
      }
      recipientName
      deliveryNotes
      deliveryCarrier
    }
    discountCode {
      id
      discountBasis
      value
      n
      discountType
      code
      discountCodeParts {
        value
        discountBasis
        discountType
        n
      }
    }
    consentedToMarketing
    marketingPreferences
    phoneNumber
  }
}
    `;

/**
 * __useDirectSalesPaymentQuery__
 *
 * To run a query within a React component, call `useDirectSalesPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectSalesPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectSalesPaymentQuery({
 *   variables: {
 *      pendingSubscriptionId: // value for 'pendingSubscriptionId'
 *   },
 * });
 */
export function useDirectSalesPaymentQuery(baseOptions: Apollo.QueryHookOptions<DirectSalesPaymentQuery, DirectSalesPaymentQueryVariables> & ({ variables: DirectSalesPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectSalesPaymentQuery, DirectSalesPaymentQueryVariables>(DirectSalesPaymentQueryDocument, options);
      }
export function useDirectSalesPaymentQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectSalesPaymentQuery, DirectSalesPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectSalesPaymentQuery, DirectSalesPaymentQueryVariables>(DirectSalesPaymentQueryDocument, options);
        }
export function useDirectSalesPaymentQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectSalesPaymentQuery, DirectSalesPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectSalesPaymentQuery, DirectSalesPaymentQueryVariables>(DirectSalesPaymentQueryDocument, options);
        }
export type DirectSalesPaymentQueryHookResult = ReturnType<typeof useDirectSalesPaymentQuery>;
export type DirectSalesPaymentQueryLazyQueryHookResult = ReturnType<typeof useDirectSalesPaymentQueryLazyQuery>;
export type DirectSalesPaymentQuerySuspenseQueryHookResult = ReturnType<typeof useDirectSalesPaymentQuerySuspenseQuery>;
export type DirectSalesPaymentQueryQueryResult = Apollo.QueryResult<DirectSalesPaymentQuery, DirectSalesPaymentQueryVariables>;
export const DirectSalesPendingSubscriptionOrderPricesDocument = gql`
    query DirectSalesPendingSubscriptionOrderPrices($planId: ID!, $discountCodeId: ID!, $productVariantIds: [ID!]!, $flavourQuantities: MealInput!, $oneOffProductsPresent: Boolean!) {
  pendingSubscriptionOrderPrices(
    planId: $planId
    productVariantIds: $productVariantIds
    discountCodeId: $discountCodeId
    flavourQuantities: $flavourQuantities
    oneOffProductsPresent: $oneOffProductsPresent
  ) {
    grossTotalPrice
    netTotalPrice
    netTotalPricePerDay
    totalDiscountedAmount
    grossCoreFoodPrice
    netCoreFoodPrice
    coreFoodDiscountedAmount
    grossCoreFoodPricePerDay
    netCoreFoodPricePerDay
    grossRecipeSurchargePrice
    netRecipeSurchargePrice
    recipeSurchargeDiscountedAmount
    grossDeliverySurchargePrice
    netDeliverySurchargePrice
    deliverySurchargeDiscountedAmount
    grossOneOffAdditionalProductsPrice
    additionalProductsDiscountedAmount
    netOneOffAdditionalProductsPrice
    grossAdditionalProductsPrice
    netAdditionalProductsPrice
    additionalProductPrices {
      id
      recurringPrice
      oneOffPrice
      discountedRecurringPrice
      discountedOneOffPrice
    }
  }
}
    `;

/**
 * __useDirectSalesPendingSubscriptionOrderPrices__
 *
 * To run a query within a React component, call `useDirectSalesPendingSubscriptionOrderPrices` and pass it any options that fit your needs.
 * When your component renders, `useDirectSalesPendingSubscriptionOrderPrices` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectSalesPendingSubscriptionOrderPrices({
 *   variables: {
 *      planId: // value for 'planId'
 *      discountCodeId: // value for 'discountCodeId'
 *      productVariantIds: // value for 'productVariantIds'
 *      flavourQuantities: // value for 'flavourQuantities'
 *      oneOffProductsPresent: // value for 'oneOffProductsPresent'
 *   },
 * });
 */
export function useDirectSalesPendingSubscriptionOrderPrices(baseOptions: Apollo.QueryHookOptions<DirectSalesPendingSubscriptionOrderPrices, DirectSalesPendingSubscriptionOrderPricesVariables> & ({ variables: DirectSalesPendingSubscriptionOrderPricesVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectSalesPendingSubscriptionOrderPrices, DirectSalesPendingSubscriptionOrderPricesVariables>(DirectSalesPendingSubscriptionOrderPricesDocument, options);
      }
export function useDirectSalesPendingSubscriptionOrderPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectSalesPendingSubscriptionOrderPrices, DirectSalesPendingSubscriptionOrderPricesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectSalesPendingSubscriptionOrderPrices, DirectSalesPendingSubscriptionOrderPricesVariables>(DirectSalesPendingSubscriptionOrderPricesDocument, options);
        }
export function useDirectSalesPendingSubscriptionOrderPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectSalesPendingSubscriptionOrderPrices, DirectSalesPendingSubscriptionOrderPricesVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectSalesPendingSubscriptionOrderPrices, DirectSalesPendingSubscriptionOrderPricesVariables>(DirectSalesPendingSubscriptionOrderPricesDocument, options);
        }
export type DirectSalesPendingSubscriptionOrderPricesHookResult = ReturnType<typeof useDirectSalesPendingSubscriptionOrderPrices>;
export type DirectSalesPendingSubscriptionOrderPricesLazyQueryHookResult = ReturnType<typeof useDirectSalesPendingSubscriptionOrderPricesLazyQuery>;
export type DirectSalesPendingSubscriptionOrderPricesSuspenseQueryHookResult = ReturnType<typeof useDirectSalesPendingSubscriptionOrderPricesSuspenseQuery>;
export type DirectSalesPendingSubscriptionOrderPricesQueryResult = Apollo.QueryResult<DirectSalesPendingSubscriptionOrderPrices, DirectSalesPendingSubscriptionOrderPricesVariables>;
export const DirectSalesChargeIdFromPaymentIntentIdDocument = gql`
    query DirectSalesChargeIdFromPaymentIntentId($paymentIntentId: String!, $paymentMethodType: PaymentMethodType!) {
  chargeIdFromPaymentIntentId(
    paymentIntentId: $paymentIntentId
    paymentMethodType: $paymentMethodType
  )
}
    `;

/**
 * __useDirectSalesChargeIdFromPaymentIntentId__
 *
 * To run a query within a React component, call `useDirectSalesChargeIdFromPaymentIntentId` and pass it any options that fit your needs.
 * When your component renders, `useDirectSalesChargeIdFromPaymentIntentId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectSalesChargeIdFromPaymentIntentId({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useDirectSalesChargeIdFromPaymentIntentId(baseOptions: Apollo.QueryHookOptions<DirectSalesChargeIdFromPaymentIntentId, DirectSalesChargeIdFromPaymentIntentIdVariables> & ({ variables: DirectSalesChargeIdFromPaymentIntentIdVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectSalesChargeIdFromPaymentIntentId, DirectSalesChargeIdFromPaymentIntentIdVariables>(DirectSalesChargeIdFromPaymentIntentIdDocument, options);
      }
export function useDirectSalesChargeIdFromPaymentIntentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectSalesChargeIdFromPaymentIntentId, DirectSalesChargeIdFromPaymentIntentIdVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectSalesChargeIdFromPaymentIntentId, DirectSalesChargeIdFromPaymentIntentIdVariables>(DirectSalesChargeIdFromPaymentIntentIdDocument, options);
        }
export function useDirectSalesChargeIdFromPaymentIntentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectSalesChargeIdFromPaymentIntentId, DirectSalesChargeIdFromPaymentIntentIdVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectSalesChargeIdFromPaymentIntentId, DirectSalesChargeIdFromPaymentIntentIdVariables>(DirectSalesChargeIdFromPaymentIntentIdDocument, options);
        }
export type DirectSalesChargeIdFromPaymentIntentIdHookResult = ReturnType<typeof useDirectSalesChargeIdFromPaymentIntentId>;
export type DirectSalesChargeIdFromPaymentIntentIdLazyQueryHookResult = ReturnType<typeof useDirectSalesChargeIdFromPaymentIntentIdLazyQuery>;
export type DirectSalesChargeIdFromPaymentIntentIdSuspenseQueryHookResult = ReturnType<typeof useDirectSalesChargeIdFromPaymentIntentIdSuspenseQuery>;
export type DirectSalesChargeIdFromPaymentIntentIdQueryResult = Apollo.QueryResult<DirectSalesChargeIdFromPaymentIntentId, DirectSalesChargeIdFromPaymentIntentIdVariables>;
export const DirectSalesSepaPaymentMethodIdFromIntentSecretDocument = gql`
    query DirectSalesSepaPaymentMethodIdFromIntentSecret($intentSecret: String!, $intentType: IntentType!) {
  sepaPaymentMethodIdFromIntentSecret(
    intentSecret: $intentSecret
    intentType: $intentType
  )
}
    `;

/**
 * __useDirectSalesSepaPaymentMethodIdFromIntentSecret__
 *
 * To run a query within a React component, call `useDirectSalesSepaPaymentMethodIdFromIntentSecret` and pass it any options that fit your needs.
 * When your component renders, `useDirectSalesSepaPaymentMethodIdFromIntentSecret` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectSalesSepaPaymentMethodIdFromIntentSecret({
 *   variables: {
 *      intentSecret: // value for 'intentSecret'
 *      intentType: // value for 'intentType'
 *   },
 * });
 */
export function useDirectSalesSepaPaymentMethodIdFromIntentSecret(baseOptions: Apollo.QueryHookOptions<DirectSalesSepaPaymentMethodIdFromIntentSecret, DirectSalesSepaPaymentMethodIdFromIntentSecretVariables> & ({ variables: DirectSalesSepaPaymentMethodIdFromIntentSecretVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectSalesSepaPaymentMethodIdFromIntentSecret, DirectSalesSepaPaymentMethodIdFromIntentSecretVariables>(DirectSalesSepaPaymentMethodIdFromIntentSecretDocument, options);
      }
export function useDirectSalesSepaPaymentMethodIdFromIntentSecretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectSalesSepaPaymentMethodIdFromIntentSecret, DirectSalesSepaPaymentMethodIdFromIntentSecretVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectSalesSepaPaymentMethodIdFromIntentSecret, DirectSalesSepaPaymentMethodIdFromIntentSecretVariables>(DirectSalesSepaPaymentMethodIdFromIntentSecretDocument, options);
        }
export function useDirectSalesSepaPaymentMethodIdFromIntentSecretSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectSalesSepaPaymentMethodIdFromIntentSecret, DirectSalesSepaPaymentMethodIdFromIntentSecretVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectSalesSepaPaymentMethodIdFromIntentSecret, DirectSalesSepaPaymentMethodIdFromIntentSecretVariables>(DirectSalesSepaPaymentMethodIdFromIntentSecretDocument, options);
        }
export type DirectSalesSepaPaymentMethodIdFromIntentSecretHookResult = ReturnType<typeof useDirectSalesSepaPaymentMethodIdFromIntentSecret>;
export type DirectSalesSepaPaymentMethodIdFromIntentSecretLazyQueryHookResult = ReturnType<typeof useDirectSalesSepaPaymentMethodIdFromIntentSecretLazyQuery>;
export type DirectSalesSepaPaymentMethodIdFromIntentSecretSuspenseQueryHookResult = ReturnType<typeof useDirectSalesSepaPaymentMethodIdFromIntentSecretSuspenseQuery>;
export type DirectSalesSepaPaymentMethodIdFromIntentSecretQueryResult = Apollo.QueryResult<DirectSalesSepaPaymentMethodIdFromIntentSecret, DirectSalesSepaPaymentMethodIdFromIntentSecretVariables>;
export const RetrieveRafUrlDocument = gql`
    query RetrieveRafUrl($id: ID!) {
  user(id: $id) {
    subscription {
      referralLink {
        url
      }
    }
  }
}
    `;

/**
 * __useRetrieveRafUrl__
 *
 * To run a query within a React component, call `useRetrieveRafUrl` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveRafUrl` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveRafUrl({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetrieveRafUrl(baseOptions: Apollo.QueryHookOptions<RetrieveRafUrl, RetrieveRafUrlVariables> & ({ variables: RetrieveRafUrlVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveRafUrl, RetrieveRafUrlVariables>(RetrieveRafUrlDocument, options);
      }
export function useRetrieveRafUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveRafUrl, RetrieveRafUrlVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveRafUrl, RetrieveRafUrlVariables>(RetrieveRafUrlDocument, options);
        }
export function useRetrieveRafUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RetrieveRafUrl, RetrieveRafUrlVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetrieveRafUrl, RetrieveRafUrlVariables>(RetrieveRafUrlDocument, options);
        }
export type RetrieveRafUrlHookResult = ReturnType<typeof useRetrieveRafUrl>;
export type RetrieveRafUrlLazyQueryHookResult = ReturnType<typeof useRetrieveRafUrlLazyQuery>;
export type RetrieveRafUrlSuspenseQueryHookResult = ReturnType<typeof useRetrieveRafUrlSuspenseQuery>;
export type RetrieveRafUrlQueryResult = Apollo.QueryResult<RetrieveRafUrl, RetrieveRafUrlVariables>;
export const ArchiveDogProfileMutationDocument = gql`
    mutation ArchiveDogProfileMutation($dogIds: [ID!]!, $archiveReason: String!) {
  archiveDogs(dogIds: $dogIds, archiveReason: $archiveReason) {
    user {
      id
      dogs {
        id
      }
    }
  }
}
    `;
export type ArchiveDogProfileMutationMutationFn = Apollo.MutationFunction<ArchiveDogProfileMutation, ArchiveDogProfileMutationVariables>;

/**
 * __useArchiveDogProfileMutation__
 *
 * To run a mutation, you first call `useArchiveDogProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDogProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDogProfileMutation, { data, loading, error }] = useArchiveDogProfileMutation({
 *   variables: {
 *      dogIds: // value for 'dogIds'
 *      archiveReason: // value for 'archiveReason'
 *   },
 * });
 */
export function useArchiveDogProfileMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveDogProfileMutation, ArchiveDogProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveDogProfileMutation, ArchiveDogProfileMutationVariables>(ArchiveDogProfileMutationDocument, options);
      }
export type ArchiveDogProfileMutationHookResult = ReturnType<typeof useArchiveDogProfileMutation>;
export type ArchiveDogProfileMutationMutationResult = Apollo.MutationResult<ArchiveDogProfileMutation>;
export type ArchiveDogProfileMutationMutationOptions = Apollo.BaseMutationOptions<ArchiveDogProfileMutation, ArchiveDogProfileMutationVariables>;
export const CreateDogProfileMutationDocument = gql`
    mutation CreateDogProfileMutation($userId: ID!, $dogIdsInput: [ID!]!) {
  dogProfilesCreate(userId: $userId, dogIdsInput: $dogIdsInput) {
    id
  }
}
    `;
export type CreateDogProfileMutationMutationFn = Apollo.MutationFunction<CreateDogProfileMutation, CreateDogProfileMutationVariables>;

/**
 * __useCreateDogProfileMutation__
 *
 * To run a mutation, you first call `useCreateDogProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDogProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDogProfileMutation, { data, loading, error }] = useCreateDogProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      dogIdsInput: // value for 'dogIdsInput'
 *   },
 * });
 */
export function useCreateDogProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateDogProfileMutation, CreateDogProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDogProfileMutation, CreateDogProfileMutationVariables>(CreateDogProfileMutationDocument, options);
      }
export type CreateDogProfileMutationHookResult = ReturnType<typeof useCreateDogProfileMutation>;
export type CreateDogProfileMutationMutationResult = Apollo.MutationResult<CreateDogProfileMutation>;
export type CreateDogProfileMutationMutationOptions = Apollo.BaseMutationOptions<CreateDogProfileMutation, CreateDogProfileMutationVariables>;
export const UpdateDogProfilePictureMutationDocument = gql`
    mutation UpdateDogProfilePictureMutation($userId: ID!, $avatarsInput: [AvatarInput!]!) {
  avatarsUpdate(userId: $userId, avatarsInput: $avatarsInput) {
    id
    dogs {
      id
      dogProfile {
        id
        avatarUrl
      }
    }
  }
}
    `;
export type UpdateDogProfilePictureMutationMutationFn = Apollo.MutationFunction<UpdateDogProfilePictureMutation, UpdateDogProfilePictureMutationVariables>;

/**
 * __useUpdateDogProfilePictureMutation__
 *
 * To run a mutation, you first call `useUpdateDogProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDogProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDogProfilePictureMutation, { data, loading, error }] = useUpdateDogProfilePictureMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      avatarsInput: // value for 'avatarsInput'
 *   },
 * });
 */
export function useUpdateDogProfilePictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDogProfilePictureMutation, UpdateDogProfilePictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDogProfilePictureMutation, UpdateDogProfilePictureMutationVariables>(UpdateDogProfilePictureMutationDocument, options);
      }
export type UpdateDogProfilePictureMutationHookResult = ReturnType<typeof useUpdateDogProfilePictureMutation>;
export type UpdateDogProfilePictureMutationMutationResult = Apollo.MutationResult<UpdateDogProfilePictureMutation>;
export type UpdateDogProfilePictureMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDogProfilePictureMutation, UpdateDogProfilePictureMutationVariables>;
export const DogProfileQueryDocument = gql`
    query DogProfileQuery($caloriesMultipleOf: Int!, $percentageMultipleOf: Int!, $lowerPercentage: Int!, $upperPercentage: Int!) {
  user {
    id
    ...DailyPortionSizeFragment
    firstName
    shippingCountryCode
    preferredLanguage
    shippingCountry {
      id
      showCare
      vetNurseCalendlyUrl
    }
    dogs {
      id
      gender
      eaterType
      snackingHabits
      possessivePronoun
      breed {
        id
        key
        name
      }
      weightInGrams
      bodyShape
      exercise
      neutered
      healthIssues {
        id
        name
      }
      allergens {
        id
        name
      }
      recommendedCareDetails {
        careType
      }
      ...DogSelectionFragment
      ...DogProfilePictureFragment
      ...ArchiveDogProfileActionDogFragment
    }
    ...ShareProfileFragment
    ...ShareRafPassFragment
  }
  ...ArchiveDogProfileActionQueryFragment
}
    ${DailyPortionSizeFragment}
${DogSelectionFragment}
${DogProfilePictureFragment}
${ArchiveDogProfileActionDogFragment}
${ShareProfileFragment}
${ShareRafPassFragment}
${ArchiveDogProfileActionQueryFragment}`;

/**
 * __useDogProfileQuery__
 *
 * To run a query within a React component, call `useDogProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDogProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDogProfileQuery({
 *   variables: {
 *      caloriesMultipleOf: // value for 'caloriesMultipleOf'
 *      percentageMultipleOf: // value for 'percentageMultipleOf'
 *      lowerPercentage: // value for 'lowerPercentage'
 *      upperPercentage: // value for 'upperPercentage'
 *   },
 * });
 */
export function useDogProfileQuery(baseOptions: Apollo.QueryHookOptions<DogProfileQuery, DogProfileQueryVariables> & ({ variables: DogProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DogProfileQuery, DogProfileQueryVariables>(DogProfileQueryDocument, options);
      }
export function useDogProfileQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DogProfileQuery, DogProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DogProfileQuery, DogProfileQueryVariables>(DogProfileQueryDocument, options);
        }
export function useDogProfileQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DogProfileQuery, DogProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DogProfileQuery, DogProfileQueryVariables>(DogProfileQueryDocument, options);
        }
export type DogProfileQueryHookResult = ReturnType<typeof useDogProfileQuery>;
export type DogProfileQueryLazyQueryHookResult = ReturnType<typeof useDogProfileQueryLazyQuery>;
export type DogProfileQuerySuspenseQueryHookResult = ReturnType<typeof useDogProfileQuerySuspenseQuery>;
export type DogProfileQueryQueryResult = Apollo.QueryResult<DogProfileQuery, DogProfileQueryVariables>;
export const DogProfileV2QueryDocument = gql`
    query DogProfileV2Query($caloriesMultipleOf: Int!) {
  user {
    id
    firstName
    shippingCountryCode
    preferredLanguage
    shippingCountry {
      id
      showCare
      vetNurseCalendlyUrl
    }
    subscription {
      id
      plan {
        id
        ...HowToFeedModalTriggerPlanFragment
      }
    }
    dogs {
      id
      ...DogProfilePictureFragment
      ...DogProfilePersonalityDetailsFragment
      ...DogProfileMedicalFragment
      ...DogProfileWeightAndAppetiteFragment
      ...DogSelectionFragment
      ...HowToFeedModalTriggerDogFragment
      ...ArchiveDogProfileActionDogFragment
    }
    ...ShareProfileFragment
    ...ShareRafPassFragment
  }
  ...ArchiveDogProfileActionQueryFragment
}
    ${HowToFeedModalTriggerPlanFragment}
${DogProfilePictureFragment}
${DogProfilePersonalityDetailsFragment}
${DogProfileMedicalFragment}
${DogProfileWeightAndAppetiteFragment}
${DogSelectionFragment}
${HowToFeedModalTriggerDogFragment}
${ArchiveDogProfileActionDogFragment}
${ShareProfileFragment}
${ShareRafPassFragment}
${ArchiveDogProfileActionQueryFragment}`;

/**
 * __useDogProfileV2Query__
 *
 * To run a query within a React component, call `useDogProfileV2Query` and pass it any options that fit your needs.
 * When your component renders, `useDogProfileV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDogProfileV2Query({
 *   variables: {
 *      caloriesMultipleOf: // value for 'caloriesMultipleOf'
 *   },
 * });
 */
export function useDogProfileV2Query(baseOptions: Apollo.QueryHookOptions<DogProfileV2Query, DogProfileV2QueryVariables> & ({ variables: DogProfileV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DogProfileV2Query, DogProfileV2QueryVariables>(DogProfileV2QueryDocument, options);
      }
export function useDogProfileV2QueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DogProfileV2Query, DogProfileV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DogProfileV2Query, DogProfileV2QueryVariables>(DogProfileV2QueryDocument, options);
        }
export function useDogProfileV2QuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DogProfileV2Query, DogProfileV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DogProfileV2Query, DogProfileV2QueryVariables>(DogProfileV2QueryDocument, options);
        }
export type DogProfileV2QueryHookResult = ReturnType<typeof useDogProfileV2Query>;
export type DogProfileV2QueryLazyQueryHookResult = ReturnType<typeof useDogProfileV2QueryLazyQuery>;
export type DogProfileV2QuerySuspenseQueryHookResult = ReturnType<typeof useDogProfileV2QuerySuspenseQuery>;
export type DogProfileV2QueryQueryResult = Apollo.QueryResult<DogProfileV2Query, DogProfileV2QueryVariables>;
export const DownsizeAndSavePageQueryDocument = gql`
    query DownsizeAndSavePageQuery {
  user {
    id
    shippingCountryCode
    preferredLanguage
    dogs {
      id
      gender
    }
    subscription {
      id
      status
      recurringOrder {
        deliveryFee
        planTotal
        planTotalPerDay
      }
      plan {
        id
        pouchSize
        numberOfPouches
        durationInDays
        typeOfPlanForCustomer
        servingSize
        downsizeablePlan {
          id
          price
          pricePerDay
          pouchSize
          numberOfPouches
          durationInDays
          typeOfPlanForCustomer
          servingSize
        }
      }
    }
  }
}
    `;

/**
 * __useDownsizeAndSavePageQuery__
 *
 * To run a query within a React component, call `useDownsizeAndSavePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownsizeAndSavePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownsizeAndSavePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useDownsizeAndSavePageQuery(baseOptions?: Apollo.QueryHookOptions<DownsizeAndSavePageQuery, DownsizeAndSavePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownsizeAndSavePageQuery, DownsizeAndSavePageQueryVariables>(DownsizeAndSavePageQueryDocument, options);
      }
export function useDownsizeAndSavePageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownsizeAndSavePageQuery, DownsizeAndSavePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownsizeAndSavePageQuery, DownsizeAndSavePageQueryVariables>(DownsizeAndSavePageQueryDocument, options);
        }
export function useDownsizeAndSavePageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownsizeAndSavePageQuery, DownsizeAndSavePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownsizeAndSavePageQuery, DownsizeAndSavePageQueryVariables>(DownsizeAndSavePageQueryDocument, options);
        }
export type DownsizeAndSavePageQueryHookResult = ReturnType<typeof useDownsizeAndSavePageQuery>;
export type DownsizeAndSavePageQueryLazyQueryHookResult = ReturnType<typeof useDownsizeAndSavePageQueryLazyQuery>;
export type DownsizeAndSavePageQuerySuspenseQueryHookResult = ReturnType<typeof useDownsizeAndSavePageQuerySuspenseQuery>;
export type DownsizeAndSavePageQueryQueryResult = Apollo.QueryResult<DownsizeAndSavePageQuery, DownsizeAndSavePageQueryVariables>;
export const EditDailyAmountQueryDocument = gql`
    query EditDailyAmountQuery($scopeType: AvailablePlansScopeType, $caloriesMultipleOf: Int!, $lowerPercentage: Int!, $upperPercentage: Int!) {
  user {
    id
    ...EditDailyAmountFragment
  }
}
    ${EditDailyAmountFragment}`;

/**
 * __useEditDailyAmountQuery__
 *
 * To run a query within a React component, call `useEditDailyAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditDailyAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditDailyAmountQuery({
 *   variables: {
 *      scopeType: // value for 'scopeType'
 *      caloriesMultipleOf: // value for 'caloriesMultipleOf'
 *      lowerPercentage: // value for 'lowerPercentage'
 *      upperPercentage: // value for 'upperPercentage'
 *   },
 * });
 */
export function useEditDailyAmountQuery(baseOptions: Apollo.QueryHookOptions<EditDailyAmountQuery, EditDailyAmountQueryVariables> & ({ variables: EditDailyAmountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditDailyAmountQuery, EditDailyAmountQueryVariables>(EditDailyAmountQueryDocument, options);
      }
export function useEditDailyAmountQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditDailyAmountQuery, EditDailyAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditDailyAmountQuery, EditDailyAmountQueryVariables>(EditDailyAmountQueryDocument, options);
        }
export function useEditDailyAmountQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditDailyAmountQuery, EditDailyAmountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditDailyAmountQuery, EditDailyAmountQueryVariables>(EditDailyAmountQueryDocument, options);
        }
export type EditDailyAmountQueryHookResult = ReturnType<typeof useEditDailyAmountQuery>;
export type EditDailyAmountQueryLazyQueryHookResult = ReturnType<typeof useEditDailyAmountQueryLazyQuery>;
export type EditDailyAmountQuerySuspenseQueryHookResult = ReturnType<typeof useEditDailyAmountQuerySuspenseQuery>;
export type EditDailyAmountQueryQueryResult = Apollo.QueryResult<EditDailyAmountQuery, EditDailyAmountQueryVariables>;
export const EditDeliveryFrequencyMutationDocument = gql`
    mutation EditDeliveryFrequencyMutation($userId: ID!, $planId: ID!, $nextNBoxesNum: Int!) {
  subscriptionPlanUpdate(userId: $userId, planId: $planId) {
    id
    subscription {
      id
      plan {
        id
        numberOfPouches
        durationInWeeks
        pricePerDay
        pouchSize
      }
      nextNBoxes(num: $nextNBoxesNum) {
        id
        numberOfPouches
        durationInDays
        isoDeliveryDate
        editable
        plan {
          id
          pouchSize
        }
        ...BoxOrderSummaryModalFragment
      }
    }
  }
}
    ${BoxOrderSummaryModalFragment}`;
export type EditDeliveryFrequencyMutationMutationFn = Apollo.MutationFunction<EditDeliveryFrequencyMutation, EditDeliveryFrequencyMutationVariables>;

/**
 * __useEditDeliveryFrequencyMutation__
 *
 * To run a mutation, you first call `useEditDeliveryFrequencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeliveryFrequencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeliveryFrequencyMutation, { data, loading, error }] = useEditDeliveryFrequencyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      planId: // value for 'planId'
 *      nextNBoxesNum: // value for 'nextNBoxesNum'
 *   },
 * });
 */
export function useEditDeliveryFrequencyMutation(baseOptions?: Apollo.MutationHookOptions<EditDeliveryFrequencyMutation, EditDeliveryFrequencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDeliveryFrequencyMutation, EditDeliveryFrequencyMutationVariables>(EditDeliveryFrequencyMutationDocument, options);
      }
export type EditDeliveryFrequencyMutationHookResult = ReturnType<typeof useEditDeliveryFrequencyMutation>;
export type EditDeliveryFrequencyMutationMutationResult = Apollo.MutationResult<EditDeliveryFrequencyMutation>;
export type EditDeliveryFrequencyMutationMutationOptions = Apollo.BaseMutationOptions<EditDeliveryFrequencyMutation, EditDeliveryFrequencyMutationVariables>;
export const EditDeliveryFrequencyQueryDocument = gql`
    query EditDeliveryFrequencyQuery($scopeType: AvailablePlansScopeType) {
  user {
    id
    ...EditDeliveryFrequencyFragment
  }
}
    ${EditDeliveryFrequencyFragment}`;

/**
 * __useEditDeliveryFrequencyQuery__
 *
 * To run a query within a React component, call `useEditDeliveryFrequencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditDeliveryFrequencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditDeliveryFrequencyQuery({
 *   variables: {
 *      scopeType: // value for 'scopeType'
 *   },
 * });
 */
export function useEditDeliveryFrequencyQuery(baseOptions?: Apollo.QueryHookOptions<EditDeliveryFrequencyQuery, EditDeliveryFrequencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditDeliveryFrequencyQuery, EditDeliveryFrequencyQueryVariables>(EditDeliveryFrequencyQueryDocument, options);
      }
export function useEditDeliveryFrequencyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditDeliveryFrequencyQuery, EditDeliveryFrequencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditDeliveryFrequencyQuery, EditDeliveryFrequencyQueryVariables>(EditDeliveryFrequencyQueryDocument, options);
        }
export function useEditDeliveryFrequencyQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditDeliveryFrequencyQuery, EditDeliveryFrequencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditDeliveryFrequencyQuery, EditDeliveryFrequencyQueryVariables>(EditDeliveryFrequencyQueryDocument, options);
        }
export type EditDeliveryFrequencyQueryHookResult = ReturnType<typeof useEditDeliveryFrequencyQuery>;
export type EditDeliveryFrequencyQueryLazyQueryHookResult = ReturnType<typeof useEditDeliveryFrequencyQueryLazyQuery>;
export type EditDeliveryFrequencyQuerySuspenseQueryHookResult = ReturnType<typeof useEditDeliveryFrequencyQuerySuspenseQuery>;
export type EditDeliveryFrequencyQueryQueryResult = Apollo.QueryResult<EditDeliveryFrequencyQuery, EditDeliveryFrequencyQueryVariables>;
export const DogDetailsQueryDocument = gql`
    query DogDetailsQuery {
  user {
    id
    dogs {
      id
      name
      gender
      dogProfile {
        id
        avatarUrl
      }
      breed {
        id
        key
        name
      }
      ageInMonths
      weightInGrams
      bodyShape
      exercise
      healthIssues {
        id
        name
      }
      allergens {
        id
        name
      }
      neutered
    }
  }
  healthIssues {
    id
    name
    warning
    information
  }
  allergens {
    id
    name
  }
}
    `;

/**
 * __useDogDetailsQuery__
 *
 * To run a query within a React component, call `useDogDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDogDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDogDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDogDetailsQuery(baseOptions?: Apollo.QueryHookOptions<DogDetailsQuery, DogDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DogDetailsQuery, DogDetailsQueryVariables>(DogDetailsQueryDocument, options);
      }
export function useDogDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DogDetailsQuery, DogDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DogDetailsQuery, DogDetailsQueryVariables>(DogDetailsQueryDocument, options);
        }
export function useDogDetailsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DogDetailsQuery, DogDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DogDetailsQuery, DogDetailsQueryVariables>(DogDetailsQueryDocument, options);
        }
export type DogDetailsQueryHookResult = ReturnType<typeof useDogDetailsQuery>;
export type DogDetailsQueryLazyQueryHookResult = ReturnType<typeof useDogDetailsQueryLazyQuery>;
export type DogDetailsQuerySuspenseQueryHookResult = ReturnType<typeof useDogDetailsQuerySuspenseQuery>;
export type DogDetailsQueryQueryResult = Apollo.QueryResult<DogDetailsQuery, DogDetailsQueryVariables>;
export const DogsUpdateDocument = gql`
    mutation DogsUpdate($userId: ID!, $attributes: [DogUpdateInput!]!) {
  dogsUpdate(userId: $userId, attributes: $attributes) {
    dogs {
      id
      name
      gender
      ageInMonths
      ageClassificationByUserWhenCreated
      dailyCalories
      weightInGrams
      bodyShape
      exercise
      healthIssues {
        id
      }
      allergens {
        id
      }
      dogProfile {
        avatarUrl
      }
      neutered
    }
    subscription {
      id
      idealPlan {
        id
        numberOfPouches
        durationInDays
        pricePerPouch
        pouchSize
        pricingCurve {
          pricingCohort
        }
        group
      }
    }
  }
}
    `;
export type DogsUpdateMutationFn = Apollo.MutationFunction<DogsUpdate, DogsUpdateVariables>;

/**
 * __useDogsUpdate__
 *
 * To run a mutation, you first call `useDogsUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDogsUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dogsUpdate, { data, loading, error }] = useDogsUpdate({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDogsUpdate(baseOptions?: Apollo.MutationHookOptions<DogsUpdate, DogsUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DogsUpdate, DogsUpdateVariables>(DogsUpdateDocument, options);
      }
export type DogsUpdateHookResult = ReturnType<typeof useDogsUpdate>;
export type DogsUpdateMutationResult = Apollo.MutationResult<DogsUpdate>;
export type DogsUpdateMutationOptions = Apollo.BaseMutationOptions<DogsUpdate, DogsUpdateVariables>;
export const EditPlanPageQueryDocument = gql`
    query EditPlanPageQuery {
  user {
    id
    preferredLanguage
    shippingCountryCode
    dogs {
      id
      name
      gender
      planPortionInGrams
    }
    subscription {
      id
      status
      meal {
        quantity
        flavour {
          id
          slug
          thumbnail {
            src
          }
        }
      }
      previewUncreatedFutureBox {
        isoDeliveryDate
        plan {
          pricePerDay
          id
        }
      }
    }
  }
}
    `;

/**
 * __useEditPlanPageQuery__
 *
 * To run a query within a React component, call `useEditPlanPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPlanPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPlanPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditPlanPageQuery(baseOptions?: Apollo.QueryHookOptions<EditPlanPageQuery, EditPlanPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditPlanPageQuery, EditPlanPageQueryVariables>(EditPlanPageQueryDocument, options);
      }
export function useEditPlanPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditPlanPageQuery, EditPlanPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditPlanPageQuery, EditPlanPageQueryVariables>(EditPlanPageQueryDocument, options);
        }
export function useEditPlanPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditPlanPageQuery, EditPlanPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditPlanPageQuery, EditPlanPageQueryVariables>(EditPlanPageQueryDocument, options);
        }
export type EditPlanPageQueryHookResult = ReturnType<typeof useEditPlanPageQuery>;
export type EditPlanPageQueryLazyQueryHookResult = ReturnType<typeof useEditPlanPageQueryLazyQuery>;
export type EditPlanPageQuerySuspenseQueryHookResult = ReturnType<typeof useEditPlanPageQuerySuspenseQuery>;
export type EditPlanPageQueryQueryResult = Apollo.QueryResult<EditPlanPageQuery, EditPlanPageQueryVariables>;
export const SaveFreshMealsMutationDocument = gql`
    mutation SaveFreshMealsMutation($userId: ID!, $meal: MealInput!) {
  mealUpdate(userId: $userId, meal: $meal) {
    id
    quantity
    flavour {
      id
      name
      recipeSurcharge
    }
  }
}
    `;
export type SaveFreshMealsMutationMutationFn = Apollo.MutationFunction<SaveFreshMealsMutation, SaveFreshMealsMutationVariables>;

/**
 * __useSaveFreshMealsMutation__
 *
 * To run a mutation, you first call `useSaveFreshMealsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFreshMealsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFreshMealsMutation, { data, loading, error }] = useSaveFreshMealsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      meal: // value for 'meal'
 *   },
 * });
 */
export function useSaveFreshMealsMutation(baseOptions?: Apollo.MutationHookOptions<SaveFreshMealsMutation, SaveFreshMealsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFreshMealsMutation, SaveFreshMealsMutationVariables>(SaveFreshMealsMutationDocument, options);
      }
export type SaveFreshMealsMutationHookResult = ReturnType<typeof useSaveFreshMealsMutation>;
export type SaveFreshMealsMutationMutationResult = Apollo.MutationResult<SaveFreshMealsMutation>;
export type SaveFreshMealsMutationMutationOptions = Apollo.BaseMutationOptions<SaveFreshMealsMutation, SaveFreshMealsMutationVariables>;
export const MealFlavoursQueryDocument = gql`
    query MealFlavoursQuery($num: Int!, $calculationType: RecipeSurchargeCalculation = per_serving) {
  user {
    id
    shippingCountry {
      id
      showUpcomingOrderSeeMoreExtras
    }
    dogs {
      id
      name
      gender
      allergens {
        id
        name
        flavours {
          id
          name
          slug
        }
      }
    }
    subscription {
      id
      nextNBoxes(num: $num) {
        id
        isNextEditableBox
        isoDeliveryDate
        amendable
      }
      plan {
        id
        numberOfPouches
        servingType
        pouchSize
        servingInformation {
          pouchesPerServing
        }
      }
      meal {
        id
        quantity
        slug
        flavour {
          id
          slug
          flavourPriority {
            priority
          }
          productBenefits {
            name
            id
            image {
              src
            }
          }
          recipeSurcharge(calculationType: $calculationType)
          name
          thumbnail {
            src
          }
          longDescription(includeHtml: false)
          composition(includeHtml: true)
          additives(includeHtml: true)
          flavourConstituents {
            constituent {
              name
            }
            percentage
          }
          images {
            src
          }
          primaryImage {
            src
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMealFlavoursQuery__
 *
 * To run a query within a React component, call `useMealFlavoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useMealFlavoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMealFlavoursQuery({
 *   variables: {
 *      num: // value for 'num'
 *      calculationType: // value for 'calculationType'
 *   },
 * });
 */
export function useMealFlavoursQuery(baseOptions: Apollo.QueryHookOptions<MealFlavoursQuery, MealFlavoursQueryVariables> & ({ variables: MealFlavoursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MealFlavoursQuery, MealFlavoursQueryVariables>(MealFlavoursQueryDocument, options);
      }
export function useMealFlavoursQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MealFlavoursQuery, MealFlavoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MealFlavoursQuery, MealFlavoursQueryVariables>(MealFlavoursQueryDocument, options);
        }
export function useMealFlavoursQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MealFlavoursQuery, MealFlavoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MealFlavoursQuery, MealFlavoursQueryVariables>(MealFlavoursQueryDocument, options);
        }
export type MealFlavoursQueryHookResult = ReturnType<typeof useMealFlavoursQuery>;
export type MealFlavoursQueryLazyQueryHookResult = ReturnType<typeof useMealFlavoursQueryLazyQuery>;
export type MealFlavoursQuerySuspenseQueryHookResult = ReturnType<typeof useMealFlavoursQuerySuspenseQuery>;
export type MealFlavoursQueryQueryResult = Apollo.QueryResult<MealFlavoursQuery, MealFlavoursQueryVariables>;
export const SaveFreshMealsUpdateQueryDocument = gql`
    query SaveFreshMealsUpdateQuery {
  user {
    id
    subscription {
      id
      nextNBoxes(num: 3) {
        id
        meals {
          id
          quantity
        }
      }
      meal {
        id
        quantity
      }
    }
  }
}
    `;

/**
 * __useSaveFreshMealsUpdateQuery__
 *
 * To run a query within a React component, call `useSaveFreshMealsUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveFreshMealsUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveFreshMealsUpdateQuery({
 *   variables: {
 *   },
 * });
 */
export function useSaveFreshMealsUpdateQuery(baseOptions?: Apollo.QueryHookOptions<SaveFreshMealsUpdateQuery, SaveFreshMealsUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveFreshMealsUpdateQuery, SaveFreshMealsUpdateQueryVariables>(SaveFreshMealsUpdateQueryDocument, options);
      }
export function useSaveFreshMealsUpdateQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveFreshMealsUpdateQuery, SaveFreshMealsUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveFreshMealsUpdateQuery, SaveFreshMealsUpdateQueryVariables>(SaveFreshMealsUpdateQueryDocument, options);
        }
export function useSaveFreshMealsUpdateQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveFreshMealsUpdateQuery, SaveFreshMealsUpdateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveFreshMealsUpdateQuery, SaveFreshMealsUpdateQueryVariables>(SaveFreshMealsUpdateQueryDocument, options);
        }
export type SaveFreshMealsUpdateQueryHookResult = ReturnType<typeof useSaveFreshMealsUpdateQuery>;
export type SaveFreshMealsUpdateQueryLazyQueryHookResult = ReturnType<typeof useSaveFreshMealsUpdateQueryLazyQuery>;
export type SaveFreshMealsUpdateQuerySuspenseQueryHookResult = ReturnType<typeof useSaveFreshMealsUpdateQuerySuspenseQuery>;
export type SaveFreshMealsUpdateQueryQueryResult = Apollo.QueryResult<SaveFreshMealsUpdateQuery, SaveFreshMealsUpdateQueryVariables>;
export const BasketButtonQueryDocument = gql`
    query BasketButtonQuery {
  user {
    id
    basket {
      id
      basketProducts {
        id
        quantity
      }
    }
  }
}
    `;

/**
 * __useBasketButtonQuery__
 *
 * To run a query within a React component, call `useBasketButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasketButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasketButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useBasketButtonQuery(baseOptions?: Apollo.QueryHookOptions<BasketButtonQuery, BasketButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasketButtonQuery, BasketButtonQueryVariables>(BasketButtonQueryDocument, options);
      }
export function useBasketButtonQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasketButtonQuery, BasketButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasketButtonQuery, BasketButtonQueryVariables>(BasketButtonQueryDocument, options);
        }
export function useBasketButtonQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BasketButtonQuery, BasketButtonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BasketButtonQuery, BasketButtonQueryVariables>(BasketButtonQueryDocument, options);
        }
export type BasketButtonQueryHookResult = ReturnType<typeof useBasketButtonQuery>;
export type BasketButtonQueryLazyQueryHookResult = ReturnType<typeof useBasketButtonQueryLazyQuery>;
export type BasketButtonQuerySuspenseQueryHookResult = ReturnType<typeof useBasketButtonQuerySuspenseQuery>;
export type BasketButtonQueryQueryResult = Apollo.QueryResult<BasketButtonQuery, BasketButtonQueryVariables>;
export const BasketProductsUpdateDocument = gql`
    mutation BasketProductsUpdate($userId: ID!, $basketProductVariants: [ProductVariantInput!]!) {
  basketProductsUpdate(
    userId: $userId
    basketProductVariants: $basketProductVariants
  ) {
    user {
      id
      basket {
        basketProducts {
          id
        }
      }
    }
  }
}
    `;
export type BasketProductsUpdateMutationFn = Apollo.MutationFunction<BasketProductsUpdate, BasketProductsUpdateVariables>;

/**
 * __useBasketProductsUpdate__
 *
 * To run a mutation, you first call `useBasketProductsUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasketProductsUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basketProductsUpdate, { data, loading, error }] = useBasketProductsUpdate({
 *   variables: {
 *      userId: // value for 'userId'
 *      basketProductVariants: // value for 'basketProductVariants'
 *   },
 * });
 */
export function useBasketProductsUpdate(baseOptions?: Apollo.MutationHookOptions<BasketProductsUpdate, BasketProductsUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BasketProductsUpdate, BasketProductsUpdateVariables>(BasketProductsUpdateDocument, options);
      }
export type BasketProductsUpdateHookResult = ReturnType<typeof useBasketProductsUpdate>;
export type BasketProductsUpdateMutationResult = Apollo.MutationResult<BasketProductsUpdate>;
export type BasketProductsUpdateMutationOptions = Apollo.BaseMutationOptions<BasketProductsUpdate, BasketProductsUpdateVariables>;
export const nonCoreOrderCreateDocument = gql`
    mutation nonCoreOrderCreate($userId: ID!, $deliveryAddress: AddressInput!, $deliveryDate: ISO8601Date!) {
  nonCoreOrderCreate(
    userId: $userId
    deliveryAddress: $deliveryAddress
    deliveryDate: $deliveryDate
  ) {
    order {
      id
    }
  }
}
    `;
export type nonCoreOrderCreateMutationFn = Apollo.MutationFunction<nonCoreOrderCreate, nonCoreOrderCreateVariables>;

/**
 * __usenonCoreOrderCreate__
 *
 * To run a mutation, you first call `usenonCoreOrderCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `usenonCoreOrderCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nonCoreOrderCreate, { data, loading, error }] = usenonCoreOrderCreate({
 *   variables: {
 *      userId: // value for 'userId'
 *      deliveryAddress: // value for 'deliveryAddress'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function usenonCoreOrderCreate(baseOptions?: Apollo.MutationHookOptions<nonCoreOrderCreate, nonCoreOrderCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<nonCoreOrderCreate, nonCoreOrderCreateVariables>(nonCoreOrderCreateDocument, options);
      }
export type nonCoreOrderCreateHookResult = ReturnType<typeof usenonCoreOrderCreate>;
export type nonCoreOrderCreateMutationResult = Apollo.MutationResult<nonCoreOrderCreate>;
export type nonCoreOrderCreateMutationOptions = Apollo.BaseMutationOptions<nonCoreOrderCreate, nonCoreOrderCreateVariables>;
export const BasketPageQueryDocument = gql`
    query BasketPageQuery {
  user {
    id
    preferredLanguage
    shippingCountryCode
    subscription {
      id
      status
      deliveriesReceived
      activePaymentMethodType
      paymentMethods {
        ... on CreditCardPaymentMethod {
          __typename
          id
          lastFourDigits
          active
        }
      }
    }
    address {
      id
      recipientName
      address1
      address2
      city
      postcode
    }
    nonCoreOrders {
      id
    }
    basket {
      id
      discountedPrice
      grossPrice
      smallOrderFee
      basketProducts {
        id
        grossPrice
        discountedPrice
        quantity
        productVariant {
          id
          name
          productCollection {
            id
            name
            thumbnail {
              src
            }
          }
        }
      }
    }
  }
  nonCoreOrderDeliveryFee
}
    `;

/**
 * __useBasketPageQuery__
 *
 * To run a query within a React component, call `useBasketPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasketPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasketPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useBasketPageQuery(baseOptions?: Apollo.QueryHookOptions<BasketPageQuery, BasketPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasketPageQuery, BasketPageQueryVariables>(BasketPageQueryDocument, options);
      }
export function useBasketPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasketPageQuery, BasketPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasketPageQuery, BasketPageQueryVariables>(BasketPageQueryDocument, options);
        }
export function useBasketPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BasketPageQuery, BasketPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BasketPageQuery, BasketPageQueryVariables>(BasketPageQueryDocument, options);
        }
export type BasketPageQueryHookResult = ReturnType<typeof useBasketPageQuery>;
export type BasketPageQueryLazyQueryHookResult = ReturnType<typeof useBasketPageQueryLazyQuery>;
export type BasketPageQuerySuspenseQueryHookResult = ReturnType<typeof useBasketPageQuerySuspenseQuery>;
export type BasketPageQueryQueryResult = Apollo.QueryResult<BasketPageQuery, BasketPageQueryVariables>;
export const ConfirmationPageQueryDocument = gql`
    query ConfirmationPageQuery($orderId: ID!) {
  user {
    shippingCountryCode
    preferredLanguage
    subscription {
      activePaymentMethodType
      paymentMethods {
        ... on CreditCardPaymentMethod {
          __typename
          lastFourDigits
          active
        }
      }
    }
    nonCoreOrder(orderId: $orderId) {
      address {
        recipientName
        address1
        address2
        city
        postcode
        deliveryNotes
        deliveryCarrier
      }
      invoice {
        grossPrice
        discountedPrice
        status
      }
      orderParts {
        consignment {
          id
          status
        }
        deliveryDate
        deliverySurcharge
        smallOrderSurcharge
        orderProducts {
          discountedPrice
          grossPrice
          quantity
          productVariant {
            name
            productCollection {
              id
              name
              thumbnail {
                src
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useConfirmationPageQuery__
 *
 * To run a query within a React component, call `useConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmationPageQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<ConfirmationPageQuery, ConfirmationPageQueryVariables> & ({ variables: ConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfirmationPageQuery, ConfirmationPageQueryVariables>(ConfirmationPageQueryDocument, options);
      }
export function useConfirmationPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmationPageQuery, ConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfirmationPageQuery, ConfirmationPageQueryVariables>(ConfirmationPageQueryDocument, options);
        }
export function useConfirmationPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfirmationPageQuery, ConfirmationPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfirmationPageQuery, ConfirmationPageQueryVariables>(ConfirmationPageQueryDocument, options);
        }
export type ConfirmationPageQueryHookResult = ReturnType<typeof useConfirmationPageQuery>;
export type ConfirmationPageQueryLazyQueryHookResult = ReturnType<typeof useConfirmationPageQueryLazyQuery>;
export type ConfirmationPageQuerySuspenseQueryHookResult = ReturnType<typeof useConfirmationPageQuerySuspenseQuery>;
export type ConfirmationPageQueryQueryResult = Apollo.QueryResult<ConfirmationPageQuery, ConfirmationPageQueryVariables>;
export const ExtrasListQueryDocument = gql`
    query ExtrasListQuery {
  user {
    id
    shippingCountryCode
    preferredLanguage
  }
  productGroups {
    id
    name
    slug
    description
    thumbnail {
      src
    }
    productCollections {
      id
      slug
      unavailableObject {
        reason
        reasonCopy
      }
      productSticker {
        image {
          src
        }
      }
      name
      discount {
        discountBasis
        value
      }
      productLabel {
        id
        name
      }
      primaryImage {
        src
      }
      productVariants {
        id
        name
        discountedPrice
        grossPrice
        productVariantDeliveryTypes {
          deliveryType
          adjustedGrossPrice
          netPrice
        }
      }
    }
  }
}
    `;

/**
 * __useExtrasListQuery__
 *
 * To run a query within a React component, call `useExtrasListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtrasListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtrasListQuery({
 *   variables: {
 *   },
 * });
 */
export function useExtrasListQuery(baseOptions?: Apollo.QueryHookOptions<ExtrasListQuery, ExtrasListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtrasListQuery, ExtrasListQueryVariables>(ExtrasListQueryDocument, options);
      }
export function useExtrasListQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtrasListQuery, ExtrasListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtrasListQuery, ExtrasListQueryVariables>(ExtrasListQueryDocument, options);
        }
export function useExtrasListQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtrasListQuery, ExtrasListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtrasListQuery, ExtrasListQueryVariables>(ExtrasListQueryDocument, options);
        }
export type ExtrasListQueryHookResult = ReturnType<typeof useExtrasListQuery>;
export type ExtrasListQueryLazyQueryHookResult = ReturnType<typeof useExtrasListQueryLazyQuery>;
export type ExtrasListQuerySuspenseQueryHookResult = ReturnType<typeof useExtrasListQuerySuspenseQuery>;
export type ExtrasListQueryQueryResult = Apollo.QueryResult<ExtrasListQuery, ExtrasListQueryVariables>;
export const orderProductsCreateDocument = gql`
    mutation orderProductsCreate($userId: ID!, $productVariantInput: ProductVariantInput!, $offset: Int!, $limit: Int!, $order: String) {
  orderProductsCreate(userId: $userId, productVariantInput: $productVariantInput) {
    user {
      ordersByDate(offset: $offset, limit: $limit, order: $order) {
        ...upcomingBoxOrderFragment
        ...nonCoreUpcomingOrderFragment
      }
      basket {
        id
        basketProducts {
          id
          quantity
        }
      }
    }
  }
}
    ${upcomingBoxOrderFragment}
${nonCoreUpcomingOrderFragment}`;
export type orderProductsCreateMutationFn = Apollo.MutationFunction<orderProductsCreate, orderProductsCreateVariables>;

/**
 * __useorderProductsCreate__
 *
 * To run a mutation, you first call `useorderProductsCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useorderProductsCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderProductsCreate, { data, loading, error }] = useorderProductsCreate({
 *   variables: {
 *      userId: // value for 'userId'
 *      productVariantInput: // value for 'productVariantInput'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useorderProductsCreate(baseOptions?: Apollo.MutationHookOptions<orderProductsCreate, orderProductsCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<orderProductsCreate, orderProductsCreateVariables>(orderProductsCreateDocument, options);
      }
export type orderProductsCreateHookResult = ReturnType<typeof useorderProductsCreate>;
export type orderProductsCreateMutationResult = Apollo.MutationResult<orderProductsCreate>;
export type orderProductsCreateMutationOptions = Apollo.BaseMutationOptions<orderProductsCreate, orderProductsCreateVariables>;
export const ProductCollectionQueryDocument = gql`
    query ProductCollectionQuery($slug: String!) {
  user {
    id
    shippingCountryCode
    preferredLanguage
    email
    subscription {
      id
      status
      nextEditableBox {
        id
      }
    }
    basket {
      id
      basketProducts {
        id
        quantity
      }
    }
    dogs {
      id
      weightInGrams
    }
  }
  nonCoreOrderDeliveryFee
  productCollection(slug: $slug) {
    id
    name
    slug
    sizeGuide
    images {
      src
    }
    productSticker {
      id
      image {
        src
      }
    }
    productBenefits {
      id
      name
      image {
        src
      }
    }
    averageCustomerRating
    countOfCustomerRatings
    publicCustomerReviews {
      id
      author
      rating
      createdAt
      description
    }
    productVariants {
      id
      name
      slug
      grossPrice
      discountedPrice
      subscribeAndSaveable
      bundleItems {
        quantity
        constituent {
          id
          grossPrice
        }
      }
      productVariantDeliveryTypes {
        deliveryType
        adjustedGrossPrice
        netPrice
      }
      unavailableObject {
        reason
        reasonCopy
      }
    }
    about
    description
  }
}
    `;

/**
 * __useProductCollectionQuery__
 *
 * To run a query within a React component, call `useProductCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCollectionQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProductCollectionQuery(baseOptions: Apollo.QueryHookOptions<ProductCollectionQuery, ProductCollectionQueryVariables> & ({ variables: ProductCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCollectionQuery, ProductCollectionQueryVariables>(ProductCollectionQueryDocument, options);
      }
export function useProductCollectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCollectionQuery, ProductCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCollectionQuery, ProductCollectionQueryVariables>(ProductCollectionQueryDocument, options);
        }
export function useProductCollectionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCollectionQuery, ProductCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCollectionQuery, ProductCollectionQueryVariables>(ProductCollectionQueryDocument, options);
        }
export type ProductCollectionQueryHookResult = ReturnType<typeof useProductCollectionQuery>;
export type ProductCollectionQueryLazyQueryHookResult = ReturnType<typeof useProductCollectionQueryLazyQuery>;
export type ProductCollectionQuerySuspenseQueryHookResult = ReturnType<typeof useProductCollectionQuerySuspenseQuery>;
export type ProductCollectionQueryQueryResult = Apollo.QueryResult<ProductCollectionQuery, ProductCollectionQueryVariables>;
export const SignupInfluencerMutationDocument = gql`
    mutation SignupInfluencerMutation($influencer: SignupInfluencerInput!) {
  signupInfluencer(influencerInput: $influencer) {
    influencer {
      token
    }
  }
}
    `;
export type SignupInfluencerMutationMutationFn = Apollo.MutationFunction<SignupInfluencerMutation, SignupInfluencerMutationVariables>;

/**
 * __useSignupInfluencerMutation__
 *
 * To run a mutation, you first call `useSignupInfluencerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupInfluencerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupInfluencerMutation, { data, loading, error }] = useSignupInfluencerMutation({
 *   variables: {
 *      influencer: // value for 'influencer'
 *   },
 * });
 */
export function useSignupInfluencerMutation(baseOptions?: Apollo.MutationHookOptions<SignupInfluencerMutation, SignupInfluencerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupInfluencerMutation, SignupInfluencerMutationVariables>(SignupInfluencerMutationDocument, options);
      }
export type SignupInfluencerMutationHookResult = ReturnType<typeof useSignupInfluencerMutation>;
export type SignupInfluencerMutationMutationResult = Apollo.MutationResult<SignupInfluencerMutation>;
export type SignupInfluencerMutationMutationOptions = Apollo.BaseMutationOptions<SignupInfluencerMutation, SignupInfluencerMutationVariables>;
export const MFITBPlanOfferQueryDocument = gql`
    query MFITBPlanOfferQuery {
  user {
    id
    shippingCountryCode
    preferredLanguage
    subscription {
      id
      increasedDeliveryCadencePlan {
        id
        durationInWeeks
        pricePerWeek
      }
      plan {
        id
        durationInWeeks
        pricePerWeek
      }
    }
  }
}
    `;

/**
 * __useMFITBPlanOfferQuery__
 *
 * To run a query within a React component, call `useMFITBPlanOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFITBPlanOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFITBPlanOfferQuery({
 *   variables: {
 *   },
 * });
 */
export function useMFITBPlanOfferQuery(baseOptions?: Apollo.QueryHookOptions<MFITBPlanOfferQuery, MFITBPlanOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MFITBPlanOfferQuery, MFITBPlanOfferQueryVariables>(MFITBPlanOfferQueryDocument, options);
      }
export function useMFITBPlanOfferQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MFITBPlanOfferQuery, MFITBPlanOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MFITBPlanOfferQuery, MFITBPlanOfferQueryVariables>(MFITBPlanOfferQueryDocument, options);
        }
export function useMFITBPlanOfferQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MFITBPlanOfferQuery, MFITBPlanOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MFITBPlanOfferQuery, MFITBPlanOfferQueryVariables>(MFITBPlanOfferQueryDocument, options);
        }
export type MFITBPlanOfferQueryHookResult = ReturnType<typeof useMFITBPlanOfferQuery>;
export type MFITBPlanOfferQueryLazyQueryHookResult = ReturnType<typeof useMFITBPlanOfferQueryLazyQuery>;
export type MFITBPlanOfferQuerySuspenseQueryHookResult = ReturnType<typeof useMFITBPlanOfferQuerySuspenseQuery>;
export type MFITBPlanOfferQueryQueryResult = Apollo.QueryResult<MFITBPlanOfferQuery, MFITBPlanOfferQueryVariables>;
export const MyDetailsInitialDataQueryDocument = gql`
    query MyDetailsInitialDataQuery {
  user {
    id
    firstName
    lastName
    shouldSupportSca
    email
    shippingCountryCode
    affiliateType
    preferredLanguage
    token
    subscription {
      id
      accountType
      status
    }
  }
}
    `;

/**
 * __useMyDetailsInitialDataQuery__
 *
 * To run a query within a React component, call `useMyDetailsInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDetailsInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDetailsInitialDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDetailsInitialDataQuery(baseOptions?: Apollo.QueryHookOptions<MyDetailsInitialDataQuery, MyDetailsInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDetailsInitialDataQuery, MyDetailsInitialDataQueryVariables>(MyDetailsInitialDataQueryDocument, options);
      }
export function useMyDetailsInitialDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDetailsInitialDataQuery, MyDetailsInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDetailsInitialDataQuery, MyDetailsInitialDataQueryVariables>(MyDetailsInitialDataQueryDocument, options);
        }
export function useMyDetailsInitialDataQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyDetailsInitialDataQuery, MyDetailsInitialDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyDetailsInitialDataQuery, MyDetailsInitialDataQueryVariables>(MyDetailsInitialDataQueryDocument, options);
        }
export type MyDetailsInitialDataQueryHookResult = ReturnType<typeof useMyDetailsInitialDataQuery>;
export type MyDetailsInitialDataQueryLazyQueryHookResult = ReturnType<typeof useMyDetailsInitialDataQueryLazyQuery>;
export type MyDetailsInitialDataQuerySuspenseQueryHookResult = ReturnType<typeof useMyDetailsInitialDataQuerySuspenseQuery>;
export type MyDetailsInitialDataQueryQueryResult = Apollo.QueryResult<MyDetailsInitialDataQuery, MyDetailsInitialDataQueryVariables>;
export const MyDetailsPersonalDetailsQueryDocument = gql`
    query MyDetailsPersonalDetailsQuery {
  user {
    ...userFragment
  }
}
    ${userFragment}`;

/**
 * __useMyDetailsPersonalDetailsQuery__
 *
 * To run a query within a React component, call `useMyDetailsPersonalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDetailsPersonalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDetailsPersonalDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDetailsPersonalDetailsQuery(baseOptions?: Apollo.QueryHookOptions<MyDetailsPersonalDetailsQuery, MyDetailsPersonalDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDetailsPersonalDetailsQuery, MyDetailsPersonalDetailsQueryVariables>(MyDetailsPersonalDetailsQueryDocument, options);
      }
export function useMyDetailsPersonalDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDetailsPersonalDetailsQuery, MyDetailsPersonalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDetailsPersonalDetailsQuery, MyDetailsPersonalDetailsQueryVariables>(MyDetailsPersonalDetailsQueryDocument, options);
        }
export function useMyDetailsPersonalDetailsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyDetailsPersonalDetailsQuery, MyDetailsPersonalDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyDetailsPersonalDetailsQuery, MyDetailsPersonalDetailsQueryVariables>(MyDetailsPersonalDetailsQueryDocument, options);
        }
export type MyDetailsPersonalDetailsQueryHookResult = ReturnType<typeof useMyDetailsPersonalDetailsQuery>;
export type MyDetailsPersonalDetailsQueryLazyQueryHookResult = ReturnType<typeof useMyDetailsPersonalDetailsQueryLazyQuery>;
export type MyDetailsPersonalDetailsQuerySuspenseQueryHookResult = ReturnType<typeof useMyDetailsPersonalDetailsQuerySuspenseQuery>;
export type MyDetailsPersonalDetailsQueryQueryResult = Apollo.QueryResult<MyDetailsPersonalDetailsQuery, MyDetailsPersonalDetailsQueryVariables>;
export const AddPaymentMethodQueryDocument = gql`
    query AddPaymentMethodQuery {
  user {
    id
    firstName
    lastName
    email
    token
    preferredLanguage
    shippingCountryCode
    affiliateType
    acquisitionChannel
    shippingCountry {
      id
      currency
      availablePaymentMethodSetupMediums {
        inputType
      }
    }
    subscription {
      id
      deliveriesReceived
    }
  }
}
    `;

/**
 * __useAddPaymentMethodQuery__
 *
 * To run a query within a React component, call `useAddPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddPaymentMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<AddPaymentMethodQuery, AddPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddPaymentMethodQuery, AddPaymentMethodQueryVariables>(AddPaymentMethodQueryDocument, options);
      }
export function useAddPaymentMethodQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddPaymentMethodQuery, AddPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddPaymentMethodQuery, AddPaymentMethodQueryVariables>(AddPaymentMethodQueryDocument, options);
        }
export function useAddPaymentMethodQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddPaymentMethodQuery, AddPaymentMethodQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddPaymentMethodQuery, AddPaymentMethodQueryVariables>(AddPaymentMethodQueryDocument, options);
        }
export type AddPaymentMethodQueryHookResult = ReturnType<typeof useAddPaymentMethodQuery>;
export type AddPaymentMethodQueryLazyQueryHookResult = ReturnType<typeof useAddPaymentMethodQueryLazyQuery>;
export type AddPaymentMethodQuerySuspenseQueryHookResult = ReturnType<typeof useAddPaymentMethodQuerySuspenseQuery>;
export type AddPaymentMethodQueryQueryResult = Apollo.QueryResult<AddPaymentMethodQuery, AddPaymentMethodQueryVariables>;
export const ArchivePaymentMethodDocument = gql`
    mutation ArchivePaymentMethod($paymentMethodId: ID!, $archivedType: ArchivedType!) {
  response: archivePaymentMethod(paymentMethodId: $paymentMethodId) {
    user {
      ...PaymentMethodsFragment
    }
  }
}
    ${PaymentMethodsFragment}`;
export type ArchivePaymentMethodMutationFn = Apollo.MutationFunction<ArchivePaymentMethod, ArchivePaymentMethodVariables>;

/**
 * __useArchivePaymentMethod__
 *
 * To run a mutation, you first call `useArchivePaymentMethod` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePaymentMethod` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePaymentMethod, { data, loading, error }] = useArchivePaymentMethod({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *      archivedType: // value for 'archivedType'
 *   },
 * });
 */
export function useArchivePaymentMethod(baseOptions?: Apollo.MutationHookOptions<ArchivePaymentMethod, ArchivePaymentMethodVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePaymentMethod, ArchivePaymentMethodVariables>(ArchivePaymentMethodDocument, options);
      }
export type ArchivePaymentMethodHookResult = ReturnType<typeof useArchivePaymentMethod>;
export type ArchivePaymentMethodMutationResult = Apollo.MutationResult<ArchivePaymentMethod>;
export type ArchivePaymentMethodMutationOptions = Apollo.BaseMutationOptions<ArchivePaymentMethod, ArchivePaymentMethodVariables>;
export const AuthenticationSetupCreateMutationDocument = gql`
    mutation AuthenticationSetupCreateMutation($email: String!, $redirectUrl: String = "", $authenticationType: String!, $provider: String!) {
  authenticationSetupCreate(
    email: $email
    redirectUrl: $redirectUrl
    authenticationType: $authenticationType
    provider: $provider
  ) {
    authenticationSetup {
      id
      redirectUrl
    }
  }
}
    `;
export type AuthenticationSetupCreateMutationMutationFn = Apollo.MutationFunction<AuthenticationSetupCreateMutation, AuthenticationSetupCreateMutationVariables>;

/**
 * __useAuthenticationSetupCreateMutation__
 *
 * To run a mutation, you first call `useAuthenticationSetupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSetupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSetupCreateMutation, { data, loading, error }] = useAuthenticationSetupCreateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      redirectUrl: // value for 'redirectUrl'
 *      authenticationType: // value for 'authenticationType'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useAuthenticationSetupCreateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationSetupCreateMutation, AuthenticationSetupCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationSetupCreateMutation, AuthenticationSetupCreateMutationVariables>(AuthenticationSetupCreateMutationDocument, options);
      }
export type AuthenticationSetupCreateMutationHookResult = ReturnType<typeof useAuthenticationSetupCreateMutation>;
export type AuthenticationSetupCreateMutationMutationResult = Apollo.MutationResult<AuthenticationSetupCreateMutation>;
export type AuthenticationSetupCreateMutationMutationOptions = Apollo.BaseMutationOptions<AuthenticationSetupCreateMutation, AuthenticationSetupCreateMutationVariables>;
export const CreatePaymentMethodMutationDocument = gql`
    mutation CreatePaymentMethodMutation($userId: ID!, $archivedType: ArchivedType, $paymentMethods: [PaymentMethodInput!]!) {
  paymentMethodsCreate(userId: $userId, paymentMethods: $paymentMethods) {
    ...PaymentMethodsFragment
  }
}
    ${PaymentMethodsFragment}`;
export type CreatePaymentMethodMutationMutationFn = Apollo.MutationFunction<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;

/**
 * __useCreatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMethodMutation, { data, loading, error }] = useCreatePaymentMethodMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      archivedType: // value for 'archivedType'
 *      paymentMethods: // value for 'paymentMethods'
 *   },
 * });
 */
export function useCreatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(CreatePaymentMethodMutationDocument, options);
      }
export type CreatePaymentMethodMutationHookResult = ReturnType<typeof useCreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationMutationResult = Apollo.MutationResult<CreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;
export const instantChargeSetupCreateDocument = gql`
    mutation instantChargeSetupCreate($redirectUrl: String) {
  instantChargeSetupCreate(redirectUrl: $redirectUrl) {
    instantChargeSetupToken
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type instantChargeSetupCreateMutationFn = Apollo.MutationFunction<instantChargeSetupCreate, instantChargeSetupCreateVariables>;

/**
 * __useinstantChargeSetupCreate__
 *
 * To run a mutation, you first call `useinstantChargeSetupCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useinstantChargeSetupCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instantChargeSetupCreate, { data, loading, error }] = useinstantChargeSetupCreate({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useinstantChargeSetupCreate(baseOptions?: Apollo.MutationHookOptions<instantChargeSetupCreate, instantChargeSetupCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<instantChargeSetupCreate, instantChargeSetupCreateVariables>(instantChargeSetupCreateDocument, options);
      }
export type instantChargeSetupCreateHookResult = ReturnType<typeof useinstantChargeSetupCreate>;
export type instantChargeSetupCreateMutationResult = Apollo.MutationResult<instantChargeSetupCreate>;
export type instantChargeSetupCreateMutationOptions = Apollo.BaseMutationOptions<instantChargeSetupCreate, instantChargeSetupCreateVariables>;
export const payOverdueInvoicesAndUnsuspendDocument = gql`
    mutation payOverdueInvoicesAndUnsuspend($paymentId: String, $paymentResourceId: String, $paymentResourceType: PaymentResourceType, $provider: String!) {
  payOverdueInvoicesAndUnsuspend(
    paymentId: $paymentId
    paymentResourceId: $paymentResourceId
    paymentResourceType: $paymentResourceType
    provider: $provider
  ) {
    user {
      id
    }
  }
}
    `;
export type payOverdueInvoicesAndUnsuspendMutationFn = Apollo.MutationFunction<payOverdueInvoicesAndUnsuspend, payOverdueInvoicesAndUnsuspendVariables>;

/**
 * __usepayOverdueInvoicesAndUnsuspend__
 *
 * To run a mutation, you first call `usepayOverdueInvoicesAndUnsuspend` within a React component and pass it any options that fit your needs.
 * When your component renders, `usepayOverdueInvoicesAndUnsuspend` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payOverdueInvoicesAndUnsuspend, { data, loading, error }] = usepayOverdueInvoicesAndUnsuspend({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      paymentResourceId: // value for 'paymentResourceId'
 *      paymentResourceType: // value for 'paymentResourceType'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function usepayOverdueInvoicesAndUnsuspend(baseOptions?: Apollo.MutationHookOptions<payOverdueInvoicesAndUnsuspend, payOverdueInvoicesAndUnsuspendVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<payOverdueInvoicesAndUnsuspend, payOverdueInvoicesAndUnsuspendVariables>(payOverdueInvoicesAndUnsuspendDocument, options);
      }
export type payOverdueInvoicesAndUnsuspendHookResult = ReturnType<typeof usepayOverdueInvoicesAndUnsuspend>;
export type payOverdueInvoicesAndUnsuspendMutationResult = Apollo.MutationResult<payOverdueInvoicesAndUnsuspend>;
export type payOverdueInvoicesAndUnsuspendMutationOptions = Apollo.BaseMutationOptions<payOverdueInvoicesAndUnsuspend, payOverdueInvoicesAndUnsuspendVariables>;
export const PaymentMethodSetActiveDocument = gql`
    mutation PaymentMethodSetActive($paymentMethodId: ID!, $archivedType: ArchivedType!) {
  response: paymentMethodSetActive(paymentMethodId: $paymentMethodId) {
    ...PaymentMethodsFragment
  }
}
    ${PaymentMethodsFragment}`;
export type PaymentMethodSetActiveMutationFn = Apollo.MutationFunction<PaymentMethodSetActive, PaymentMethodSetActiveVariables>;

/**
 * __usePaymentMethodSetActive__
 *
 * To run a mutation, you first call `usePaymentMethodSetActive` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodSetActive` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodSetActive, { data, loading, error }] = usePaymentMethodSetActive({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *      archivedType: // value for 'archivedType'
 *   },
 * });
 */
export function usePaymentMethodSetActive(baseOptions?: Apollo.MutationHookOptions<PaymentMethodSetActive, PaymentMethodSetActiveVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodSetActive, PaymentMethodSetActiveVariables>(PaymentMethodSetActiveDocument, options);
      }
export type PaymentMethodSetActiveHookResult = ReturnType<typeof usePaymentMethodSetActive>;
export type PaymentMethodSetActiveMutationResult = Apollo.MutationResult<PaymentMethodSetActive>;
export type PaymentMethodSetActiveMutationOptions = Apollo.BaseMutationOptions<PaymentMethodSetActive, PaymentMethodSetActiveVariables>;
export const SubscriptionUnsuspensionAttemptMutationDocument = gql`
    mutation SubscriptionUnsuspensionAttemptMutation {
  subscriptionUnsuspensionAttempt {
    id
  }
}
    `;
export type SubscriptionUnsuspensionAttemptMutationMutationFn = Apollo.MutationFunction<SubscriptionUnsuspensionAttemptMutation, SubscriptionUnsuspensionAttemptMutationVariables>;

/**
 * __useSubscriptionUnsuspensionAttemptMutation__
 *
 * To run a mutation, you first call `useSubscriptionUnsuspensionAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionUnsuspensionAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionUnsuspensionAttemptMutation, { data, loading, error }] = useSubscriptionUnsuspensionAttemptMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionUnsuspensionAttemptMutation(baseOptions?: Apollo.MutationHookOptions<SubscriptionUnsuspensionAttemptMutation, SubscriptionUnsuspensionAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscriptionUnsuspensionAttemptMutation, SubscriptionUnsuspensionAttemptMutationVariables>(SubscriptionUnsuspensionAttemptMutationDocument, options);
      }
export type SubscriptionUnsuspensionAttemptMutationHookResult = ReturnType<typeof useSubscriptionUnsuspensionAttemptMutation>;
export type SubscriptionUnsuspensionAttemptMutationMutationResult = Apollo.MutationResult<SubscriptionUnsuspensionAttemptMutation>;
export type SubscriptionUnsuspensionAttemptMutationMutationOptions = Apollo.BaseMutationOptions<SubscriptionUnsuspensionAttemptMutation, SubscriptionUnsuspensionAttemptMutationVariables>;
export const PaymentMethodsQueryDocument = gql`
    query PaymentMethodsQuery($archivedType: ArchivedType, $num: Int!) {
  user {
    id
    dogs {
      id
      name
    }
    shippingCountryCode
    preferredLanguage
    subscription {
      id
      status
      activePaymentMethodType
      deliveriesReceived
      nextNBoxes(num: $num) {
        id
        isNextEditableBox
        isFreeBox
      }
    }
    ...PaymentMethodsFragment
  }
}
    ${PaymentMethodsFragment}`;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *      archivedType: // value for 'archivedType'
 *      num: // value for 'num'
 *   },
 * });
 */
export function usePaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables> & ({ variables: PaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsQueryDocument, options);
      }
export function usePaymentMethodsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsQueryDocument, options);
        }
export function usePaymentMethodsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsQueryDocument, options);
        }
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsQueryLazyQueryHookResult = ReturnType<typeof usePaymentMethodsQueryLazyQuery>;
export type PaymentMethodsQuerySuspenseQueryHookResult = ReturnType<typeof usePaymentMethodsQuerySuspenseQuery>;
export type PaymentMethodsQueryQueryResult = Apollo.QueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const NoDogsHeroQueryDocument = gql`
    query NoDogsHeroQuery {
  user {
    id
    firstName
    subscription {
      id
      status
      pauses {
        id
        subreason
        createdAt
      }
    }
  }
}
    `;

/**
 * __useNoDogsHeroQuery__
 *
 * To run a query within a React component, call `useNoDogsHeroQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoDogsHeroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoDogsHeroQuery({
 *   variables: {
 *   },
 * });
 */
export function useNoDogsHeroQuery(baseOptions?: Apollo.QueryHookOptions<NoDogsHeroQuery, NoDogsHeroQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoDogsHeroQuery, NoDogsHeroQueryVariables>(NoDogsHeroQueryDocument, options);
      }
export function useNoDogsHeroQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoDogsHeroQuery, NoDogsHeroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoDogsHeroQuery, NoDogsHeroQueryVariables>(NoDogsHeroQueryDocument, options);
        }
export function useNoDogsHeroQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoDogsHeroQuery, NoDogsHeroQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoDogsHeroQuery, NoDogsHeroQueryVariables>(NoDogsHeroQueryDocument, options);
        }
export type NoDogsHeroQueryHookResult = ReturnType<typeof useNoDogsHeroQuery>;
export type NoDogsHeroQueryLazyQueryHookResult = ReturnType<typeof useNoDogsHeroQueryLazyQuery>;
export type NoDogsHeroQuerySuspenseQueryHookResult = ReturnType<typeof useNoDogsHeroQuerySuspenseQuery>;
export type NoDogsHeroQueryQueryResult = Apollo.QueryResult<NoDogsHeroQuery, NoDogsHeroQueryVariables>;
export const ProductSectionQueryDocument = gql`
    query ProductSectionQuery($limit: Int) {
  user {
    id
    preferredLanguage
    shippingCountryCode
    subscription {
      id
      status
    }
  }
  upsellableProductCollections(limit: $limit) {
    ...productCollectionFragment
  }
}
    ${productCollectionFragment}`;

/**
 * __useProductSectionQuery__
 *
 * To run a query within a React component, call `useProductSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSectionQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductSectionQuery(baseOptions?: Apollo.QueryHookOptions<ProductSectionQuery, ProductSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSectionQuery, ProductSectionQueryVariables>(ProductSectionQueryDocument, options);
      }
export function useProductSectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSectionQuery, ProductSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSectionQuery, ProductSectionQueryVariables>(ProductSectionQueryDocument, options);
        }
export function useProductSectionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSectionQuery, ProductSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductSectionQuery, ProductSectionQueryVariables>(ProductSectionQueryDocument, options);
        }
export type ProductSectionQueryHookResult = ReturnType<typeof useProductSectionQuery>;
export type ProductSectionQueryLazyQueryHookResult = ReturnType<typeof useProductSectionQueryLazyQuery>;
export type ProductSectionQuerySuspenseQueryHookResult = ReturnType<typeof useProductSectionQuerySuspenseQuery>;
export type ProductSectionQueryQueryResult = Apollo.QueryResult<ProductSectionQuery, ProductSectionQueryVariables>;
export const NoDogsPageDataDocument = gql`
    query NoDogsPageData {
  user {
    id
    firstName
    subscription {
      id
      status
      pauses {
        id
        subreason
        createdAt
      }
    }
  }
}
    `;

/**
 * __useNoDogsPageData__
 *
 * To run a query within a React component, call `useNoDogsPageData` and pass it any options that fit your needs.
 * When your component renders, `useNoDogsPageData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoDogsPageData({
 *   variables: {
 *   },
 * });
 */
export function useNoDogsPageData(baseOptions?: Apollo.QueryHookOptions<NoDogsPageData, NoDogsPageDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoDogsPageData, NoDogsPageDataVariables>(NoDogsPageDataDocument, options);
      }
export function useNoDogsPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoDogsPageData, NoDogsPageDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoDogsPageData, NoDogsPageDataVariables>(NoDogsPageDataDocument, options);
        }
export function useNoDogsPageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoDogsPageData, NoDogsPageDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoDogsPageData, NoDogsPageDataVariables>(NoDogsPageDataDocument, options);
        }
export type NoDogsPageDataHookResult = ReturnType<typeof useNoDogsPageData>;
export type NoDogsPageDataLazyQueryHookResult = ReturnType<typeof useNoDogsPageDataLazyQuery>;
export type NoDogsPageDataSuspenseQueryHookResult = ReturnType<typeof useNoDogsPageDataSuspenseQuery>;
export type NoDogsPageDataQueryResult = Apollo.QueryResult<NoDogsPageData, NoDogsPageDataVariables>;
export const NoPaymentMethodPageDataDocument = gql`
    query NoPaymentMethodPageData {
  user {
    id
    preferredLanguage
    shippingCountryCode
    email
    token
    shouldSupportSca
    dogs {
      name
    }
    subscription {
      plan {
        durationInDays
      }
      firstBox {
        price
        cutOffDate
      }
    }
  }
}
    `;

/**
 * __useNoPaymentMethodPageData__
 *
 * To run a query within a React component, call `useNoPaymentMethodPageData` and pass it any options that fit your needs.
 * When your component renders, `useNoPaymentMethodPageData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoPaymentMethodPageData({
 *   variables: {
 *   },
 * });
 */
export function useNoPaymentMethodPageData(baseOptions?: Apollo.QueryHookOptions<NoPaymentMethodPageData, NoPaymentMethodPageDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoPaymentMethodPageData, NoPaymentMethodPageDataVariables>(NoPaymentMethodPageDataDocument, options);
      }
export function useNoPaymentMethodPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoPaymentMethodPageData, NoPaymentMethodPageDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoPaymentMethodPageData, NoPaymentMethodPageDataVariables>(NoPaymentMethodPageDataDocument, options);
        }
export function useNoPaymentMethodPageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoPaymentMethodPageData, NoPaymentMethodPageDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoPaymentMethodPageData, NoPaymentMethodPageDataVariables>(NoPaymentMethodPageDataDocument, options);
        }
export type NoPaymentMethodPageDataHookResult = ReturnType<typeof useNoPaymentMethodPageData>;
export type NoPaymentMethodPageDataLazyQueryHookResult = ReturnType<typeof useNoPaymentMethodPageDataLazyQuery>;
export type NoPaymentMethodPageDataSuspenseQueryHookResult = ReturnType<typeof useNoPaymentMethodPageDataSuspenseQuery>;
export type NoPaymentMethodPageDataQueryResult = Apollo.QueryResult<NoPaymentMethodPageData, NoPaymentMethodPageDataVariables>;
export const oneOffBoxQueryDocument = gql`
    query oneOffBoxQuery {
  user {
    __typename
    id
    shippingCountryCode
    preferredLanguage
    dogs {
      id
      name
      gender
    }
    address {
      id
      address1
      address2
      city
      postcode
      recipientName
      deliveryNotes
      deliveryCarrier
    }
    subscription {
      id
      plan {
        id
        pouchSize
        numberOfPouches
        durationInDays
        pouchesPerDay
      }
      meal {
        quantity
        flavour {
          id
          slug
          thumbnail {
            src
          }
          themeColour
          name
          recipeSurcharge
          productLabels {
            id
            name
            themeColour
          }
        }
      }
      previewUncreatedFutureBox(withDiscounts: false) {
        isoDeliveryDate
        editable
        cutOffDate
        order {
          deliveryFee
          physicalProductsTotal
          planTotal
          planTotalPerDay
          subtotal
          totalPrice
          surchargeTotal
          physicalOrderProducts {
            quantity
            price
            frequency
            requiresPayment
            nonPaymentReason
            discountedPrice
            productVariant {
              subscribeAndSaveable
              name
              grossPrice
              oneOffDeliveryType {
                netPrice
              }
              recurringDeliveryType {
                netPrice
              }
              productCollection {
                name
                thumbnail {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
  shouldSeeRecipeSurchargeTooltips: featureFlag(
    flag: "should_see_recipe_surcharge_tooltips"
    fallback: "false"
  )
  shouldSeeRecipeSurchargePriceIncreasePl: featureFlag(
    flag: "should_see_recipe_surcharge_price_increase_pl"
    fallback: "false"
  )
}
    `;

/**
 * __useoneOffBoxQuery__
 *
 * To run a query within a React component, call `useoneOffBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useoneOffBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useoneOffBoxQuery({
 *   variables: {
 *   },
 * });
 */
export function useoneOffBoxQuery(baseOptions?: Apollo.QueryHookOptions<oneOffBoxQuery, oneOffBoxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<oneOffBoxQuery, oneOffBoxQueryVariables>(oneOffBoxQueryDocument, options);
      }
export function useoneOffBoxQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<oneOffBoxQuery, oneOffBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<oneOffBoxQuery, oneOffBoxQueryVariables>(oneOffBoxQueryDocument, options);
        }
export function useoneOffBoxQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<oneOffBoxQuery, oneOffBoxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<oneOffBoxQuery, oneOffBoxQueryVariables>(oneOffBoxQueryDocument, options);
        }
export type oneOffBoxQueryHookResult = ReturnType<typeof useoneOffBoxQuery>;
export type oneOffBoxQueryLazyQueryHookResult = ReturnType<typeof useoneOffBoxQueryLazyQuery>;
export type oneOffBoxQuerySuspenseQueryHookResult = ReturnType<typeof useoneOffBoxQuerySuspenseQuery>;
export type oneOffBoxQueryQueryResult = Apollo.QueryResult<oneOffBoxQuery, oneOffBoxQueryVariables>;
export const calendarDatesQueryDocument = gql`
    query calendarDatesQuery($userId: ID!, $nDays: Int) {
  calendarDates(nDays: $nDays, userId: $userId) {
    date
    deliverable
  }
}
    `;

/**
 * __usecalendarDatesQuery__
 *
 * To run a query within a React component, call `usecalendarDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usecalendarDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usecalendarDatesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      nDays: // value for 'nDays'
 *   },
 * });
 */
export function usecalendarDatesQuery(baseOptions: Apollo.QueryHookOptions<calendarDatesQuery, calendarDatesQueryVariables> & ({ variables: calendarDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<calendarDatesQuery, calendarDatesQueryVariables>(calendarDatesQueryDocument, options);
      }
export function usecalendarDatesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<calendarDatesQuery, calendarDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<calendarDatesQuery, calendarDatesQueryVariables>(calendarDatesQueryDocument, options);
        }
export function usecalendarDatesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<calendarDatesQuery, calendarDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<calendarDatesQuery, calendarDatesQueryVariables>(calendarDatesQueryDocument, options);
        }
export type calendarDatesQueryHookResult = ReturnType<typeof usecalendarDatesQuery>;
export type calendarDatesQueryLazyQueryHookResult = ReturnType<typeof usecalendarDatesQueryLazyQuery>;
export type calendarDatesQuerySuspenseQueryHookResult = ReturnType<typeof usecalendarDatesQuerySuspenseQuery>;
export type calendarDatesQueryQueryResult = Apollo.QueryResult<calendarDatesQuery, calendarDatesQueryVariables>;
export const OneOffBoxesCreateDocument = gql`
    mutation OneOffBoxesCreate($userId: ID!, $deliveryDate: ISO8601Date!, $address: AddressInput!) {
  oneOffBoxCreate(userId: $userId, deliveryDate: $deliveryDate, address: $address) {
    id
  }
}
    `;
export type OneOffBoxesCreateMutationFn = Apollo.MutationFunction<OneOffBoxesCreate, OneOffBoxesCreateVariables>;

/**
 * __useOneOffBoxesCreate__
 *
 * To run a mutation, you first call `useOneOffBoxesCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOneOffBoxesCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oneOffBoxesCreate, { data, loading, error }] = useOneOffBoxesCreate({
 *   variables: {
 *      userId: // value for 'userId'
 *      deliveryDate: // value for 'deliveryDate'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useOneOffBoxesCreate(baseOptions?: Apollo.MutationHookOptions<OneOffBoxesCreate, OneOffBoxesCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OneOffBoxesCreate, OneOffBoxesCreateVariables>(OneOffBoxesCreateDocument, options);
      }
export type OneOffBoxesCreateHookResult = ReturnType<typeof useOneOffBoxesCreate>;
export type OneOffBoxesCreateMutationResult = Apollo.MutationResult<OneOffBoxesCreate>;
export type OneOffBoxesCreateMutationOptions = Apollo.BaseMutationOptions<OneOffBoxesCreate, OneOffBoxesCreateVariables>;
export const BoxDeliveryAddressUpdateDocument = gql`
    mutation BoxDeliveryAddressUpdate($userId: ID!, $boxId: ID!, $address: AddressInput!) {
  boxAddressUpdate(userId: $userId, boxId: $boxId, address: $address) {
    subscription {
      id
      box(boxId: $boxId) {
        address {
          id
          recipientName
          address1
          address2
          city
          postcode
          deliveryNotes
          deliveryCarrier
        }
      }
    }
  }
}
    `;
export type BoxDeliveryAddressUpdateMutationFn = Apollo.MutationFunction<BoxDeliveryAddressUpdate, BoxDeliveryAddressUpdateVariables>;

/**
 * __useBoxDeliveryAddressUpdate__
 *
 * To run a mutation, you first call `useBoxDeliveryAddressUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoxDeliveryAddressUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boxDeliveryAddressUpdate, { data, loading, error }] = useBoxDeliveryAddressUpdate({
 *   variables: {
 *      userId: // value for 'userId'
 *      boxId: // value for 'boxId'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useBoxDeliveryAddressUpdate(baseOptions?: Apollo.MutationHookOptions<BoxDeliveryAddressUpdate, BoxDeliveryAddressUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BoxDeliveryAddressUpdate, BoxDeliveryAddressUpdateVariables>(BoxDeliveryAddressUpdateDocument, options);
      }
export type BoxDeliveryAddressUpdateHookResult = ReturnType<typeof useBoxDeliveryAddressUpdate>;
export type BoxDeliveryAddressUpdateMutationResult = Apollo.MutationResult<BoxDeliveryAddressUpdate>;
export type BoxDeliveryAddressUpdateMutationOptions = Apollo.BaseMutationOptions<BoxDeliveryAddressUpdate, BoxDeliveryAddressUpdateVariables>;
export const BoxDeliveryDateUpdateDocument = gql`
    mutation BoxDeliveryDateUpdate($userId: ID!, $boxId: ID!, $selectedDeliveryDate: ISO8601Date!, $adjustFutureBoxDates: Boolean!, $triggerEvents: Boolean) {
  boxDeliveryDateUpdate(
    userId: $userId
    boxId: $boxId
    date: $selectedDeliveryDate
    adjustFutureBoxDates: $adjustFutureBoxDates
    triggerEvents: $triggerEvents
  ) {
    subscription {
      id
      box(boxId: $boxId) {
        id
        isoDeliveryDate
        cutOffDate
      }
    }
  }
}
    `;
export type BoxDeliveryDateUpdateMutationFn = Apollo.MutationFunction<BoxDeliveryDateUpdate, BoxDeliveryDateUpdateVariables>;

/**
 * __useBoxDeliveryDateUpdate__
 *
 * To run a mutation, you first call `useBoxDeliveryDateUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoxDeliveryDateUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boxDeliveryDateUpdate, { data, loading, error }] = useBoxDeliveryDateUpdate({
 *   variables: {
 *      userId: // value for 'userId'
 *      boxId: // value for 'boxId'
 *      selectedDeliveryDate: // value for 'selectedDeliveryDate'
 *      adjustFutureBoxDates: // value for 'adjustFutureBoxDates'
 *      triggerEvents: // value for 'triggerEvents'
 *   },
 * });
 */
export function useBoxDeliveryDateUpdate(baseOptions?: Apollo.MutationHookOptions<BoxDeliveryDateUpdate, BoxDeliveryDateUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BoxDeliveryDateUpdate, BoxDeliveryDateUpdateVariables>(BoxDeliveryDateUpdateDocument, options);
      }
export type BoxDeliveryDateUpdateHookResult = ReturnType<typeof useBoxDeliveryDateUpdate>;
export type BoxDeliveryDateUpdateMutationResult = Apollo.MutationResult<BoxDeliveryDateUpdate>;
export type BoxDeliveryDateUpdateMutationOptions = Apollo.BaseMutationOptions<BoxDeliveryDateUpdate, BoxDeliveryDateUpdateVariables>;
export const boxQueryDocument = gql`
    query boxQuery($boxId: ID!) {
  user {
    id
    shippingCountryCode
    shippingCountry {
      id
      showUpcomingOrderSeeMoreExtras
      showExtras
      showInvoiceDownloadDirections
    }
    preferredLanguage
    dogs {
      gender
      name
    }
    subscription {
      id
      upsellableSampleProduct {
        id
        name
        grossPrice
        recurringDeliveryType {
          adjustedGrossPrice
        }
        productCollection {
          id
          slug
          name
          thumbnail {
            src
          }
          productVariants {
            id
            ...PriceFragment
          }
        }
      }
      plan {
        id
        pouchSize
      }
      nextNBoxes(num: 3) {
        id
        isNextEditableBox
      }
      box(boxId: $boxId) {
        id
        descriptor
        isFreeBox
        isReplacementBox
        invoices {
          id
          issueDate
          corrective
          grossTotal
        }
        meals {
          id
          quantity
        }
        invoice {
          id
        }
        shouldOfferSelfService
        totalGrams
        consignment {
          id
          trackingUrl
          status
        }
        editable
        amendable
        id
        cutOffDate
        isoDeliveryDate
        address {
          id
          recipientName
          address1
          address2
          city
          postcode
          deliveryNotes
          deliveryCarrier
        }
        order {
          id
          deliveryFee
          discountTotal
          discountTotalPercentage
          physicalProductsTotal
          planTotal
          planTotalPerDay
          subtotal
          totalPrice
          surchargeTotal
        }
        physicalOrderProducts {
          id
          requiresPayment
          nonPaymentReason
          quantity
          frequency
          price
          discountedPrice
          productVariant {
            id
            name
            grossPrice
            oneOffDeliveryType {
              netPrice
            }
            recurringDeliveryType {
              adjustedGrossPrice
              netPrice
            }
            subscribeAndSaveable
            productCollection {
              id
              slug
              name
              thumbnail {
                src
              }
              productVariants {
                id
                name
                ...PriceFragment
              }
            }
          }
        }
      }
    }
  }
}
    ${PriceFragment}`;

/**
 * __useboxQuery__
 *
 * To run a query within a React component, call `useboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useboxQuery({
 *   variables: {
 *      boxId: // value for 'boxId'
 *   },
 * });
 */
export function useboxQuery(baseOptions: Apollo.QueryHookOptions<boxQuery, boxQueryVariables> & ({ variables: boxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<boxQuery, boxQueryVariables>(boxQueryDocument, options);
      }
export function useboxQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<boxQuery, boxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<boxQuery, boxQueryVariables>(boxQueryDocument, options);
        }
export function useboxQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<boxQuery, boxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<boxQuery, boxQueryVariables>(boxQueryDocument, options);
        }
export type boxQueryHookResult = ReturnType<typeof useboxQuery>;
export type boxQueryLazyQueryHookResult = ReturnType<typeof useboxQueryLazyQuery>;
export type boxQuerySuspenseQueryHookResult = ReturnType<typeof useboxQuerySuspenseQuery>;
export type boxQueryQueryResult = Apollo.QueryResult<boxQuery, boxQueryVariables>;
export const mealsQueryDocument = gql`
    query mealsQuery($boxId: ID!) {
  user {
    id
    subscription {
      id
      box(boxId: $boxId) {
        id
        editable
        meals {
          quantity
          flavour {
            id
            thumbnail {
              src
            }
            themeColour
            name
            slug
            recipeSurcharge
            productLabels {
              id
              name
              themeColour
            }
          }
        }
      }
    }
  }
  shouldSeeRecipeSurchargeTooltips: featureFlag(
    flag: "should_see_recipe_surcharge_tooltips"
    fallback: "false"
  )
  shouldSeeRecipeSurchargePriceIncreasePl: featureFlag(
    flag: "should_see_recipe_surcharge_price_increase_pl"
    fallback: "false"
  )
}
    `;

/**
 * __usemealsQuery__
 *
 * To run a query within a React component, call `usemealsQuery` and pass it any options that fit your needs.
 * When your component renders, `usemealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usemealsQuery({
 *   variables: {
 *      boxId: // value for 'boxId'
 *   },
 * });
 */
export function usemealsQuery(baseOptions: Apollo.QueryHookOptions<mealsQuery, mealsQueryVariables> & ({ variables: mealsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<mealsQuery, mealsQueryVariables>(mealsQueryDocument, options);
      }
export function usemealsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<mealsQuery, mealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<mealsQuery, mealsQueryVariables>(mealsQueryDocument, options);
        }
export function usemealsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<mealsQuery, mealsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<mealsQuery, mealsQueryVariables>(mealsQueryDocument, options);
        }
export type mealsQueryHookResult = ReturnType<typeof usemealsQuery>;
export type mealsQueryLazyQueryHookResult = ReturnType<typeof usemealsQueryLazyQuery>;
export type mealsQuerySuspenseQueryHookResult = ReturnType<typeof usemealsQuerySuspenseQuery>;
export type mealsQueryQueryResult = Apollo.QueryResult<mealsQuery, mealsQueryVariables>;
export const pastOrderQueryDocument = gql`
    query pastOrderQuery($to: ISO8601Date!, $offset: Int!, $limit: Int!, $order: String) {
  user {
    id
    shippingCountryCode
    ordersByDate(to: $to, offset: $offset, limit: $limit, order: $order) {
      __typename
      ... on Box {
        id
        ...boxOrderFragment
      }
      ... on NonCoreOrder {
        id
        ...nonCoreOrderFragment
      }
    }
  }
}
    ${boxOrderFragment}
${nonCoreOrderFragment}`;

/**
 * __usepastOrderQuery__
 *
 * To run a query within a React component, call `usepastOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usepastOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usepastOrderQuery({
 *   variables: {
 *      to: // value for 'to'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usepastOrderQuery(baseOptions: Apollo.QueryHookOptions<pastOrderQuery, pastOrderQueryVariables> & ({ variables: pastOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<pastOrderQuery, pastOrderQueryVariables>(pastOrderQueryDocument, options);
      }
export function usepastOrderQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<pastOrderQuery, pastOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<pastOrderQuery, pastOrderQueryVariables>(pastOrderQueryDocument, options);
        }
export function usepastOrderQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<pastOrderQuery, pastOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<pastOrderQuery, pastOrderQueryVariables>(pastOrderQueryDocument, options);
        }
export type pastOrderQueryHookResult = ReturnType<typeof usepastOrderQuery>;
export type pastOrderQueryLazyQueryHookResult = ReturnType<typeof usepastOrderQueryLazyQuery>;
export type pastOrderQuerySuspenseQueryHookResult = ReturnType<typeof usepastOrderQuerySuspenseQuery>;
export type pastOrderQueryQueryResult = Apollo.QueryResult<pastOrderQuery, pastOrderQueryVariables>;
export const upcomingOrderQueryDocument = gql`
    query upcomingOrderQuery($offset: Int!, $limit: Int!) {
  user {
    id
    shippingCountryCode
    ordersByDate(from: "", offset: $offset, limit: $limit) {
      __typename
      ... on Box {
        ...boxOrderFragment
      }
      ... on NonCoreOrder {
        ...nonCoreOrderFragment
      }
    }
  }
  shippingCountries {
    id
    code
    showUpcomingOrderSeeMoreExtras
  }
}
    ${boxOrderFragment}
${nonCoreOrderFragment}`;

/**
 * __useupcomingOrderQuery__
 *
 * To run a query within a React component, call `useupcomingOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useupcomingOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useupcomingOrderQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useupcomingOrderQuery(baseOptions: Apollo.QueryHookOptions<upcomingOrderQuery, upcomingOrderQueryVariables> & ({ variables: upcomingOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<upcomingOrderQuery, upcomingOrderQueryVariables>(upcomingOrderQueryDocument, options);
      }
export function useupcomingOrderQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<upcomingOrderQuery, upcomingOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<upcomingOrderQuery, upcomingOrderQueryVariables>(upcomingOrderQueryDocument, options);
        }
export function useupcomingOrderQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<upcomingOrderQuery, upcomingOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<upcomingOrderQuery, upcomingOrderQueryVariables>(upcomingOrderQueryDocument, options);
        }
export type upcomingOrderQueryHookResult = ReturnType<typeof useupcomingOrderQuery>;
export type upcomingOrderQueryLazyQueryHookResult = ReturnType<typeof useupcomingOrderQueryLazyQuery>;
export type upcomingOrderQuerySuspenseQueryHookResult = ReturnType<typeof useupcomingOrderQuerySuspenseQuery>;
export type upcomingOrderQueryQueryResult = Apollo.QueryResult<upcomingOrderQuery, upcomingOrderQueryVariables>;
export const PauseFlowStartedEventCreateDocument = gql`
    mutation PauseFlowStartedEventCreate($properties: Boolean!) {
  pauseFlowStartedEventCreate(properties: $properties) {
    id
    status
  }
}
    `;
export type PauseFlowStartedEventCreateMutationFn = Apollo.MutationFunction<PauseFlowStartedEventCreate, PauseFlowStartedEventCreateVariables>;

/**
 * __usePauseFlowStartedEventCreate__
 *
 * To run a mutation, you first call `usePauseFlowStartedEventCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseFlowStartedEventCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseFlowStartedEventCreate, { data, loading, error }] = usePauseFlowStartedEventCreate({
 *   variables: {
 *      properties: // value for 'properties'
 *   },
 * });
 */
export function usePauseFlowStartedEventCreate(baseOptions?: Apollo.MutationHookOptions<PauseFlowStartedEventCreate, PauseFlowStartedEventCreateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseFlowStartedEventCreate, PauseFlowStartedEventCreateVariables>(PauseFlowStartedEventCreateDocument, options);
      }
export type PauseFlowStartedEventCreateHookResult = ReturnType<typeof usePauseFlowStartedEventCreate>;
export type PauseFlowStartedEventCreateMutationResult = Apollo.MutationResult<PauseFlowStartedEventCreate>;
export type PauseFlowStartedEventCreateMutationOptions = Apollo.BaseMutationOptions<PauseFlowStartedEventCreate, PauseFlowStartedEventCreateVariables>;
export const UpdatePersonalDetailsDocument = gql`
    mutation UpdatePersonalDetails($userId: ID!, $userDetails: UserDetailsInput!) {
  response: userDetailsUpdate(userId: $userId, userDetails: $userDetails) {
    ...personalDetailsFragment
  }
}
    ${personalDetailsFragment}`;
export type UpdatePersonalDetailsMutationFn = Apollo.MutationFunction<UpdatePersonalDetails, UpdatePersonalDetailsVariables>;

/**
 * __useUpdatePersonalDetails__
 *
 * To run a mutation, you first call `useUpdatePersonalDetails` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalDetails` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalDetails, { data, loading, error }] = useUpdatePersonalDetails({
 *   variables: {
 *      userId: // value for 'userId'
 *      userDetails: // value for 'userDetails'
 *   },
 * });
 */
export function useUpdatePersonalDetails(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalDetails, UpdatePersonalDetailsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalDetails, UpdatePersonalDetailsVariables>(UpdatePersonalDetailsDocument, options);
      }
export type UpdatePersonalDetailsHookResult = ReturnType<typeof useUpdatePersonalDetails>;
export type UpdatePersonalDetailsMutationResult = Apollo.MutationResult<UpdatePersonalDetails>;
export type UpdatePersonalDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalDetails, UpdatePersonalDetailsVariables>;
export const PersonalDetailsQueryDocument = gql`
    query PersonalDetailsQuery {
  user {
    preferredLanguage
    ...personalDetailsFragment
    ...UserAddressFragment
    shippingCountryCode
    currentDeliveryAreaPreference {
      id
      preferredCarrierService {
        id
        deliveryNotesLimit
      }
    }
    subscription {
      id
      status
      pauseUrl
      previewUncreatedFutureBox {
        editable
        isoDeliveryDate
        order {
          id
          discountTotal
          discountTotalPercentage
        }
        shippingCountry {
          id
          code
        }
      }
      nextEditableBox {
        id
        editable
        isoDeliveryDate
        order {
          id
          discountTotal
          discountTotalPercentage
        }
        shippingCountry {
          id
          code
        }
      }
    }
  }
}
    ${personalDetailsFragment}
${UserAddressFragment}`;

/**
 * __usePersonalDetailsQuery__
 *
 * To run a query within a React component, call `usePersonalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalDetailsQuery(baseOptions?: Apollo.QueryHookOptions<PersonalDetailsQuery, PersonalDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalDetailsQuery, PersonalDetailsQueryVariables>(PersonalDetailsQueryDocument, options);
      }
export function usePersonalDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalDetailsQuery, PersonalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalDetailsQuery, PersonalDetailsQueryVariables>(PersonalDetailsQueryDocument, options);
        }
export function usePersonalDetailsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalDetailsQuery, PersonalDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalDetailsQuery, PersonalDetailsQueryVariables>(PersonalDetailsQueryDocument, options);
        }
export type PersonalDetailsQueryHookResult = ReturnType<typeof usePersonalDetailsQuery>;
export type PersonalDetailsQueryLazyQueryHookResult = ReturnType<typeof usePersonalDetailsQueryLazyQuery>;
export type PersonalDetailsQuerySuspenseQueryHookResult = ReturnType<typeof usePersonalDetailsQuerySuspenseQuery>;
export type PersonalDetailsQueryQueryResult = Apollo.QueryResult<PersonalDetailsQuery, PersonalDetailsQueryVariables>;
export const CurrentDiscountCodeDocument = gql`
    query CurrentDiscountCode($discountCodeId: ID!) {
  discountCode(discountCodeId: $discountCodeId) {
    id
    code
  }
}
    `;

/**
 * __useCurrentDiscountCode__
 *
 * To run a query within a React component, call `useCurrentDiscountCode` and pass it any options that fit your needs.
 * When your component renders, `useCurrentDiscountCode` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentDiscountCode({
 *   variables: {
 *      discountCodeId: // value for 'discountCodeId'
 *   },
 * });
 */
export function useCurrentDiscountCode(baseOptions: Apollo.QueryHookOptions<CurrentDiscountCode, CurrentDiscountCodeVariables> & ({ variables: CurrentDiscountCodeVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentDiscountCode, CurrentDiscountCodeVariables>(CurrentDiscountCodeDocument, options);
      }
export function useCurrentDiscountCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentDiscountCode, CurrentDiscountCodeVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentDiscountCode, CurrentDiscountCodeVariables>(CurrentDiscountCodeDocument, options);
        }
export function useCurrentDiscountCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentDiscountCode, CurrentDiscountCodeVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentDiscountCode, CurrentDiscountCodeVariables>(CurrentDiscountCodeDocument, options);
        }
export type CurrentDiscountCodeHookResult = ReturnType<typeof useCurrentDiscountCode>;
export type CurrentDiscountCodeLazyQueryHookResult = ReturnType<typeof useCurrentDiscountCodeLazyQuery>;
export type CurrentDiscountCodeSuspenseQueryHookResult = ReturnType<typeof useCurrentDiscountCodeSuspenseQuery>;
export type CurrentDiscountCodeQueryResult = Apollo.QueryResult<CurrentDiscountCode, CurrentDiscountCodeVariables>;
export const AddDiscountToGuestDocument = gql`
    mutation AddDiscountToGuest($discountCode: String!) {
  addDiscountToGuest(code: $discountCode) {
    guest {
      discountCode {
        code
        id
      }
    }
  }
}
    `;
export type AddDiscountToGuestMutationFn = Apollo.MutationFunction<AddDiscountToGuest, AddDiscountToGuestVariables>;

/**
 * __useAddDiscountToGuest__
 *
 * To run a mutation, you first call `useAddDiscountToGuest` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDiscountToGuest` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDiscountToGuest, { data, loading, error }] = useAddDiscountToGuest({
 *   variables: {
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function useAddDiscountToGuest(baseOptions?: Apollo.MutationHookOptions<AddDiscountToGuest, AddDiscountToGuestVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDiscountToGuest, AddDiscountToGuestVariables>(AddDiscountToGuestDocument, options);
      }
export type AddDiscountToGuestHookResult = ReturnType<typeof useAddDiscountToGuest>;
export type AddDiscountToGuestMutationResult = Apollo.MutationResult<AddDiscountToGuest>;
export type AddDiscountToGuestMutationOptions = Apollo.BaseMutationOptions<AddDiscountToGuest, AddDiscountToGuestVariables>;
export const CreatePendingSubscriptionDocument = gql`
    mutation CreatePendingSubscription($pendingSubscription: PendingSubscriptionInput!) {
  createPendingSubscription(pendingSubscription: $pendingSubscription) {
    user {
      id
    }
    pendingSubscription {
      pendingSubscriptionFlavours {
        flavour {
          name
        }
        sevenDayServings
      }
    }
  }
}
    `;
export type CreatePendingSubscriptionMutationFn = Apollo.MutationFunction<CreatePendingSubscription, CreatePendingSubscriptionVariables>;

/**
 * __useCreatePendingSubscription__
 *
 * To run a mutation, you first call `useCreatePendingSubscription` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePendingSubscription` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPendingSubscription, { data, loading, error }] = useCreatePendingSubscription({
 *   variables: {
 *      pendingSubscription: // value for 'pendingSubscription'
 *   },
 * });
 */
export function useCreatePendingSubscription(baseOptions?: Apollo.MutationHookOptions<CreatePendingSubscription, CreatePendingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePendingSubscription, CreatePendingSubscriptionVariables>(CreatePendingSubscriptionDocument, options);
      }
export type CreatePendingSubscriptionHookResult = ReturnType<typeof useCreatePendingSubscription>;
export type CreatePendingSubscriptionMutationResult = Apollo.MutationResult<CreatePendingSubscription>;
export type CreatePendingSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreatePendingSubscription, CreatePendingSubscriptionVariables>;
export const UpdatePlanDocument = gql`
    mutation UpdatePlan($userId: ID!, $meal: MealInput!, $planId: ID!) {
  mealUpdate(userId: $userId, meal: $meal) {
    flavour {
      name
    }
  }
  subscriptionPlanUpdate(userId: $userId, planId: $planId) {
    id
    subscription {
      plan {
        id
      }
    }
  }
}
    `;
export type UpdatePlanMutationFn = Apollo.MutationFunction<UpdatePlan, UpdatePlanVariables>;

/**
 * __useUpdatePlan__
 *
 * To run a mutation, you first call `useUpdatePlan` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlan` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlan, { data, loading, error }] = useUpdatePlan({
 *   variables: {
 *      userId: // value for 'userId'
 *      meal: // value for 'meal'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useUpdatePlan(baseOptions?: Apollo.MutationHookOptions<UpdatePlan, UpdatePlanVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlan, UpdatePlanVariables>(UpdatePlanDocument, options);
      }
export type UpdatePlanHookResult = ReturnType<typeof useUpdatePlan>;
export type UpdatePlanMutationResult = Apollo.MutationResult<UpdatePlan>;
export type UpdatePlanMutationOptions = Apollo.BaseMutationOptions<UpdatePlan, UpdatePlanVariables>;
export const GuestQueryDocument = gql`
    query GuestQuery {
  currentUser {
    __typename
    ... on Guest {
      id
      preferredLanguage
      assumedShippingCountry {
        id
        code
      }
      planRecommendation {
        recommendedExtraProductVariants {
          ...recommendedExtraProductVariantsFields
        }
      }
    }
    ... on User {
      id
      address {
        postcode
      }
      planRecommendation {
        recommendedExtraProductVariants {
          ...recommendedExtraProductVariantsFields
        }
      }
    }
  }
}
    ${recommendedExtraProductVariantsFields}`;

/**
 * __useGuestQuery__
 *
 * To run a query within a React component, call `useGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestQuery(baseOptions?: Apollo.QueryHookOptions<GuestQuery, GuestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestQuery, GuestQueryVariables>(GuestQueryDocument, options);
      }
export function useGuestQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestQuery, GuestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestQuery, GuestQueryVariables>(GuestQueryDocument, options);
        }
export function useGuestQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GuestQuery, GuestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GuestQuery, GuestQueryVariables>(GuestQueryDocument, options);
        }
export type GuestQueryHookResult = ReturnType<typeof useGuestQuery>;
export type GuestQueryLazyQueryHookResult = ReturnType<typeof useGuestQueryLazyQuery>;
export type GuestQuerySuspenseQueryHookResult = ReturnType<typeof useGuestQuerySuspenseQuery>;
export type GuestQueryQueryResult = Apollo.QueryResult<GuestQuery, GuestQueryVariables>;
export const ReviewQueryDocument = gql`
    query ReviewQuery {
  standardDeliveryFee
  currentUser {
    __typename
    ... on Guest {
      id
      assumedShippingCountry {
        id
        code
      }
      preferredLanguage
      discountCode {
        id
        discountCodeParts {
          n
          discountType
          discountBasis
          value
        }
      }
      planRecommendation {
        individual {
          dog {
            id
            name
            createdAt
            gender
            dailyGrams
            dogProfile {
              avatarUrl
            }
          }
        }
      }
    }
    ... on User {
      id
      preferredLanguage
      shippingCountry {
        code
      }
      dogs {
        name
      }
      subscription {
        id
        status
        planPricePerDay
        planPriceTotal
        plan {
          pouchSize
          numberOfPouches
          durationInDays
          pouchesPerDay
          typeOfPlanForCustomer
        }
        meal {
          flavour {
            id
            slug
            name
            thumbnail {
              src
            }
            themeColour
          }
          quantity
        }
        recurringOrder {
          surchargeTotal
        }
      }
      planRecommendation {
        individual {
          dog {
            id
            name
            createdAt
            gender
            dailyGrams
            dogProfile {
              avatarUrl
            }
          }
        }
      }
    }
  }
  pendingSubscription {
    standardOrderPricing {
      ...pendingSubscriptionOrderPricingFragment
    }
    firstOrderPricing {
      ...pendingSubscriptionOrderPricingFragment
    }
    secondOrderPricing {
      ...pendingSubscriptionOrderPricingFragment
    }
    trialDiscountCodePart {
      value
    }
    productVariants {
      ...pendingSubscriptionProductVariantFields
    }
    plan {
      id
      numberOfPouches
      durationInDays
      trialLengthInDays
      pouchesPerDay
      pricingCurve {
        pricingCohort
      }
      pricesPerDayPerDogs {
        name
        pricePerDayWithDiscount
        pricePerDayWithoutDiscount
      }
      typeOfPlanForCustomer
    }
    pendingSubscriptionFlavours {
      flavour {
        name
        slug
        themeColour
        thumbnail {
          src
        }
      }
      servings
      trialBoxServings
      sevenDayServings
    }
  }
}
    ${pendingSubscriptionOrderPricingFragment}
${pendingSubscriptionProductVariantFields}`;

/**
 * __useReviewQuery__
 *
 * To run a query within a React component, call `useReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useReviewQuery(baseOptions?: Apollo.QueryHookOptions<ReviewQuery, ReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewQuery, ReviewQueryVariables>(ReviewQueryDocument, options);
      }
export function useReviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewQuery, ReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewQuery, ReviewQueryVariables>(ReviewQueryDocument, options);
        }
export function useReviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewQuery, ReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewQuery, ReviewQueryVariables>(ReviewQueryDocument, options);
        }
export type ReviewQueryHookResult = ReturnType<typeof useReviewQuery>;
export type ReviewQueryLazyQueryHookResult = ReturnType<typeof useReviewQueryLazyQuery>;
export type ReviewQuerySuspenseQueryHookResult = ReturnType<typeof useReviewQuerySuspenseQuery>;
export type ReviewQueryQueryResult = Apollo.QueryResult<ReviewQuery, ReviewQueryVariables>;
export const RecommendationQueryDocument = gql`
    query RecommendationQuery {
  flavours {
    productBenefits {
      id
      name
      image {
        src
      }
    }
  }
  currentUser {
    __typename
    ... on Guest {
      id
      preferredLanguage
      assumedShippingCountry {
        id
        code
      }
      discountCode {
        id
        discountCodeParts {
          n
          discountType
          discountBasis
          value
        }
      }
      planRecommendation {
        idealGramsAmount
        combinedRecommendedFlavours {
          ...flavourFields
        }
        combinedOtherFlavours {
          ...flavourFields
        }
        combinedNotRecommendedFlavours {
          ...flavourFields
        }
        plans {
          ...planFields
        }
        recommendationReasons {
          id
          text
        }
        individual {
          dog {
            id
            name
            dailyCalories
            gender
            eaterType
          }
        }
      }
    }
    ... on User {
      id
      preferredLanguage
      shippingCountry {
        code
      }
      planRecommendation {
        idealGramsAmount
        combinedRecommendedFlavours {
          ...flavourFields
        }
        combinedOtherFlavours {
          ...flavourFields
        }
        combinedNotRecommendedFlavours {
          ...flavourFields
        }
        plans {
          ...planFields
        }
        recommendationReasons {
          id
          text
        }
        individual {
          dog {
            id
            name
            dailyCalories
            gender
            eaterType
          }
        }
      }
    }
  }
}
    ${flavourFields}
${planFields}`;

/**
 * __useRecommendationQuery__
 *
 * To run a query within a React component, call `useRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendationQuery(baseOptions?: Apollo.QueryHookOptions<RecommendationQuery, RecommendationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendationQuery, RecommendationQueryVariables>(RecommendationQueryDocument, options);
      }
export function useRecommendationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendationQuery, RecommendationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendationQuery, RecommendationQueryVariables>(RecommendationQueryDocument, options);
        }
export function useRecommendationQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendationQuery, RecommendationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendationQuery, RecommendationQueryVariables>(RecommendationQueryDocument, options);
        }
export type RecommendationQueryHookResult = ReturnType<typeof useRecommendationQuery>;
export type RecommendationQueryLazyQueryHookResult = ReturnType<typeof useRecommendationQueryLazyQuery>;
export type RecommendationQuerySuspenseQueryHookResult = ReturnType<typeof useRecommendationQuerySuspenseQuery>;
export type RecommendationQueryQueryResult = Apollo.QueryResult<RecommendationQuery, RecommendationQueryVariables>;
export const PriceSensitivePausedPageQueryDocument = gql`
    query PriceSensitivePausedPageQuery($from: ISO8601Date!, $to: ISO8601Date!) {
  user {
    id
    preferredLanguage
    shippingCountryCode
    ordersByDate(from: $from, to: $to) {
      ...upcomingBoxOrderFragment
      ...nonCoreUpcomingOrderFragment
    }
    subscription {
      id
      status
      activePaymentMethodType
      previewUncreatedFutureBox {
        order {
          id
          deliveryFee
          subtotal
          discountTotalPercentage
        }
      }
      plan {
        id
        durationInWeeks
        pouchSize
        numberOfPouches
        pouchesPerDay
        pricePerWeek
      }
      increasedDeliveryCadencePlan {
        id
        durationInWeeks
        pouchSize
        numberOfPouches
        pouchesPerDay
        pricePerWeek
      }
      currentPause {
        id
        priceSensitiveTreatments
      }
    }
  }
}
    ${upcomingBoxOrderFragment}
${nonCoreUpcomingOrderFragment}`;

/**
 * __usePriceSensitivePausedPageQuery__
 *
 * To run a query within a React component, call `usePriceSensitivePausedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceSensitivePausedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceSensitivePausedPageQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function usePriceSensitivePausedPageQuery(baseOptions: Apollo.QueryHookOptions<PriceSensitivePausedPageQuery, PriceSensitivePausedPageQueryVariables> & ({ variables: PriceSensitivePausedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceSensitivePausedPageQuery, PriceSensitivePausedPageQueryVariables>(PriceSensitivePausedPageQueryDocument, options);
      }
export function usePriceSensitivePausedPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceSensitivePausedPageQuery, PriceSensitivePausedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceSensitivePausedPageQuery, PriceSensitivePausedPageQueryVariables>(PriceSensitivePausedPageQueryDocument, options);
        }
export function usePriceSensitivePausedPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PriceSensitivePausedPageQuery, PriceSensitivePausedPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PriceSensitivePausedPageQuery, PriceSensitivePausedPageQueryVariables>(PriceSensitivePausedPageQueryDocument, options);
        }
export type PriceSensitivePausedPageQueryHookResult = ReturnType<typeof usePriceSensitivePausedPageQuery>;
export type PriceSensitivePausedPageQueryLazyQueryHookResult = ReturnType<typeof usePriceSensitivePausedPageQueryLazyQuery>;
export type PriceSensitivePausedPageQuerySuspenseQueryHookResult = ReturnType<typeof usePriceSensitivePausedPageQuerySuspenseQuery>;
export type PriceSensitivePausedPageQueryQueryResult = Apollo.QueryResult<PriceSensitivePausedPageQuery, PriceSensitivePausedPageQueryVariables>;
export const ReferAFriendPageQueryDocument = gql`
    query ReferAFriendPageQuery {
  user {
    id
    shippingCountryCode
    firstName
    dogs {
      id
      name
      dogProfile {
        id
        avatarUrl
      }
    }
    subscription {
      id
      referralLink {
        referralLinkTypeName
        referralDiscountsTotalValue
        url
        referralDiscount {
          id
          code
          discountCodeParts {
            value
            discountType
            discountBasis
            n
          }
        }
        referrerDiscount {
          applicableDiscountParts {
            value
            discountBasis
            n
            discountType
          }
        }
        referrals {
          refereeFirstName
          refereeDogNames
          refereeSignUpDate
        }
      }
      activeRafCampaignRedeemed
      activeRafCampaignVariant {
        name
        rafCampaign {
          name
          endDate
        }
        view {
          data
        }
      }
    }
  }
  shippingCountries {
    code
    showRafCharityButton
  }
  whatsAppSingleDog: copyEntry(slug: "whatsapp_single_dog") {
    text
  }
  whatsAppMultipleDogs: copyEntry(slug: "whatsapp_multiple_dogs") {
    text
  }
}
    `;

/**
 * __useReferAFriendPageQuery__
 *
 * To run a query within a React component, call `useReferAFriendPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferAFriendPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferAFriendPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferAFriendPageQuery(baseOptions?: Apollo.QueryHookOptions<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>(ReferAFriendPageQueryDocument, options);
      }
export function useReferAFriendPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>(ReferAFriendPageQueryDocument, options);
        }
export function useReferAFriendPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>(ReferAFriendPageQueryDocument, options);
        }
export type ReferAFriendPageQueryHookResult = ReturnType<typeof useReferAFriendPageQuery>;
export type ReferAFriendPageQueryLazyQueryHookResult = ReturnType<typeof useReferAFriendPageQueryLazyQuery>;
export type ReferAFriendPageQuerySuspenseQueryHookResult = ReturnType<typeof useReferAFriendPageQuerySuspenseQuery>;
export type ReferAFriendPageQueryQueryResult = Apollo.QueryResult<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>;
export const ReviewPlanChangesMutationDocument = gql`
    mutation ReviewPlanChangesMutation($userId: ID!, $planId: ID!, $nextNBoxesNum: Int!) {
  subscriptionPlanUpdate(userId: $userId, planId: $planId) {
    id
    subscription {
      id
      plan {
        id
        numberOfPouches
        durationInWeeks
        pricePerDay
        pouchSize
        servingInformation {
          gramsPerDay
        }
      }
      nextNBoxes(num: $nextNBoxesNum) {
        id
        numberOfPouches
        durationInDays
        isoDeliveryDate
        editable
        plan {
          id
          pouchSize
        }
        ...BoxOrderSummaryModalFragment
      }
    }
  }
}
    ${BoxOrderSummaryModalFragment}`;
export type ReviewPlanChangesMutationMutationFn = Apollo.MutationFunction<ReviewPlanChangesMutation, ReviewPlanChangesMutationVariables>;

/**
 * __useReviewPlanChangesMutation__
 *
 * To run a mutation, you first call `useReviewPlanChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewPlanChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewPlanChangesMutation, { data, loading, error }] = useReviewPlanChangesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      planId: // value for 'planId'
 *      nextNBoxesNum: // value for 'nextNBoxesNum'
 *   },
 * });
 */
export function useReviewPlanChangesMutation(baseOptions?: Apollo.MutationHookOptions<ReviewPlanChangesMutation, ReviewPlanChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewPlanChangesMutation, ReviewPlanChangesMutationVariables>(ReviewPlanChangesMutationDocument, options);
      }
export type ReviewPlanChangesMutationHookResult = ReturnType<typeof useReviewPlanChangesMutation>;
export type ReviewPlanChangesMutationMutationResult = Apollo.MutationResult<ReviewPlanChangesMutation>;
export type ReviewPlanChangesMutationMutationOptions = Apollo.BaseMutationOptions<ReviewPlanChangesMutation, ReviewPlanChangesMutationVariables>;
export const SegmentedPausedPageQueryDocument = gql`
    query SegmentedPausedPageQuery($from: ISO8601Date!, $to: ISO8601Date!) {
  user {
    id
    preferredLanguage
    shippingCountryCode
    ordersByDate(from: $from, to: $to) {
      ...upcomingBoxOrderFragment
      ...nonCoreUpcomingOrderFragment
    }
    address {
      id
      deliverable
      postcode
    }
    subscription {
      id
      status
      activePaymentMethodType
      previewUncreatedFutureBox {
        isoDeliveryDate
        plan {
          durationInWeeks
          pouchesPerDay
          pouchSize
          pricePerDay
          id
        }
        order {
          id
          deliveryFee
          subtotal
          discountTotalPercentage
        }
      }
      currentPause {
        id
        segmentedTreatments
      }
    }
  }
}
    ${upcomingBoxOrderFragment}
${nonCoreUpcomingOrderFragment}`;

/**
 * __useSegmentedPausedPageQuery__
 *
 * To run a query within a React component, call `useSegmentedPausedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentedPausedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentedPausedPageQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSegmentedPausedPageQuery(baseOptions: Apollo.QueryHookOptions<SegmentedPausedPageQuery, SegmentedPausedPageQueryVariables> & ({ variables: SegmentedPausedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentedPausedPageQuery, SegmentedPausedPageQueryVariables>(SegmentedPausedPageQueryDocument, options);
      }
export function useSegmentedPausedPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentedPausedPageQuery, SegmentedPausedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentedPausedPageQuery, SegmentedPausedPageQueryVariables>(SegmentedPausedPageQueryDocument, options);
        }
export function useSegmentedPausedPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SegmentedPausedPageQuery, SegmentedPausedPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SegmentedPausedPageQuery, SegmentedPausedPageQueryVariables>(SegmentedPausedPageQueryDocument, options);
        }
export type SegmentedPausedPageQueryHookResult = ReturnType<typeof useSegmentedPausedPageQuery>;
export type SegmentedPausedPageQueryLazyQueryHookResult = ReturnType<typeof useSegmentedPausedPageQueryLazyQuery>;
export type SegmentedPausedPageQuerySuspenseQueryHookResult = ReturnType<typeof useSegmentedPausedPageQuerySuspenseQuery>;
export type SegmentedPausedPageQueryQueryResult = Apollo.QueryResult<SegmentedPausedPageQuery, SegmentedPausedPageQueryVariables>;
export const CustomerIssueCategorySubmissionDocument = gql`
    mutation CustomerIssueCategorySubmission($userId: ID!, $boxId: ID!, $categoryId: ID!) {
  response: customerIssueCategorySubmission(
    userId: $userId
    boxId: $boxId
    categoryId: $categoryId
  ) {
    resolutions {
      key
      requiresAction
      resolutionType
      details {
        __typename
        ... on OrderTrackingNumber {
          type
          ...orderTrackingNumberFields
        }
      }
    }
    fields {
      name
      dataType
      presentationalOrder
      selectionFormat
      __typename
      ... on CustomerIssueEntryFieldAssociation {
        allowedAssociationValues {
          __typename
          ... on CustomerIssueCategory {
            id
            description
            name
            key
            selfServable
            parentId
          }
          ... on Product {
            id
          }
        }
        associationType
        associationDisplayType
        id
      }
      ... on CustomerIssueEntryFieldString {
        allowedStringValues
        stringDisplayType
        id
      }
      ... on CustomerIssueEntryFieldInteger {
        allowedIntegerValues
        integerDisplayType
        id
      }
      ... on CustomerIssueEntryFieldBoolean {
        booleanDisplayType
        id
      }
      ... on CustomerIssueEntryFieldMultifield {
        multifieldDisplayType
        id
        fields {
          name
          dataType
          presentationalOrder
          selectionFormat
          __typename
          ... on CustomerIssueEntryFieldAssociation {
            allowedAssociationValues {
              __typename
              ... on CustomerIssueCategory {
                id
                description
                name
                key
                selfServable
                parentId
              }
              ... on Product {
                id
              }
            }
            associationType
            associationDisplayType
            id
          }
          ... on CustomerIssueEntryFieldString {
            allowedStringValues
            stringDisplayType
            id
          }
          ... on CustomerIssueEntryFieldInteger {
            allowedIntegerValues
            integerDisplayType
            id
          }
          ... on CustomerIssueEntryFieldBoolean {
            booleanDisplayType
            id
          }
        }
      }
    }
    reasons {
      id
      name
      presentationalOrder
    }
    reportId
    entryId
  }
}
    ${orderTrackingNumberFields}`;
export type CustomerIssueCategorySubmissionMutationFn = Apollo.MutationFunction<CustomerIssueCategorySubmission, CustomerIssueCategorySubmissionVariables>;

/**
 * __useCustomerIssueCategorySubmission__
 *
 * To run a mutation, you first call `useCustomerIssueCategorySubmission` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerIssueCategorySubmission` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerIssueCategorySubmission, { data, loading, error }] = useCustomerIssueCategorySubmission({
 *   variables: {
 *      userId: // value for 'userId'
 *      boxId: // value for 'boxId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useCustomerIssueCategorySubmission(baseOptions?: Apollo.MutationHookOptions<CustomerIssueCategorySubmission, CustomerIssueCategorySubmissionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerIssueCategorySubmission, CustomerIssueCategorySubmissionVariables>(CustomerIssueCategorySubmissionDocument, options);
      }
export type CustomerIssueCategorySubmissionHookResult = ReturnType<typeof useCustomerIssueCategorySubmission>;
export type CustomerIssueCategorySubmissionMutationResult = Apollo.MutationResult<CustomerIssueCategorySubmission>;
export type CustomerIssueCategorySubmissionMutationOptions = Apollo.BaseMutationOptions<CustomerIssueCategorySubmission, CustomerIssueCategorySubmissionVariables>;
export const CustomerIssueReportEntriesSubmissionDocument = gql`
    mutation CustomerIssueReportEntriesSubmission($userId: ID!, $reportId: ID!, $entryFieldInputs: [CustomerIssueReportEntryInputInput!]!, $reasonId: ID!) {
  response: customerIssueReportEntriesSubmission(
    userId: $userId
    reportId: $reportId
    entryFieldInputs: $entryFieldInputs
    reasonId: $reasonId
  ) {
    reportId
    resolutions {
      key
      details {
        __typename
        ... on ReplacementBoxDetails {
          availableDeliveryDates {
            date
            deliverable
          }
          defaultAddress {
            address1
            address2
            city
            country
            deliveryNotes
            deliveryCarrier
            postcode
            recipientName
            shippingCountry {
              active
              code
              name
              id
            }
          }
          type
        }
        ... on ApplyDiscounts {
          discountCode {
            discountCodeParts {
              value
            }
          }
        }
      }
    }
  }
}
    `;
export type CustomerIssueReportEntriesSubmissionMutationFn = Apollo.MutationFunction<CustomerIssueReportEntriesSubmission, CustomerIssueReportEntriesSubmissionVariables>;

/**
 * __useCustomerIssueReportEntriesSubmission__
 *
 * To run a mutation, you first call `useCustomerIssueReportEntriesSubmission` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerIssueReportEntriesSubmission` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerIssueReportEntriesSubmission, { data, loading, error }] = useCustomerIssueReportEntriesSubmission({
 *   variables: {
 *      userId: // value for 'userId'
 *      reportId: // value for 'reportId'
 *      entryFieldInputs: // value for 'entryFieldInputs'
 *      reasonId: // value for 'reasonId'
 *   },
 * });
 */
export function useCustomerIssueReportEntriesSubmission(baseOptions?: Apollo.MutationHookOptions<CustomerIssueReportEntriesSubmission, CustomerIssueReportEntriesSubmissionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerIssueReportEntriesSubmission, CustomerIssueReportEntriesSubmissionVariables>(CustomerIssueReportEntriesSubmissionDocument, options);
      }
export type CustomerIssueReportEntriesSubmissionHookResult = ReturnType<typeof useCustomerIssueReportEntriesSubmission>;
export type CustomerIssueReportEntriesSubmissionMutationResult = Apollo.MutationResult<CustomerIssueReportEntriesSubmission>;
export type CustomerIssueReportEntriesSubmissionMutationOptions = Apollo.BaseMutationOptions<CustomerIssueReportEntriesSubmission, CustomerIssueReportEntriesSubmissionVariables>;
export const CustomerIssueResolutionAcceptanceApplyDiscountDocument = gql`
    mutation CustomerIssueResolutionAcceptanceApplyDiscount($userId: ID!, $reportId: ID!) {
  response: customerIssueResolutionAcceptanceApplyDiscount(
    userId: $userId
    reportId: $reportId
  ) {
    resolutionApplicationConfirmation {
      type
    }
  }
}
    `;
export type CustomerIssueResolutionAcceptanceApplyDiscountMutationFn = Apollo.MutationFunction<CustomerIssueResolutionAcceptanceApplyDiscount, CustomerIssueResolutionAcceptanceApplyDiscountVariables>;

/**
 * __useCustomerIssueResolutionAcceptanceApplyDiscount__
 *
 * To run a mutation, you first call `useCustomerIssueResolutionAcceptanceApplyDiscount` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerIssueResolutionAcceptanceApplyDiscount` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerIssueResolutionAcceptanceApplyDiscount, { data, loading, error }] = useCustomerIssueResolutionAcceptanceApplyDiscount({
 *   variables: {
 *      userId: // value for 'userId'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useCustomerIssueResolutionAcceptanceApplyDiscount(baseOptions?: Apollo.MutationHookOptions<CustomerIssueResolutionAcceptanceApplyDiscount, CustomerIssueResolutionAcceptanceApplyDiscountVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerIssueResolutionAcceptanceApplyDiscount, CustomerIssueResolutionAcceptanceApplyDiscountVariables>(CustomerIssueResolutionAcceptanceApplyDiscountDocument, options);
      }
export type CustomerIssueResolutionAcceptanceApplyDiscountHookResult = ReturnType<typeof useCustomerIssueResolutionAcceptanceApplyDiscount>;
export type CustomerIssueResolutionAcceptanceApplyDiscountMutationResult = Apollo.MutationResult<CustomerIssueResolutionAcceptanceApplyDiscount>;
export type CustomerIssueResolutionAcceptanceApplyDiscountMutationOptions = Apollo.BaseMutationOptions<CustomerIssueResolutionAcceptanceApplyDiscount, CustomerIssueResolutionAcceptanceApplyDiscountVariables>;
export const CustomerIssueResolutionAcceptanceReplacementBoxSubmissionDocument = gql`
    mutation CustomerIssueResolutionAcceptanceReplacementBoxSubmission($userId: ID!, $reportId: ID!, $replacementBoxDetails: CustomerIssueResolutionAcceptanceReplacementBoxDetailsInput!) {
  response: customerIssueResolutionAcceptanceReplacementBoxSubmission(
    userId: $userId
    reportId: $reportId
    replacementBoxDetails: $replacementBoxDetails
  ) {
    resolutionApplicationConfirmation {
      type
    }
  }
}
    `;
export type CustomerIssueResolutionAcceptanceReplacementBoxSubmissionMutationFn = Apollo.MutationFunction<CustomerIssueResolutionAcceptanceReplacementBoxSubmission, CustomerIssueResolutionAcceptanceReplacementBoxSubmissionVariables>;

/**
 * __useCustomerIssueResolutionAcceptanceReplacementBoxSubmission__
 *
 * To run a mutation, you first call `useCustomerIssueResolutionAcceptanceReplacementBoxSubmission` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerIssueResolutionAcceptanceReplacementBoxSubmission` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerIssueResolutionAcceptanceReplacementBoxSubmission, { data, loading, error }] = useCustomerIssueResolutionAcceptanceReplacementBoxSubmission({
 *   variables: {
 *      userId: // value for 'userId'
 *      reportId: // value for 'reportId'
 *      replacementBoxDetails: // value for 'replacementBoxDetails'
 *   },
 * });
 */
export function useCustomerIssueResolutionAcceptanceReplacementBoxSubmission(baseOptions?: Apollo.MutationHookOptions<CustomerIssueResolutionAcceptanceReplacementBoxSubmission, CustomerIssueResolutionAcceptanceReplacementBoxSubmissionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerIssueResolutionAcceptanceReplacementBoxSubmission, CustomerIssueResolutionAcceptanceReplacementBoxSubmissionVariables>(CustomerIssueResolutionAcceptanceReplacementBoxSubmissionDocument, options);
      }
export type CustomerIssueResolutionAcceptanceReplacementBoxSubmissionHookResult = ReturnType<typeof useCustomerIssueResolutionAcceptanceReplacementBoxSubmission>;
export type CustomerIssueResolutionAcceptanceReplacementBoxSubmissionMutationResult = Apollo.MutationResult<CustomerIssueResolutionAcceptanceReplacementBoxSubmission>;
export type CustomerIssueResolutionAcceptanceReplacementBoxSubmissionMutationOptions = Apollo.BaseMutationOptions<CustomerIssueResolutionAcceptanceReplacementBoxSubmission, CustomerIssueResolutionAcceptanceReplacementBoxSubmissionVariables>;
export const SelfResolutionCategoriesDocument = gql`
    query SelfResolutionCategories($boxId: ID!) {
  user {
    id
    shippingCountryCode
    preferredLanguage
    subscription {
      box(boxId: $boxId) {
        hasPreviousOrderIssue
        potentialMissingItems {
          name
          productId
          productCode
          category
          thumbnail
          quantity
          price
        }
        isoDeliveryDate
        price
      }
    }
  }
  categories: customerIssueCategories(selfServable: true) {
    id
    name
    description
    key
    selfServable
    parentId
  }
}
    `;

/**
 * __useSelfResolutionCategories__
 *
 * To run a query within a React component, call `useSelfResolutionCategories` and pass it any options that fit your needs.
 * When your component renders, `useSelfResolutionCategories` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfResolutionCategories({
 *   variables: {
 *      boxId: // value for 'boxId'
 *   },
 * });
 */
export function useSelfResolutionCategories(baseOptions: Apollo.QueryHookOptions<SelfResolutionCategories, SelfResolutionCategoriesVariables> & ({ variables: SelfResolutionCategoriesVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfResolutionCategories, SelfResolutionCategoriesVariables>(SelfResolutionCategoriesDocument, options);
      }
export function useSelfResolutionCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfResolutionCategories, SelfResolutionCategoriesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfResolutionCategories, SelfResolutionCategoriesVariables>(SelfResolutionCategoriesDocument, options);
        }
export function useSelfResolutionCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfResolutionCategories, SelfResolutionCategoriesVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfResolutionCategories, SelfResolutionCategoriesVariables>(SelfResolutionCategoriesDocument, options);
        }
export type SelfResolutionCategoriesHookResult = ReturnType<typeof useSelfResolutionCategories>;
export type SelfResolutionCategoriesLazyQueryHookResult = ReturnType<typeof useSelfResolutionCategoriesLazyQuery>;
export type SelfResolutionCategoriesSuspenseQueryHookResult = ReturnType<typeof useSelfResolutionCategoriesSuspenseQuery>;
export type SelfResolutionCategoriesQueryResult = Apollo.QueryResult<SelfResolutionCategories, SelfResolutionCategoriesVariables>;
export const addDogsDocument = gql`
    mutation addDogs($dogs: [DogInput!]!) {
  addDogs(dogs: $dogs) {
    dogs {
      id
    }
    mealSelectionTypeSwitched
  }
}
    `;
export type addDogsMutationFn = Apollo.MutationFunction<addDogs, addDogsVariables>;

/**
 * __useaddDogs__
 *
 * To run a mutation, you first call `useaddDogs` within a React component and pass it any options that fit your needs.
 * When your component renders, `useaddDogs` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDogs, { data, loading, error }] = useaddDogs({
 *   variables: {
 *      dogs: // value for 'dogs'
 *   },
 * });
 */
export function useaddDogs(baseOptions?: Apollo.MutationHookOptions<addDogs, addDogsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<addDogs, addDogsVariables>(addDogsDocument, options);
      }
export type addDogsHookResult = ReturnType<typeof useaddDogs>;
export type addDogsMutationResult = Apollo.MutationResult<addDogs>;
export type addDogsMutationOptions = Apollo.BaseMutationOptions<addDogs, addDogsVariables>;
export const AllergensDocument = gql`
    query Allergens {
  allergens {
    id
    name
  }
}
    `;

/**
 * __useAllergens__
 *
 * To run a query within a React component, call `useAllergens` and pass it any options that fit your needs.
 * When your component renders, `useAllergens` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllergens({
 *   variables: {
 *   },
 * });
 */
export function useAllergens(baseOptions?: Apollo.QueryHookOptions<Allergens, AllergensVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Allergens, AllergensVariables>(AllergensDocument, options);
      }
export function useAllergensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Allergens, AllergensVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Allergens, AllergensVariables>(AllergensDocument, options);
        }
export function useAllergensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Allergens, AllergensVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Allergens, AllergensVariables>(AllergensDocument, options);
        }
export type AllergensHookResult = ReturnType<typeof useAllergens>;
export type AllergensLazyQueryHookResult = ReturnType<typeof useAllergensLazyQuery>;
export type AllergensSuspenseQueryHookResult = ReturnType<typeof useAllergensSuspenseQuery>;
export type AllergensQueryResult = Apollo.QueryResult<Allergens, AllergensVariables>;
export const FoodCategoriesDocument = gql`
    query FoodCategories {
  foodCategories {
    id
    name
  }
}
    `;

/**
 * __useFoodCategories__
 *
 * To run a query within a React component, call `useFoodCategories` and pass it any options that fit your needs.
 * When your component renders, `useFoodCategories` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodCategories({
 *   variables: {
 *   },
 * });
 */
export function useFoodCategories(baseOptions?: Apollo.QueryHookOptions<FoodCategories, FoodCategoriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FoodCategories, FoodCategoriesVariables>(FoodCategoriesDocument, options);
      }
export function useFoodCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FoodCategories, FoodCategoriesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FoodCategories, FoodCategoriesVariables>(FoodCategoriesDocument, options);
        }
export function useFoodCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FoodCategories, FoodCategoriesVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FoodCategories, FoodCategoriesVariables>(FoodCategoriesDocument, options);
        }
export type FoodCategoriesHookResult = ReturnType<typeof useFoodCategories>;
export type FoodCategoriesLazyQueryHookResult = ReturnType<typeof useFoodCategoriesLazyQuery>;
export type FoodCategoriesSuspenseQueryHookResult = ReturnType<typeof useFoodCategoriesSuspenseQuery>;
export type FoodCategoriesQueryResult = Apollo.QueryResult<FoodCategories, FoodCategoriesVariables>;
export const ShippingCountriesDocument = gql`
    query ShippingCountries {
  settings(names: ["marketing_opt_in_default"]) {
    value
    name
  }
  shippingCountries {
    id
    name
    code
    currency
    active
    scaEnforced
  }
  availableMarketingMethodPurposes {
    id
    marketingPurpose {
      id
      key
      name
      encouraged
    }
  }
}
    `;

/**
 * __useShippingCountries__
 *
 * To run a query within a React component, call `useShippingCountries` and pass it any options that fit your needs.
 * When your component renders, `useShippingCountries` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingCountries({
 *   variables: {
 *   },
 * });
 */
export function useShippingCountries(baseOptions?: Apollo.QueryHookOptions<ShippingCountries, ShippingCountriesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingCountries, ShippingCountriesVariables>(ShippingCountriesDocument, options);
      }
export function useShippingCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingCountries, ShippingCountriesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingCountries, ShippingCountriesVariables>(ShippingCountriesDocument, options);
        }
export function useShippingCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShippingCountries, ShippingCountriesVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShippingCountries, ShippingCountriesVariables>(ShippingCountriesDocument, options);
        }
export type ShippingCountriesHookResult = ReturnType<typeof useShippingCountries>;
export type ShippingCountriesLazyQueryHookResult = ReturnType<typeof useShippingCountriesLazyQuery>;
export type ShippingCountriesSuspenseQueryHookResult = ReturnType<typeof useShippingCountriesSuspenseQuery>;
export type ShippingCountriesQueryResult = Apollo.QueryResult<ShippingCountries, ShippingCountriesVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    __typename
    ... on User {
      id
      marketingPreference
    }
  }
  availableMarketingMethodPurposes {
    id
    marketingPurpose {
      id
      key
      name
      encouraged
    }
  }
}
    `;

/**
 * __useCurrentUser__
 *
 * To run a query within a React component, call `useCurrentUser` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUser` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUser({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUser(baseOptions?: Apollo.QueryHookOptions<CurrentUser, CurrentUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUser, CurrentUserVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUser, CurrentUserVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUser, CurrentUserVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUser, CurrentUserVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUser, CurrentUserVariables>(CurrentUserDocument, options);
        }
export type CurrentUserHookResult = ReturnType<typeof useCurrentUser>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUser, CurrentUserVariables>;
export const HealthIssuesDocument = gql`
    query HealthIssues {
  healthIssues {
    id
    name
    information
    warning
    slug
  }
}
    `;

/**
 * __useHealthIssues__
 *
 * To run a query within a React component, call `useHealthIssues` and pass it any options that fit your needs.
 * When your component renders, `useHealthIssues` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthIssues({
 *   variables: {
 *   },
 * });
 */
export function useHealthIssues(baseOptions?: Apollo.QueryHookOptions<HealthIssues, HealthIssuesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HealthIssues, HealthIssuesVariables>(HealthIssuesDocument, options);
      }
export function useHealthIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HealthIssues, HealthIssuesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HealthIssues, HealthIssuesVariables>(HealthIssuesDocument, options);
        }
export function useHealthIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HealthIssues, HealthIssuesVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HealthIssues, HealthIssuesVariables>(HealthIssuesDocument, options);
        }
export type HealthIssuesHookResult = ReturnType<typeof useHealthIssues>;
export type HealthIssuesLazyQueryHookResult = ReturnType<typeof useHealthIssuesLazyQuery>;
export type HealthIssuesSuspenseQueryHookResult = ReturnType<typeof useHealthIssuesSuspenseQuery>;
export type HealthIssuesQueryResult = Apollo.QueryResult<HealthIssues, HealthIssuesVariables>;
export const UpdateDiscountCodeDocument = gql`
    mutation UpdateDiscountCode($discountCode: String!) {
  addDiscountToGuest(code: $discountCode) {
    guest {
      discountCode {
        id
        code
        discountBasis
        value
        discountCodeParts {
          discountBasis
          value
          discountType
          n
        }
      }
    }
  }
}
    `;
export type UpdateDiscountCodeMutationFn = Apollo.MutationFunction<UpdateDiscountCode, UpdateDiscountCodeVariables>;

/**
 * __useUpdateDiscountCode__
 *
 * To run a mutation, you first call `useUpdateDiscountCode` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountCode` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountCode, { data, loading, error }] = useUpdateDiscountCode({
 *   variables: {
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function useUpdateDiscountCode(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountCode, UpdateDiscountCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountCode, UpdateDiscountCodeVariables>(UpdateDiscountCodeDocument, options);
      }
export type UpdateDiscountCodeHookResult = ReturnType<typeof useUpdateDiscountCode>;
export type UpdateDiscountCodeMutationResult = Apollo.MutationResult<UpdateDiscountCode>;
export type UpdateDiscountCodeMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountCode, UpdateDiscountCodeVariables>;
export const SimplifiedCreatePendingSubscriptionDocument = gql`
    mutation SimplifiedCreatePendingSubscription($pendingSubscription: PendingSubscriptionInput!) {
  createPendingSubscription(pendingSubscription: $pendingSubscription) {
    user {
      id
    }
    pendingSubscription {
      id
      firstOrderPricing {
        netTotalPrice
        standardOrderCoreFoodGrossPrice
        grossAdditionalProductsPrice
      }
      pendingSubscriptionFlavours {
        flavour {
          name
          slug
          themeColour
          thumbnail {
            src
          }
        }
        sevenDayServings
      }
    }
  }
}
    `;
export type SimplifiedCreatePendingSubscriptionMutationFn = Apollo.MutationFunction<SimplifiedCreatePendingSubscription, SimplifiedCreatePendingSubscriptionVariables>;

/**
 * __useSimplifiedCreatePendingSubscription__
 *
 * To run a mutation, you first call `useSimplifiedCreatePendingSubscription` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimplifiedCreatePendingSubscription` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simplifiedCreatePendingSubscription, { data, loading, error }] = useSimplifiedCreatePendingSubscription({
 *   variables: {
 *      pendingSubscription: // value for 'pendingSubscription'
 *   },
 * });
 */
export function useSimplifiedCreatePendingSubscription(baseOptions?: Apollo.MutationHookOptions<SimplifiedCreatePendingSubscription, SimplifiedCreatePendingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SimplifiedCreatePendingSubscription, SimplifiedCreatePendingSubscriptionVariables>(SimplifiedCreatePendingSubscriptionDocument, options);
      }
export type SimplifiedCreatePendingSubscriptionHookResult = ReturnType<typeof useSimplifiedCreatePendingSubscription>;
export type SimplifiedCreatePendingSubscriptionMutationResult = Apollo.MutationResult<SimplifiedCreatePendingSubscription>;
export type SimplifiedCreatePendingSubscriptionMutationOptions = Apollo.BaseMutationOptions<SimplifiedCreatePendingSubscription, SimplifiedCreatePendingSubscriptionVariables>;
export const ExtrasScreenQueryDocument = gql`
    query ExtrasScreenQuery {
  guest {
    id
    planRecommendation {
      recommendedExtraProductVariants {
        ...recommendedExtrasFragment
      }
    }
  }
}
    ${recommendedExtrasFragment}`;

/**
 * __useExtrasScreenQuery__
 *
 * To run a query within a React component, call `useExtrasScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtrasScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtrasScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useExtrasScreenQuery(baseOptions?: Apollo.QueryHookOptions<ExtrasScreenQuery, ExtrasScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtrasScreenQuery, ExtrasScreenQueryVariables>(ExtrasScreenQueryDocument, options);
      }
export function useExtrasScreenQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtrasScreenQuery, ExtrasScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtrasScreenQuery, ExtrasScreenQueryVariables>(ExtrasScreenQueryDocument, options);
        }
export function useExtrasScreenQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtrasScreenQuery, ExtrasScreenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtrasScreenQuery, ExtrasScreenQueryVariables>(ExtrasScreenQueryDocument, options);
        }
export type ExtrasScreenQueryHookResult = ReturnType<typeof useExtrasScreenQuery>;
export type ExtrasScreenQueryLazyQueryHookResult = ReturnType<typeof useExtrasScreenQueryLazyQuery>;
export type ExtrasScreenQuerySuspenseQueryHookResult = ReturnType<typeof useExtrasScreenQuerySuspenseQuery>;
export type ExtrasScreenQueryQueryResult = Apollo.QueryResult<ExtrasScreenQuery, ExtrasScreenQueryVariables>;
export const FunnelGiftCampaignQueryDocument = gql`
    query FunnelGiftCampaignQuery($slug: String!) {
  funnelGiftCampaign(slug: $slug) {
    productVariant {
      id
      name
      recurringDeliveryType {
        netPrice
      }
      productCollection {
        id
        name
        merchandisingImage {
          src
        }
        slug
      }
      grossPrice
    }
  }
}
    `;

/**
 * __useFunnelGiftCampaignQuery__
 *
 * To run a query within a React component, call `useFunnelGiftCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunnelGiftCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunnelGiftCampaignQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useFunnelGiftCampaignQuery(baseOptions: Apollo.QueryHookOptions<FunnelGiftCampaignQuery, FunnelGiftCampaignQueryVariables> & ({ variables: FunnelGiftCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FunnelGiftCampaignQuery, FunnelGiftCampaignQueryVariables>(FunnelGiftCampaignQueryDocument, options);
      }
export function useFunnelGiftCampaignQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FunnelGiftCampaignQuery, FunnelGiftCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FunnelGiftCampaignQuery, FunnelGiftCampaignQueryVariables>(FunnelGiftCampaignQueryDocument, options);
        }
export function useFunnelGiftCampaignQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FunnelGiftCampaignQuery, FunnelGiftCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FunnelGiftCampaignQuery, FunnelGiftCampaignQueryVariables>(FunnelGiftCampaignQueryDocument, options);
        }
export type FunnelGiftCampaignQueryHookResult = ReturnType<typeof useFunnelGiftCampaignQuery>;
export type FunnelGiftCampaignQueryLazyQueryHookResult = ReturnType<typeof useFunnelGiftCampaignQueryLazyQuery>;
export type FunnelGiftCampaignQuerySuspenseQueryHookResult = ReturnType<typeof useFunnelGiftCampaignQuerySuspenseQuery>;
export type FunnelGiftCampaignQueryQueryResult = Apollo.QueryResult<FunnelGiftCampaignQuery, FunnelGiftCampaignQueryVariables>;
export const SimplifiedGuestQueryDocument = gql`
    query SimplifiedGuestQuery {
  shouldSeePuppyDiscountModal: featureFlag(
    flag: "should_see_puppy_discount_modal"
    fallback: "not_in_cohort"
  )
  shouldSeePlansMultivariateTest: featureFlag(
    flag: "should_see_plans_multivariate_test"
    fallback: "not_in_cohort"
  )
  currentUser {
    __typename
    ... on Guest {
      id
      numberOfAffiliateFreeBoxes
      preferredLanguage
      assumedShippingCountry {
        id
        code
        showExtras
        trustpilotBusinessUnitId
      }
      dogs {
        id
        name
        gender
        previousFoodTypes {
          foodItem
        }
      }
      discountCode {
        id
        discountCodeParts {
          n
          discountType
          discountBasis
          value
        }
      }
    }
  }
}
    `;

/**
 * __useSimplifiedGuestQuery__
 *
 * To run a query within a React component, call `useSimplifiedGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimplifiedGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimplifiedGuestQuery({
 *   variables: {
 *   },
 * });
 */
export function useSimplifiedGuestQuery(baseOptions?: Apollo.QueryHookOptions<SimplifiedGuestQuery, SimplifiedGuestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimplifiedGuestQuery, SimplifiedGuestQueryVariables>(SimplifiedGuestQueryDocument, options);
      }
export function useSimplifiedGuestQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimplifiedGuestQuery, SimplifiedGuestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimplifiedGuestQuery, SimplifiedGuestQueryVariables>(SimplifiedGuestQueryDocument, options);
        }
export function useSimplifiedGuestQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimplifiedGuestQuery, SimplifiedGuestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimplifiedGuestQuery, SimplifiedGuestQueryVariables>(SimplifiedGuestQueryDocument, options);
        }
export type SimplifiedGuestQueryHookResult = ReturnType<typeof useSimplifiedGuestQuery>;
export type SimplifiedGuestQueryLazyQueryHookResult = ReturnType<typeof useSimplifiedGuestQueryLazyQuery>;
export type SimplifiedGuestQuerySuspenseQueryHookResult = ReturnType<typeof useSimplifiedGuestQuerySuspenseQuery>;
export type SimplifiedGuestQueryQueryResult = Apollo.QueryResult<SimplifiedGuestQuery, SimplifiedGuestQueryVariables>;
export const IdealPlanQueryDocument = gql`
    query IdealPlanQuery {
  guest {
    id
    planRecommendation {
      idealMixPlan {
        ...idealPlanFragment
      }
      idealAllPlan {
        ...idealPlanFragment
      }
    }
  }
}
    ${idealPlanFragment}`;

/**
 * __useIdealPlanQuery__
 *
 * To run a query within a React component, call `useIdealPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdealPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdealPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdealPlanQuery(baseOptions?: Apollo.QueryHookOptions<IdealPlanQuery, IdealPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdealPlanQuery, IdealPlanQueryVariables>(IdealPlanQueryDocument, options);
      }
export function useIdealPlanQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdealPlanQuery, IdealPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdealPlanQuery, IdealPlanQueryVariables>(IdealPlanQueryDocument, options);
        }
export function useIdealPlanQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdealPlanQuery, IdealPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdealPlanQuery, IdealPlanQueryVariables>(IdealPlanQueryDocument, options);
        }
export type IdealPlanQueryHookResult = ReturnType<typeof useIdealPlanQuery>;
export type IdealPlanQueryLazyQueryHookResult = ReturnType<typeof useIdealPlanQueryLazyQuery>;
export type IdealPlanQuerySuspenseQueryHookResult = ReturnType<typeof useIdealPlanQuerySuspenseQuery>;
export type IdealPlanQueryQueryResult = Apollo.QueryResult<IdealPlanQuery, IdealPlanQueryVariables>;
export const PendingSubscriptionOrderPricingQueryDocument = gql`
    query PendingSubscriptionOrderPricingQuery($planId: ID!, $productVariantIds: [ID!]!, $flavourQuantities: MealInput!, $discountCodeId: ID) {
  pendingSubscriptionOrderPrices(
    planId: $planId
    productVariantIds: $productVariantIds
    flavourQuantities: $flavourQuantities
    discountCodeId: $discountCodeId
  ) {
    standardOrderCoreFoodGrossPricePerDay
  }
}
    `;

/**
 * __usePendingSubscriptionOrderPricingQuery__
 *
 * To run a query within a React component, call `usePendingSubscriptionOrderPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingSubscriptionOrderPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingSubscriptionOrderPricingQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      productVariantIds: // value for 'productVariantIds'
 *      flavourQuantities: // value for 'flavourQuantities'
 *      discountCodeId: // value for 'discountCodeId'
 *   },
 * });
 */
export function usePendingSubscriptionOrderPricingQuery(baseOptions: Apollo.QueryHookOptions<PendingSubscriptionOrderPricingQuery, PendingSubscriptionOrderPricingQueryVariables> & ({ variables: PendingSubscriptionOrderPricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingSubscriptionOrderPricingQuery, PendingSubscriptionOrderPricingQueryVariables>(PendingSubscriptionOrderPricingQueryDocument, options);
      }
export function usePendingSubscriptionOrderPricingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingSubscriptionOrderPricingQuery, PendingSubscriptionOrderPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingSubscriptionOrderPricingQuery, PendingSubscriptionOrderPricingQueryVariables>(PendingSubscriptionOrderPricingQueryDocument, options);
        }
export function usePendingSubscriptionOrderPricingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingSubscriptionOrderPricingQuery, PendingSubscriptionOrderPricingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingSubscriptionOrderPricingQuery, PendingSubscriptionOrderPricingQueryVariables>(PendingSubscriptionOrderPricingQueryDocument, options);
        }
export type PendingSubscriptionOrderPricingQueryHookResult = ReturnType<typeof usePendingSubscriptionOrderPricingQuery>;
export type PendingSubscriptionOrderPricingQueryLazyQueryHookResult = ReturnType<typeof usePendingSubscriptionOrderPricingQueryLazyQuery>;
export type PendingSubscriptionOrderPricingQuerySuspenseQueryHookResult = ReturnType<typeof usePendingSubscriptionOrderPricingQuerySuspenseQuery>;
export type PendingSubscriptionOrderPricingQueryQueryResult = Apollo.QueryResult<PendingSubscriptionOrderPricingQuery, PendingSubscriptionOrderPricingQueryVariables>;
export const RecipesScreenQueryDocument = gql`
    query RecipesScreenQuery($planId: ID!) {
  guest {
    id
    planRecommendation {
      idealGramsAmount
      individual {
        dog {
          id
          allergens {
            id
            name
            flavours {
              id
              name
            }
          }
          healthIssues {
            id
            flavours {
              id
              name
            }
            name
          }
        }
      }
      recommendedExtraProductVariants {
        ...recommendedExtrasFragment
      }
      combinedRecommendedFlavours {
        ...recipeCardFlavourFragment
      }
      combinedNotRecommendedFlavours {
        ...recipeCardFlavourFragment
      }
      combinedOtherFlavours {
        ...recipeCardFlavourFragment
      }
    }
  }
}
    ${recommendedExtrasFragment}
${recipeCardFlavourFragment}`;

/**
 * __useRecipesScreenQuery__
 *
 * To run a query within a React component, call `useRecipesScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipesScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipesScreenQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useRecipesScreenQuery(baseOptions: Apollo.QueryHookOptions<RecipesScreenQuery, RecipesScreenQueryVariables> & ({ variables: RecipesScreenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipesScreenQuery, RecipesScreenQueryVariables>(RecipesScreenQueryDocument, options);
      }
export function useRecipesScreenQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipesScreenQuery, RecipesScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipesScreenQuery, RecipesScreenQueryVariables>(RecipesScreenQueryDocument, options);
        }
export function useRecipesScreenQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecipesScreenQuery, RecipesScreenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecipesScreenQuery, RecipesScreenQueryVariables>(RecipesScreenQueryDocument, options);
        }
export type RecipesScreenQueryHookResult = ReturnType<typeof useRecipesScreenQuery>;
export type RecipesScreenQueryLazyQueryHookResult = ReturnType<typeof useRecipesScreenQueryLazyQuery>;
export type RecipesScreenQuerySuspenseQueryHookResult = ReturnType<typeof useRecipesScreenQuerySuspenseQuery>;
export type RecipesScreenQueryQueryResult = Apollo.QueryResult<RecipesScreenQuery, RecipesScreenQueryVariables>;
export const SurveyPageQueryDocument = gql`
    query SurveyPageQuery($slug: String!) {
  user {
    id
    dogs {
      id
      name
      possessivePronoun
      breed {
        id
        key
        name
      }
      dogProfile {
        id
        avatarUrl
      }
    }
    shippingCountryCode
  }
  survey(slug: $slug) {
    id
    name
    finishedUrl
    finishedMessage
    questions {
      id
      text
      questionType
      options {
        id
        text
        image {
          src
        }
        goodOption
      }
    }
  }
}
    `;

/**
 * __useSurveyPageQuery__
 *
 * To run a query within a React component, call `useSurveyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSurveyPageQuery(baseOptions: Apollo.QueryHookOptions<SurveyPageQuery, SurveyPageQueryVariables> & ({ variables: SurveyPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyPageQuery, SurveyPageQueryVariables>(SurveyPageQueryDocument, options);
      }
export function useSurveyPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyPageQuery, SurveyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyPageQuery, SurveyPageQueryVariables>(SurveyPageQueryDocument, options);
        }
export function useSurveyPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyPageQuery, SurveyPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyPageQuery, SurveyPageQueryVariables>(SurveyPageQueryDocument, options);
        }
export type SurveyPageQueryHookResult = ReturnType<typeof useSurveyPageQuery>;
export type SurveyPageQueryLazyQueryHookResult = ReturnType<typeof useSurveyPageQueryLazyQuery>;
export type SurveyPageQuerySuspenseQueryHookResult = ReturnType<typeof useSurveyPageQuerySuspenseQuery>;
export type SurveyPageQueryQueryResult = Apollo.QueryResult<SurveyPageQuery, SurveyPageQueryVariables>;
export const SubscriptionPlanUpdateDocument = gql`
    mutation SubscriptionPlanUpdate($userId: ID!, $planId: ID!) {
  subscriptionPlanUpdate(userId: $userId, planId: $planId) {
    id
    subscription {
      plan {
        id
      }
    }
  }
}
    `;
export type SubscriptionPlanUpdateMutationFn = Apollo.MutationFunction<SubscriptionPlanUpdate, SubscriptionPlanUpdateVariables>;

/**
 * __useSubscriptionPlanUpdate__
 *
 * To run a mutation, you first call `useSubscriptionPlanUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPlanUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionPlanUpdate, { data, loading, error }] = useSubscriptionPlanUpdate({
 *   variables: {
 *      userId: // value for 'userId'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useSubscriptionPlanUpdate(baseOptions?: Apollo.MutationHookOptions<SubscriptionPlanUpdate, SubscriptionPlanUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscriptionPlanUpdate, SubscriptionPlanUpdateVariables>(SubscriptionPlanUpdateDocument, options);
      }
export type SubscriptionPlanUpdateHookResult = ReturnType<typeof useSubscriptionPlanUpdate>;
export type SubscriptionPlanUpdateMutationResult = Apollo.MutationResult<SubscriptionPlanUpdate>;
export type SubscriptionPlanUpdateMutationOptions = Apollo.BaseMutationOptions<SubscriptionPlanUpdate, SubscriptionPlanUpdateVariables>;
export const SwapAndSavePageQueryDocument = gql`
    query SwapAndSavePageQuery {
  user {
    id
    shippingCountryCode
    preferredLanguage
    dogs {
      id
      gender
    }
    subscription {
      id
      status
      recurringOrder {
        deliveryFee
        planTotal
        planTotalPerDay
      }
      plan {
        id
        pouchSize
        numberOfPouches
        durationInDays
        typeOfPlanForCustomer
        servingSize
        swappablePlan {
          id
          price
          pricePerDay
          pouchSize
          numberOfPouches
          durationInDays
          typeOfPlanForCustomer
          servingSize
        }
      }
    }
  }
}
    `;

/**
 * __useSwapAndSavePageQuery__
 *
 * To run a query within a React component, call `useSwapAndSavePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwapAndSavePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwapAndSavePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSwapAndSavePageQuery(baseOptions?: Apollo.QueryHookOptions<SwapAndSavePageQuery, SwapAndSavePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwapAndSavePageQuery, SwapAndSavePageQueryVariables>(SwapAndSavePageQueryDocument, options);
      }
export function useSwapAndSavePageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwapAndSavePageQuery, SwapAndSavePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwapAndSavePageQuery, SwapAndSavePageQueryVariables>(SwapAndSavePageQueryDocument, options);
        }
export function useSwapAndSavePageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwapAndSavePageQuery, SwapAndSavePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwapAndSavePageQuery, SwapAndSavePageQueryVariables>(SwapAndSavePageQueryDocument, options);
        }
export type SwapAndSavePageQueryHookResult = ReturnType<typeof useSwapAndSavePageQuery>;
export type SwapAndSavePageQueryLazyQueryHookResult = ReturnType<typeof useSwapAndSavePageQueryLazyQuery>;
export type SwapAndSavePageQuerySuspenseQueryHookResult = ReturnType<typeof useSwapAndSavePageQuerySuspenseQuery>;
export type SwapAndSavePageQueryQueryResult = Apollo.QueryResult<SwapAndSavePageQuery, SwapAndSavePageQueryVariables>;
export const DogPlanPortionQueryDocument = gql`
    query DogPlanPortionQuery($planId: ID!) {
  user {
    id
    dogs {
      id
      name
      planPortionInGrams
      planPortionInGramsForPlan(planId: $planId)
      gender
    }
  }
}
    `;

/**
 * __useDogPlanPortionQuery__
 *
 * To run a query within a React component, call `useDogPlanPortionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDogPlanPortionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDogPlanPortionQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useDogPlanPortionQuery(baseOptions: Apollo.QueryHookOptions<DogPlanPortionQuery, DogPlanPortionQueryVariables> & ({ variables: DogPlanPortionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DogPlanPortionQuery, DogPlanPortionQueryVariables>(DogPlanPortionQueryDocument, options);
      }
export function useDogPlanPortionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DogPlanPortionQuery, DogPlanPortionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DogPlanPortionQuery, DogPlanPortionQueryVariables>(DogPlanPortionQueryDocument, options);
        }
export function useDogPlanPortionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DogPlanPortionQuery, DogPlanPortionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DogPlanPortionQuery, DogPlanPortionQueryVariables>(DogPlanPortionQueryDocument, options);
        }
export type DogPlanPortionQueryHookResult = ReturnType<typeof useDogPlanPortionQuery>;
export type DogPlanPortionQueryLazyQueryHookResult = ReturnType<typeof useDogPlanPortionQueryLazyQuery>;
export type DogPlanPortionQuerySuspenseQueryHookResult = ReturnType<typeof useDogPlanPortionQuerySuspenseQuery>;
export type DogPlanPortionQueryQueryResult = Apollo.QueryResult<DogPlanPortionQuery, DogPlanPortionQueryVariables>;
export const UpdatePlanAndResumeDocument = gql`
    mutation UpdatePlanAndResume($userId: ID!, $planId: ID!) {
  subscriptionPlanUpdate(userId: $userId, planId: $planId) {
    id
    subscription {
      id
      plan {
        id
      }
    }
  }
  subscriptionResume {
    id
    subscription {
      id
      status
    }
  }
}
    `;
export type UpdatePlanAndResumeMutationFn = Apollo.MutationFunction<UpdatePlanAndResume, UpdatePlanAndResumeVariables>;

/**
 * __useUpdatePlanAndResume__
 *
 * To run a mutation, you first call `useUpdatePlanAndResume` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanAndResume` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanAndResume, { data, loading, error }] = useUpdatePlanAndResume({
 *   variables: {
 *      userId: // value for 'userId'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useUpdatePlanAndResume(baseOptions?: Apollo.MutationHookOptions<UpdatePlanAndResume, UpdatePlanAndResumeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanAndResume, UpdatePlanAndResumeVariables>(UpdatePlanAndResumeDocument, options);
      }
export type UpdatePlanAndResumeHookResult = ReturnType<typeof useUpdatePlanAndResume>;
export type UpdatePlanAndResumeMutationResult = Apollo.MutationResult<UpdatePlanAndResume>;
export type UpdatePlanAndResumeMutationOptions = Apollo.BaseMutationOptions<UpdatePlanAndResume, UpdatePlanAndResumeVariables>;
export const RemoveSurchargedRecipesDocument = gql`
    mutation RemoveSurchargedRecipes {
  removeSurchargedRecipes {
    user {
      id
    }
  }
}
    `;
export type RemoveSurchargedRecipesMutationFn = Apollo.MutationFunction<RemoveSurchargedRecipes, RemoveSurchargedRecipesVariables>;

/**
 * __useRemoveSurchargedRecipes__
 *
 * To run a mutation, you first call `useRemoveSurchargedRecipes` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSurchargedRecipes` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSurchargedRecipes, { data, loading, error }] = useRemoveSurchargedRecipes({
 *   variables: {
 *   },
 * });
 */
export function useRemoveSurchargedRecipes(baseOptions?: Apollo.MutationHookOptions<RemoveSurchargedRecipes, RemoveSurchargedRecipesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSurchargedRecipes, RemoveSurchargedRecipesVariables>(RemoveSurchargedRecipesDocument, options);
      }
export type RemoveSurchargedRecipesHookResult = ReturnType<typeof useRemoveSurchargedRecipes>;
export type RemoveSurchargedRecipesMutationResult = Apollo.MutationResult<RemoveSurchargedRecipes>;
export type RemoveSurchargedRecipesMutationOptions = Apollo.BaseMutationOptions<RemoveSurchargedRecipes, RemoveSurchargedRecipesVariables>;
export const SwitchAndSavePageQueryDocument = gql`
    query SwitchAndSavePageQuery {
  user {
    id
    shippingCountryCode
    preferredLanguage
    subscription {
      id
      status
      recurringOrder {
        deliveryFee
        planTotal
        planTotalPerDay
        surchargeTotal
      }
      meal {
        quantity
        flavour {
          slug
          thumbnail {
            src
          }
          name
          recipeSurcharge
        }
      }
    }
  }
}
    `;

/**
 * __useSwitchAndSavePageQuery__
 *
 * To run a query within a React component, call `useSwitchAndSavePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwitchAndSavePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwitchAndSavePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSwitchAndSavePageQuery(baseOptions?: Apollo.QueryHookOptions<SwitchAndSavePageQuery, SwitchAndSavePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwitchAndSavePageQuery, SwitchAndSavePageQueryVariables>(SwitchAndSavePageQueryDocument, options);
      }
export function useSwitchAndSavePageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwitchAndSavePageQuery, SwitchAndSavePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwitchAndSavePageQuery, SwitchAndSavePageQueryVariables>(SwitchAndSavePageQueryDocument, options);
        }
export function useSwitchAndSavePageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwitchAndSavePageQuery, SwitchAndSavePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwitchAndSavePageQuery, SwitchAndSavePageQueryVariables>(SwitchAndSavePageQueryDocument, options);
        }
export type SwitchAndSavePageQueryHookResult = ReturnType<typeof useSwitchAndSavePageQuery>;
export type SwitchAndSavePageQueryLazyQueryHookResult = ReturnType<typeof useSwitchAndSavePageQueryLazyQuery>;
export type SwitchAndSavePageQuerySuspenseQueryHookResult = ReturnType<typeof useSwitchAndSavePageQuerySuspenseQuery>;
export type SwitchAndSavePageQueryQueryResult = Apollo.QueryResult<SwitchAndSavePageQuery, SwitchAndSavePageQueryVariables>;
export const thankYouQueryDocument = gql`
    query thankYouQuery($headerSlug: String!, $whatsappSingleDogSlug: String!, $whatsappMultipleDogsSlug: String!) {
  systemShouldShowAppContent: featureFlag(
    flag: "system_should_show_app_content"
    fallback: "not_in_cohort"
  )
  user {
    id
    shippingCountryCode
    preferredLanguage
    dogs {
      gender
      name
      id
      ageInMonths
      breed {
        id
        key
        name
      }
      dogProfile {
        avatarUrl
        description
      }
      dailyCalories
      dailyGrams
      eaterType
      neutered
      possessivePronoun
      pouchSizeInGrams
      weightInGrams
    }
    subscription {
      referralLink {
        url
      }
      nextNBoxes(num: 1) {
        id
        cutOffDate
        isoDeliveryDate
      }
    }
  }
  header: copyEntry(slug: $headerSlug) {
    text
  }
  whatsAppSingleDog: copyEntry(slug: $whatsappSingleDogSlug) {
    text
  }
  whatsAppMultipleDogs: copyEntry(slug: $whatsappMultipleDogsSlug) {
    text
  }
}
    `;

/**
 * __usethankYouQuery__
 *
 * To run a query within a React component, call `usethankYouQuery` and pass it any options that fit your needs.
 * When your component renders, `usethankYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usethankYouQuery({
 *   variables: {
 *      headerSlug: // value for 'headerSlug'
 *      whatsappSingleDogSlug: // value for 'whatsappSingleDogSlug'
 *      whatsappMultipleDogsSlug: // value for 'whatsappMultipleDogsSlug'
 *   },
 * });
 */
export function usethankYouQuery(baseOptions: Apollo.QueryHookOptions<thankYouQuery, thankYouQueryVariables> & ({ variables: thankYouQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<thankYouQuery, thankYouQueryVariables>(thankYouQueryDocument, options);
      }
export function usethankYouQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<thankYouQuery, thankYouQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<thankYouQuery, thankYouQueryVariables>(thankYouQueryDocument, options);
        }
export function usethankYouQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<thankYouQuery, thankYouQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<thankYouQuery, thankYouQueryVariables>(thankYouQueryDocument, options);
        }
export type thankYouQueryHookResult = ReturnType<typeof usethankYouQuery>;
export type thankYouQueryLazyQueryHookResult = ReturnType<typeof usethankYouQueryLazyQuery>;
export type thankYouQuerySuspenseQueryHookResult = ReturnType<typeof usethankYouQuerySuspenseQuery>;
export type thankYouQueryQueryResult = Apollo.QueryResult<thankYouQuery, thankYouQueryVariables>;
export const thankYouQueryV3Document = gql`
    query thankYouQueryV3($headerSlug: String!, $whatsappSingleDogSlug: String!, $whatsappMultipleDogsSlug: String!) {
  systemShouldShowAppContent: featureFlag(
    flag: "system_should_show_app_content"
    fallback: "not_in_cohort"
  )
  user {
    id
    shippingCountryCode
    preferredLanguage
    dogs {
      gender
      name
      id
      ageInMonths
      dogProfile {
        id
        avatarUrl
        description
      }
      possessivePronoun
    }
    subscription {
      id
      referralLink {
        referralLinkTypeName
        referralDiscountsTotalValue
        url
        referralDiscount {
          id
          code
          discountCodeParts {
            value
            discountType
            discountBasis
            n
          }
        }
        referrerDiscount {
          applicableDiscountParts {
            value
            discountBasis
            n
            discountType
          }
        }
        referrals {
          refereeFirstName
          refereeDogNames
          refereeSignUpDate
        }
      }
    }
  }
  header: copyEntry(slug: $headerSlug) {
    text
  }
  whatsAppSingleDog: copyEntry(slug: $whatsappSingleDogSlug) {
    text
  }
  whatsAppMultipleDogs: copyEntry(slug: $whatsappMultipleDogsSlug) {
    text
  }
}
    `;

/**
 * __usethankYouQueryV3__
 *
 * To run a query within a React component, call `usethankYouQueryV3` and pass it any options that fit your needs.
 * When your component renders, `usethankYouQueryV3` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usethankYouQueryV3({
 *   variables: {
 *      headerSlug: // value for 'headerSlug'
 *      whatsappSingleDogSlug: // value for 'whatsappSingleDogSlug'
 *      whatsappMultipleDogsSlug: // value for 'whatsappMultipleDogsSlug'
 *   },
 * });
 */
export function usethankYouQueryV3(baseOptions: Apollo.QueryHookOptions<thankYouQueryV3, thankYouQueryV3Variables> & ({ variables: thankYouQueryV3Variables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<thankYouQueryV3, thankYouQueryV3Variables>(thankYouQueryV3Document, options);
      }
export function usethankYouQueryV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<thankYouQueryV3, thankYouQueryV3Variables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<thankYouQueryV3, thankYouQueryV3Variables>(thankYouQueryV3Document, options);
        }
export function usethankYouQueryV3SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<thankYouQueryV3, thankYouQueryV3Variables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<thankYouQueryV3, thankYouQueryV3Variables>(thankYouQueryV3Document, options);
        }
export type thankYouQueryV3HookResult = ReturnType<typeof usethankYouQueryV3>;
export type thankYouQueryV3LazyQueryHookResult = ReturnType<typeof usethankYouQueryV3LazyQuery>;
export type thankYouQueryV3SuspenseQueryHookResult = ReturnType<typeof usethankYouQueryV3SuspenseQuery>;
export type thankYouQueryV3QueryResult = Apollo.QueryResult<thankYouQueryV3, thankYouQueryV3Variables>;
export const PausedCalendarDatesDataDocument = gql`
    query PausedCalendarDatesData($calendarInitDate: ISO8601Date!, $nDays: Int, $city: String, $shipmentType: String!, $shouldAttemptToOfferNextDayDelivery: Boolean, $postcode: String, $userId: ID) {
  user {
    id
    shippingCountryCode
    subscription {
      id
      nextNBoxes(num: 3) {
        id
        isoDeliveryDate
        editable
      }
    }
  }
  calendarDates(
    startDate: $calendarInitDate
    nDays: $nDays
    city: $city
    shipmentType: $shipmentType
    shouldAttemptToOfferNextDayDelivery: $shouldAttemptToOfferNextDayDelivery
    postcode: $postcode
    userId: $userId
  ) {
    date
    deliverable
    replacementDate
  }
}
    `;

/**
 * __usePausedCalendarDatesData__
 *
 * To run a query within a React component, call `usePausedCalendarDatesData` and pass it any options that fit your needs.
 * When your component renders, `usePausedCalendarDatesData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePausedCalendarDatesData({
 *   variables: {
 *      calendarInitDate: // value for 'calendarInitDate'
 *      nDays: // value for 'nDays'
 *      city: // value for 'city'
 *      shipmentType: // value for 'shipmentType'
 *      shouldAttemptToOfferNextDayDelivery: // value for 'shouldAttemptToOfferNextDayDelivery'
 *      postcode: // value for 'postcode'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePausedCalendarDatesData(baseOptions: Apollo.QueryHookOptions<PausedCalendarDatesData, PausedCalendarDatesDataVariables> & ({ variables: PausedCalendarDatesDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PausedCalendarDatesData, PausedCalendarDatesDataVariables>(PausedCalendarDatesDataDocument, options);
      }
export function usePausedCalendarDatesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PausedCalendarDatesData, PausedCalendarDatesDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PausedCalendarDatesData, PausedCalendarDatesDataVariables>(PausedCalendarDatesDataDocument, options);
        }
export function usePausedCalendarDatesDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PausedCalendarDatesData, PausedCalendarDatesDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PausedCalendarDatesData, PausedCalendarDatesDataVariables>(PausedCalendarDatesDataDocument, options);
        }
export type PausedCalendarDatesDataHookResult = ReturnType<typeof usePausedCalendarDatesData>;
export type PausedCalendarDatesDataLazyQueryHookResult = ReturnType<typeof usePausedCalendarDatesDataLazyQuery>;
export type PausedCalendarDatesDataSuspenseQueryHookResult = ReturnType<typeof usePausedCalendarDatesDataSuspenseQuery>;
export type PausedCalendarDatesDataQueryResult = Apollo.QueryResult<PausedCalendarDatesData, PausedCalendarDatesDataVariables>;
export const TreatmentsPausedFutureBoxesQueryDocument = gql`
    query TreatmentsPausedFutureBoxesQuery {
  user {
    id
    subscription {
      id
      previewUncreatedFutureBox {
        isoDeliveryDate
        order {
          id
          totalPrice
          surchargeTotal
          planTotal
          deliveryFee
          subtotal
          discountTotal
          discountedSubtotalPricePerDay
          subtotalPricePerDay
        }
      }
    }
  }
}
    `;

/**
 * __useTreatmentsPausedFutureBoxesQuery__
 *
 * To run a query within a React component, call `useTreatmentsPausedFutureBoxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentsPausedFutureBoxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentsPausedFutureBoxesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTreatmentsPausedFutureBoxesQuery(baseOptions?: Apollo.QueryHookOptions<TreatmentsPausedFutureBoxesQuery, TreatmentsPausedFutureBoxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentsPausedFutureBoxesQuery, TreatmentsPausedFutureBoxesQueryVariables>(TreatmentsPausedFutureBoxesQueryDocument, options);
      }
export function useTreatmentsPausedFutureBoxesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentsPausedFutureBoxesQuery, TreatmentsPausedFutureBoxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentsPausedFutureBoxesQuery, TreatmentsPausedFutureBoxesQueryVariables>(TreatmentsPausedFutureBoxesQueryDocument, options);
        }
export function useTreatmentsPausedFutureBoxesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TreatmentsPausedFutureBoxesQuery, TreatmentsPausedFutureBoxesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TreatmentsPausedFutureBoxesQuery, TreatmentsPausedFutureBoxesQueryVariables>(TreatmentsPausedFutureBoxesQueryDocument, options);
        }
export type TreatmentsPausedFutureBoxesQueryHookResult = ReturnType<typeof useTreatmentsPausedFutureBoxesQuery>;
export type TreatmentsPausedFutureBoxesQueryLazyQueryHookResult = ReturnType<typeof useTreatmentsPausedFutureBoxesQueryLazyQuery>;
export type TreatmentsPausedFutureBoxesQuerySuspenseQueryHookResult = ReturnType<typeof useTreatmentsPausedFutureBoxesQuerySuspenseQuery>;
export type TreatmentsPausedFutureBoxesQueryQueryResult = Apollo.QueryResult<TreatmentsPausedFutureBoxesQuery, TreatmentsPausedFutureBoxesQueryVariables>;
export const TreatmentsPausedPageQueryDocument = gql`
    query TreatmentsPausedPageQuery($from: ISO8601Date!, $to: ISO8601Date!) {
  user {
    id
    preferredLanguage
    shippingCountryCode
    shippingCountry {
      id
      code
    }
    address {
      id
      deliverable
      postcode
    }
    dogs {
      id
      name
      gender
    }
    ordersByDate(from: $from, to: $to) {
      ...upcomingBoxOrderFragment
      ...nonCoreUpcomingOrderFragment
    }
    subscription {
      id
      status
      activePaymentMethodType
      previewUncreatedFutureBox {
        isoDeliveryDate
        order {
          id
          totalPrice
          surchargeTotal
          planTotal
          deliveryFee
          subtotal
          discountTotal
          discountedSubtotalPricePerDay
          subtotalPricePerDay
        }
      }
      meal {
        quantity
        flavour {
          id
          slug
          thumbnail {
            src
          }
          themeColour
          name
          recipeSurcharge
          productLabels {
            id
            name
            themeColour
          }
        }
      }
      plan {
        id
        pouchSize
        numberOfPouches
        durationInDays
        swappablePlan {
          id
          pouchSize
          price
        }
        downsizeablePlan {
          id
          price
        }
      }
      currentPause {
        id
        treatments
      }
      defaultReactivationCampaign {
        name
        expiryDate
        description
        discountCode {
          id
          discountCodeParts {
            discountBasis
            value
            discountType
            n
          }
        }
      }
      alreadyRedeemedReactivationCampaign {
        name
        expiryDate
        description
        discountCode {
          id
          discountCodeParts {
            discountBasis
            value
            discountType
            n
          }
        }
      }
    }
  }
}
    ${upcomingBoxOrderFragment}
${nonCoreUpcomingOrderFragment}`;

/**
 * __useTreatmentsPausedPageQuery__
 *
 * To run a query within a React component, call `useTreatmentsPausedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentsPausedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentsPausedPageQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useTreatmentsPausedPageQuery(baseOptions: Apollo.QueryHookOptions<TreatmentsPausedPageQuery, TreatmentsPausedPageQueryVariables> & ({ variables: TreatmentsPausedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentsPausedPageQuery, TreatmentsPausedPageQueryVariables>(TreatmentsPausedPageQueryDocument, options);
      }
export function useTreatmentsPausedPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentsPausedPageQuery, TreatmentsPausedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentsPausedPageQuery, TreatmentsPausedPageQueryVariables>(TreatmentsPausedPageQueryDocument, options);
        }
export function useTreatmentsPausedPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TreatmentsPausedPageQuery, TreatmentsPausedPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TreatmentsPausedPageQuery, TreatmentsPausedPageQueryVariables>(TreatmentsPausedPageQueryDocument, options);
        }
export type TreatmentsPausedPageQueryHookResult = ReturnType<typeof useTreatmentsPausedPageQuery>;
export type TreatmentsPausedPageQueryLazyQueryHookResult = ReturnType<typeof useTreatmentsPausedPageQueryLazyQuery>;
export type TreatmentsPausedPageQuerySuspenseQueryHookResult = ReturnType<typeof useTreatmentsPausedPageQuerySuspenseQuery>;
export type TreatmentsPausedPageQueryQueryResult = Apollo.QueryResult<TreatmentsPausedPageQuery, TreatmentsPausedPageQueryVariables>;
export const UpdateDogAboutInfoMutationDocument = gql`
    mutation UpdateDogAboutInfoMutation($userId: ID!, $attributes: [DogUpdateInput!]!) {
  dogsUpdate(userId: $userId, attributes: $attributes) {
    id
    dogs {
      id
      name
      ageInMonths
      breed {
        key
        name
      }
      gender
    }
    subscription {
      id
      idealPlan {
        pricingCurve {
          pricingCohort
        }
      }
      plan {
        pricingCurve {
          pricingCohort
        }
      }
    }
  }
}
    `;
export type UpdateDogAboutInfoMutationMutationFn = Apollo.MutationFunction<UpdateDogAboutInfoMutation, UpdateDogAboutInfoMutationVariables>;

/**
 * __useUpdateDogAboutInfoMutation__
 *
 * To run a mutation, you first call `useUpdateDogAboutInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDogAboutInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDogAboutInfoMutation, { data, loading, error }] = useUpdateDogAboutInfoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateDogAboutInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDogAboutInfoMutation, UpdateDogAboutInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDogAboutInfoMutation, UpdateDogAboutInfoMutationVariables>(UpdateDogAboutInfoMutationDocument, options);
      }
export type UpdateDogAboutInfoMutationHookResult = ReturnType<typeof useUpdateDogAboutInfoMutation>;
export type UpdateDogAboutInfoMutationMutationResult = Apollo.MutationResult<UpdateDogAboutInfoMutation>;
export type UpdateDogAboutInfoMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDogAboutInfoMutation, UpdateDogAboutInfoMutationVariables>;
export const DogAboutInfoQueryDocument = gql`
    query DogAboutInfoQuery {
  user {
    id
    dogs {
      id
      name
      ageInMonths
      breed {
        id
        key
        name
      }
      gender
      neutered
    }
  }
  breeds {
    id
    key
    name
  }
}
    `;

/**
 * __useDogAboutInfoQuery__
 *
 * To run a query within a React component, call `useDogAboutInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDogAboutInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDogAboutInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDogAboutInfoQuery(baseOptions?: Apollo.QueryHookOptions<DogAboutInfoQuery, DogAboutInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DogAboutInfoQuery, DogAboutInfoQueryVariables>(DogAboutInfoQueryDocument, options);
      }
export function useDogAboutInfoQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DogAboutInfoQuery, DogAboutInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DogAboutInfoQuery, DogAboutInfoQueryVariables>(DogAboutInfoQueryDocument, options);
        }
export function useDogAboutInfoQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DogAboutInfoQuery, DogAboutInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DogAboutInfoQuery, DogAboutInfoQueryVariables>(DogAboutInfoQueryDocument, options);
        }
export type DogAboutInfoQueryHookResult = ReturnType<typeof useDogAboutInfoQuery>;
export type DogAboutInfoQueryLazyQueryHookResult = ReturnType<typeof useDogAboutInfoQueryLazyQuery>;
export type DogAboutInfoQuerySuspenseQueryHookResult = ReturnType<typeof useDogAboutInfoQuerySuspenseQuery>;
export type DogAboutInfoQueryQueryResult = Apollo.QueryResult<DogAboutInfoQuery, DogAboutInfoQueryVariables>;
export const UpdateDogBasicInformationMutationDocument = gql`
    mutation UpdateDogBasicInformationMutation($userId: ID!, $attributes: [DogUpdateInput!]!) {
  dogsUpdate(userId: $userId, attributes: $attributes) {
    id
    dogs {
      id
      name
      ageInMonths
      breed {
        key
        name
      }
      gender
      neutered
    }
    subscription {
      id
      idealPlan {
        pricingCurve {
          pricingCohort
        }
      }
      plan {
        pricingCurve {
          pricingCohort
        }
      }
    }
  }
}
    `;
export type UpdateDogBasicInformationMutationMutationFn = Apollo.MutationFunction<UpdateDogBasicInformationMutation, UpdateDogBasicInformationMutationVariables>;

/**
 * __useUpdateDogBasicInformationMutation__
 *
 * To run a mutation, you first call `useUpdateDogBasicInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDogBasicInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDogBasicInformationMutation, { data, loading, error }] = useUpdateDogBasicInformationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateDogBasicInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDogBasicInformationMutation, UpdateDogBasicInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDogBasicInformationMutation, UpdateDogBasicInformationMutationVariables>(UpdateDogBasicInformationMutationDocument, options);
      }
export type UpdateDogBasicInformationMutationHookResult = ReturnType<typeof useUpdateDogBasicInformationMutation>;
export type UpdateDogBasicInformationMutationMutationResult = Apollo.MutationResult<UpdateDogBasicInformationMutation>;
export type UpdateDogBasicInformationMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDogBasicInformationMutation, UpdateDogBasicInformationMutationVariables>;
export const UpdateDogBasicInfoMutationDocument = gql`
    mutation UpdateDogBasicInfoMutation($userId: ID!, $attributes: [DogUpdateInput!]!, $caloriesMultipleOf: Int!, $percentageMultipleOf: Int!, $lowerPercentage: Int!, $upperPercentage: Int!) {
  dogsUpdate(userId: $userId, attributes: $attributes) {
    id
    dogs {
      id
      name
      gender
      weightInGrams
      bodyShape
      exercise
      neutered
      ...CalorieDetailsFragment
    }
    subscription {
      id
      idealPlan {
        pricingCurve {
          pricingCohort
        }
      }
      plan {
        pricingCurve {
          pricingCohort
        }
      }
    }
  }
}
    ${CalorieDetailsFragment}`;
export type UpdateDogBasicInfoMutationMutationFn = Apollo.MutationFunction<UpdateDogBasicInfoMutation, UpdateDogBasicInfoMutationVariables>;

/**
 * __useUpdateDogBasicInfoMutation__
 *
 * To run a mutation, you first call `useUpdateDogBasicInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDogBasicInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDogBasicInfoMutation, { data, loading, error }] = useUpdateDogBasicInfoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *      caloriesMultipleOf: // value for 'caloriesMultipleOf'
 *      percentageMultipleOf: // value for 'percentageMultipleOf'
 *      lowerPercentage: // value for 'lowerPercentage'
 *      upperPercentage: // value for 'upperPercentage'
 *   },
 * });
 */
export function useUpdateDogBasicInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDogBasicInfoMutation, UpdateDogBasicInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDogBasicInfoMutation, UpdateDogBasicInfoMutationVariables>(UpdateDogBasicInfoMutationDocument, options);
      }
export type UpdateDogBasicInfoMutationHookResult = ReturnType<typeof useUpdateDogBasicInfoMutation>;
export type UpdateDogBasicInfoMutationMutationResult = Apollo.MutationResult<UpdateDogBasicInfoMutation>;
export type UpdateDogBasicInfoMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDogBasicInfoMutation, UpdateDogBasicInfoMutationVariables>;
export const DogBasicInfoQueryDocument = gql`
    query DogBasicInfoQuery {
  user {
    id
    subscription {
      id
      idealPlan {
        pricingCurve {
          pricingCohort
        }
      }
      plan {
        pricingCurve {
          pricingCohort
        }
      }
    }
    dogs {
      id
      name
      gender
      weightInGrams
      bodyShape
      exercise
      neutered
    }
  }
}
    `;

/**
 * __useDogBasicInfoQuery__
 *
 * To run a query within a React component, call `useDogBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDogBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDogBasicInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDogBasicInfoQuery(baseOptions?: Apollo.QueryHookOptions<DogBasicInfoQuery, DogBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DogBasicInfoQuery, DogBasicInfoQueryVariables>(DogBasicInfoQueryDocument, options);
      }
export function useDogBasicInfoQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DogBasicInfoQuery, DogBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DogBasicInfoQuery, DogBasicInfoQueryVariables>(DogBasicInfoQueryDocument, options);
        }
export function useDogBasicInfoQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DogBasicInfoQuery, DogBasicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DogBasicInfoQuery, DogBasicInfoQueryVariables>(DogBasicInfoQueryDocument, options);
        }
export type DogBasicInfoQueryHookResult = ReturnType<typeof useDogBasicInfoQuery>;
export type DogBasicInfoQueryLazyQueryHookResult = ReturnType<typeof useDogBasicInfoQueryLazyQuery>;
export type DogBasicInfoQuerySuspenseQueryHookResult = ReturnType<typeof useDogBasicInfoQuerySuspenseQuery>;
export type DogBasicInfoQueryQueryResult = Apollo.QueryResult<DogBasicInfoQuery, DogBasicInfoQueryVariables>;
export const UpdateDogEatingHabitsMutationDocument = gql`
    mutation UpdateDogEatingHabitsMutation($userId: ID!, $attributes: [DogUpdateInput!]!) {
  dogsUpdate(userId: $userId, attributes: $attributes) {
    id
    dogs {
      id
      name
      gender
      eaterType
      snackingHabits
    }
    subscription {
      id
      idealPlan {
        pricingCurve {
          pricingCohort
        }
      }
      plan {
        pricingCurve {
          pricingCohort
        }
      }
    }
  }
}
    `;
export type UpdateDogEatingHabitsMutationMutationFn = Apollo.MutationFunction<UpdateDogEatingHabitsMutation, UpdateDogEatingHabitsMutationVariables>;

/**
 * __useUpdateDogEatingHabitsMutation__
 *
 * To run a mutation, you first call `useUpdateDogEatingHabitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDogEatingHabitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDogEatingHabitsMutation, { data, loading, error }] = useUpdateDogEatingHabitsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateDogEatingHabitsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDogEatingHabitsMutation, UpdateDogEatingHabitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDogEatingHabitsMutation, UpdateDogEatingHabitsMutationVariables>(UpdateDogEatingHabitsMutationDocument, options);
      }
export type UpdateDogEatingHabitsMutationHookResult = ReturnType<typeof useUpdateDogEatingHabitsMutation>;
export type UpdateDogEatingHabitsMutationMutationResult = Apollo.MutationResult<UpdateDogEatingHabitsMutation>;
export type UpdateDogEatingHabitsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDogEatingHabitsMutation, UpdateDogEatingHabitsMutationVariables>;
export const DogEatingHabitsQueryDocument = gql`
    query DogEatingHabitsQuery {
  user {
    id
    dogs {
      id
      name
      gender
      eaterType
      snackingHabits
    }
  }
}
    `;

/**
 * __useDogEatingHabitsQuery__
 *
 * To run a query within a React component, call `useDogEatingHabitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDogEatingHabitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDogEatingHabitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDogEatingHabitsQuery(baseOptions?: Apollo.QueryHookOptions<DogEatingHabitsQuery, DogEatingHabitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DogEatingHabitsQuery, DogEatingHabitsQueryVariables>(DogEatingHabitsQueryDocument, options);
      }
export function useDogEatingHabitsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DogEatingHabitsQuery, DogEatingHabitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DogEatingHabitsQuery, DogEatingHabitsQueryVariables>(DogEatingHabitsQueryDocument, options);
        }
export function useDogEatingHabitsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DogEatingHabitsQuery, DogEatingHabitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DogEatingHabitsQuery, DogEatingHabitsQueryVariables>(DogEatingHabitsQueryDocument, options);
        }
export type DogEatingHabitsQueryHookResult = ReturnType<typeof useDogEatingHabitsQuery>;
export type DogEatingHabitsQueryLazyQueryHookResult = ReturnType<typeof useDogEatingHabitsQueryLazyQuery>;
export type DogEatingHabitsQuerySuspenseQueryHookResult = ReturnType<typeof useDogEatingHabitsQuerySuspenseQuery>;
export type DogEatingHabitsQueryQueryResult = Apollo.QueryResult<DogEatingHabitsQuery, DogEatingHabitsQueryVariables>;
export const UpdateMedicalInfoMutationDocument = gql`
    mutation UpdateMedicalInfoMutation($userId: ID!, $attributes: [DogUpdateInput!]!) {
  dogsUpdate(userId: $userId, attributes: $attributes) {
    id
    dogs {
      id
      name
      gender
      possessivePronoun
      healthIssues {
        id
        name
        warning
        information
      }
      allergens {
        id
        name
      }
    }
    subscription {
      id
      idealPlan {
        id
        pricingCurve {
          id
          pricingCohort
        }
      }
      plan {
        id
        pricingCurve {
          id
          pricingCohort
        }
      }
    }
  }
}
    `;
export type UpdateMedicalInfoMutationMutationFn = Apollo.MutationFunction<UpdateMedicalInfoMutation, UpdateMedicalInfoMutationVariables>;

/**
 * __useUpdateMedicalInfoMutation__
 *
 * To run a mutation, you first call `useUpdateMedicalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicalInfoMutation, { data, loading, error }] = useUpdateMedicalInfoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateMedicalInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMedicalInfoMutation, UpdateMedicalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMedicalInfoMutation, UpdateMedicalInfoMutationVariables>(UpdateMedicalInfoMutationDocument, options);
      }
export type UpdateMedicalInfoMutationHookResult = ReturnType<typeof useUpdateMedicalInfoMutation>;
export type UpdateMedicalInfoMutationMutationResult = Apollo.MutationResult<UpdateMedicalInfoMutation>;
export type UpdateMedicalInfoMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMedicalInfoMutation, UpdateMedicalInfoMutationVariables>;
export const MedicalInfoQueryDocument = gql`
    query MedicalInfoQuery {
  user {
    id
    subscription {
      id
      idealPlan {
        id
        pricingCurve {
          id
          pricingCohort
        }
      }
      plan {
        id
        pricingCurve {
          id
          pricingCohort
        }
      }
    }
    dogs {
      id
      name
      gender
      possessivePronoun
      healthIssues {
        id
        name
        warning
        information
      }
      allergens {
        id
        name
      }
    }
  }
  healthIssues {
    id
    name
    warning
    information
  }
  allergens {
    id
    name
  }
}
    `;

/**
 * __useMedicalInfoQuery__
 *
 * To run a query within a React component, call `useMedicalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMedicalInfoQuery(baseOptions?: Apollo.QueryHookOptions<MedicalInfoQuery, MedicalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicalInfoQuery, MedicalInfoQueryVariables>(MedicalInfoQueryDocument, options);
      }
export function useMedicalInfoQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalInfoQuery, MedicalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicalInfoQuery, MedicalInfoQueryVariables>(MedicalInfoQueryDocument, options);
        }
export function useMedicalInfoQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MedicalInfoQuery, MedicalInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedicalInfoQuery, MedicalInfoQueryVariables>(MedicalInfoQueryDocument, options);
        }
export type MedicalInfoQueryHookResult = ReturnType<typeof useMedicalInfoQuery>;
export type MedicalInfoQueryLazyQueryHookResult = ReturnType<typeof useMedicalInfoQueryLazyQuery>;
export type MedicalInfoQuerySuspenseQueryHookResult = ReturnType<typeof useMedicalInfoQuerySuspenseQuery>;
export type MedicalInfoQueryQueryResult = Apollo.QueryResult<MedicalInfoQuery, MedicalInfoQueryVariables>;
export const CreateDogProfilesMutationDocument = gql`
    mutation CreateDogProfilesMutation($userId: ID!, $dogIdsInput: [ID!]!) {
  dogProfilesCreate(userId: $userId, dogIdsInput: $dogIdsInput) {
    id
  }
}
    `;
export type CreateDogProfilesMutationMutationFn = Apollo.MutationFunction<CreateDogProfilesMutation, CreateDogProfilesMutationVariables>;

/**
 * __useCreateDogProfilesMutation__
 *
 * To run a mutation, you first call `useCreateDogProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDogProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDogProfilesMutation, { data, loading, error }] = useCreateDogProfilesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      dogIdsInput: // value for 'dogIdsInput'
 *   },
 * });
 */
export function useCreateDogProfilesMutation(baseOptions?: Apollo.MutationHookOptions<CreateDogProfilesMutation, CreateDogProfilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDogProfilesMutation, CreateDogProfilesMutationVariables>(CreateDogProfilesMutationDocument, options);
      }
export type CreateDogProfilesMutationHookResult = ReturnType<typeof useCreateDogProfilesMutation>;
export type CreateDogProfilesMutationMutationResult = Apollo.MutationResult<CreateDogProfilesMutation>;
export type CreateDogProfilesMutationMutationOptions = Apollo.BaseMutationOptions<CreateDogProfilesMutation, CreateDogProfilesMutationVariables>;
export const UpdateDogPersonalityMutationDocument = gql`
    mutation UpdateDogPersonalityMutation($userId: ID!, $traitsInput: [TraitsInput!]!, $activitiesInput: [ActivitiesInput!]!, $favouriteGamesInput: [FavouriteGameInput!]!) {
  traitsUpdate(userId: $userId, traitsInput: $traitsInput) {
    id
  }
  activitiesUpdate(userId: $userId, activitiesInput: $activitiesInput) {
    id
  }
  favouriteGamesUpdate(userId: $userId, favouriteGamesInput: $favouriteGamesInput) {
    id
  }
}
    `;
export type UpdateDogPersonalityMutationMutationFn = Apollo.MutationFunction<UpdateDogPersonalityMutation, UpdateDogPersonalityMutationVariables>;

/**
 * __useUpdateDogPersonalityMutation__
 *
 * To run a mutation, you first call `useUpdateDogPersonalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDogPersonalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDogPersonalityMutation, { data, loading, error }] = useUpdateDogPersonalityMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      traitsInput: // value for 'traitsInput'
 *      activitiesInput: // value for 'activitiesInput'
 *      favouriteGamesInput: // value for 'favouriteGamesInput'
 *   },
 * });
 */
export function useUpdateDogPersonalityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDogPersonalityMutation, UpdateDogPersonalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDogPersonalityMutation, UpdateDogPersonalityMutationVariables>(UpdateDogPersonalityMutationDocument, options);
      }
export type UpdateDogPersonalityMutationHookResult = ReturnType<typeof useUpdateDogPersonalityMutation>;
export type UpdateDogPersonalityMutationMutationResult = Apollo.MutationResult<UpdateDogPersonalityMutation>;
export type UpdateDogPersonalityMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDogPersonalityMutation, UpdateDogPersonalityMutationVariables>;
export const DogPersonalityQueryDocument = gql`
    query DogPersonalityQuery {
  user {
    id
    dogs {
      id
      name
      gender
      dogProfile {
        id
        dogActivities {
          activity
        }
        dogPersonalityTraits {
          trait
        }
        favouriteGame
      }
    }
  }
}
    `;

/**
 * __useDogPersonalityQuery__
 *
 * To run a query within a React component, call `useDogPersonalityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDogPersonalityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDogPersonalityQuery({
 *   variables: {
 *   },
 * });
 */
export function useDogPersonalityQuery(baseOptions?: Apollo.QueryHookOptions<DogPersonalityQuery, DogPersonalityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DogPersonalityQuery, DogPersonalityQueryVariables>(DogPersonalityQueryDocument, options);
      }
export function useDogPersonalityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DogPersonalityQuery, DogPersonalityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DogPersonalityQuery, DogPersonalityQueryVariables>(DogPersonalityQueryDocument, options);
        }
export function useDogPersonalityQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DogPersonalityQuery, DogPersonalityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DogPersonalityQuery, DogPersonalityQueryVariables>(DogPersonalityQueryDocument, options);
        }
export type DogPersonalityQueryHookResult = ReturnType<typeof useDogPersonalityQuery>;
export type DogPersonalityQueryLazyQueryHookResult = ReturnType<typeof useDogPersonalityQueryLazyQuery>;
export type DogPersonalityQuerySuspenseQueryHookResult = ReturnType<typeof useDogPersonalityQuerySuspenseQuery>;
export type DogPersonalityQueryQueryResult = Apollo.QueryResult<DogPersonalityQuery, DogPersonalityQueryVariables>;
export const UpdateDogWeightAndAppetiteMutationDocument = gql`
    mutation UpdateDogWeightAndAppetiteMutation($userId: ID!, $attributes: [DogUpdateInput!]!, $caloriesMultipleOf: Int!, $percentageMultipleOf: Int!, $lowerPercentage: Int!, $upperPercentage: Int!) {
  dogsUpdate(userId: $userId, attributes: $attributes) {
    id
    dogs {
      id
      name
      gender
      weightInGrams
      bodyShape
      exercise
      neutered
      eaterType
      snackingHabits
      ...CalorieDetailsFragment
    }
    subscription {
      id
      idealPlan {
        id
        pricingCurve {
          id
          pricingCohort
        }
      }
      plan {
        id
        pricingCurve {
          id
          pricingCohort
        }
      }
    }
  }
}
    ${CalorieDetailsFragment}`;
export type UpdateDogWeightAndAppetiteMutationMutationFn = Apollo.MutationFunction<UpdateDogWeightAndAppetiteMutation, UpdateDogWeightAndAppetiteMutationVariables>;

/**
 * __useUpdateDogWeightAndAppetiteMutation__
 *
 * To run a mutation, you first call `useUpdateDogWeightAndAppetiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDogWeightAndAppetiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDogWeightAndAppetiteMutation, { data, loading, error }] = useUpdateDogWeightAndAppetiteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *      caloriesMultipleOf: // value for 'caloriesMultipleOf'
 *      percentageMultipleOf: // value for 'percentageMultipleOf'
 *      lowerPercentage: // value for 'lowerPercentage'
 *      upperPercentage: // value for 'upperPercentage'
 *   },
 * });
 */
export function useUpdateDogWeightAndAppetiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDogWeightAndAppetiteMutation, UpdateDogWeightAndAppetiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDogWeightAndAppetiteMutation, UpdateDogWeightAndAppetiteMutationVariables>(UpdateDogWeightAndAppetiteMutationDocument, options);
      }
export type UpdateDogWeightAndAppetiteMutationHookResult = ReturnType<typeof useUpdateDogWeightAndAppetiteMutation>;
export type UpdateDogWeightAndAppetiteMutationMutationResult = Apollo.MutationResult<UpdateDogWeightAndAppetiteMutation>;
export type UpdateDogWeightAndAppetiteMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDogWeightAndAppetiteMutation, UpdateDogWeightAndAppetiteMutationVariables>;
export const DogWeightAndAppetiteQueryDocument = gql`
    query DogWeightAndAppetiteQuery {
  user {
    id
    subscription {
      id
      idealPlan {
        pricingCurve {
          pricingCohort
        }
      }
      plan {
        pricingCurve {
          pricingCohort
        }
      }
    }
    dogs {
      id
      name
      gender
      weightInGrams
      bodyShape
      exercise
      neutered
      eaterType
      snackingHabits
    }
  }
}
    `;

/**
 * __useDogWeightAndAppetiteQuery__
 *
 * To run a query within a React component, call `useDogWeightAndAppetiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDogWeightAndAppetiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDogWeightAndAppetiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useDogWeightAndAppetiteQuery(baseOptions?: Apollo.QueryHookOptions<DogWeightAndAppetiteQuery, DogWeightAndAppetiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DogWeightAndAppetiteQuery, DogWeightAndAppetiteQueryVariables>(DogWeightAndAppetiteQueryDocument, options);
      }
export function useDogWeightAndAppetiteQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DogWeightAndAppetiteQuery, DogWeightAndAppetiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DogWeightAndAppetiteQuery, DogWeightAndAppetiteQueryVariables>(DogWeightAndAppetiteQueryDocument, options);
        }
export function useDogWeightAndAppetiteQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DogWeightAndAppetiteQuery, DogWeightAndAppetiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DogWeightAndAppetiteQuery, DogWeightAndAppetiteQueryVariables>(DogWeightAndAppetiteQueryDocument, options);
        }
export type DogWeightAndAppetiteQueryHookResult = ReturnType<typeof useDogWeightAndAppetiteQuery>;
export type DogWeightAndAppetiteQueryLazyQueryHookResult = ReturnType<typeof useDogWeightAndAppetiteQueryLazyQuery>;
export type DogWeightAndAppetiteQuerySuspenseQueryHookResult = ReturnType<typeof useDogWeightAndAppetiteQuerySuspenseQuery>;
export type DogWeightAndAppetiteQueryQueryResult = Apollo.QueryResult<DogWeightAndAppetiteQuery, DogWeightAndAppetiteQueryVariables>;
export const PreWizardGuestIterableUpsertMutationDocument = gql`
    mutation PreWizardGuestIterableUpsertMutation($email: String!) {
  preWizardGuestIterableUpsert(email: $email) {
    trackingId
  }
}
    `;
export type PreWizardGuestIterableUpsertMutationMutationFn = Apollo.MutationFunction<PreWizardGuestIterableUpsertMutation, PreWizardGuestIterableUpsertMutationVariables>;

/**
 * __usePreWizardGuestIterableUpsertMutation__
 *
 * To run a mutation, you first call `usePreWizardGuestIterableUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreWizardGuestIterableUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preWizardGuestIterableUpsertMutation, { data, loading, error }] = usePreWizardGuestIterableUpsertMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePreWizardGuestIterableUpsertMutation(baseOptions?: Apollo.MutationHookOptions<PreWizardGuestIterableUpsertMutation, PreWizardGuestIterableUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreWizardGuestIterableUpsertMutation, PreWizardGuestIterableUpsertMutationVariables>(PreWizardGuestIterableUpsertMutationDocument, options);
      }
export type PreWizardGuestIterableUpsertMutationHookResult = ReturnType<typeof usePreWizardGuestIterableUpsertMutation>;
export type PreWizardGuestIterableUpsertMutationMutationResult = Apollo.MutationResult<PreWizardGuestIterableUpsertMutation>;
export type PreWizardGuestIterableUpsertMutationMutationOptions = Apollo.BaseMutationOptions<PreWizardGuestIterableUpsertMutation, PreWizardGuestIterableUpsertMutationVariables>;
export const HomeBreedSelectorQueryDocument = gql`
    query HomeBreedSelectorQuery($name: String, $popular: Boolean) {
  breeds(name: $name, popular: $popular) {
    id
    name
    key
    popular
  }
}
    `;

/**
 * __useHomeBreedSelectorQuery__
 *
 * To run a query within a React component, call `useHomeBreedSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeBreedSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeBreedSelectorQuery({
 *   variables: {
 *      name: // value for 'name'
 *      popular: // value for 'popular'
 *   },
 * });
 */
export function useHomeBreedSelectorQuery(baseOptions?: Apollo.QueryHookOptions<HomeBreedSelectorQuery, HomeBreedSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeBreedSelectorQuery, HomeBreedSelectorQueryVariables>(HomeBreedSelectorQueryDocument, options);
      }
export function useHomeBreedSelectorQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeBreedSelectorQuery, HomeBreedSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeBreedSelectorQuery, HomeBreedSelectorQueryVariables>(HomeBreedSelectorQueryDocument, options);
        }
export function useHomeBreedSelectorQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeBreedSelectorQuery, HomeBreedSelectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeBreedSelectorQuery, HomeBreedSelectorQueryVariables>(HomeBreedSelectorQueryDocument, options);
        }
export type HomeBreedSelectorQueryHookResult = ReturnType<typeof useHomeBreedSelectorQuery>;
export type HomeBreedSelectorQueryLazyQueryHookResult = ReturnType<typeof useHomeBreedSelectorQueryLazyQuery>;
export type HomeBreedSelectorQuerySuspenseQueryHookResult = ReturnType<typeof useHomeBreedSelectorQuerySuspenseQuery>;
export type HomeBreedSelectorQueryQueryResult = Apollo.QueryResult<HomeBreedSelectorQuery, HomeBreedSelectorQueryVariables>;
export const PreWizardGuestIterableUpsertWithRecaptchaMutationDocument = gql`
    mutation PreWizardGuestIterableUpsertWithRecaptchaMutation($email: String!, $recaptchaToken: String!) {
  preWizardGuestIterableUpsertWithRecaptcha(
    email: $email
    recaptchaToken: $recaptchaToken
  ) {
    trackingId
  }
}
    `;
export type PreWizardGuestIterableUpsertWithRecaptchaMutationMutationFn = Apollo.MutationFunction<PreWizardGuestIterableUpsertWithRecaptchaMutation, PreWizardGuestIterableUpsertWithRecaptchaMutationVariables>;

/**
 * __usePreWizardGuestIterableUpsertWithRecaptchaMutation__
 *
 * To run a mutation, you first call `usePreWizardGuestIterableUpsertWithRecaptchaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreWizardGuestIterableUpsertWithRecaptchaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preWizardGuestIterableUpsertWithRecaptchaMutation, { data, loading, error }] = usePreWizardGuestIterableUpsertWithRecaptchaMutation({
 *   variables: {
 *      email: // value for 'email'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function usePreWizardGuestIterableUpsertWithRecaptchaMutation(baseOptions?: Apollo.MutationHookOptions<PreWizardGuestIterableUpsertWithRecaptchaMutation, PreWizardGuestIterableUpsertWithRecaptchaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreWizardGuestIterableUpsertWithRecaptchaMutation, PreWizardGuestIterableUpsertWithRecaptchaMutationVariables>(PreWizardGuestIterableUpsertWithRecaptchaMutationDocument, options);
      }
export type PreWizardGuestIterableUpsertWithRecaptchaMutationHookResult = ReturnType<typeof usePreWizardGuestIterableUpsertWithRecaptchaMutation>;
export type PreWizardGuestIterableUpsertWithRecaptchaMutationMutationResult = Apollo.MutationResult<PreWizardGuestIterableUpsertWithRecaptchaMutation>;
export type PreWizardGuestIterableUpsertWithRecaptchaMutationMutationOptions = Apollo.BaseMutationOptions<PreWizardGuestIterableUpsertWithRecaptchaMutation, PreWizardGuestIterableUpsertWithRecaptchaMutationVariables>;
export const SaveLanguageUpdateDocument = gql`
    mutation SaveLanguageUpdate($language: Language!) {
  languageUpdate(language: $language) {
    __typename
    ... on User {
      id
    }
    ... on Guest {
      id
    }
  }
}
    `;
export type SaveLanguageUpdateMutationFn = Apollo.MutationFunction<SaveLanguageUpdate, SaveLanguageUpdateVariables>;

/**
 * __useSaveLanguageUpdate__
 *
 * To run a mutation, you first call `useSaveLanguageUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLanguageUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLanguageUpdate, { data, loading, error }] = useSaveLanguageUpdate({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSaveLanguageUpdate(baseOptions?: Apollo.MutationHookOptions<SaveLanguageUpdate, SaveLanguageUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLanguageUpdate, SaveLanguageUpdateVariables>(SaveLanguageUpdateDocument, options);
      }
export type SaveLanguageUpdateHookResult = ReturnType<typeof useSaveLanguageUpdate>;
export type SaveLanguageUpdateMutationResult = Apollo.MutationResult<SaveLanguageUpdate>;
export type SaveLanguageUpdateMutationOptions = Apollo.BaseMutationOptions<SaveLanguageUpdate, SaveLanguageUpdateVariables>;
export const UserQueryDocument = gql`
    query UserQuery {
  currentUser {
    __typename
    ... on User {
      preferredLanguage
    }
    ... on Guest {
      preferredLanguage
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserQueryDocument, options);
      }
export function useUserQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserQueryDocument, options);
        }
export function useUserQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserQueryDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserQueryLazyQueryHookResult = ReturnType<typeof useUserQueryLazyQuery>;
export type UserQuerySuspenseQueryHookResult = ReturnType<typeof useUserQuerySuspenseQuery>;
export type UserQueryQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const SubscriptionResumeMutationDocument = gql`
    mutation SubscriptionResumeMutation($numOfBoxes: Int!, $deliveryDate: ISO8601Date) {
  subscriptionResumeWithDeliveryDate(deliveryDate: $deliveryDate) {
    id
    subscription {
      id
      status
      increasedDeliveryCadencePlan {
        id
      }
      nextNBoxes(num: $numOfBoxes) {
        id
        cutOffDate
        isTrialBox
        isoDeliveryDate
        editable
        descriptor
      }
    }
  }
}
    `;
export type SubscriptionResumeMutationMutationFn = Apollo.MutationFunction<SubscriptionResumeMutation, SubscriptionResumeMutationVariables>;

/**
 * __useSubscriptionResumeMutation__
 *
 * To run a mutation, you first call `useSubscriptionResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionResumeMutation, { data, loading, error }] = useSubscriptionResumeMutation({
 *   variables: {
 *      numOfBoxes: // value for 'numOfBoxes'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useSubscriptionResumeMutation(baseOptions?: Apollo.MutationHookOptions<SubscriptionResumeMutation, SubscriptionResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscriptionResumeMutation, SubscriptionResumeMutationVariables>(SubscriptionResumeMutationDocument, options);
      }
export type SubscriptionResumeMutationHookResult = ReturnType<typeof useSubscriptionResumeMutation>;
export type SubscriptionResumeMutationMutationResult = Apollo.MutationResult<SubscriptionResumeMutation>;
export type SubscriptionResumeMutationMutationOptions = Apollo.BaseMutationOptions<SubscriptionResumeMutation, SubscriptionResumeMutationVariables>;
export const CreateDogProfileMutationHookDocument = gql`
    mutation CreateDogProfileMutationHook($userId: ID!, $dogIdsInput: [ID!]!) {
  dogProfilesCreate(userId: $userId, dogIdsInput: $dogIdsInput) {
    id
  }
}
    `;
export type CreateDogProfileMutationHookMutationFn = Apollo.MutationFunction<CreateDogProfileMutationHook, CreateDogProfileMutationHookVariables>;

/**
 * __useCreateDogProfileMutationHook__
 *
 * To run a mutation, you first call `useCreateDogProfileMutationHook` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDogProfileMutationHook` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDogProfileMutationHook, { data, loading, error }] = useCreateDogProfileMutationHook({
 *   variables: {
 *      userId: // value for 'userId'
 *      dogIdsInput: // value for 'dogIdsInput'
 *   },
 * });
 */
export function useCreateDogProfileMutationHook(baseOptions?: Apollo.MutationHookOptions<CreateDogProfileMutationHook, CreateDogProfileMutationHookVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDogProfileMutationHook, CreateDogProfileMutationHookVariables>(CreateDogProfileMutationHookDocument, options);
      }
export type CreateDogProfileMutationHookHookResult = ReturnType<typeof useCreateDogProfileMutationHook>;
export type CreateDogProfileMutationHookMutationResult = Apollo.MutationResult<CreateDogProfileMutationHook>;
export type CreateDogProfileMutationHookMutationOptions = Apollo.BaseMutationOptions<CreateDogProfileMutationHook, CreateDogProfileMutationHookVariables>;
export const UpdateDogProfilePictureMutationHookDocument = gql`
    mutation UpdateDogProfilePictureMutationHook($userId: ID!, $avatarsInput: [AvatarInput!]!) {
  avatarsUpdate(userId: $userId, avatarsInput: $avatarsInput) {
    id
    dogs {
      id
      dogProfile {
        id
        avatarUrl
      }
    }
  }
}
    `;
export type UpdateDogProfilePictureMutationHookMutationFn = Apollo.MutationFunction<UpdateDogProfilePictureMutationHook, UpdateDogProfilePictureMutationHookVariables>;

/**
 * __useUpdateDogProfilePictureMutationHook__
 *
 * To run a mutation, you first call `useUpdateDogProfilePictureMutationHook` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDogProfilePictureMutationHook` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDogProfilePictureMutationHook, { data, loading, error }] = useUpdateDogProfilePictureMutationHook({
 *   variables: {
 *      userId: // value for 'userId'
 *      avatarsInput: // value for 'avatarsInput'
 *   },
 * });
 */
export function useUpdateDogProfilePictureMutationHook(baseOptions?: Apollo.MutationHookOptions<UpdateDogProfilePictureMutationHook, UpdateDogProfilePictureMutationHookVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDogProfilePictureMutationHook, UpdateDogProfilePictureMutationHookVariables>(UpdateDogProfilePictureMutationHookDocument, options);
      }
export type UpdateDogProfilePictureMutationHookHookResult = ReturnType<typeof useUpdateDogProfilePictureMutationHook>;
export type UpdateDogProfilePictureMutationHookMutationResult = Apollo.MutationResult<UpdateDogProfilePictureMutationHook>;
export type UpdateDogProfilePictureMutationHookMutationOptions = Apollo.BaseMutationOptions<UpdateDogProfilePictureMutationHook, UpdateDogProfilePictureMutationHookVariables>;
export const InAccountRafQueryDocument = gql`
    query InAccountRafQuery {
  user {
    id
    firstName
    shippingCountryCode
    dogs {
      id
      name
      dogProfile {
        id
        avatarUrl
      }
    }
    subscription {
      id
      referralLink {
        referralLinkTypeName
        referralDiscountsTotalValue
        url
        referralDiscount {
          id
          code
          discountCodeParts {
            value
            discountType
            discountBasis
            n
          }
        }
        referrerDiscount {
          applicableDiscountParts {
            value
            discountBasis
            n
            discountType
          }
        }
        referrals {
          refereeFirstName
          refereeDogNames
          refereeSignUpDate
        }
      }
      activeRafCampaignRedeemed
      activeRafCampaignVariant {
        name
        rafCampaign {
          name
          endDate
        }
        view {
          data
        }
      }
    }
  }
  shippingCountries {
    id
    code
    showRafCharityButton
  }
  whatsAppSingleDog: copyEntry(slug: "whatsapp_single_dog") {
    text
  }
  whatsAppMultipleDogs: copyEntry(slug: "whatsapp_multiple_dogs") {
    text
  }
}
    `;

/**
 * __useInAccountRafQuery__
 *
 * To run a query within a React component, call `useInAccountRafQuery` and pass it any options that fit your needs.
 * When your component renders, `useInAccountRafQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInAccountRafQuery({
 *   variables: {
 *   },
 * });
 */
export function useInAccountRafQuery(baseOptions?: Apollo.QueryHookOptions<InAccountRafQuery, InAccountRafQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InAccountRafQuery, InAccountRafQueryVariables>(InAccountRafQueryDocument, options);
      }
export function useInAccountRafQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InAccountRafQuery, InAccountRafQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InAccountRafQuery, InAccountRafQueryVariables>(InAccountRafQueryDocument, options);
        }
export function useInAccountRafQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InAccountRafQuery, InAccountRafQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InAccountRafQuery, InAccountRafQueryVariables>(InAccountRafQueryDocument, options);
        }
export type InAccountRafQueryHookResult = ReturnType<typeof useInAccountRafQuery>;
export type InAccountRafQueryLazyQueryHookResult = ReturnType<typeof useInAccountRafQueryLazyQuery>;
export type InAccountRafQuerySuspenseQueryHookResult = ReturnType<typeof useInAccountRafQuerySuspenseQuery>;
export type InAccountRafQueryQueryResult = Apollo.QueryResult<InAccountRafQuery, InAccountRafQueryVariables>;
export const IntercomPersonalDetailsQueryDocument = gql`
    query IntercomPersonalDetailsQuery {
  user {
    id
    firstName
    lastName
    email
    numericalCreatedAt
    intercomUserHash
    trackingId
  }
}
    `;

/**
 * __useIntercomPersonalDetailsQuery__
 *
 * To run a query within a React component, call `useIntercomPersonalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntercomPersonalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntercomPersonalDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntercomPersonalDetailsQuery(baseOptions?: Apollo.QueryHookOptions<IntercomPersonalDetailsQuery, IntercomPersonalDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntercomPersonalDetailsQuery, IntercomPersonalDetailsQueryVariables>(IntercomPersonalDetailsQueryDocument, options);
      }
export function useIntercomPersonalDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntercomPersonalDetailsQuery, IntercomPersonalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntercomPersonalDetailsQuery, IntercomPersonalDetailsQueryVariables>(IntercomPersonalDetailsQueryDocument, options);
        }
export function useIntercomPersonalDetailsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntercomPersonalDetailsQuery, IntercomPersonalDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntercomPersonalDetailsQuery, IntercomPersonalDetailsQueryVariables>(IntercomPersonalDetailsQueryDocument, options);
        }
export type IntercomPersonalDetailsQueryHookResult = ReturnType<typeof useIntercomPersonalDetailsQuery>;
export type IntercomPersonalDetailsQueryLazyQueryHookResult = ReturnType<typeof useIntercomPersonalDetailsQueryLazyQuery>;
export type IntercomPersonalDetailsQuerySuspenseQueryHookResult = ReturnType<typeof useIntercomPersonalDetailsQuerySuspenseQuery>;
export type IntercomPersonalDetailsQueryQueryResult = Apollo.QueryResult<IntercomPersonalDetailsQuery, IntercomPersonalDetailsQueryVariables>;
export const UsePlanQueryDocument = gql`
    query UsePlanQuery($caloriesMultipleOf: Int!, $lowerPercentage: Int!, $upperPercentage: Int!) {
  user {
    id
    subscription {
      id
      deliveriesReceived
      recurringOrder {
        deliveryFee
        physicalProductsTotal
        surchargeTotal
      }
      planOptions {
        ...PlanFragment
      }
      plan {
        ...PlanFragment
      }
      idealPlan {
        ...PlanFragment
      }
    }
    dogs {
      id
      ...DogPlanFragment
    }
  }
}
    ${PlanFragment}
${DogPlanFragment}`;

/**
 * __useUsePlanQuery__
 *
 * To run a query within a React component, call `useUsePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsePlanQuery({
 *   variables: {
 *      caloriesMultipleOf: // value for 'caloriesMultipleOf'
 *      lowerPercentage: // value for 'lowerPercentage'
 *      upperPercentage: // value for 'upperPercentage'
 *   },
 * });
 */
export function useUsePlanQuery(baseOptions: Apollo.QueryHookOptions<UsePlanQuery, UsePlanQueryVariables> & ({ variables: UsePlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsePlanQuery, UsePlanQueryVariables>(UsePlanQueryDocument, options);
      }
export function useUsePlanQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsePlanQuery, UsePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsePlanQuery, UsePlanQueryVariables>(UsePlanQueryDocument, options);
        }
export function useUsePlanQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsePlanQuery, UsePlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsePlanQuery, UsePlanQueryVariables>(UsePlanQueryDocument, options);
        }
export type UsePlanQueryHookResult = ReturnType<typeof useUsePlanQuery>;
export type UsePlanQueryLazyQueryHookResult = ReturnType<typeof useUsePlanQueryLazyQuery>;
export type UsePlanQuerySuspenseQueryHookResult = ReturnType<typeof useUsePlanQuerySuspenseQuery>;
export type UsePlanQueryQueryResult = Apollo.QueryResult<UsePlanQuery, UsePlanQueryVariables>;
export const UpdatePlanMutationDocument = gql`
    mutation UpdatePlanMutation($userId: ID!, $planId: ID!, $numOfBoxes: Int!) {
  subscriptionPlanUpdate(userId: $userId, planId: $planId) {
    id
    subscription {
      id
      nextNBoxes(num: $numOfBoxes) {
        id
        numberOfPouches
        durationInDays
        plan {
          id
          pouchSize
        }
      }
      plan {
        ...PlanFragment
      }
    }
  }
}
    ${PlanFragment}`;
export type UpdatePlanMutationMutationFn = Apollo.MutationFunction<UpdatePlanMutation, UpdatePlanMutationVariables>;

/**
 * __useUpdatePlanMutation__
 *
 * To run a mutation, you first call `useUpdatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanMutation, { data, loading, error }] = useUpdatePlanMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      planId: // value for 'planId'
 *      numOfBoxes: // value for 'numOfBoxes'
 *   },
 * });
 */
export function useUpdatePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanMutation, UpdatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanMutation, UpdatePlanMutationVariables>(UpdatePlanMutationDocument, options);
      }
export type UpdatePlanMutationHookResult = ReturnType<typeof useUpdatePlanMutation>;
export type UpdatePlanMutationMutationResult = Apollo.MutationResult<UpdatePlanMutation>;
export type UpdatePlanMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePlanMutation, UpdatePlanMutationVariables>;
export const MockQueryDocument = gql`
    query MockQuery($userId: ID!) {
  user(id: $userId) {
    id
  }
}
    `;

/**
 * __useMockQuery__
 *
 * To run a query within a React component, call `useMockQuery` and pass it any options that fit your needs.
 * When your component renders, `useMockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMockQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMockQuery(baseOptions: Apollo.QueryHookOptions<MockQuery, MockQueryVariables> & ({ variables: MockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MockQuery, MockQueryVariables>(MockQueryDocument, options);
      }
export function useMockQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MockQuery, MockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MockQuery, MockQueryVariables>(MockQueryDocument, options);
        }
export function useMockQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MockQuery, MockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MockQuery, MockQueryVariables>(MockQueryDocument, options);
        }
export type MockQueryHookResult = ReturnType<typeof useMockQuery>;
export type MockQueryLazyQueryHookResult = ReturnType<typeof useMockQueryLazyQuery>;
export type MockQuerySuspenseQueryHookResult = ReturnType<typeof useMockQuerySuspenseQuery>;
export type MockQueryQueryResult = Apollo.QueryResult<MockQuery, MockQueryVariables>;